import img6584 from "./images/products/6584.jpg";
import img6585 from "./images/products/6585.jpg";
import img6586 from "./images/products/6586.jpg";
import img6587 from "./images/products/6587.jpg";
import img107977 from "./images/products/107977.jpg";
import img6589 from "./images/products/6589.jpg";
import img6590 from "./images/products/6590.jpg";
import img107978 from "./images/products/107978.jpg";
import img93916 from "./images/products/93916.jpg";
import img93921 from "./images/products/93921.jpg";
import img108088 from "./images/products/108088.jpg";
import img33885 from "./images/products/33885.jpg";
import img107979 from "./images/products/107979.jpg";
import img107980 from "./images/products/107980.jpg";
import img11014 from "./images/products/11014.jpg";
import img11003 from "./images/products/11003.jpg";
import img6599 from "./images/products/6599.jpg";
import img6600 from "./images/products/6600.jpg";
import img6601 from "./images/products/6601.jpg";
import img11006 from "./images/products/11006.jpg";
import img51990 from "./images/products/51990.jpg";
import img102757 from "./images/products/102757.jpg";
import img6610 from "./images/products/6610.jpg";
import img6611 from "./images/products/6611.jpg";
import img107981 from "./images/products/107981.jpg";
import img11015 from "./images/products/11015.jpg";
import img25833 from "./images/products/25833.jpg";
import img6614 from "./images/products/6614.jpg";
import img6615 from "./images/products/6615.jpg";
import img6617 from "./images/products/6617.jpg";
import img68971 from "./images/products/68971.jpg";
import img6619 from "./images/products/6619.jpg";
import img107982 from "./images/products/107982.jpg";
import img107983 from "./images/products/107983.jpg";
import img107984 from "./images/products/107984.jpg";
import img11008 from "./images/products/11008.jpg";
import img107985 from "./images/products/107985.jpg";
import img107986 from "./images/products/107986.jpg";
import img6628 from "./images/products/6628.jpg";
import img6629 from "./images/products/6629.jpg";
import img27457 from "./images/products/27457.jpg";
import img11629 from "./images/products/11629.jpg";
import img14751 from "./images/products/14751.jpg";
import img6640 from "./images/products/6640.jpg";
import img6641 from "./images/products/6641.jpg";
import img6643 from "./images/products/6643.jpg";
import img6644 from "./images/products/6644.jpg";
import img6645 from "./images/products/6645.jpg";
import img6647 from "./images/products/6647.jpg";
import img6648 from "./images/products/6648.jpg";
import img6650 from "./images/products/6650.jpg";
import img6651 from "./images/products/6651.jpg";
import img6652 from "./images/products/6652.jpg";
import img6653 from "./images/products/6653.jpg";
import img6654 from "./images/products/6654.jpg";
import img6655 from "./images/products/6655.jpg";
import img6656 from "./images/products/6656.jpg";
import img6657 from "./images/products/6657.jpg";
import img6660 from "./images/products/6660.jpg";
import img6661 from "./images/products/6661.jpg";
import img6662 from "./images/products/6662.jpg";
import img6663 from "./images/products/6663.jpg";
import img6664 from "./images/products/6664.jpg";
import img6665 from "./images/products/6665.jpg";
import img6668 from "./images/products/6668.jpg";
import img6670 from "./images/products/6670.jpg";
import img6674 from "./images/products/6674.jpg";
import img6704 from "./images/products/6704.jpg";
import img6708 from "./images/products/6708.jpg";
import img34861 from "./images/products/34861.jpg";
import img11005 from "./images/products/11005.jpg";
import img6734 from "./images/products/6734.jpg";
import img6735 from "./images/products/6735.jpg";
import img6737 from "./images/products/6737.jpg";
import img6748 from "./images/products/6748.jpg";
import img11007 from "./images/products/11007.jpg";
import img11013 from "./images/products/11013.jpg";
import img6753 from "./images/products/6753.jpg";
import img11011 from "./images/products/11011.jpg";
import img6754 from "./images/products/6754.jpg";
import img6755 from "./images/products/6755.jpg";
import img6756 from "./images/products/6756.jpg";
import img6758 from "./images/products/6758.jpg";
import img6759 from "./images/products/6759.jpg";
import img6760 from "./images/products/6760.jpg";
import img6761 from "./images/products/6761.jpg";
import img6762 from "./images/products/6762.jpg";
import img6763 from "./images/products/6763.jpg";
import img6764 from "./images/products/6764.jpg";
import img6765 from "./images/products/6765.jpg";
import img6766 from "./images/products/6766.jpg";
import img6767 from "./images/products/6767.jpg";
import img93920 from "./images/products/93920.jpg";
import img6777 from "./images/products/6777.jpg";
import img93917 from "./images/products/93917.jpg";
import img93922 from "./images/products/93922.jpg";
import img93918 from "./images/products/93918.jpg";
import img93923 from "./images/products/93923.jpg";
import img6788 from "./images/products/6788.jpg";
import img6791 from "./images/products/6791.jpg";
import img6795 from "./images/products/6795.jpg";
import img6796 from "./images/products/6796.jpg";
import img6799 from "./images/products/6799.jpg";
import img6800 from "./images/products/6800.jpg";
import img6803 from "./images/products/6803.jpg";
import img6804 from "./images/products/6804.jpg";
import img6806 from "./images/products/6806.jpg";
import img6807 from "./images/products/6807.jpg";
import img6808 from "./images/products/6808.jpg";
import img6809 from "./images/products/6809.jpg";
import img6812 from "./images/products/6812.jpg";
import img6813 from "./images/products/6813.jpg";
import img6814 from "./images/products/6814.jpg";
import img6815 from "./images/products/6815.jpg";
import img6818 from "./images/products/6818.jpg";
import img108015 from "./images/products/108015.jpg";
import img6820 from "./images/products/6820.jpg";
import img6821 from "./images/products/6821.jpg";
import img6822 from "./images/products/6822.jpg";
import img6823 from "./images/products/6823.jpg";
import img6824 from "./images/products/6824.jpg";
import img6825 from "./images/products/6825.jpg";
import img6826 from "./images/products/6826.jpg";
import img6827 from "./images/products/6827.jpg";
import img6828 from "./images/products/6828.jpg";
import img6829 from "./images/products/6829.jpg";
import img6830 from "./images/products/6830.jpg";
import img6831 from "./images/products/6831.jpg";
import img6832 from "./images/products/6832.jpg";
import img6833 from "./images/products/6833.jpg";
import img6834 from "./images/products/6834.jpg";
import img6835 from "./images/products/6835.jpg";
import img6836 from "./images/products/6836.jpg";
import img6837 from "./images/products/6837.jpg";
import img6838 from "./images/products/6838.jpg";
import img6839 from "./images/products/6839.jpg";
import img6840 from "./images/products/6840.jpg";
import img6841 from "./images/products/6841.jpg";
import img6842 from "./images/products/6842.jpg";
import img6843 from "./images/products/6843.jpg";
import img6844 from "./images/products/6844.jpg";
import img6845 from "./images/products/6845.jpg";
import img6852 from "./images/products/6852.jpg";
import img6853 from "./images/products/6853.jpg";
import img6854 from "./images/products/6854.jpg";
import img6855 from "./images/products/6855.jpg";
import img6856 from "./images/products/6856.jpg";
import img6857 from "./images/products/6857.jpg";
import img16594 from "./images/products/16594.jpg";
import img16072 from "./images/products/16072.jpg";
import img27183 from "./images/products/27183.jpg";
import img24242 from "./images/products/24242.jpg";

import img16073 from "./images/products/16073.jpg";
import img31987 from "./images/products/31987.jpg";
import img18682 from "./images/products/18682.jpg";
import img13884 from "./images/products/13884.jpg";
import img26834 from "./images/products/26834.jpg";

import img16074 from "./images/products/16074.jpg";
import img25037 from "./images/products/25037.jpg";
import img26381 from "./images/products/26381.jpg";
import img18946 from "./images/products/18946.jpg";
import img51983 from "./images/products/51983.jpg";
import img18947 from "./images/products/18947.jpg";
import img16075 from "./images/products/16075.jpg";
import img13885 from "./images/products/13885.jpg";
import img11017 from "./images/products/11017.jpg";
import img16307 from "./images/products/16307.jpg";
import img6858 from "./images/products/6858.jpg";
import img6859 from "./images/products/6859.jpg";
import img6860 from "./images/products/6860.jpg";
import img11010 from "./images/products/11010.jpg";
import img103468 from "./images/products/103468.jpg";
import img6865 from "./images/products/6865.jpg";
import img6866 from "./images/products/6866.jpg";
import img6867 from "./images/products/6867.jpg";
import img108016 from "./images/products/108016.jpg";
import img6870 from "./images/products/6870.jpg";
import img107987 from "./images/products/107987.jpg";
import img6873 from "./images/products/6873.jpg";
import img6875 from "./images/products/6875.jpg";
import img6876 from "./images/products/6876.jpg";
import img6877 from "./images/products/6877.jpg";
import img52195 from "./images/products/52195.jpg";

import img6880 from "./images/products/6880.jpg";

import img52299 from "./images/products/52299.jpg";
import img6889 from "./images/products/6889.jpg";

import img22623 from "./images/products/22623.jpg";
import img88957 from "./images/products/88957.jpg";
import img52297 from "./images/products/52297.jpg";
import img42779 from "./images/products/42779.jpg";
import img52298 from "./images/products/52298.jpg";
import img18685 from "./images/products/18685.jpg";
import img18686 from "./images/products/18686.jpg";
import img63810 from "./images/products/63810.jpg";
import img62906 from "./images/products/62906.jpg";
import img19122 from "./images/products/19122.jpg";
import img16079 from "./images/products/16079.jpg";
import img11256 from "./images/products/11256.jpg";
import img19203 from "./images/products/19203.jpg";
import img19204 from "./images/products/19204.jpg";
import img81623 from "./images/products/81623.jpg";
import img74838 from "./images/products/74838.jpg";
import img14300 from "./images/products/14300.jpg";
import img29392 from "./images/products/29392.jpg";
import img54172 from "./images/products/54172.jpg";
import img54171 from "./images/products/54171.jpg";
import img66219 from "./images/products/66219.jpg";
import img101210 from "./images/products/101210.jpg";
import img63578 from "./images/products/63578.jpg";
import img101211 from "./images/products/101211.jpg";
import img18042 from "./images/products/18042.jpg";
import img18950 from "./images/products/18950.jpg";
import img18687 from "./images/products/18687.jpg";
import img18688 from "./images/products/18688.jpg";
import img108161 from "./images/products/108161.jpg";
import img18951 from "./images/products/18951.jpg";
import img21955 from "./images/products/21955.jpg";
import img18952 from "./images/products/18952.jpg";
import img18689 from "./images/products/18689.jpg";
import img69798 from "./images/products/69798.jpg";
import img18953 from "./images/products/18953.jpg";
import img34002 from "./images/products/34002.jpg";
import img6894 from "./images/products/6894.jpg";
import img40331 from "./images/products/40331.jpg";
import img51277 from "./images/products/51277.jpg";
import img39156 from "./images/products/39156.jpg";
import img16614 from "./images/products/16614.jpg";
import img17799 from "./images/products/17799.jpg";
import img108001 from "./images/products/108001.jpg";
import img19767 from "./images/products/19767.jpg";
import img6904 from "./images/products/6904.jpg";
import img11012 from "./images/products/11012.jpg";
import img107988 from "./images/products/107988.jpg";
import img107991 from "./images/products/107991.jpg";
import img30783 from "./images/products/30783.jpg";
import img62908 from "./images/products/62908.jpg";
import img17292 from "./images/products/17292.jpg";
import img67463 from "./images/products/67463.jpg";
import img17881 from "./images/products/17881.jpg";
import img33900 from "./images/products/33900.jpg";
import img74835 from "./images/products/74835.jpg";
import img18691 from "./images/products/18691.jpg";
import img62909 from "./images/products/62909.jpg";

import img28197 from "./images/products/28197.jpg";
import img13889 from "./images/products/13889.jpg";

import img18692 from "./images/products/18692.jpg";
import img18693 from "./images/products/18693.jpg";
import img108113 from "./images/products/108113.jpg";
import img16708 from "./images/products/16708.jpg";
import img18694 from "./images/products/18694.jpg";
import img81499 from "./images/products/81499.jpg";
import img81498 from "./images/products/81498.jpg";
import img81495 from "./images/products/81495.jpg";
import img19206 from "./images/products/19206.jpg";
import img18695 from "./images/products/18695.jpg";
import img19207 from "./images/products/19207.jpg";
import img19208 from "./images/products/19208.jpg";
import img28278 from "./images/products/28278.jpg";
import img28277 from "./images/products/28277.jpg";
import img19209 from "./images/products/19209.jpg";
import img27637 from "./images/products/27637.jpg";
import img31507 from "./images/products/31507.jpg";
import img28001 from "./images/products/28001.jpg";
import img18696 from "./images/products/18696.jpg";
import img101213 from "./images/products/101213.jpg";
import img31508 from "./images/products/31508.jpg";
import img27729 from "./images/products/27729.jpg";
import img31244 from "./images/products/31244.jpg";
import img31509 from "./images/products/31509.jpg";
import img18955 from "./images/products/18955.jpg";

import img18697 from "./images/products/18697.jpg";
import img18698 from "./images/products/18698.jpg";
import img18699 from "./images/products/18699.jpg";
import img16081 from "./images/products/16081.jpg";
import img26294 from "./images/products/26294.jpg";
import img96333 from "./images/products/96333.jpg";
import img108000 from "./images/products/108000.jpg";
import img18956 from "./images/products/18956.jpg";
import img18700 from "./images/products/18700.jpg";
import img18701 from "./images/products/18701.jpg";

import img81497 from "./images/products/81497.jpg";
import img107999 from "./images/products/107999.jpg";
import img31427 from "./images/products/31427.jpg";

import img18702 from "./images/products/18702.jpg";
import img31893 from "./images/products/31893.jpg";
import img18703 from "./images/products/18703.jpg";

import img108112 from "./images/products/108112.jpg";
import img31894 from "./images/products/31894.jpg";
import img18704 from "./images/products/18704.jpg";
import img27728 from "./images/products/27728.jpg";
import img18705 from "./images/products/18705.jpg";
import img47469 from "./images/products/47469.jpg";
import img18957 from "./images/products/18957.jpg";
import img28280 from "./images/products/28280.jpg";
import img18958 from "./images/products/18958.jpg";

import img6905 from "./images/products/6905.jpg";
import img6906 from "./images/products/6906.jpg";
import img6907 from "./images/products/6907.jpg";
import img6908 from "./images/products/6908.jpg";
import img6909 from "./images/products/6909.jpg";
import img6910 from "./images/products/6910.jpg";
import img6911 from "./images/products/6911.jpg";
import img6912 from "./images/products/6912.jpg";
import img6913 from "./images/products/6913.jpg";
import img6914 from "./images/products/6914.jpg";
import img6915 from "./images/products/6915.jpg";
import img6916 from "./images/products/6916.jpg";
import img6917 from "./images/products/6917.jpg";
import img6918 from "./images/products/6918.jpg";
import img18706 from "./images/products/18706.jpg";
import img18959 from "./images/products/18959.jpg";
import img18960 from "./images/products/18960.jpg";
import img18961 from "./images/products/18961.jpg";
import img108111 from "./images/products/108111.jpg";
import img108116 from "./images/products/108116.jpg";
import img31897 from "./images/products/31897.jpg";
import img18963 from "./images/products/18963.jpg";
import img28281 from "./images/products/28281.jpg";
import img108110 from "./images/products/108110.jpg";
import img108123 from "./images/products/108123.jpg";
import img31900 from "./images/products/31900.jpg";
import img11662 from "./images/products/11662.jpg";
import img11663 from "./images/products/11663.jpg";
import img13799 from "./images/products/13799.jpg";
import img13800 from "./images/products/13800.jpg";
import img108120 from "./images/products/108120.jpg";
import img33904 from "./images/products/33904.jpg";
import img17034 from "./images/products/17034.jpg";
import img35353 from "./images/products/35353.jpg";
import img90331 from "./images/products/90331.jpg";
import img108109 from "./images/products/108109.jpg";
import img100782 from "./images/products/100782.jpg";
import img108108 from "./images/products/108108.jpg";
import img37982 from "./images/products/37982.jpg";
import img34007 from "./images/products/34007.jpg";
import img33905 from "./images/products/33905.jpg";
import img59288 from "./images/products/59288.jpg";
import img59287 from "./images/products/59287.jpg";
import img108107 from "./images/products/108107.jpg";
import img91663 from "./images/products/91663.jpg";
import img33906 from "./images/products/33906.jpg";
import img33907 from "./images/products/33907.jpg";
import img33908 from "./images/products/33908.jpg";
import img34462 from "./images/products/34462.jpg";
import img34008 from "./images/products/34008.jpg";
import img108106 from "./images/products/108106.jpg";
import img108105 from "./images/products/108105.jpg";
import img53970 from "./images/products/53970.jpg";
import img59972 from "./images/products/59972.jpg";
import img108104 from "./images/products/108104.jpg";
import img108171 from "./images/products/108171.jpg";
import img35249 from "./images/products/35249.jpg";
import img31901 from "./images/products/31901.jpg";
import img35250 from "./images/products/35250.jpg";
import img35248 from "./images/products/35248.jpg";
import img34874 from "./images/products/34874.jpg";
import img34875 from "./images/products/34875.jpg";
import img34876 from "./images/products/34876.jpg";
import img34877 from "./images/products/34877.jpg";
import img34878 from "./images/products/34878.jpg";
import img34879 from "./images/products/34879.jpg";
import img34880 from "./images/products/34880.jpg";
import img34881 from "./images/products/34881.jpg";
import img108103 from "./images/products/108103.jpg";
import img35254 from "./images/products/35254.jpg";
import img35247 from "./images/products/35247.jpg";
import img35252 from "./images/products/35252.jpg";
import img35253 from "./images/products/35253.jpg";
import img35251 from "./images/products/35251.jpg";
import img34768 from "./images/products/34768.jpg";
import img34882 from "./images/products/34882.jpg";
import img33909 from "./images/products/33909.jpg";
import img33910 from "./images/products/33910.jpg";
import img108100 from "./images/products/108100.jpg";
import img108102 from "./images/products/108102.jpg";
import img107449 from "./images/products/107449.jpg";
import img45489 from "./images/products/45489.jpg";
import img45490 from "./images/products/45490.jpg";
import img108118 from "./images/products/108118.jpg";
import img45491 from "./images/products/45491.jpg";
import img45492 from "./images/products/45492.jpg";
import img45487 from "./images/products/45487.jpg";
import img45488 from "./images/products/45488.jpg";
import img108119 from "./images/products/108119.jpg";
import img108089 from "./images/products/108089.jpg";

import img108122 from "./images/products/108122.jpg";
import img81858 from "./images/products/81858.jpg";
import img81859 from "./images/products/81859.jpg";
import img59969 from "./images/products/59969.jpg";

import img81489 from "./images/products/81489.jpg";
import img81488 from "./images/products/81488.jpg";
import img81490 from "./images/products/81490.jpg";
import img104184 from "./images/products/104184.jpg";
import img82774 from "./images/products/82774.jpg";
import img107997 from "./images/products/107997.jpg";
import img107996 from "./images/products/107996.jpg";
import img81491 from "./images/products/81491.jpg";
import img81493 from "./images/products/81493.jpg";
import img81492 from "./images/products/81492.jpg";
import img82723 from "./images/products/82723.jpg";
import img81494 from "./images/products/81494.jpg";
import img81860 from "./images/products/81860.jpg";
import img81861 from "./images/products/81861.jpg";
import img81621 from "./images/products/81621.jpg";
import img81862 from "./images/products/81862.jpg";
import img81863 from "./images/products/81863.jpg";
import img81622 from "./images/products/81622.jpg";
import img108121 from "./images/products/108121.jpg";
import img108117 from "./images/products/108117.jpg";

import img108115 from "./images/products/108115.jpg";

import img108170 from "./images/products/108170.jpg";

import img108114 from "./images/products/108114.jpg";

import img81853 from "./images/products/81853.jpg";

import img86322 from "./images/products/86322.jpg";
import img107998 from "./images/products/107998.jpg";
import img108101 from "./images/products/108101.jpg";

import img108124 from "./images/products/108124.jpg";
import img108085 from "./images/products/108085.jpg";
import img108135 from "./images/products/108135.jpg";
import img7427 from "./images/products/7427.jpg";
import img7435 from "./images/products/7435.jpg";
import img7465 from "./images/products/7465.jpg";
import img7515 from "./images/products/7515.jpg";
import img7516 from "./images/products/7516.jpg";
import img7539 from "./images/products/7539.jpg";
import img7551 from "./images/products/7551.jpg";
import img7626 from "./images/products/7626.jpg";
import img82482 from "./images/products/82482.jpg";
import img101474 from "./images/products/101474.jpg";
import img80559 from "./images/products/80559.jpg";
import img7901 from "./images/products/7901.jpg";
import img11004 from "./images/products/11004.jpg";
import img7919 from "./images/products/7919.jpg";
import img8010 from "./images/products/8010.jpg";
import img8165 from "./images/products/8165.jpg";
import img8332 from "./images/products/8332.jpg";
import img8334 from "./images/products/8334.jpg";
import img8335 from "./images/products/8335.jpg";
import img8336 from "./images/products/8336.jpg";
import img8338 from "./images/products/8338.jpg";
import img8339 from "./images/products/8339.jpg";
import img8341 from "./images/products/8341.jpg";
import img8342 from "./images/products/8342.jpg";
import img8343 from "./images/products/8343.jpg";
import img8344 from "./images/products/8344.jpg";
import img8504 from "./images/products/8504.jpg";

import img8521 from "./images/products/8521.jpg";
import img8522 from "./images/products/8522.jpg";
import img8523 from "./images/products/8523.jpg";
import img8524 from "./images/products/8524.jpg";
import img8528 from "./images/products/8528.jpg";
import img8530 from "./images/products/8530.jpg";
import img8531 from "./images/products/8531.jpg";
import img8532 from "./images/products/8532.jpg";
import img29485 from "./images/products/29485.jpg";
import img29107 from "./images/products/29107.jpg";
import img10557 from "./images/products/10557.jpg";
import img10559 from "./images/products/10559.jpg";
import img10560 from "./images/products/10560.jpg";
import img10561 from "./images/products/10561.jpg";
import img10562 from "./images/products/10562.jpg";
import img10563 from "./images/products/10563.jpg";
import img10565 from "./images/products/10565.jpg";
import img10643 from "./images/products/10643.jpg";
import img23665 from "./images/products/23665.jpg";
import img29111 from "./images/products/29111.jpg";
import img29112 from "./images/products/29112.jpg";
import img29113 from "./images/products/29113.jpg";
import img29114 from "./images/products/29114.jpg";
import img32932 from "./images/products/32932.jpg";
import img32933 from "./images/products/32933.jpg";
import img32934 from "./images/products/32934.jpg";
import img68853 from "./images/products/68853.jpg";
import img68970 from "./images/products/68970.jpg";
import img68854 from "./images/products/68854.jpg";
import img68851 from "./images/products/68851.jpg";
import img108090 from "./images/products/108090.jpg";
/*
import img2000001 from "http://eshop.eurovat.sk/img/p/1/0/8/4/7/9/108479.jpg";
import img2000002 from "http://eshop.eurovat.sk/img/p/1/0/8/4/7/6/108476.jpg";
import img2000003 from "http://eshop.eurovat.sk/img/p/1/0/8/4/7/5/108475.jpg";
import img2000004 from "http://eshop.eurovat.sk/img/p/1/0/8/4/7/4/108474.jpg";
import img2000005 from "http://eshop.eurovat.sk/img/p/1/0/8/4/7/3/108473.jpg";
import img2000006 from "http://eshop.eurovat.sk/img/p/1/0/8/4/7/2/108472.jpg";
import img2000007 from "http://eshop.eurovat.sk/img/p/1/0/8/4/7/1/108471.jpg";
import img2000008 from "http://eshop.eurovat.sk/img/p/1/0/8/4/7/0/108470.jpg";
import img2000009 from "http://eshop.eurovat.sk/img/p/1/0/8/4/6/9/108469.jpg";
import img2000010 from "http://eshop.eurovat.sk/img/p/1/0/8/4/6/8/108468.jpg";
import img2000011 from "http://eshop.eurovat.sk/img/p/1/0/8/4/6/7/108467.jpg";
import img2000012 from "http://eshop.eurovat.sk/img/p/1/0/8/4/6/6/108466.jpg";
import img2000013 from "http://eshop.eurovat.sk/img/p/1/0/8/4/6/5/108465.jpg";
import img2000014 from "http://eshop.eurovat.sk/img/p/1/0/8/4/6/4/108464.jpg";
import img2000015 from "http://eshop.eurovat.sk/img/p/1/0/8/4/6/3/108463.jpg";
import img2000016 from "http://eshop.eurovat.sk/img/p/1/0/8/4/6/2/108462.jpg";
import img2000017 from "http://eshop.eurovat.sk/img/p/1/0/8/4/6/1/108461.jpg";
import img2000018 from "http://eshop.eurovat.sk/img/p/1/0/8/4/6/0/108460.jpg";
import img2000019 from "http://eshop.eurovat.sk/img/p/1/0/8/4/5/9/108459.jpg";
import img2000020 from "http://eshop.eurovat.sk/img/p/1/0/8/4/8/4/108484.jpg";
import img2000021 from "http://eshop.eurovat.sk/img/p/1/0/8/4/8/5/108485.jpg";
import img2000022 from "http://eshop.eurovat.sk/img/p/1/0/8/4/5/8/108458.jpg";
import img2000023 from "http://eshop.eurovat.sk/img/p/1/0/8/4/5/7/108457.jpg";
import img2000024 from "http://eshop.eurovat.sk/img/p/1/0/8/3/9/6/108396.jpg";
import img2000025 from "http://eshop.eurovat.sk/img/p/1/0/8/3/9/5/108395.jpg";
import img2000026 from "http://eshop.eurovat.sk/img/p/1/0/8/3/9/4/108394.jpg";
import img2000027 from "http://eshop.eurovat.sk/img/p/1/0/8/3/9/3/108393.jpg";
import img2000028 from "http://eshop.eurovat.sk/img/p/1/0/8/3/9/2/108392.jpg";
import img2000029 from "http://eshop.eurovat.sk/img/p/1/0/8/3/9/1/108391.jpg";
import img2000030 from "http://eshop.eurovat.sk/img/p/1/0/8/3/9/0/108390.jpg";
import img2000031 from "http://eshop.eurovat.sk/img/p/1/0/8/3/8/9/108389.jpg";
import img2000032 from "http://eshop.eurovat.sk/img/p/1/0/8/3/8/7/108387.jpg";
import img2000033 from "http://eshop.eurovat.sk/img/p/1/0/8/3/8/5/108385.jpg";
import img2000034 from "http://eshop.eurovat.sk/img/p/1/0/8/3/8/4/108384.jpg";
import img2000035 from "http://eshop.eurovat.sk/img/p/1/0/8/3/8/3/108383.jpg";

import img2000036 from "http://eshop.eurovat.sk/img/p/1/0/8/3/0/6/108306.jpg";
import img2000037 from "http://eshop.eurovat.sk/img/p/1/0/8/3/0/5/108305.jpg";
import img2000038 from "http://eshop.eurovat.sk/img/p/1/0/8/3/0/4/108304.jpg";
import img2000039 from "http://eshop.eurovat.sk/img/p/1/0/8/3/0/3/108303.jpg";
*/

/*
import olej1 from "./images/products/shell-ect-c3.jpg";
import olej2 from "./images/products/shell-hx8-ect.jpg";
import olej3 from "./images/products/febi-brzdovka.jpg";
import filter1 from "./images/products/mecafilter.jpg";
import filter2 from "./images/products/champion.jpg";
import brzdy1 from "./images/products/brzdy.jpg";
import sprej from "./images/products/sprej.jpg";
*/

const products = [
  {
    id: "500011",
    brand: "DYNAMAX",
    image: img6584,
    src: "6584.jpg",
    name: "DYNAMAX TRUCKMAN PLUS 15W-40 20L",
    short_desc:
      "Motorový olej DYNAMAX TRUCKMAN PLUS 15W-40 je ropný motorový olej vyrobený modernými technológiami za použitia starostlivo vyváženého aditívneho systému (detergenty-disperzanty, protioderové prísady, antioxidanty, antikorodanty, protipenivostné prísady a prísady neutralizujúce kyslé zložky a tiež modifikátory viskozity).",
    desc: "Motorový olej DYNAMAX TRUCKMAN PLUS 15W-40 je ropný motorový olej vyrobený modernými technológiami za použitia starostlivo vyváženého aditívneho systému (detergenty-disperzanty, protioderové prísady, antioxidanty, antikorodanty, protipenivostné prísady a prísady neutralizujúce kyslé zložky a tiež modifikátory viskozity). Olej zabezpečuje plnú ochranu motora vo všetkých prevádzkových podmienkach, udržuje čisté vnútorné časti motora, znižuje opotrebenie oderom, chráni pred koróziou a neutralizuje kyslé produkty, vznikajúce pri spaľovaní.",
    ean: 8586016010995,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: 32.78,
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500012,
    brand: "DYNAMAX",
    image: img6585,
    src: "6585.jpg",
    name: "DYNAMAX 5L DEMINERALIZOVANÁ TECHNICKÁ VODA",
    short_desc:
      "Demineralizovaná technická voda určená na riedenie koncentrátov nemrznúcich a letných zmesí do ostrekovačov DYNAMAX a všetkých typov chladiacich kvapalín DYNAMAX. Je vhodná na použitie do akumulátorov, žehličiek alebo fotolaboratórií.",
    desc: "Demineralizovaná technická voda určená na riedenie koncentrátov nemrznúcich a letných zmesí do ostrekovačov DYNAMAX a všetkých typov chladiacich kvapalín DYNAMAX. Je vhodná na použitie do akumulátorov, žehličiek alebo fotolaboratórií.",
    ean: 8588001502041,
    package: 3,
    type: "olej",
    sub_category: "chladiaci",
    price: 17.78,
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500013,
    brand: "DYNAMAX",
    image: img6586,
    src: "6586.jpg",
    name: "DYNAMAX 3L DEMINERALIZOVANÁ TECHNICKÁ VODA",
    short_desc:
      "Demineralizovaná technická voda určená na riedenie koncentrátov nemrznúcich a letných zmesí do ostrekovačov DYNAMAX a všetkých typov chladiacich kvapalín DYNAMAX. Je vhodná na použitie do akumulátorov, žehličiek alebo fotolaboratórií.",
    desc: "Demineralizovaná technická voda určená na riedenie koncentrátov nemrznúcich a letných zmesí do ostrekovačov DYNAMAX a všetkých typov chladiacich kvapalín DYNAMAX. Je vhodná na použitie do akumulátorov, žehličiek alebo fotolaboratórií.",
    ean: 8588001502034,
    package: 3,
    type: "olej",
    sub_category: "chladiaci",
    price: 12.78,
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: "500014",
    brand: "DYNAMAX",
    image: img6587,
    src: "6587.jpg",
    name: "DYNAMAX 10L DEMINERALIZOVANÁ TECHNICKÁ VODA",
    short_desc:
      "Demineralizovaná technická voda určená na riedenie koncentrátov nemrznúcich a letných zmesí do ostrekovačov DYNAMAX a všetkých typov chladiacich kvapalín DYNAMAX. Je vhodná na použitie do akumulátorov, žehličiek alebo fotolaboratórií.",
    desc: "Demineralizovaná technická voda určená na riedenie koncentrátov nemrznúcich a letných zmesí do ostrekovačov DYNAMAX a všetkých typov chladiacich kvapalín DYNAMAX. Je vhodná na použitie do akumulátorov, žehličiek alebo fotolaboratórií.",
    ean: 8588001502331,
    package: "",
    type: "olej",
    sub_category: "chladiaci",
    price: 8.78,
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500015,
    brand: "DYNAMAX",
    image: img107977,
    src: "107977.jpg",
    name: "DYNAMAX COOL 10 1L",
    short_desc:
      "Koncentrovaná nízkotuhnúca chladiaca kvapalina na báze etylénglykolu je určená pre všetky typy starších motorových vozidiel, poľnohospodárske a stavebné stroje. Celoročne chráni chladiaci systém pred koróziou a zabraňuje prehriatiu motorov v letný ch mesiacoch. Odporúčaná výmena je po troch rokoch.",
    desc: "Koncentrovaná  chladiaca kvapalina na báze etylénglykolu je určená pre všetky typy starších motorových vozidiel, poľnohospodárske a stavebné stroje. Celoročne chráni chladiaci systém pred koróziou a zabraňuje prehriatiu motorov v letný ch mesiacoch. Odporúčaná výmena je po troch rokoch. Výrobca zabezpečuje konzultácie a neručí za škody spôsobené nesprávnym použitím výrobku. Plní sa do čistého chladiaceho systému podľa pokynov výrobcu automobilu. Je riediteľná pitnou alebo demineralizovanou vodou na požadovaný bod tuhnutia.",
    ean: 8588002690433,
    package: 12,
    type: "olej",
    sub_category: "chladiaci",
    price: 8.56,
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500017,
    brand: "DYNAMAX",
    image: img6589,
    src: "6589.jpg",
    name: "DYNAMAX ROZMRAZOVAČ ZÁMKOV 50ML",
    short_desc:
      "Prípravok, ktorý účinne rozmrazuje a bráni zamŕzaniu. Chráni a maže zámky a iné mechanizmy vystavené poveternostným podmienkam. Má antikorózne vlastnosti.",
    desc: "Prípravok, ktorý účinne rozmrazuje a bráni zamŕzaniu. Chráni a maže zámky a iné mechanizmy vystavené poveternostným podmienkam. Má antikorózne vlastnosti.",
    ean: 8586011471159,
    package: 66,
    type: "doplnok",
    sub_category: "",
    price: 21.78,
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: "500018",
    brand: "DYNAMAX",
    image: img6590,
    src: "6590.jpg",
    name: "DYNAMAX LETNÁ ZMES 1L CITRON",
    short_desc:
      "DYNAMAX letná zmes 1:2 je vysokoúčinný prostriedok pre odstránenie zbytkov hmyzu a všetkých bežných nečistôt zo skla automobilu. Koncentrát obsahuje aktívnu látku, ktorá predstavuje úplne nový spôsob údržby. Znižuje námahu spojenú s čistením okien. Sklo zanecháva dokonale čisté.",
    desc: "DYNAMAX letná zmes 1:2 je vysokoúčinný prostriedok pre odstránenie zbytkov hmyzu a všetkých bežných nečistôt zo skla automobilu. Koncentrát obsahuje aktívnu látku, ktorá predstavuje úplne nový spôsob údržby. Znižuje námahu spojenú s čistením okien. Sklo zanecháva dokonale čisté. Je biologicky odbúrateľný. DYNAMAX letná zmes je určený na použitie ako náplň do ostrekovačov pre všetky typy motorových vozidiel v letnom období. Plní sa do zásobnej nádržky ostrekovača a podľa potreby sa aplikuje na čelné sklo automobilu.",
    ean: 8586016010476,
    package: 8,
    type: "doplnok",
    sub_category: "",
    price: 9.78,
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500019,
    brand: "DYNAMAX",
    image: img107978,
    src: "107978.jpg",
    name: "DYNAMAX COOL 11 1L",
    short_desc:
      "Nízkotuhnúca zmes do chladičov automobilov na báze monoetylénglykolu s antikoróznymi prísadami je zvlášť vhodná pre chladiace sústavy spaľovacích motorov z ľahkých zliatín. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Prípravok neobsahuje dusitany, amíny a fosfáty.",
    desc: "Nízkotuhnúca zmes do chladičov automobilov na báze monoetylénglykolu s antikoróznymi prísadami je zvlášť vhodná pre chladiace sústavy spaľovacích motorov z ľahkých zliatín. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Prípravok neobsahuje dusitany, amíny a fosfáty. Plní sa do čistého chladiaceho systému podľa pokynov výrobcu automobilu. Je riediteľná pitnou alebo demineralizovanou vodou na požadovaný bod tuhnutia.",
    ean: 8588002690457,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: 4.78,
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500021,
    brand: "DYNAMAX",
    image: img93916,
    src: "93916.jpg",
    name: "DYNAMAX SCREENWASH -20 1L",
    short_desc:
      "DYNAMAX Screenwash -20 °C Black drake je nemrznúca kvapalina do ostrekovačov automobilov. Spoľahlivo odstraňuje zo skla automobilu mastnotu a iné nečistoty.",
    desc: "Je vysoko účinná, celoročná mrazuvzdorná kvapalina do všetkých typov ostrekovačov motorových vozidiel. DYNAMAX Screenwash -20 °C Black drake je nemrznúca kvapalina do ostrekovačov automobilov. Spoľahlivo odstraňuje zo skla automobilu mastnotu a iné nečistoty.",
    ean: 8586016010315,
    package: 12,
    type: "olej",
    sub_category: "ostrekovaci",
    price: 42.78,
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500022,
    brand: "DYNAMAX",
    image: "img93921",
    src: "93921.jpg",
    name: "DYNAMAX SCREENWASH -40 1L",
    short_desc:
      "Nemrznúci koncentrát je vysokoúčinná náplň do ostrekovačov automobilov. Zo skla automobilu spoľahlivo odstraňuje mastnotu a iné nečistoty. Chráni ostrekovací systém pred zamŕzaním až do -40°C a vytváraním vodného kameňa. Zlepšuje viditeľnosť počas nepriaznivého počasia. Spríjemňuje jazdu. Zvyšuje bezpečnosť jazdy v zimnom období.",
    desc: "Nemrznúci koncentrát je vysokoúčinná náplň do ostrekovačov automobilov. Zo skla automobilu spoľahlivo odstraňuje mastnotu a iné nečistoty. Chráni ostrekovací systém pred zamŕzaním až do -40°C a vytváraním vodného kameňa. Zlepšuje viditeľnosť počas nepriaznivého počasia. Spríjemňuje jazdu. Zvyšuje bezpečnosť jazdy v zimnom období.",
    ean: 8586016010278,
    package: 12,
    type: "olej",
    sub_category: "ostrekovaci",
    price: 17.14,
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500024,
    brand: "DYNAMAX",
    image: "img108088",
    src: "108088.jpg",
    name: "DYNAMAX SCREENWASH -20 CITRON 5L",
    short_desc:
      "Nemrznúca kvapalina do ostrekovačov automobilov. Spoľahlivo odstraňuje zo skla automobilu mastnotu a iné nečistoty.",
    desc: "Je vysoko účinná, celoročná mrazuvzdorná kvapalina do všetkých typov ostrekovačov motorových vozidiel. Chráni zariadenie ostrekovačov pred koróziou.",
    ean: 8588001502102,
    package: 3,
    type: "olej",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: "500028",
    brand: "DYNAMAX",
    image: "img33885",
    src: "33885.jpg",
    name: "DYNAMAX STOP 265 50L(53,5 KG)",
    short_desc:
      "Brzdová kvapalina pre hydraulické brzdové systémy motorových vozidiel je určená pre prevádzku v teplotnom rozmedzí -50 °C až 260 °C. Prípravok vysokej kvality zaručuje bezpečné a presné brzdenie, nepoškodzuje gumu a kov, je určený pre kotúčové a bubnové brzdy.",
    desc: "Brzdová kvapalina pre hydraulické brzdové systémy motorových vozidiel je určená pre prevádzku v teplotnom rozmedzí -50 °C až 260 °C. Prípravok vysokej kvality zaručuje bezpečné a presné brzdenie, nepoškodzuje gumu a kov, je určený pre kotúčové a bubnové brzdy. Má dobrú tepelnú stabilitu, výbornú ochranu proti korózii železných aj neželezných kovov.Možno miešať s brzdovými kvapalinami, ktoré zdopovedajú normám ISO 4925, SAE J 1703 FM VSS 571-116 DOT 3 a DOT 4, VW TL 766, t.j. s brzdovými kvapalinymi rovnakej špecifikácie. Číra kvapalina s nádychom žltej farby štiplavej arómy. Používa sa neriedený.",
    ean: "",
    package: 3,
    type: "olej",
    sub_category: "brzdovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500034,
    brand: "DYNAMAX",
    image: img107979,
    src: "107979.jpg",
    name: "DYNAMAX COOL 11 AL 3L",
    short_desc:
      "Nízkotuhnúca zmes do chladičov automobilov na báze monoetylénglykolu s antikoróznymi prísadami je zvlášť vhodná pre chladiace sústavy spaľovacích motorov z ľahkých zliatín. Celoročne chráni chladiaci systém motorového vozdila pred pôsobením mrazu a pred koróziou.",
    desc: "Nízkotuhnúca zmes do chladičov automobilov na báze monoetylénglykolu s antikoróznymi prísadami je zvlášť vhodná pre chladiace sústavy spaľovacích motorov z ľahkých zliatín. Celoročne chráni chladiaci systém motorového vozidila pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Prípravok neobsahuje dusitany, amíny a fosfáty. Plní sa do čistého chladiaceho systému podľa pokynov výrobcu automobilu. Je riediteľná pitnou alebo demineralizovanou vodou na požadovaný bod tuhnutia podľa doporučených pomerov výrobcu. Chladiaca kvapalina DYNAMAX COOLANT AL G11 je miešateľná s nízkotuhnúcimi kvapalinami na báze monoetylénglykolu (etylén-glykolu a propylénglykolu).",
    ean: 8586011471616,
    package: 4,
    type: "doplnok",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500038,
    brand: "DYNAMAX",
    image: "img107980",
    src: "107980.jpg",
    name: "DYNAMAX COOL 12 ULTRA 3L",
    short_desc:
      "DYNAMAX COOLANT ULTRA G12 je koncentrovaná nízkotuhnúca chladiaca kvapalina určená pre najmodernejšie druhy motorov. Je vysoko kvalitná nízkotuhnúca zmes vyrobená z monoetylénglykolu s vysoko progresívnymi antikoróznymi prísadami, zvlášť vhodná pre chladiče moderných hliníkových a zliatinových chladiacich sústav spaľovacích motorov.",
    desc: "DYNAMAX COOLANT ULTRA G12 je koncentrovaná nízkotuhnúca chladiaca kvapalina určená pre najmodernejšie druhy motorov. Je vysoko kvalitná nízkotuhnúca zmes vyrobená z monoetylénglykolu s vysoko progresívnymi antikoróznymi prísadami, zvlášť vhodná pre chladiče moderných hliníkových a zliatinových chladiacich sústav spaľovacích motorov. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. V roku 2008 získala chladiaca kvapalina DYNAMAX COOLANT ULTRA G12 prestížne ocenenie Zlatú medailu a Certifikát ochrannej známky kvality Slovak Gold. Obsahuje látku brániacu požitiu chladiacej kvapaliny. Plní sa do čistého chladiaceho systému podľa pokynov výrobcu automobilu. Je riediteľná pitnou alebo demineralizovanou vodou na požadovaný bod tuhnutia podľa učených pomerov výrobcu. DYNAMAX COOLANT ULTRA G12 chladiaca kvapalina je miešateľná s nízkotuhnúcimi kvapalinami na báze monoetylén-glykolu (etylénglykolu a propylénglykolu).",
    ean: 8586011471692,
    package: 4,
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500040,
    brand: "DYNAMAX",
    image: img11014,
    src: "11014.jpg",
    name: "DYNAMAX LETNÁ ZMES 50L CITRON",
    short_desc:
      "DYNAMAX letná zmes 1:2 je vysokoúčinný prostriedok pre odstránenie zbytkov hmyzu a všetkých bežných nečistôt zo skla automobilu. Koncentrát obsahuje aktívnu látku, ktorá predstavuje úplne nový spôsob údržby.",
    desc: "DYNAMAX letná zmes 1:2 je vysokoúčinný prostriedok pre odstránenie zbytkov hmyzu a všetkých bežných nečistôt zo skla automobilu. Koncentrát obsahuje aktívnu látku, ktorá predstavuje úplne nový spôsob údržby. Znižuje námahu spojenú s čistením okien. Sklo zanecháva dokonale čisté. Je biologicky odbúrateľný. DYNAMAX letná zmes je určený na použitie ako náplň do ostrekovačov pre všetky typy motorových vozidiel v letnom období. Plní sa do zásobnej nádržky ostrekovača a podľa potreby sa aplikuje n a čelné sklo automobilu.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500045,
    brand: "DYNAMAX",
    image: "img11003",
    src: "11003.jpg",
    name: "DYNAMAX 240 DOT3 0,5L",
    short_desc:
      "Brzdová kvapalina je určená ako náplň do všetkých brzdových spojkových a ďalších hydraulických systémov a mechanizmov. Je miešateľná s inými brzdovými kvapalinami zodpovedajúcej triedy.",
    desc: "Brzdová kvapalina je určená ako náplň do všetkých brzdových spojkových a ďalších hydraulických systémov a mechanizmov. Je miešateľná s inými brzdovými kvapalinami zodpovedajúcej triedy. DOT3 – určená pre prevádzku v teplotnom rozmedzí -50 °C až 24 0 ° C. Číra kvapalina s nádychom žltej farby štiplavej arómy. Používa sa neriedený.",
    ean: 8588001502133,
    package: 16,
    type: "olej",
    sub_category: "brzdovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500046,
    brand: "DYNAMAX",
    image: "img6599",
    src: "6599.jpg",
    name: "DYNAMAX 240 DOT3 4L",
    short_desc:
      "Brzdová kvapalina je určená ako náplň do všetkých brzdových spojkových a ďalších hydraulických systémov a mechanizmov. Je miešateľná s inými brzdovými kvapalinami zodpovedajúcej triedy.",
    desc: "Brzdová kvapalina je určená ako náplň do všetkých brzdových spojkových a ďalších hydraulických systémov a mechanizmov. Je miešateľná s inými brzdovými kvapalinami zodpovedajúcej triedy. DOT3 – určená pre prevádzku v teplotnom rozmedzí -50 °C až 24 0 °C. Číra kvapalina s nádychom žltej farby štiplavej arómy. Používa sa neriedený.",
    ean: 8588001502140,
    package: 3,
    type: "olej",
    sub_category: "brzdovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500047,
    brand: "DYNAMAX",
    image: "img6600",
    src: "6600.jpg",
    name: "DYNAMAX 265 DOT4 0,5L",
    short_desc:
      "Brzdová kvapalina pre hydraulické brzdové systémy motorových vozidiel je určená pre prevádzku v teplotnom rozmedzí -50 °C až 260 °C.",
    desc: "Brzdová kvapalina pre hydraulické brzdové systémy motorových vozidiel je určená pre prevádzku v teplotnom rozmedzí -50 °C až 260 °C. Prípravok vysokej kvality zaručuje bezpečné a presné brzdenie, nepoškodzuje gumu a kov, je určený pre kotúčové a b ubnové brzdy. Má dobrú tepelnú stabilitu, výbornú ochranu proti korózii železných aj neželezných kovov. Možno miešať s brzdovými kvapalinami, ktoré zdopovedajú normám ISO 4925, SAE J 1703 FM VSS 571-116 DOT 3 a DOT 4, VW TL 766, t.j. s brzdovými kv apalinymi rovnakej špecifikácie. Číra kvapalina s nádychom žltej farby štiplavej arómy. Používa sa neriedený.",
    ean: 8588001502157,
    package: 16,
    type: "olej",
    sub_category: "brzdovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500048,
    brand: "DYNAMAX",
    image: "img6601",
    src: "6601.jpg",
    name: "DYNAMAX 265 DOT4 4L",
    short_desc:
      "Brzdová kvapalina pre hydraulické brzdové systémy motorových vozidiel je určená pre prevádzku v teplotnom rozmedzí -50 °C až 260 °C.",
    desc: "Brzdová kvapalina pre hydraulické brzdové systémy motorových vozidiel je určená pre prevádzku v teplotnom rozmedzí -50 °C až 260 °C. Prípravok vysokej kvality zaručuje bezpečné a presné brzdenie, nepoškodzuje gumu a kov, je určený pre kotúčové a b ubnové brzdy. Má dobrú tepelnú stabilitu, výbornú ochranu proti korózii železných aj neželezných kovov. Možno miešať s brzdovými kvapalinami, ktoré zdopovedajú normám ISO 4925, SAE J 1703 FM VSS 571-116 DOT 3 a DOT 4, VW TL 766, t.j. s brzdovými kvap alinymi rovnakej špecifikácie. Číra kvapalina s nádychom žltej farby štiplavej arómy. Používa sa neriedený.",
    ean: 8588001502324,
    package: 3,
    type: "olej",
    sub_category: "brzdovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500051,
    brand: "DYNAMAX",
    image: "img11006",
    src: "11006.jpg",
    name: "DYNAMAX COOL 10 10L",
    short_desc:
      "Koncentrovaná nízkotuhnúca chladiaca kvapalina na báze etylénglykolu je určená pre všetky typy starších motorových vozidiel, poľnohospodárske a stavebné stroje. Celoročne chráni chladiaci systém pred koróziou a zabraňuje prehriatiu motorov letných mesiacoch.",
    desc: "Koncentrovaná nízkotuhnúca chladiaca kvapalina na báze etylénglykolu je určená pre všetky typy starších motorových vozidiel, poľnohospodárske a stavebné stroje. Celoročne chráni chladiaci systém pred koróziou a zabraňuje prehriatiu motorov v letný ch mesiacoch. Odporúčaná výmena je po troch rokoch. Výrobca zabezpečuje konzultácie a neručí za škody spôsobené nesprávnym použitím výrobku. Plní sa do čistého chladiaceho systému podľa pokynov výrobcu automobilu. Je riediteľná pitnou alebo demineralizovanou vodou na požadovaný bod tuhnutia podľa určených pomerov výrobcu. Chladiaca kvapalina DYNAMAX COOLANT G10 je miešateľná s nízkotuhnúcimi kvapalinami na báze monoetylénglykolu (etylénglykolu a propylénglykolu).",
    ean: 8588002690495,
    package: "",
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500070,
    brand: "DYNAMAX",
    image: "img51990",
    src: "51990.jpg",
    name: "DYNAMAX ZIMNÉ ADITÍVUM DO NAFTY 500ML 1:1000",
    short_desc:
      "Zlepšené prietokové a mazacie vlastnosti. Prevencia voči parafínovým krištáľom až do -28°C. Zaisťuje zlepšenie prietokových vlastností motorovej nafty. Balenie 500 ml na 500 l nafty. Používať počas zimného obdobia pri tankovaní.",
    desc: "Zlepšené prietokové a mazacie vlastnosti. Prevencia voči parafínovým krištáľom až do -28°C. Zaisťuje zlepšenie prietokových vlastností motorovej nafty. Balenie 500 ml na 500 l nafty. Používať počas zimného obdobia pri tankovaní.",
    ean: 8588001502614,
    package: 6,
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500073,
    brand: "DYNAMAX",
    image: "img102757",
    src: "102757.jpg",
    name: "DYNAMAX LETNÁ ZMES 3L CITRON",
    short_desc:
      "DYNAMAX letná zmes 1:2 je vysokoúčinný prostriedok pre odstránenie zbytkov hmyzu a všetkých bežných nečistôt zo skla automobilu. Koncentrát obsahuje aktívnu látku, ktorá predstavuje úplne nový spôsob údržby. Znižuje námahu spojenú s čistením okien. Sklo zanecháva dokonale čisté.",
    desc: "DYNAMAX letná zmes 1:2 je vysokoúčinný prostriedok pre odstránenie zbytkov hmyzu a všetkých bežných nečistôt zo skla automobilu. Koncentrát obsahuje aktívnu látku, ktorá predstavuje úplne nový spôsob údržby. Znižuje námahu spojenú s čistením okien. Sklo zanecháva dokonale čisté. Je biologicky odbúrateľný. DYNAMAX letná zmes je určený na použitie ako náplň do ostrekovačov pre všetky typy motorových vozidiel v letnom období. Plní sa do zásobnej nádržky ostrekovača a podľa potreby sa aplikuje n a čelné sklo automobilu.",
    ean: 8586016010483,
    package: 4,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500105,
    brand: "DYNAMAX",
    image: "img6610",
    src: "6610.jpg",
    name: "DYNAMAX LETNÁ ZMES 5L CITRON",
    short_desc:
      "DYNAMAX letná zmes 1:2 je vysokoúčinný prostriedok pre odstránenie zbytkov hmyzu a všetkých bežných nečistôt zo skla automobilu. Koncentrát obsahuje aktívnu látku, ktorá predstavuje úplne nový spôsob údržby. Znižuje námahu spojenú s čistením okien .",
    desc: "DYNAMAX letná zmes 1:2 je vysokoúčinný prostriedok pre odstránenie zbytkov hmyzu a všetkých bežných nečistôt zo skla automobilu. Koncentrát obsahuje aktívnu látku, ktorá predstavuje úplne nový spôsob údržby. Znižuje námahu spojenú s čistením okien. Sklo zanecháva dokonale čisté. Je biologicky odbúrateľný. DYNAMAX letná zmes je určený na použitie ako náplň do ostrekovačov pre všetky typy motorových vozidiel v letnom období. Plní sa do zásobnej nádržky ostrekovača a podľa potreby sa aplikuje n a čelné sklo automobilu.",
    ean: 8586016010438,
    package: 3,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500106,
    brand: "DYNAMAX",
    image: "img6611",
    src: "6611.jpg",
    name: "DYNAMAX COOL 10 200L",
    short_desc:
      "Koncentrovaná nízkotuhnúca chladiaca kvapalina na báze etylénglykolu je určená pre všetky typy starších motorových vozidiel, poľnohospodárske a stavebné stroje. Celoročne chráni chladiaci systém pred koróziou a zabraňuje prehriatiu motorov v letných mesiacoch.",
    desc: "Koncentrovaná nízkotuhnúca chladiaca kvapalina na báze etylénglykolu je určená pre všetky typy starších motorových vozidiel, poľnohospodárske a stavebné stroje. Celoročne chráni chladiaci systém pred koróziou a zabraňuje prehriatiu motorov v letný ch mesiacoch. Odporúčaná výmena je po troch rokoch. Výrobca zabezpečuje konzultácie a neručí za škody spôsobené nesprávnym použitím výrobku. Plní sa do čistého chladiaceho systému podľa pokynov výrobcu automobilu. Je rieditelná pitnou alebo demineralizovanou vodou na požadovaný bod tuhnutia podľa určených pomerov výrobcu. Chladiaca kvapalina DYNAMAX COOLANT G10 je miešatelná s nízkotuhnúcimi kvapalinami na báze monoetylénglykolu (etylénglykolu a propylénglykolu).",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500109,
    brand: "DYNAMAX",
    image: "img107981",
    src: "107981.jpg",
    name: "DYNAMAX COOL 11 AL 4L",
    short_desc:
      "Nízkotuhnúca zmes do chladičov automobilov na báze monoetylénglykolu s antikoróznymi prí-sadami je zvlášť vhodná pre chladiace sústavy spaľovacích motorov z ľahkých zliatín. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou.",
    desc: "Nízkotuhnúca zmes do chladičov automobilov na báze monoetylénglykolu s antikoróznymi prísadami je zvlášť vhodná pre chladiace sústavy spaľovacích motorov z ľahkých zliatin. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Prípravok neobsahuje dusitany, amíny a fosfáty. Plní sa do čistého chladiaceho systému podľa pokynov výrobcu automobilu. Je rieditelná pitnou alebo demineralizovanou vodou na požadovaný bod tuhnutia podľa doporučených pomerov výrobcu. Chladiaca kvapalina DYNAMAX COOLANT AL G11 je miešatelná s nízkotuhnúcimi kvapalinami na báze monoetylénglykolu (etylén-glykolu a propylénglykolu).",
    ean: 8588002690464,
    package: 3,
    type: "doplnok",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500111,
    brand: "DYNAMAX",
    image: "img11015",
    src: "11015.jpg",
    name: "DYNAMAX SCREENWASH -20 50L CITRON",
    short_desc:
      "Je vysoko účinná, celoročná mrazuvzdorná kvapalina do všetkých typov ostrekovačov motorových vozidiel. DYNAMAX Screenwash -20 °C je nemrznúca kvapalina do ostrekovačov automobilov.",
    desc: "Je vysoko účinná, celoročná mrazuvzdorná kvapalina do všetkých typov ostrekovačov motorových vozidiel. DYNAMAX Screenwash -20 °C je nemrznúca kvapalina do ostrekovačov automobilov. Spoľahlivo odstraňuje zo skla automobilu mastnotu a iné nečistoty. Chráni ostrekovací systém pred zamŕzaním a vytváraním vodného kameňa. Zlepšuje viditeľnosť počas nepriaznivého zimného počasia. DYNAMAX Screenwash -20 °C sa používa neriedený alebo po nariedeni podľa tabuľky.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500116,
    brand: "DYNAMAX",
    image: "img25833",
    src: "25833.jpg",
    name: "DYNAMAX LIEH DENATUROVANÝ 1 L",
    short_desc:
      "Používa sa do liehových varičov, na svietenie, kúrenie, čistenie a odmasťovanie.",
    desc: "Lieh je určený do liehových varičov, na horenie a na svietenie. Používa sa taktiež na čistenie a odmasťovanie. Obsah etanolu je min. 90% obj. Roztok alkoholu, denaturačných činidiel a vody.",
    ean: 8588002690570,
    package: 8,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500117,
    brand: "DYNAMAX",
    image: "img6614",
    src: "6614.jpg",
    name: "DYNAMAX 25L DEMINERALIZOVANÁ TECHNICKÁ VODA",
    short_desc:
      "Demineralizovaná technická voda určená na riedenie koncentrátov nemrznúcich a letných zmesí do ostrekovačov DYNAMAX a všetkých typov chladiacich kvapalín DYNAMAX. Je vhodná na použitie do akumulátorov, žehličiek alebo fotolaboratórií.",
    desc: "Demineralizovaná technická voda určená na riedenie koncentrátov nemrznúcich a letných zmesí do ostrekovačov DYNAMAX a všetkých typov chladiacich kvapalín DYNAMAX. Je vhodná na použitie do akumulátorov, žehličiek alebo fotolaboratórií.",
    ean: 8586016011886,
    package: "",
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500118,
    brand: "DYNAMAX",
    image: "img6615",
    src: "6615.jpg",
    name: "DYNAMAX 50L DEMINERALIZOVANÁ TECHNICKÁ VODA",
    short_desc:
      "Demineralizovaná technická voda určená na riedeniekoncentrátov nemrznúcich a letných zmesí do ostrekovačov DYNAMAX a všetkých typov chladiacich kvapalín DYNAMAX. Je vhodná na použitie do akumulátorov, žehličiek alebo fotolaboratórií.",
    desc: "Demineralizovaná technická voda určená na riedenie koncentrátov nemrznúcich a letných zmesí do ostrekovačov DYNAMAX a všetkých typov chladiacich kvapalín DYNAMAX. Je vhodná na použitie do akumulátorov, žehličiek alebo fotolaboratórií.",
    ean: 8586016011893,
    package: "",
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500137,
    brand: "DYNAMAX",
    image: "img6617",
    src: "6617.jpg",
    name: "DYNAMAX 1L DEMINERALIZOVANÁ TECHNICKÁ VODA",
    short_desc:
      "Demineralizovaná technická voda DYNAQUA je určená na riedenie koncentrátov DYNASTIC - nízkotuhnúcich zmesí do ostrekovačov, na riedenie koncentrátov DYNAMAX G10, DYNAMAX AL G11, DYNAMAX ULTRA G12 - nízko tuhnúcich chladiacich kvapalín, pre dopĺňanie do akumulátorov, do chladičov, do naparovacích žehličiek, do fotolaboratórií...",
    desc: "Demineralizovaná technická voda DYNAQUA je určená na riedenie koncentrátov DYNASTIC - nízkotuhnúcich zmesí do ostrekovačov, na riedenie koncentrátov DYNAMAX G10, DYNAMAX AL G11, DYNAMAX ULTRA G12 - nízko tuhnúcich chladiacich kvapalín, pre dopĺňanie do akumulátorov, do chladičov, do naparovacích žehličiek, do fotolaboratórií...",
    ean: 8588001502010,
    package: 8,
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500138,
    brand: "DYNAMAX",
    image: "img68971",
    src: "68971.jpg",
    name: "DYNAMAX 2L DEMINERALIZOVANÁ TECHNICKÁ VODA",
    short_desc:
      "Demineralizovaná technická voda určená na riedenie koncentrátov nemrznúcich a letných zmesí do ostrekovačov DYNAMAX a všetkých typov chladiacich kvapalín DYNAMAX. Je vhodná na použitie do akumulátorov, žehličiek alebo fotolaboratórií.",
    desc: "Demineralizovaná technická voda určená na riedenie koncentrátov nemrznúcich a letných zmesí do ostrekovačov DYNAMAX a všetkých typov chladiacich kvapalín DYNAMAX. Je vhodná na použitie do akumulátorov, žehličiek alebo fotolaboratórií.",
    ean: 8588001502027,
    package: 4,
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500139,
    brand: "DRACO",
    image: "img6619",
    src: "6619.jpg",
    name: "DRACO ČISTIČ NA KRBY, GRIL, RÚRY 500ML",
    short_desc:
      "Prípravok sa používa na odstraňovanie pripálenín olejov, čistenie skiel krbov, čistenie grilov a rúr. Môže byť použitý aj na ručné čistenie podláh od zvyškov gúm, cestnej špiny a podobne.",
    desc: "Prípravok sa používa na odstraňovanie pripálenín olejov, čistenie skiel krbov, čistenie grilov a rúr. Môže byť použitý aj na ručné čistenie podláh od zvyškov gúm, cestnej špiny a podobne.",
    ean: 8586016010414,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500140,
    brand: "DYNAMAX",
    image: "img107982",
    src: "107982.jpg",
    name: "DYNAMAX COOL 10 4L",
    short_desc:
      "Koncentrovaná nízkotuhnúca chladiaca kvapalina na báze etylénglykolu je určená pre všetky typy starších motorových vozidiel, poľnohospodárske a stavebné stroje. Celoročne chráni chladiaci systém pred koróziou a zabraňuje prehriatiu motorov v letných mesiacoch. Odporúčaná výmena je po troch rokoch. Výrobca zabezpečuje konzultácie a neručí za škody spôsobené nesprávnym použitím výrobku.",
    desc: "Koncentrovaná nízkotuhnúca chladiaca kvapalina na báze etylénglykolu je určená pre všetky typy starších motorových vozidiel, poľnohospodárske a stavebné stroje. Celoročne chráni chladiaci systém pred koróziou a zabraňuje prehriatiu motorov v letných mesiacoch. Odporúčaná výmena je po troch rokoch. Výrobca zabezpečuje konzultácie a neručí za škody spôsobené nesprávnym použitím výrobku. Plní sa do čistého chladiaceho systému podľa pokynov výrobcu automobilu. Je rieditelná pitnou alebo demineralizovanou vodou na požadovaný bod tuhnutia podľa určených pomerov výrobcu. Chladiaca kvapalina DYNAMAX COOLANT G10 je miešatelná s nízkotuhnúcimi kvapalinami na báze monoetylénglykolu (etylénglykolu a propylénglykolu).",
    ean: 8588002690440,
    package: 3,
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500143,
    brand: "DYNAMAX",
    image: "img107983",
    src: "107983.jpg",
    name: "DYNAMAX COOL 12 ULTRA 1L",
    short_desc:
      "Koncentrovaná nízkotuhnúca chladiaca kvapalina určená pre najmodernejšie druhy motorov.DYNAMAX ULTRA G12 je vysoko kvalitná nízkotuhnúca zmes vyrobená z monoetylénglykolu s vysoko progresívnymi antikoróznymi prísadami, zvlášť vhodná pre chladiče moderných hliníkových a zliatinových chladiacich sústav spaľovacích motorov.",
    desc: "Koncentrovaná nízkotuhnúca chladiaca kvapalina určená pre najmodernejšie druhy motorov.DYNAMAX ULTRA G12 je vysoko kvalitná nízkotuhnúca zmes vyrobená z monoetylénglykolu s vysoko progresívnymi antikoróznymi prísadami, zvlášť vhodná pre chladiče moderných hliníkových a zliatinových chladiacich sústav spaľovacích motorov. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. V roku 2008 získala chladiaca kvapalina DYNAMAX ULTRA G12 prestížne ocenenie Zlatú medailu a Certifikát ochrannej známky kvality Slovak Gold. Obsahuje látku brániacu požitiu chladiacej kvapaliny.",
    ean: 8588002690471,
    package: 12,
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500144,
    brand: "DYNAMAX",
    image: "img107984",
    src: "107984.jpg",
    name: "DYNAMAX COOL 12 ULTRA 4L",
    short_desc:
      "DYNAMAX COOLANT ULTRA G12 je koncentrovaná nízkotuhnúca chladiaca kvapalina určená pre najmodernejšie druhy motorov. Je vysoko kvalitná nízkotuhnúca zmes vyrobená z monoetylénglykolu s vysoko progresívnymi antikoróznymi prísadami, zvlášť vhod ná pre chladiče moderných hliníkových a zliatinových chladiacich sústav spaľovacích motorov.",
    desc: "DYNAMAX COOLANT ULTRA G12 je koncentrovaná nízkotuhnúca chladiaca kvapalina určená pre najmodernejšie druhy motorov. Je vysoko kvalitná nízkotuhnúca zmes vyrobená z monoetylénglykolu s vysoko progresívnymi antikoróznymi prísadami, zvlášť vhod ná pre chladiče moderných hliníkových a zliatinových chladiacich sústav spaľovacích motorov. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. V roku 2008 získala chladiaca kvapalina DYNAMAX COOLANT ULTRA G12 prestížne ocenenie Zlatú medailu a Certifikát ochrannej známky kvality Slovak Gold. Obsahuje látku brániacu požitiu chladiacej kvapaliny. Plní sa do čistého chladiaceho systému podľa pokynov výrobcu automobilu. Je riediteľná pitnou alebo demineralizovanou vodou na požadovaný bod tuhnutia podľa učených pomerov výrobcu. DYNAMAX COOLANT ULTRA G12 chladiaca kvapalina je miešateľná s nízkotuhnúcimi kvapalinami na báze monoetylén-glykolu (etylénglykolu a propylén glykolu).",
    ean: 8588002690488,
    package: 3,
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500152,
    brand: "DYNAMAX",
    image: "img11008",
    src: "11008.jpg",
    name: "DYNAMAX COOL 10 25L",
    short_desc:
      "Koncentrovaná nízkotuhnúca chladiaca kvapalina na báze etylénglykolu je určená pre všetky typy starších motorových vozidiel, poľnohospodárske a stavebné stroje. Celoročne chráni chladiaci systém pred koróziou a zabraňuje prehriatiu motorov v letných mesiacoch. Odporúčaná výmena je po troch rokoch.",
    desc: "Koncentrovaná nízkotuhnúca chladiaca kvapalina na báze etylénglykolu je určená pre všetky typy starších motorových vozidiel, poľnohospodárske a stavebné stroje. Celoročne chráni chladiaci systém pred koróziou a zabraňuje prehriatiu motorov v letných mesiacoch. Odporúčaná výmena je po troch rokoch. Výrobca zabezpečuje konzultácie a neručí za škody spôsobené nesprávnym použitím výrobku. Plní sa do čistého chladiaceho systému podľa pokynov výrobcu automobilu. Je rieditelná pitnou alebo demineralizovanou vodou na požadovaný bod tuhnutia podľa určených pomerov výrobcu. Chladiaca kvapalina DYNAMAX COOLANT G10 je miešatelná s nízkotuhnúcimi kvapalinami na báze monoetylénglykolu (etylénglykolu a propylénglykolu).",
    ean: 8586011471333,
    package: "",
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500158,
    brand: "DYNAMAX",
    image: "img107985",
    src: "107985.jpg",
    name: "DYNAMAX COOL 12++ ULTRA 1L",
    short_desc:
      "DYNAMAX COOLANT ULTRA G12 ++ je vhodný do chladičov hliníkových a liatinových chladiacich sústav spaľovacích motorov u najnovších automobilov. Základnou funkciou je veľmi dobrý prevod tepla a ochrana motora prípadne chladiacej sústavy.",
    desc: "DYNAMAX COOLANT ULTRA G12 ++ je vhodný do chladičov hliníkových a liatinových chladiacich sústav spaľovacích motorov u najnovších automobilov. Základnou funkciou je veľmi dobrý prevod tepla a ochrana motora prípadne chladiacej sústavy. Inhibítor korózie pre DYNAMAX COOLANT ULTRA G12 ++ obsahuje navyše kremičitany, ktoré plnia funkciu maximálnej ochrany (hlavne pri autách s vysokou mierou záťaže, napr. športové autá).",
    ean: 8586016011824,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500160,
    brand: "DYNAMAX",
    image: "img107986",
    src: "107986.jpg",
    name: "DYNAMAX COOL 12++ ULTRA 4L",
    short_desc:
      "DYNAMAX COOLANT ULTRA G12 ++ je vhodný do chladičov hliníkových a liatinových chladiacich sústav spaľovacích motorov u najnovších automobilov. Základnou funkciou je veľmi dobrý prevod tepla a ochrana motora prípadne chladiacej sústavy.",
    desc: "DYNAMAX COOLANT ULTRA G12 ++ je vhodný do chladičov hliníkových a liatinových chladiacich sústav spaľovacích motorov u najnovších automobilov. Základnou funkciou je veľmi dobrý prevod tepla a ochrana motora prípadne chladiacej sústavy. Inhibítor korózie pre DYNAMAX COOLANT ULTRA G12 ++ obsahuje navyše kremičitany, ktoré plnia funkciu maximálnej ochrany (hlavne pri autách s vysokou mierou záťaže, napr. športové autá).",
    ean: 8586016011831,
    package: 3,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500161,
    brand: "DYNAMAX",
    image: "img6628",
    src: "6628.jpg",
    name: "DYNAMAX SCREENWASH -40 50L CITRON",
    short_desc:
      "Nemrznúci koncentrát je vysokoúčinná náplň do ostrekovačov automobilov. Zo skla automobilu spoľahlivo odstraňuje mastnotu a iné nečistoty. Chráni ostrekovací systém pred zamŕzaním až do -40°C a vytváraním vodného kameňa. Zlepšuje viditeľnosť počas nepriaznivého počasia. Spríjemňuje jazdu. Zvyšuje bezpečnosť jazdy v zimnom období.",
    desc: "Nemrznúci koncentrát je vysokoúčinná náplň do ostrekovačov automobilov. Zo skla automobilu spoľahlivo odstraňuje mastnotu a iné nečistoty. Chráni ostrekovací systém pred zamŕzaním až do -40°C a vytváraním vodného kameňa. Zlepšuje viditeľnosť počas nepriaznivého počasia. Spríjemňuje jazdu. Zvyšuje bezpečnosť jazdy v zimnom období. Kvapalina do ostrekovačov sa plní do zásobnej nádržky ostrekovača a podľa potreby sa aplikuje na čelné sklo automobilu, pri slabších mrazoch sa riedi podľa tabuľky. Pri riedení odporúčame použiť demineralizovanú vodu DYNAMAX alebo kvalitnú pitnú vodu.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500162,
    brand: "DYNAMAX",
    image: "img6629",
    src: "6629.jpg",
    name: "DYNAMAX COOL 11 ULTRA AL 10L",
    short_desc:
      "Nízkotuhnúca zmes do chladičov automobilov na báze monoetylénglykolu s antikoróznymi prísadami je zvlášť vhodná pre chladiace sústavy spaľovacích motorov z ľahkých zliatín. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Prípravok neobsahuje dusitany, amíny a fosfáty.",
    desc: "Nízkotuhnúca zmes do chladičov automobilov na báze monoetylénglykolu s antikoróznymi prísadami je zvlášť vhodná pre chladiace sústavy spaľovacích motorov z ľahkých zliatín. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Prípravok neobsahuje dusitany, amíny a fosfáty. Plní sa do čistého chladiaceho systému podľa pokynov výrobcu automobilu. Je riediteľná pitnou alebo demineralizovanou vodou na požadovaný bod tuhnutia podľa doporučených pomerov výrobcu. Chladiaca kvapalina DYNAMAX COOLANT AL G11 je miešateľná s nízkotuhnúcimi kvapalinami na báze monoetylénglykolu (etylén-glykolu a propylénglykolu).",
    ean: 8586011471296,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500169,
    brand: "DYNAMAX",
    image: "img27457",
    src: "27457.jpg",
    name: "DYNAMAX MG-M2T SUPER SAE40/50 0,25L",
    short_desc:
      "DYNAMAX M2T je ur čený na vozidlá a motocykle s dvojtaktnými motormi, na motory motorových a reťazových píl, na motory motorových sekačiek.",
    desc: "DYNAMAX M2T je ropný olej pre dvojtaktné motory. Vyznačuje sa vynikajúcimi úžitkovými vlastnosťami, garantuje výbornú ochranu pred opotrebovaním, je veľmi dobre miešateľný s palivom a má veľmi dobré protikorózne vlastnosti.",
    ean: 8588002690099,
    package: 24,
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500170,
    brand: "DYNAMAX",
    image: "img11629",
    src: "11629.jpg",
    name: "DYNAMAX M2T SUPER 0,5 L",
    short_desc:
      "Olej pre dvojtaktné benzínové motory DYNAMAX M2T SUPER je ropný olej vyrobený modernou technológiou, obsahujúci prísady potláčajúce tvorbu usadenín v piestnych drážkach, na výfukových kanáloch a na elektródach sviečok, ako aj prísady zlepšujúce mazacie schopnosti oleja.",
    desc: "Olej pre dvojtaktné benzínové motory DYNAMAX M2T SUPER je ropný olej vyrobený modernou technológiou, obsahujúci prísady potláčajúce tvorbu usadenín v piestnych drážkach, na výfukových kanáloch a na elektródach sviečok, ako aj prísady zlepšujúce mazacie schopnosti oleja.Olej na celoročné mazanie vysoko tepelne zaťažených dvojtaktných motorov mazaných zmesou oleja s benzínom. Vhodný na mazanie náročných automobilov.",
    ean: 8588002690105,
    package: 16,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500171,
    brand: "DYNAMAX",
    image: "img14751",
    src: "14751.jpg",
    name: "DYNAMAX MG-M2T SUPER 1L",
    short_desc:
      "DYNAMAX M2T je ropný olej pre dvojtaktné motory. Vyznačuje sa vynikajúcimi úžitkovými vlastnosťami, garantuje výbornú ochranu pred opotrebovaním, je veľmi dobre miešateľný s palivom a má veľmi dobré protikorózne vlastnosti.",
    desc: "DYNAMAX M2T je ropný olej pre dvojtaktné motory. Vyznačuje sa vynikajúcimi úžitkovými vlastnosťami, garantuje výbornú ochranu pred opotrebovaním, je veľmi dobre miešateľný s palivom a má veľmi dobré protikorózne vlastnosti. DYNAMAX M2T je určený n a vozidlá a motocykle s dvojtaktnými motormi, na motory motorových a reťazových píl, na motory motorových sekačiek rôzneho typu a na rôzne pomôcky do záhrady vybavené dvojtaktnými motormi.",
    ean: 8588002690112,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500181,
    brand: "DYNAMAX",
    image: "img6640",
    src: "6640.jpg",
    name: "DYNAMAX M6AD 10L",
    short_desc:
      "Letný motorový olej na mazanie benzínových a nepreplňovaných naftových štvortaktných motorov, najmä starších typov, v nenáročných prevádzkových podmienkach. Automobilový motorový olej DYNAMAX M6AD sa používa predovšetkým pre staršie typy nákladných automobilov a ľahkých dodávkových automobilov.",
    desc: "Letný motorový olej na mazanie benzínových a nepreplňovaných naftových štvortaktných motorov, najmä starších typov, v nenáročných prevádzkových podmienkach. Automobilový motorový olej DYNAMAX M6AD sa používa predovšetkým pre staršie typy nákladných automobilov a ľahkých dodávkových automobilov.",
    ean: 8588001502898,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500182,
    brand: "DYNAMAX",
    image: "img6641",
    src: "6641.jpg",
    name: "DYNAMAX M6AD 20L",
    short_desc:
      "Letný motorový olej na mazanie benzínových a nepreplňovaných naftových štvortaktných motorov, najmä starších typov, v nenáročných prevádzkových podmienkach. Automobilový motorový olej DYNAMAX M6AD sa používa predovšetkým pre staršie typy nákladných automobilov a ľahkých dodávkových automobilov.",
    desc: "Letný motorový olej na mazanie benzínových a nepreplňovaných naftových štvortaktných motorov, najmä starších typov, v nenáročných prevádzkových podmienkach. Automobilový motorový olej DYNAMAX M6AD sa používa predovšetkým pre staršie typy nákladných automobilov a ľahkých dodávkových automobilov.",
    ean: 8588001502904,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500184,
    brand: "DYNAMAX",
    image: "img6643",
    src: "6643.jpg",
    name: "DYNAMAX M7ADX 10L",
    short_desc:
      "Univerzálny automobilový motorový olej DYNAMAX M7ADX je zvlášť vhodný pre staršie typy osobných automobilov LADA a DACIA. Celoročný univerzálny motorový olej určený na mazanie všetkých benzínových štvortaktných motorov.",
    desc: "Univerzálny automobilový motorový olej DYNAMAX M7ADX je zvlášť vhodný pre staršie typy osobných automobilov LADA a DACIA. Celoročný univerzálny motorový olej určený na mazanie všetkých benzínových štvortaktných motorov. Možno ho tiež použiť na mazanie štvortaktných naftových motorov. DYNAMAX M7ADX obsahuje prísady, ktoré ho robia optimálnym pre stredoeurópske pásmo.",
    ean: 8588002690020,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500185,
    brand: "DYNAMAX",
    image: "img6644",
    src: "6644.jpg",
    name: "DYNAMAX T-M6ADSII SAE30 10L",
    short_desc:
      "Motorový olej DYNAMAX M6ADSII sa používa na mazanie automobilových, traktorových, lodných a stacionárnych naftových motorov moderných konštrukcií. Vhodný na mazanie náročných druhov nepreplňovaných a preplňovaných naftových štvortaktných motorov, pracujúcich za sťažených podmienok, najmä v prechodnom a letnom období.",
    desc: "Motorový olej DYNAMAX M6ADSII sa používa na mazanie automobilových, traktorových, lodných a stacionárnych naftových motorov moderných konštrukcií. Motorový olej na mazanie náročných druhov nepreplňovaných a preplňovaných naftových štvortaktných motorov, pracujúcich za sťažených podmienok, najmä v prechodnom a letnom období.",
    ean: 8588001502911,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500186,
    brand: "DYNAMAX",
    image: "img6645",
    src: "6645.jpg",
    name: "DYNAMAX M7AD SIII 10L",
    short_desc:
      "DYNAMAX M7ADSIII sa používa predovšetkým v nákladnej automobilovej doprave, v mestskej a diaľkovej autobusovej doprave, v lodnej doprave a v železničnej doprave. Celoročný motorový olej určený pre štvortaktné naftové motory preplňované aj nepreplňované. Vysoká kvalita oleja je garantovaná použitím kvalitného základového oleja.",
    desc: "DYNAMAX M7ADSIII sa používa predovšetkým v nákladnej automobilovej doprave, v mestskej a diaľkovej autobusovej doprave, v lodnej doprave a v železničnej doprave. Celoročný motorový olej určený pre štvortaktné naftové motory preplňované aj nepreplňované. Vysoká kvalita oleja je garantovaná použitím kvalitného základového oleja a starostlivo vyváženou kombináciou viskozitných, antioxidačných, detergentných a iných prísad. Umožňuje veľmi dobré štartovanie motorov pri nízkych teplotách a zároveň má značnú rezervu viskozity pre letné obdobie.",
    ean: 8588001502942,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500188,
    brand: "DYNAMAX",
    image: "img6647",
    src: "6647.jpg",
    name: "DYNAMAX PP 80 4L",
    short_desc:
      "Prevodový olej DYNAMAX PP 80 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov vystavených nízkym teplotám. Prevodový olej DYNAMAX PP80 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu.",
    desc: "Prevodový olej DYNAMAX PP 80 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov vystavených nízkym teplotám. Prevodový olej DYNAMAX PP80 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Prevodový olej Dynamax PP 80 je vhodný do prevodoviek vozidiel TATRA 148 a 815, PRAGA V3S a S5T.",
    ean: 8588002690167,
    package: 3,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500189,
    brand: "DYNAMAX",
    image: "img6648",
    src: "6648.jpg",
    name: "DYNAMAX PP 80 10L",
    short_desc:
      "Prevodový olej DYNAMAX PP 80 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov vystavených nízkym teplotám. Prevodový olej DYNAMAX PP80 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu.",
    desc: "Prevodový olej DYNAMAX PP 80 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov vystavených nízkym teplotám. Prevodový olej DYNAMAX PP80 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Prevodový olej Dynamax PP 80 je vhodný do prevodoviek vozidiel TATRA 148 a 815, PRAGA V3S a S5T.",
    ean: 8588002690174,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500191,
    brand: "DYNAMAX",
    image: "img6650",
    src: "6650.jpg",
    name: "DYNAMAX PP 90 4L",
    short_desc:
      "Prevodový olej DYNAMAX PP90 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Prevodový olej DYNAMAX PP 90 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov, ktoré majú predpísaný olej s vyššou viskozitou.",
    desc: "Prevodový olej DYNAMAX PP 90 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Prevodový olej DYNAMAX PP 90 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov, ktoré majú predpísaný olej s vyššou viskozitou. Prevodový olej Dynamax PP 90 je vhodný do prevodoviek vozidiel AVIA 21 a 31, LIAZ, KAROSA, IKARUS 280.",
    ean: 8588002690198,
    package: 3,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500192,
    brand: "DYNAMAX",
    image: "img6651",
    src: "6651.jpg",
    name: "DYNAMAX PP 90 10L",
    short_desc:
      "Prevodový olej DYNAMAX PP 90 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Prevodový olej DYNAMAX PP 90 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov, ktoré majú predpísaný olej s vyššou viskozitou.",
    desc: "Prevodový olej DYNAMAX PP 90 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Prevodový olej DYNAMAX PP 90 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov, ktoré majú predpísaný olej s vyššou viskozitou. Prevodový olej Dynamax PP 90 je vhodný do prevodoviek vozidiel AVIA 21 a 31, LIAZ, KAROSA, IKARUS 280.",
    ean: 8588002690204,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500193,
    brand: "DYNAMAX",
    image: "img6652",
    src: "6652.jpg",
    name: "DYNAMAX PP 90 20L",
    short_desc:
      "Prevodový olej DYNAMAX PP 90 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Prevodový olej DYNAMAX PP 90 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov, ktoré majú predpísaný olej s vyššou viskozitou.",
    desc: "Prevodový olej DYNAMAX PP 90 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Prevodový olej DYNAMAX PP 90 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov, ktoré majú predpísaný olej s vyššou viskozitou. Prevodový olej Dynamax PP 90 je vhodný do prevodoviek vozidiel AVIA 21 a 31, LIAZ, KAROSA, IKARUS 280.",
    ean: 8588001502294,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500194,
    brand: "DYNAMAX",
    image: "img6653",
    src: "6653.jpg",
    name: "DYNAMAX OTHP 32 10L",
    short_desc:
      "DYNAMAX OTHP 32 je ropný olej s prídavkom výkonnostnej prísady a modifikátorom viskozity s depresantným účinkom. Je vhodný na mazanie automatických prevodoviek, posilňovačov bŕzd a riadenia. Tiež je vhodný ako náplň hydrodynamických sústav autobus ov, stavebných strojov, vysokozdvižných vozíkov a pod.",
    desc: "DYNAMAX OTHP 32 je ropný olej s prídavkom výkonnostnej prísady a modifikátorom viskozity s depresantným účinkom. Je vhodný na mazanie automatických prevodoviek, posilňovačov bŕzd a riadenia. Tiež je vhodný ako náplň hydrodynamických sústav autobusov, stavebných strojov, vysokozdvižných vozíkov a pod. Hydraulický olej DYNAMAX OTHP 32 je určený hlavne na použitie vo veľmi záťažových sústavách prenosu sily a hydraulického riadenia tj. hydraulických prevodoch, regulačných a riadiacich mechanizmoch a podobných zariadeniach, v ktorých vznikajú pracovné podmienky (tlak do 25 MPa v ozubených čerpadlách a tlak 35 MPa v piestových čerpadlách) a všade tam, kde sa vyskytuje zvýšená teplota a vlhkosť prostredia.",
    ean: 8588002690228,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500195,
    brand: "DYNAMAX",
    image: "img6654",
    src: "6654.jpg",
    name: "DYNAMAX OHHM 46 10L",
    short_desc:
      "Hydraulický olej OHHM 46 je určený pre hydrostatické mechanizmy s vysokým mechanickým aj tepelným namáhaním pre stabilné aj mobilné stroje.",
    desc: "DYNAMAX OHHM 46 je hydrogenačne rafinovaný ropný olej zušľachtený prísadami na zlepšenie oxidačnej stálosti, protikoróznych a protioderových vlastností a prísadami proti peneniu. Obsahujú modifikátor viskozity s depresantným účinkom.",
    ean: 8588002690266,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500196,
    brand: "DYNAMAX",
    image: "img6655",
    src: "6655.jpg",
    name: "DYNAMAX OTHP 32 1L",
    short_desc:
      "DYNAMAX OTHP 32 je ropný olej s prídavkom výkonnostnej prísady a modifikátorom viskozity s depresantným účinkom. Je vhodný na mazanie automatických prevodoviek, posilňovačov bŕzd a riadenia.Tiež je vhodný ako náplň hydrodynamických sústav autobusov, stavebných strojov, vysokozdvižných vozíkov a pod.",
    desc: "DYNAMAX OTHP 32 je ropný olej s prídavkom výkonnostnej prísady a modifikátorom viskozity s depresantným účinkom. Je vhodný na mazanie automatických prevodoviek, posilňovačov bŕzd a riadenia.Tiež je vhodný ako náplň hydrodynamických sústav autobusov, stavebných strojov, vysokozdvižných vozíkov a pod. Hydraulický olej DYNAMAX OTHP 32 je určený hlavne na použitie vo veľmi záťažových sústavách prenosu sily a hydraulického riadenia.",
    ean: 8588002690679,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500197,
    brand: "DYNAMAX",
    image: "img6656",
    src: "6656.jpg",
    name: "DYNAMAX M8AD 1L",
    short_desc:
      "Motorový olej DYNAMAX M8AD je určený pre mazanie benzínových a dieselových štvortaktných motorov automobilov. Celoročný motorový olej DYNAMAX M8AD je ropný olej vyrobený modernou technológiou, obsahujúci viskozitné výkonnostné prísady. Olej si počas celej doby používania zachováva svoju výkonnostnú triedu.",
    desc: "Celoročný motorový olej DYNAMAX M8AD je ropný olej vyrobený modernou technológiou, obsahujúci viskozitné výkonnostné prísady.Olej si počas celej doby používania zachováva svoju výkonnostnú triedu. Je určený na celoročné mazanie benzínových a dieselových štvortaktných motorov automobilov. Umožňuje veľmi dobré štartovanie motorov pri nízkych teplotách a zároveň má značnú rezervu viskozity pre letné obdobie.",
    ean: 8588002690037,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500198,
    brand: "DYNAMAX",
    image: "img6657",
    src: "6657.jpg",
    name: "DYNAMAX M8AD 4L",
    short_desc:
      "Motorový olej DYNAMAX M8AD je určený pre mazanie benzínových a dieselových štvortaktných motorov automobilov. Celoročný motorový olej DYNAMAX M8AD je ropný olej vyrobený modernou technológiou, obsahujúci viskozitné výkonnostné prísady.Olej si počas celej doby používania zachováva svoju výkonnostnú triedu.",
    desc: "Motorový olej DYNAMAX M8AD je určený pre mazanie benzínových a dieselových štvortaktných motorov automobilov. Celoročný motorový olej DYNAMAX M8AD je ropný olej vyrobený modernou technológiou, obsahujúci viskozitné výkonnostné prísady. Olej si počas celej doby používania zachováva svoju výkonnostnú triedu. Je určený na celoročné mazanie benzínových a dieselových štvortaktných motorov automobilov. Umožňuje veľmi dobré štartovanie motorov pri nízkych teplotách a zároveň má značnú rezervu viskozity pre letné obdobie.",
    ean: 8588002690044,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500201,
    brand: "DYNAMAX",
    image: "img6660",
    src: "6660.jpg",
    name: "DYNAMAX OHHM 46 20L",
    short_desc:
      "DYNAMAX OHHM 46 je hydrogenačne rafinovaný ropný olej zušľachtený prísadami na zlepšenie oxidačnej stálosti, protikoróznych a protioderových vlastností a prísadami proti peneniu. Obsahujú modifikátor viskozity s depresantným účinkom. Určený pre hydrostatické mechanizmy s vysokým mechanickým aj tepelným namáhaním pre stabilné aj mobilné stroje pracujúce v nechránenom prostredí.",
    desc: "DYNAMAX OHHM 46 je hydrogenačne rafinovaný ropný olej zušľachtený prísadami na zlepšenie oxidačnej stálosti, protikoróznych a protioderových vlastností a prísadami proti peneniu. Obsahujú modifikátor viskozity s depresantným účinkom. Hydraulický olej OHHM 46 je určený pre hydrostatické mechanizmy s vysokým mechanickým aj tepelným namáhaním pre stabilné aj mobilné stroje pracujúce v nechránenom prostredí. Sú použiteľné celoročne a sú kompatibilné s väčšinou hydraulických olejov iných výrobcov.",
    ean: 8588002690273,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500202,
    brand: "DYNAMAX",
    image: "img6661",
    src: "6661.jpg",
    name: "DYNAMAX M7ADSIII 20L",
    short_desc:
      "DYNAMAX M7AD SIII sa používa predovšetkým v nákladnej automobilovej doprave, v mestskej a diaľkovej autobusovej doprave, v lodnej doprave a v železničnej doprave. Celoročný motorový olej určený pre štvortaktné naftové motory preplňované aj nepreplňované.",
    desc: "DYNAMAX M7AD SIII sa používa predovšetkým v nákladnej automobilovej doprave, v mestskej a diaľkovej autobusovej doprave, v lodnej doprave a v železničnej doprave. Celoročný motorový olej určený pre štvortaktné naftové motory preplňované aj nepreplňované. Vysoká kvalita oleja je garantovaná použitím kvalitného základového oleja a starostlivo vyváženou kombináciou viskozitných, antioxidačných, detergentných a iných prísad. Umožňuje veľmi dobré štartovanie motorov pri nízkych teplotách a zároveň má značnú rezervu viskozity pre letné obdobie.",
    ean: 8588001502959,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500203,
    brand: "DYNAMAX",
    image: "img6662",
    src: "6662.jpg",
    name: "DYNAMAX M6AD SII 20L",
    short_desc:
      "Motorový olej DYNAMAX M6AD SII sa používa na mazanie automobilových, traktorových, lodných a stacionárnych naftových motorov moderných konštrukcií. Motorový olej na mazanie náročných druhov nepreplňovaných a preplňovaných naftových štvortaktných motorov, pracujúcich za sťažených podmienok, najmä v prechodnom a letnom období.",
    desc: "Motorový olej DYNAMAX M6AD SII sa používa na mazanie automobilových, traktorových, lodných a stacionárnych naftových motorov moderných konštrukcií. Motorový olej na mazanie náročných druhov nepreplňovaných a preplňovaných naftových štvortaktných motorov, pracujúcich za sťažených podmienok, najmä v prechodnom a letnom období.",
    ean: 8588001502928,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500204,
    brand: "DYNAMAX",
    image: "img6663",
    src: "6663.jpg",
    name: "DYNAMAX OTHP 32 20L",
    short_desc:
      "DYNAMAX OTHP 32 je ropný olej s prídavkom výkonnostnej prísady a modifikátorom viskozity s depresantným účinkom. Je vhodný na mazanie automatických prevodoviek, posilňovačov bŕzd a riadenia. Tiež je vhodný ako náplň hydrodynamických sústav autobus ov, stavebných strojov, vysokozdvižných vozíkov a pod.",
    desc: "DYNAMAX OTHP 32 je ropný olej s prídavkom výkonnostnej prísady a modifikátorom viskozity s depresantným účinkom. Je vhodný na mazanie automatických prevodoviek, posilňovačov bŕzd a riadenia. Tiež je vhodný ako náplň hydrodynamických sústav autobusov, stavebných strojov, vysokozdvižných vozíkov a pod. Hydraulický olej DYNAMAX OTHP 32 je určený hlavne na použitie vo veľmi záťažových sústavách prenosu sily a hydraulického riadenia tj. hydraulických prevodoch, regulačných a riadiacich mechanizmoch a podobných zariadeniach, v ktorých vznikajú pracovné podmienky (tlak do 25 MPa v ozubených čerpadlách a tlak 35 MPa v piestových čerpadlách) a všade tam, kde sa vyskytuje zvýšená teplota a vlhkosť prostredia.",
    ean: 8588002690235,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500205,
    brand: "DYNAMAX",
    image: "img6664",
    src: "6664.jpg",
    name: "DYNAMAX PP 80 20L",
    short_desc:
      "Prevodový olej DYNAMAX PP 80 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov vystavených nízkym teplotám. Prevodový olej DYNAMAX PP80 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu.",
    desc: "Prevodový olej DYNAMAX PP 80 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov vystavených nízkym teplotám. Prevodový olej DYNAMAX PP80 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Prevodový olej Dynamax PP 80 je vhodný do prevodoviek vozidiel TATRA 148 a 815, PRAGA V3S a S5T.",
    ean: 8588001502300,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500206,
    brand: "DYNAMAX",
    image: "img6665",
    src: "6665.jpg",
    name: "DYNAMAX OTHP 32 4L",
    short_desc:
      "DYNAMAX OTHP 32 je ropný olej s prídavkom výkonnostnej prísady a modifikátorom viskozity s depresantným účinkom. Je vhodný na mazanie automatických prevodoviek, posilňovačov bŕzd a riadenia. Tiež je vhodný ako náplň hydrodynamických sústav autobusov, stavebných strojov, vysokozdvižných vozíkov a pod.",
    desc: "DYNAMAX OTHP 32 je ropný olej s prídavkom výkonnostnej prísady a modifikátorom viskozity s depresantným účinkom. Je vhodný na mazanie automatických prevodoviek, posilňovačov bŕzd a riadenia. Tiež je vhodný ako náplň hydrodynamických sústav autobusov, stavebných strojov, vysokozdvižných vozíkov a pod. Hydraulický olej DYNAMAX OTHP 32 je určený hlavne na použitie vo veľmi záťažových sústavách prenosu sily a hydraulického riadenia tj. hydraulických prevodoch, regulačných a riadiacich mechanizmoch a podobných zariadeniach, v ktorých vznikajú pracovné podmienky (tlak do 25 MPa v ozubených čerpadlách a tlak 35 MPa v piestových čerpadlách) a všade tam, kde sa vyskytuje zvýšená teplota a vlhkosť prostredia.",
    ean: 8588002690211,
    package: 3,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500211,
    brand: "DYNAMAX",
    image: "img6668",
    src: "6668.jpg",
    name: "DYNAMAX TRUCKMAN PLUS 15W-40 4L",
    short_desc:
      "DYNAMAX TRUCKMAN X 15W-40 je zvlášť vhodný pre použitie v preplňovaných a nepreplňovaných naftových štvortaktných motoroch nákladných automobilov. Je olej novej generácie typu SHPDO (Super High Performance Diesel Oil), odporúčaný pre vysoko namáhané naftové motory s turbo preplňovaním aj nepreplňovaním.",
    desc: "DYNAMAX TRUCKMAN X 15W-40 je zvlášť vhodný pre použitie v preplňovaných a nepreplňovaných naftových štvortaktných motoroch nákladných automobilov. Je olej novej generácie typu SHPDO (Super High Performance Diesel Oil), odporúčaný pre vysoko namáhané naftové motory s turbo preplňovaním aj nepreplňovaním, s vylepšenými vlastnosťami, čo sa týka čistoty piestu, leštenia povrchu valca, zníženia opotrebenia, znečistenia sadzami a odolnosti proti stárnutiu. Umožňuje dosahovať veľmi dlhé výmenné intervaly.",
    ean: 8586011471135,
    package: 3,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500213,
    brand: "DYNAMAX",
    image: "img6670",
    src: "6670.jpg",
    name: "DYNAMAX TRUCKMAN PLUS FE 10W-40 4L",
    short_desc:
      "DYNAMAX TRUCKMAN PLUS FE je vhodný pre použitie v preplňovaných aj nepreplňovaných naftových štvortaktných motoroch s nízkymi emisiami. Je motorový olej novej generácie typu SHPDO (Super High Performance Diesel Oil), doporučovaný pre vysoko namáhané naftové motory s turbopreplňovaním aj nepreplňovaním, s vylepšenými vlastnosťami.",
    desc: "Je motorový olej novej generácie typu SHPDO (Super High Performance Diesel Oil), doporučovaný pre vysoko namáhané naftové motory s turbopreplňovaním aj nepreplňovaním, s vylepšenými vlastnosťami, čo sa týka čistoty piestu,leštenia povrchu valca, zníženia opotrebenia,znečistenia sadzami a odolnosti proti stárnutiu. Umožňuje dosahovať veľmi dlhé výmenné intervaly.DYNAMAX TRUCKMAN PLUS FE je olej určený pre prevádzku naftovýchmotorov zvlášť pre veľké nákladné automobily, stavebnú techniku a autobusy.",
    ean: 8586011470046,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500217,
    brand: "DYNAMAX",
    image: "img6674",
    src: "6674.jpg",
    name: "DYNAMAX TRUCKMAN PLUS15W-40 10L",
    short_desc:
      "DYNAMAX TRUCKMAN X 15W-40 je zvlášť vhodný pre použitie v preplňovaných a nepreplňovaných naftových štvortaktných motoroch nákladných automobilov v diaľkovej nákladnej doprave, v autobusovej doprave, v stavebníctve a v lodnej doprave. Je vhodný aj na mazanie motorov ľahkých dodávkových automobilov s naftovým motorom. Je olej novej generácie typu SHPDO (Super High Performance Diesel Oil).",
    desc: "DYNAMAX TRUCKMAN X 15W-40 je zvlášť vhodný pre použitie v preplňovaných a preplňovaných naftových štvortaktných motoroch nákladných automobilov v diaľkovej nákladnej doprave, v autobusovej doprave, v stavebníctve a v lodnej doprave. Je vhodný aj na mazanie motorov ľahkých dodávkových automobilov s naftovým motorom. Je olej novej generácie typu SHPDO (Super High Performance Diesel Oil), odporúčaný pre vysoko namáhané naftové motory s turbopreplňovaním aj nepreplňovaním, s vylepšenými vlastnosťami, čo sa týka čistoty piestu, leštenia povrchu valca, zníženia opotrebenia, znečistenia sadzami a odolnosti proti stárnutiu. Umožňuje dosahovať veľmi dlhé výmenné intervaly.",
    ean: 8586011470329,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500247,
    brand: "DYNAMAX",
    image: "img6704",
    src: "6704.jpg",
    name: "DYNAMAX TB 46 175KG(200L)",
    short_desc:
      "DYNAMAX TB 46 je turbínový olej na ropnej báze s antioxidačnými a antikoróznymi prísadami, ktoré zlepšujú ich úžitkové vlastnosti.",
    desc: "DYNAMAX TB 46 je turbínový olej na ropnej báze s antioxidačnými a antikoróznymi prísadami, ktoré zlepšujú ich úžitkové vlastnosti. Vyznačuje sa výbornou oxidačnou stálosťou, dobrými protikoróznymi, protipenivostnými a deemulgačnými vlastnosťami. Je určený na mazanie parných, plynových a vodných turbín, turbokompresorov, rýchlobežných prevodoviek na turbosústrojoch, môže byť tiež používaný ako hydraulická kvapalina v sústavách riadenia turbín a na mazanie okrem iného: lodných turbonakladačov hlavných a pomocných motorov poháňaných výfukovými plynmi, v cirkulačných systémoch strojov vyžadujúcich olejov kvality turbínových olejov, napr. turbokompresoroch a turbínových čerpadlách.",
    ean: 8586011470404,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500251,
    brand: "DYNAMAX",
    image: "img6708",
    src: "6708.jpg",
    name: "DYNAMAX OL 68 175KG(198L)",
    short_desc:
      "DYNAMAX OL 68 je vhodný najmä na mazanie strojových častí pracovných a hnacích strojov s nižšími otáčkami a väčším mechanickým zaťažením.",
    desc: "DYNAMAX OL 68 je vhodný najmä na mazanie strojových častí pracovných a hnacích strojov s nižšími otáčkami a väčším mechanickým zaťažením Ložiskové oleje sú ropné oleje s dobrou oxidačnou stálosťou.Obsahujú zušľachťujúce prísady, ktoré priaznivo vp lývajú na životnosť ložísk. Sú určené na krátkodobé mazanie sústav pri normálnych teplotách, okrem mazania sústav s veľkou prietokovou rýchlosťou. Sú vhodné aj ako náplň do nenáročných hydraulických sústav.",
    ean: 8586011470442,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500265,
    brand: "DYNAMAX",
    image: "img34861",
    src: "34861.jpg",
    name: "DYNAMAX FORMEX 2 170KG(200L)",
    short_desc:
      "Olej odformovací DYNAMAX FORMEX 2 je rafinát ľahkého minerálneho a rastlinného oleja s prísadami. Používa sa na vymazávanie oceľových foriem pri výrobe prefabrikátov. Má dobrú roztierateľnosť a schopnosť, že už jemná vrstva chráni proti prilepeniu.",
    desc: "Olej odformovací DYNAMAX FORMEX 2 je rafinát ľahkého minerálneho a rastlinného oleja s prísadami. Používa sa na vymazávanie oceľových foriem pri výrobe prefabrikátov. Má dobrú roztierateľnosť a schopnosť, že už jemná vrstva chráni proti prilepeniu . Odformovací olej zaisťuje dokonalé oddelenie betónu od formy, pôsobí konzervačne na formu, znižuje jej opotrebenie a zlepšuje kvalitu povrchových vrstiev betónu. Najvýhodnejšie nanášanie na povrch formy je rozprašovaním, je ho tiež možno nanášať natieraním.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500420,
    brand: "DYNAMAX",
    image: "img11005",
    src: "11005.jpg",
    name: "DYNAMAX LETNÝ KONCENTRÁT 1:100",
    short_desc:
      "Je to učinná kvapalina do ostrekovačov určená pre všetky typy motorových vozidiel v letnom období. Stlačením fľaše naplňte dávkovač a vzápätí naplňte nádobku ostrekovača. Dávka vystačí na 3 l vody. Výrobok sa riedi v pomere 1:100 (1 diel zmesi a 1 00 dielov vody).",
    desc: "Je to učinná kvapalina do ostrekovačov určená pre všetky typy motorových vozidiel v letnom období. Stlačením fľaše naplňte dávkovač a vzápätí naplňte nádobku ostrekovača. Dávka vystačí na 3 l vody. Výrobok sa riedi v pomere 1:100 (1 diel zmesi a 1 00 dielov vody). Z obsahu 250 ml sa zarobí 25 l letnej zmesi. Dávka vystačí na 3 l vody. Výrobok sa riedi v pomere 1:100 (1 diel zmesi a 1 00 dielov vody). Z obsahu 250 ml sa zarobí 25 l letnej zmesi.",
    ean: 8586011470992,
    package: 20,
    type: "olej",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500513,
    brand: "DYNAMAX",
    image: "img6734",
    src: "6734.jpg",
    name: "DXM3-MOTOR CLEANER 500ML",
    short_desc:
      "Univerzálny čistiaci prípravok na odstraňovanie mastných nečistôt z povrchu motora, podvozku vozidiel, náradia, podláh a iných silne znečistených častí a plôch. Je vhodný aj ako náplň do univerzálnych odmasťovacích zariadení.",
    desc: "Univerzálny čistiaci prípravok na odstraňovanie mastných nečistôt z povrchu motora, podvozku vozidiel, náradia, podláh a iných silne znečistených častí a plôch. Je vhodný aj ako náplň do univerzálnych odmasťovacích zariadení. Použitie: Pred použitím pretrepte. Prípravok používajte v dodanom stave, nerieďte! Prípravok nastriekajte alebo naneste štetcom na znečistené miesto.",
    ean: 8586011471142,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500520,
    brand: "DYNAMAX",
    image: "img6735",
    src: "6735.jpg",
    name: "DXM3-MOTOR CLEANER 3,4L",
    short_desc:
      "Univerzálny čistiaci prípravok na odstraňovanie mastných nečistôt z povrchu motora, podvozku vozidiel, náradia, podláh a iných silne znečistených častí a plôch. Je vhodný aj ako náplň do univerzálnych odmasťovacích zariadení.",
    desc: "Univerzálny čistiaci prípravok na odstraňovanie mastných nečistôt z povrchu motora, podvozku vozidiel, náradia, podláh a iných silne znečistených častí a plôch. Je vhodný aj ako náplň do univerzálnych odmasťovacích zariadení. Použitie: Pred použitím pretrepte. Prípravok používajte v dodanom stave, nerieďte! Prípravok nastriekajte alebo naneste štetcom na znečistené miesta.",
    ean: 8586011471357,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500522,
    brand: "DYNAMAX",
    image: "img6737",
    src: "6737.jpg",
    name: "DYNAMAX TRUCKMAN ULTRA 5W-30 4L",
    short_desc:
      "DYNAMAX TRUCKMAN ULTRA je špeciálny vysokovýkonný syntetický olej pre všetky dieselové a turbodieselové motory s veľkou záťažou. Spĺňa požiadavky moderných európskych motorov v súlade s požiadavkami emisných noriem EURO 4.",
    desc: "DYNAMAX TRUCKMAN ULTRA je špeciálny vysokovýkonný syntetický olej pre všetky dieselové a turbodieselové motory s veľkou záťažou. Spĺňa požiadavky moderných európskych motorov v súlade s požiadavkami emisných noriem EURO 4. Skladá sa zo základnýc h kvapalín špičkovej kvality a špičkového aditívneho systému zabezpečuje výbornú ochranu motorov a výrazne predlžuje výmenné intervaly. Tento olej spĺňa najnovšie špecifikácie ACEA E7 a ACEA E6 technológiami za použitia starostlivo vyváženého aditív neho systému.",
    ean: 8586011471302,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500552,
    brand: "DYNAMAX",
    image: "img6748",
    src: "6748.jpg",
    name: "DYNAMAX DIESEL PLUS 10W-40 175KG",
    short_desc:
      "Je navrhnutý tak, aby poskytoval optimálny výkon vo vysokovýkonných preplňovaných dieselových motoroch osobných automobilov, dodávok, SUV a ľahkých nákladných vozidiel.",
    desc: "Je navrhnutý tak, aby poskytoval optimálny výkon vo vysokovýkonných preplňovaných dieselových motoroch osobných automobilov, dodávok, SUV a ľahkých nákladných vozidiel. Zdokonalená adivácia obsiahnutá v tomto oleji mu umožňuje prekonať striktné výkonnostné požiadavky vedúcich výrobcov osobných automobilov a globálnych priemyslových štandardov.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500562,
    brand: "DYNAMAX",
    image: "img11007",
    src: "11007.jpg",
    name: "DYNAMAX TRUCKMAN ULTRA 5W-30 20L",
    short_desc:
      "DYNAMAX TRUCKMAN ULTRA je špeciálny vysokovýkonný syntetický olej pre všetky dieselové a turbo dieselové motory s veľkou záťažou. Spĺňa požiadavky moderných európskych motorov v súlade s požiadavkami emisných noriem EURO 4. Skladá sa zo základných kvapalín špičkovej kvality a špičkového aditívneho systému zabezpečuje výbornú ochranu motorov a výrazne predlžuje výmenné intervaly.",
    desc: "DYNAMAX TRUCKMAN ULTRA je špeciálny vysokovýkonný syntetický olej pre všetky dieselové a turbo dieselové motory s veľkou záťažou. Spĺňa požiadavky moderných európskych motorov v súlade s požiadavkami emisných noriem EURO 4. Skladá sa zo základných kvapalín špičkovej kvality a špičkového aditívneho systému zabezpečuje výbornú ochranu motorov a výrazne predlžuje výmenné intervaly. Tento olej spĺňa najnovšie špecifikácie ACEA E7 a ACEA E6 technológiami za použitia starostlivo vyváženého aditívneho systému. Olej zabezpečuje plnú ochranu motora vo všetkých prevádzkových podmienkach, udržuje čisté vnútorné časti motora, znižuje opotrebenie.",
    ean: 8586011471425,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500584,
    brand: "DYNAMAX",
    image: "img11013",
    src: "11013.jpg",
    name: "DYNAMAX LETNÁ ZMES DO OSTREKOVAČOV 25L CITRON",
    short_desc:
      "DYNAMAX letná zmes 1:2 je vysoko účinný prostriedok pre odstránenie zbytkov hmyzu a všetkých bežných nečistôt zo skla automobilu. Koncentrát obsahuje aktívnu látku, ktorá predstavuje úplne nový spôsob údržby. Znižuje námahu spojenú s čistením okien.",
    desc: "DYNAMAX letná zmes 1:2 je vysokoúčinný prostriedok pre odstránenie zbytkov hmyzu a všetkých bežných nečistôt zo skla automobilu. Koncentrát obsahuje aktívnu látku, ktorá predstavuje úplne nový spôsob údržby. Znižuje námahu spojenú s čistením okien . Sklo zanecháva dokonale čisté. Je biologicky odbúrateľný. DYNAMAX letná zmes je určený na použitie ako náplň do ostrekovačov pre všetky typy motorových vozidiel v letnom období. Plní sa do zásobnej nádržky ostrekovača a podľa potreby sa aplikuje n a čelné sklo automobilu.",
    ean: 8586016015334,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500640,
    brand: "DYNAMAX",
    image: "img6753",
    src: "6753.jpg",
    name: "DXG3 - ROZMRAZOVAČ OKIEN 500ML",
    short_desc:
      "Prípravok je určený na pohodlné odstránenie ľadu a námrazy z okien automobilov. Stačí nastriekať na zamrznuté okná a nechať chvíľu pôsobiť.",
    desc: "Prípravok je určený na pohodlné odstránenie ľadu a námrazy z okien automobilov. Stačí nastriekať na zamrznuté okná a nechať chvíľu pôsobiť. Po roztopení námrazy utrite handrou alebo stierkou do sucha. Na zabezpečenie maximálnej účinnosti prípravku sa odporúča uchovávať nádobu pri izbovej teplote.",
    ean: 8586011471166,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500661,
    brand: "DYNAMAX",
    image: "img11011",
    src: "11011.jpg",
    name: "DYNAMAX SCREENWASH -20 25L CITRON",
    short_desc:
      "DYNASTIC je nemrznúca kvapalina do ostrekovačov automobilov. Spoľahlivo odstraňuje zo skla automobilu mastnotu a iné nečistoty.",
    desc: "Je vysoko účinná, celoročná mrazuvzdorná kvapalina do všetkých typov ostrekovačov motorových vozidiel. Chráni zariadenie ostrekovačov pred koróziou.",
    ean: 8586011471470,
    package: "",
    type: "olej",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500667,
    brand: "DYNAMAX",
    image: "img6754",
    src: "6754.jpg",
    name: "DYNAMAX SCREENWASH -80 25L CITRON",
    short_desc:
      "Nemrznúca kvapalina do ostrekovačov automobilov. Spoľahlivo odstraňuje zo skla automobilu mastnotu a iné nečistoty.",
    desc: "Je vysoko účinná, celoročná mrazuvzdorná kvapalina do všetkých typov ostrekovačov motorových vozidiel. Chráni zariadenie ostrekovačov pred koróziou.",
    ean: 8586011471111,
    package: "",
    type: "olej",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500669,
    brand: "DYNAMAX",
    image: "img6755",
    src: "6755.jpg",
    name: "DYNAMAX SCREENWASH -40 25L CITRON",
    short_desc:
      "Nemrznúci koncentrát je vysokoúčinná náplň do ostrekovačov automobilov. Zo skla automobilu spoľahlivo odstraňuje mastnotu a iné nečistoty. Chráni ostrekovací systém pred zamŕzaním až do -40°C a vytváraním vodného kameňa. Zlepšuje viditeľnosť počas nepriaznivého počasia. Spríjemňuje jazdu. Zvyšuje bezpečnosť jazdy v zimnom období.",
    desc: "Nemrznúci koncentrát je vysokoúčinná náplň do ostrekovačov automobilov. Zo skla automobilu spoľahlivo odstraňuje mastnotu a iné nečistoty. Chráni ostrekovací systém pred zamŕzaním až do -40°C a vytváraním vodného kameňa. Zlepšuje viditeľnosť počas nepriaznivého počasia. Spríjemňuje jazdu. Zvyšuje bezpečnosť jazdy v zimnom období.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500683,
    brand: "DYNAMAX",
    image: "img6756",
    src: "6756.jpg",
    name: "DYNAMAX SCREENWASH -80 50L CITRON",
    short_desc:
      "DYNASTIC je nemrznúca kvapalina do ostrekovačov automobilov. Spoľahlivo odstraňuje zo skla automobilu mastnotu a iné nečistoty.",
    desc: "Je vysoko účinná, celoročná mrazuvzdorná kvapalina do všetkých typov ostrekovačov motorových vozidiel. Chráni zariadenie ostrekovačov pred koróziou.",
    ean: 8586011471487,
    package: "",
    type: "olej",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500823,
    brand: "DYNAMAX",
    image: "img6758",
    src: "6758.jpg",
    name: "DYNAMAX M2T SUPER HP 0,25L",
    short_desc:
      "Dynamax M2T SUPER HP je vysoko kvalitný ropný olej vyrobený modernou technológiou, obsahujúci prísady potláčajúce tvorbu úsad v piestnych drážkach, na výfukových kanáloch a na elektródach sviečok, ako aj prísady zlepšujúce mazacie schopnosti oleja. Chráni piest pred odieraním a časti motora pred predčasným opotrebením.",
    desc: "Dynamax M2T SUPER HP je vysoko kvalitný ropný olej vyrobený modernou technológiou, obsahujúci prísady potláčajúce tvorbu úsad v piestnych drážkach, na výfukových kanáloch a na elektródach sviečok, ako aj prísady zlepšujúce mazacie schopnosti oleja. Chráni piest pred odieraním a časti motora pred predčasným opotrebením. Má skvelú miešateľnosť s benzínom, čím vzniká homogénna a stabilná zmes aj pri nízkej teplote okolia. Olej je odporúčaný pre dvojtaktné motory u motocyklov, skútrov, alebo v ručnom motorovom náradí vyžadujúcich kvalitu API TC a JASO FB. Je vhodný tak pre priam vstrekovanie oleja ako aj pre mazacie systémy s vopred zamiešanou zmesou.",
    ean: 8586016012777,
    package: 24,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500824,
    brand: "DYNAMAX",
    image: "img6759",
    src: "6759.jpg",
    name: "DYNAMAX M2T SUPER HP 0,5L",
    short_desc:
      "Dynamax M2T SUPER HP je vysoko kvalitný ropný olej vyrobený modernou technológiou, obsahujúci prísady potláčajúce tvorbu úsad v piestnych drážkach, na výfukových kanáloch a na elektródach sviečok, ako aj prísady zlepšujúce mazacie schopnosti oleja. Chráni piest pred odieraním a časti motora pred predčasným opotrebením.",
    desc: "Dynamax M2T SUPER HP je vysoko kvalitný ropný olej vyrobený modernou technológiou, obsahujúci prísady potláčajúce tvorbu úsad v piestnych drážkach, na výfukových kanáloch a na elektródach sviečok, ako aj prísady zlepšujúce mazacie schopnosti ole ja. Chráni piest pred odieraním a časti motora pred predčasným opotrebením. Má skvelú miešateľnosť s benzínom, čím vzniká homogénna a stabilná zmes aj pri nízkej teplote okolia. Olej je odporúčaný pre dvojtaktné motory u motocyklov, skútrov, alebo v r učnom motorovom náradí vyžadujúcich kvalitu API TC a JASO FB. Je vhodný tak pre priam vstrekovanie oleja ako aj pre mazacie systémy s vopred zamiešanou zmesou.",
    ean: 8586016012784,
    package: 16,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500990,
    brand: "DYNAMAX",
    image: "img6760",
    src: "6760.jpg",
    name: "DYNAMAX COOL 12 ULTRA 10L",
    short_desc:
      "Koncentrovaná nízkotuhnúca chladiaca kvapalina určená pre najmodernejšie druhy motorov. DYNAMAX ULTRA G12 je vysoko kvalitná nízkotuhnúca zmes vyrobená z monoetylénglykolu s vysoko progresívnymi antikoróznymi prísadami, zvlášť vhodná pre chladiče moderných hliníkových a zliatinových chladiacich sústav spaľovacích motorov.",
    desc: "Koncentrovaná nízkotuhnúca chladiaca kvapalina určená pre najmodernejšie druhy motorov. DYNAMAX ULTRA G12 je vysoko kvalitná nízkotuhnúca zmes vyrobená z monoetylénglykolu s vysoko progresívnymi antikoróznymi prísadami, zvlášť vhodná pre chladiče moderných hliníkových a zliatinových chladiacich sústav spaľovacích motorov. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. V roku 2008 získala chladiaca kvapalina DYNAMAX ULTRA G12 prestížne ocenenie Zlatú medailu a Certifikát ochrannej známky kvality Slovak Gold. Obsahuje látku brániacu požitiu chladiacej kvapaliny.",
    ean: 8586011471791,
    package: "",
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501016,
    brand: "DYNAMAX",
    image: "img6761",
    src: "6761.jpg",
    name: "DYNAMAX DIESEL ADITIV PLUS 60 L SUD",
    short_desc:
      "Zimná viacfunkčná prísada do motorovej nafty. Dokonale naviaže nakondenzovanú vodu v systéme a tým zlepší spaľovanie nafty.",
    desc: "Zimná viacfunkčná prísada do motorovej nafty. Dokonale naviaže nakondenzovanú vodu v systéme a tým zlepší spaľovanie nafty. Zlepšuje štartovateľnosť motora v zime i v lete. Udržuje čistotu vstrekovacích trysiek. Dokonale chráni palivový systém pre d koróziou. Zvyšuje mazaciu schopnosť paliva a tým predlžuje životnosť vstrekovacích čerpadiel a trysiek. Znižuje hlučnosť motora. Zamedzuje parafinovaniu dieselového paliva pri extrémnom chlade. Zaisťuje optimálne mazanie všetkých pohyblivých č astí dieselového systému. Zlepšuje studený štart motora.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501017,
    brand: "DYNAMAX",
    image: "img6762",
    src: "6762.jpg",
    name: "DYNAMAX DIESEL ADITIV PLUS 200 L SUD",
    short_desc:
      "Zimná viacfunkčná prísada do motorovej nafty. Dokonale naviaže nakondenzovanú vodu v systéme a tým zlepší spaľovanie nafty. Zlepšuje štartovateľnosť motora v zime i v lete.",
    desc: "Zimná viacfunkčná prísada do motorovej nafty. Dokonale naviaže nakondenzovanú vodu v systéme a tým zlepší spaľovanie nafty. Zlepšuje štartovateľnosť motora v zime i v lete. Udržuje čistotu vstrekovacích trysiek. Dokonale chráni palivový systém pre d koróziou. Zvyšuje mazaciu schopnosť paliva a tým predlžuje životnosť vstrekovacích čerpadiel a trysiek. Znižuje hlučnosť motora. Zamedzuje parafinovaniu dieselového paliva pri extrémnom chlade. Zaisťuje optimálne mazanie všetkých pohyblivých častí dieselového systému. Zlepšuje studený štart motora.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501071,
    brand: "DYNAMAX",
    image: "img6763",
    src: "6763.jpg",
    name: "DYNAMAX ADBLUE 10L",
    short_desc:
      "Vodný roztok močoviny s vysokou chemickou čistotou podľa ISO 22241 pre prevádzku SCR katalyzátorov.",
    desc: "Vodný roztok močoviny s vysokou chemickou čistotou podľa ISO 22241 pre prevádzku SCR katalyzátorov.",
    ean: 8586011471906,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501072,
    brand: "DYNAMAX",
    image: "img6764",
    src: "6764.jpg",
    name: "DYNAMAX ADBLUE 20L",
    short_desc:
      "Vodný roztok močoviny s vysokou chemickou čistotou podľa ISO 22241 pre prevádzku SCR katalyzátorov.",
    desc: "Vodný roztok močoviny s vysokou chemickou čistotou podľa ISO 22241 pre prevádzku SCR katalyzátorov.",
    ean: 8586011471913,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501093,
    brand: "DYNAMAX",
    image: "img6765",
    src: "6765.jpg",
    name: "DYNAMAX M6AD SII 4L",
    short_desc:
      "Motorový olej DYNAMAX M6ADSII sa používa na mazanie automobilových, traktorových, lodných a stacionárnych naftových motorov moderných konštrukcií. Motorový olej na mazanie náročných druhov nepreplňovaných a preplňovaných naftových štvortaktných motorov, pracujúcich za sťažených podmienok, najmä v prechodnom a letnom období.",
    desc: "Motorový olej DYNAMAX M6ADSII sa používa na mazanie automobilových, traktorových, lodných a stacionárnych naftových motorov moderných konštrukcií. Motorový olej na mazanie náročných druhov nepreplňovaných a preplňovaných naftových štvortaktných motorov, pracujúcich za sťažených podmienok, najmä v prechodnom a letnom období.",
    ean: 8588002690945,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501094,
    brand: "DYNAMAX",
    image: "img6766",
    src: "6766.jpg",
    name: "DYNAMAX M7AD SIII 20W-40 4L",
    short_desc:
      "DYNAMAX M7ADSIII sa používa predovšetkým v nákladnej automo-bilovej doprave, v mestskej a diaľkovej autobusov ej doprave, v lodnej doprave. Celoročný motorový olej určený pre štvortaktné naftové motory preplňované aj nepreplňované.",
    desc: "Celoročný motorový olej určený pre štvortaktné naftové motory preplňované aj nepreplňované. Vysoká kvalita oleja je garantovaná použitím kvalitného základového oleja a starostlivo vyváženou kombináciou viskozitných, antioxidačných, detergentných a iných prísad. Umožňuje veľmi dobré štartovanie motorov pri nízkych teplotách a zároveň má značnú rezervu viskozity pre letné obdobie.",
    ean: 8588001502935,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501095,
    brand: "DYNAMAX",
    image: "img6767",
    src: "6767.jpg",
    name: "DYNAMAX BENZIN PLUS 10W-40 175KG(200L)",
    short_desc:
      "Je vhodný pre benzínové aj naftové motory, pre ktoré sú vhodné minerálne oleje. Syntetická báza oleja zlepšuje mazanie motora v záťažových podmienkach, zároveň zachováva výborné vlastnosti oleja. Je vhodný na celoročné používanie. Má vyhovujúce vlastnosti pri nízkych teplotách v zimnom období a tiež pri vysokých teplotách v letnom období.",
    desc: "Je vhodný pre benzínové aj naftové motory, pre ktoré sú vhodné minerálne oleje. Syntetická báza oleja zlepšuje mazanie motora v záťažových podmienkach, zároveň zachováva výborné vlastnosti oleja. Je vhodný na celoročné používanie. Má vyhovujúce vlastnosti pri nízkych teplotách v zimnom období a tiež pri vysokých teplotách v letnom období. DYNAMAX BENZÍN PLUS sa používa na mazanie preplňovaných aj nepreplňovaných benzínových štvortaktných motorov osobných automobilov a dodávok.",
    ean: "",
    package: 1,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501145,
    brand: "DYNAMAX",
    image: "img93920",
    src: "93920.jpg",
    name: "DYNAMAX SCREENWASH -20 5L",
    short_desc:
      "DYNAMAX Screenwash -20 °C Black drake je nemrznúca kvapalina do ostrekovačov automobilov. Spoľahlivo odstraňuje zo skla automobilu mastnotu a iné nečistoty.",
    desc: "Je vysoko účinná, celoročná mrazuvzdorná kvapalina do všetkých typov ostrekovačov motorových vozidiel. DYNAMAX Screenwash -20 °C Black drake je nemrznúca kvapalina do ostrekovačov automobilov. Spoľahlivo odstraňuje zo skla automobilu mastnotu a iné nečistoty.",
    ean: 8586016010070,
    package: 3,
    type: "olej",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501151,
    brand: "DYNAMAX",
    image: "img6777",
    src: "6777.jpg",
    name: "DYNAMAX EMULGOL DS 30 10L",
    short_desc:
      "DYNAMAX Emulgol DS 30 sa používa vo forme vodnej chladiaco-mazacej emulzie pri sústružení ocele, liatiny, neželezných kovov. Doporučená pracovná koncentrácia emulzie (pripravená vo vode so stupňom tvrdosti do 20°N) v závislosti od druhu obrábania a obrábaného materiálu: brúsenie 3-5%, sústruženie, frézovanie, vŕtanie 5-10%, závitovanie 10-15%.",
    desc: "DYNAMAX Emulgol DS 30 sa používa vo forme vodnej chladiaco-mazacej emulzie pri sústružení ocele, liatiny, neželezných kovov. Doporučená pracovná koncentrácia emulzie (pripravená vo vode so stupňom tvrdosti do 20°N) v závislosti od druhu obrábania a obrábaného materiálu: brúsenie 3-5%, sústruženie, frézovanie, vŕtanie 5-10%, závitovanie 10-15%.",
    ean: 8586016010124,
    package: "",
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501152,
    brand: "DYNAMAX",
    image: "img93917",
    src: "93917.jpg",
    name: "DYNAMAX SCREENWASH -20 3L",
    short_desc:
      "DYNAMAX Screenwash -20 °C je nemrznúca kvapalina do ostrekovačov automobilov. Spoľahlivo odstraňuje zo skla automobilu mastnotu a iné nečistoty. Chráni ostrekovací systém pred zamŕzaním a vytváraním vodného kameňa. Zlepšuje viditeľnosť počas nepriaznivého zimného počasia.",
    desc: "DYNAMAX Screenwash -20 °C je nemrznúca kvapalina do ostrekovačov automobilov. Spoľahlivo odstraňuje zo skla automobilu mastnotu a iné nečistoty. Chráni ostrekovací systém pred zamŕzaním a vytváraním vodného kameňa. Zlepšuje viditeľnosť počas nepriaznivého zimného počasia.",
    ean: 8586016010322,
    package: 4,
    type: "olej",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501153,
    brand: "DYNAMAX",
    image: "img93922",
    src: "93922.jpg",
    name: "DYNAMAX SCREENWASH -40 3L",
    short_desc:
      "Kvapalina do ostrekovačov sa plní do zásobnej nádržky ostrekovača a podľa potreby sa aplikuje na čelné sklo automobilu, pri slabších mrazoch.",
    desc: "Nemrznúci koncentrát je vysokoúčinná náplň do ostrekovačov automobilov. Zo skla automobilu spoľahlivo odstraňuje mastnotu a iné nečistoty. Chráni ostrekovací systém pred zamŕzaním až do -40°C a vytváraním vodného kameňa. Zlepšuje viditeľnosť počas nepriaznivého počasia. Spríjemňuje jazdu. Zvyšuje bezpečnosť jazdy v zimnom období.",
    ean: 8586016010285,
    package: 4,
    type: "doplnok",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501155,
    brand: "DYNAMAX",
    image: "img93918",
    src: "93918.jpg",
    name: "DYNAMAX SCREENWASH -20 4L",
    short_desc:
      "DYNAMAX Screenwash -20 °C je nemrznúca kvapalina do ostrekovačov automobilov. Spoľahlivo odstraňuje zo skla automobilu mastnotu a iné nečistoty. Chráni ostrekovací systém pred zamŕzaním a vytváraním vodného kameňa. Zlepšuje viditeľnosť počas nepriaznivého zimného počasia.",
    desc: "Je vysoko účinná, celoročná mrazuvzdorná kvapalina do všetkých typov ostrekovačov motorových vozidiel. DYNAMAX Screenwash -20 °C Black drake je nemrznúca kvapalina do ostrekovačov automobilov. Spoľahlivo odstraňuje zo skla automobilu mastnotu a iné nečistoty.",
    ean: 8586016010339,
    package: 3,
    type: "olej",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501157,
    brand: "DYNAMAX",
    image: "img93923",
    src: "93923.jpg",
    name: "DYNAMAX SCREENWASH -40 5L",
    short_desc:
      "Nemrznúci koncentrát je vysokoúčinná náplň do ostrekovačov automobilov. Zo skla automobilu spoľahlivo odstraňuje mastnotu a iné nečistoty. Chráni ostrekovací systém pred zamŕzaním až do -40°C a vytváraním vodného kameňa. Zlepšuje viditeľnosť počas nepriaznivého počasia. Spríjemňuje jazdu. Zvyšuje bezpečnosť jazdy v zimnom období.",
    desc: "Nemrznúci koncentrát je vysokoúčinná náplň do ostrekovačov automobilov. Zo skla automobilu spoľahlivo odstraňuje mastnotu a iné nečistoty. Chráni ostrekovací systém pred zamŕzaním až do -40°C a vytváraním vodného kameňa. Zlepšuje viditeľnosť počas nepriaznivého počasia. Spríjemňuje jazdu. Zvyšuje bezpečnosť jazdy v zimnom období.",
    ean: 8586016010308,
    package: 3,
    type: "olej",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501251,
    brand: "DYNAMAX",
    image: "img6788",
    src: "6788.jpg",
    name: "DYNAMAX ULTRA PLUS PD 5W-40 20L",
    short_desc:
      "Motorový olej DYNAMAX ULTRA PLUS PD je vysoko výkonný nízkoemisný syntetický celoročný motorový olej spĺňajúci požiadavky mid SAPS (Sulphated Ash, Phosphorus - Sulphur). Syntetický motorový DYNAMAX ULTRA PLU S PD je najviac doporučovaný pre najnovšiu generáciu vysoko zaťažovaných benzínových, LPG a dieselových motorov.",
    desc: "Motorový olej DYNAMAX ULTRA PLUS PD je vysoko výkonný nízkoemisný syntetický celoročný motorový olej spĺňajúci požiadavky mid SAPS (Sulphated Ash, Phosphorus - Sulphur). Je vyrobený tak, aby predĺžil životnosť motora a životnosť zariadenia pre následnú úpravu výfukových plynov, ktoré používa posledná generácia benzínových a dieselových motorov u osobných automobilov.DYNAMAX ULTRA PLUS PD znižuje tvorbu popola v dieselových časticových filtroch (DPF).",
    ean: 8586016011152,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501383,
    brand: "DYNAMAX",
    image: "img6791",
    src: "6791.jpg",
    name: "DYNAMAX TRUCKMAN PLUS M 10W-40 20L",
    short_desc:
      "Olej je odporúčaný pre dieselové motory pracujúce za veľmi ťažkých prevádzkových podmienok napr. predĺžené intervaly výmeny olejov podľa odporúčania výrobcov olejov.",
    desc: "DYNAMAX Truckman Plus M 10W40 je vysoko výkonný syntetický motorový olej, ktorý je určený na mazanie dieselových motorov s turbo preplňovaním i nepreplňovaním. Má vynikajúcu tepelnú a oxidačnú stabilitu a vysokú odolnosť proti starnutiu, zvlášť pr i vysokých teplotách. Spĺňa požiadavky na emisie podľa Euro 3.",
    ean: 8586016011923,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501421,
    brand: "DYNAMAX",
    image: "img6795",
    src: "6795.jpg",
    name: "DYNAMAX TRUCKMAN PLUS LM 10W-40 10L",
    short_desc:
      "DYNAMAX TRUCKMAN PLUS LM je vysoko výkonný syntetický olej pre dieselové motory s nízkym obsahom popola, fosforu a síry (SAPS). Bol špeciálne vyvinutý pre motory s filtrom pevných častíc (DPF) alebo zariadeniami na následnú úpravu výfukových plyno v SCR.",
    desc: "DYNAMAX TRUCKMAN PLUS LM je vysoko výkonný syntetický olej pre dieselové motory s nízkym obsahom popola, fosforu a síry (SAPS). Bol špeciálne vyvinutý pre motory s filtrom pevných častíc (DPF) alebo zariadeniami na následnú úpravu výfukových plyno v SCR (selektívna katalytická redukcia). DYNAMAX TRUCKMAN PLUS LM je doporučovaný pre použitie v dieslových motoroch spĺňajúcich emisné požiadavky EURO 4 a 5, ale aj nižšie emisné normy.",
    ean: 8586016012036,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501422,
    brand: "DYNAMAX",
    image: "img6796",
    src: "6796.jpg",
    name: "DYNAMAX TRUCKMAN PLUS LM 10W-40 20L",
    short_desc:
      "DYNAMAX TRUCKMAN PLUS LM je vysoko výkonný syntetický olej pre dieselové motory s nízkym obsahom popola, fosforu a síry (SAPS). Bol špeciálne vyvinutý pre motory s filtrom pevných častíc (DPF) alebo zariadeniami na následnú úpravu výfukových plynov SCR.",
    desc: "DYNAMAX TRUCKMAN PLUS LM je vysoko výkonný syntetický olej pre dieselové motory s nízkym obsahom popola, fosforu a síry (SAPS). Bol špeciálne vyvinutý pre motory s filtrom pevných častíc (DPF) alebo zariadeniami na následnú úpravu výfukových plynov SCR (selektívna katalytická redukcia). DYNAMAX TRUCKMAN PLUS LM je doporučovaný pre použitie v dieslových motoroch spĺňajúcich emisné požiadavky EURO 4 a 5, ale aj nižšie emisné normy.",
    ean: 8586016012043,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501490,
    brand: "DYNAMAX",
    image: "img6799",
    src: "6799.jpg",
    name: "DYNAMAX TRUCKMAN PLUS 15W-40 50KG(56L)",
    short_desc:
      "DYNAMAX TRUCKMAN PLUS 15W-40 je vysokovýkonný motorový olej vhodný pre motory Euro III, Euro IV a Euro V (bez DPF)",
    desc: "Motorový olej DYNAMAX TRUCKMAN PLUS 15W-40 je ropný motorový olej vyrobený modernými technológiami za použitia starostlivo vyváženého aditívneho systému (detergenty-disperzanty, protioderové prísady, antioxidanty, antikorodanty, protipenivostné prísady a prísady neutralizujúce kyslé zložky a tiež modifikátory viskozity). Olej zabezpečuje plnú ochranu motora vo všetkých prevádzkových podmienkach, udržuje čisté vnútorné časti motora, znižuje opotrebenie oderom, chráni pred koróziou a neutralizuje kyslé produkty, vznikajúce pri spaľovaní.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501492,
    brand: "DYNAMAX",
    image: "img6800",
    src: "6800.jpg",
    name: "DYNAMAX TRACTOR PLUS TXM 85W 20L",
    short_desc:
      "DYNAMAX TRACTOR PLUS TXM 85W je vysoko kvalitný takzvaný UTTO olej (Universal Tractor Transmission Oil), zložený zo starostlivo vybraných minerálnych základných zložiek a moderných aditív. Je určený pre použitie vo vysoko výkonných traktoroch, ktoré vyžadujú jeden olej pre hydraulický systém, prevodovku, diferenciál, vývodový hriadeľ alebo tzv. „mokré brzdy“.",
    desc: "DYNAMAX TRACTOR PLUS TXM 85W je vysoko kvalitný takzvaný UTTO olej (Universal Tractor Transmission Oil), zložený zo starostlivo vybraných minerálnych základných zložiek a moderných aditív. Je určený pre použitie vo vysoko výkonných traktoroch, ktoré vyžadujú jeden olej pre hydraulický systém, prevodovku, diferenciál, vývodový hriadeľ alebo tzv. „mokré brzdy“. Olej obsahuje aditívum pre zlepšenie indexu šmykovej stability, čím zabezpečuje skvelú tekutosť pri nízkych teplotách.",
    ean: 8586016012739,
    package: "",
    type: "olej",
    sub_category: "brzdovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501495,
    brand: "DYNAMAX",
    image: "img6803",
    src: "6803.jpg",
    name: "DYNAMAX TRACTOR PLUS TX 10W-40 20L",
    short_desc:
      "DYNAMAX TRACTOR PLUS TX 10W-40 je vysoko kvalitný takzvaný STOU olej (Super Tractor Oil Universal), zložený zo starostlivo vybraných minerálnych základných zložiek a moderných aditív. Tento olej bol navrhnutý tak, aby slúžil aj v hydraulickom systéme, mazal prevodovku, vývodový hriadeľ, rozvodovku a tzv. „mokré brzdy“.",
    desc: "DYNAMAX TRACTOR PLUS TX 10W-40 je vysoko kvalitný takzvaný STOU olej (Super Tractor Oil Universal), zložený zo starostlivo vybraných minerálnych základných zložiek a moderných aditív. Tento olej bol navrhnutý tak, aby slúžil aj v hydraulickom systéme, mazal prevodovku, vývodový hriadeľ, rozvodovku a tzv. „mokré brzdy“. Má viskozimetrické charakteristiky, ktoré umožňujú skvelé štartovanie za studena počas zimného obdobia. Zabezpečuje optimálnu ochranu motora, efektívne zabraňuje opotrebovaniu a nečistotám.",
    ean: 8586016012715,
    package: "",
    type: "olej",
    sub_category: "brzdovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501496,
    brand: "DYNAMAX",
    image: "img6804",
    src: "6804.jpg",
    name: "DYNAMAX TRACTOR PLUS TX 10W-40 50KG(57L)",
    short_desc:
      'DYNAMAX TRACTOR PLUS TX 10W-40 je vysoko kvalitný takzvaný STOU olej (Super Tractor Oil Universal), zložený zo starostlivo vybraných minerálnych základných zložiek a moderných aditív. Tento olej bol navrhnutý tak, aby slúžil aj v hydraulickom systéme, mazal prevodovku, vývodový hriadeľ, rozvodovku a tzv. „mokré brzdy".',
    desc: 'DYNAMAX TRACTOR PLUS TX 10W-40 je vysoko kvalitný takzvaný STOU olej (Super Tractor Oil Universal), zložený zo starostlivo vybraných minerálnych základných zložiek a moderných aditív. Tento olej bol navrhnutý tak, aby slúžil aj v hydraulickom systéme, mazal prevodovku, vývodový hriadeľ, rozvodovku a tzv. „mokré brzdy". Má viskozimetrické charakteristiky, ktoré umožňujú skvelé štartovanie za studena počas zimného obdobia. Zabezpečuje optimálnu ochranu motora, efektívne zabraňuje opotrebovan iu a nečistotám.',
    ean: "",
    package: "",
    type: "olej",
    sub_category: "brzdovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501498,
    brand: "DYNAMAX",
    image: "img6806",
    src: "6806.jpg",
    name: "DYNAMAX TRACTOR PLUS E 10W-40 20L",
    short_desc:
      "DYNAMAX TRACTOR PLUS E 10W-40 redukuje usadeniny na piestoch, znižuje spotrebu oleja a dovoľuje dlhšie výmenné intervaly. Je supervýkonný syntetický dieselový „Super High Performance Diesel Oil“ (SHPDO) motorový olej poskytujúci najvyšší výkon a dlhý pracovný potenciál pre vysoko výkonné, rýchlobežné, preplňované motory pracujúce za ťažkých podmienok.",
    desc: "DYNAMAX TRACTOR PLUS E 10W-40 redukuje usadeniny na piestoch, znižuje spotrebu oleja a dovoľuje dlhšie výmenné intervaly. Je supervýkonný syntetický dieselový „Super High Performance Diesel Oil“ (SHPDO) motorový olej poskytujúci najvyšší výkon a dlhý pracovný potenciál pre vysoko výkonné, rýchlobežné, preplňované motory pracujúce za ťažkých podmienok.",
    ean: 8586016012708,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501499,
    brand: "DYNAMAX",
    image: "img6807",
    src: "6807.jpg",
    name: "DYNAMAX TRACTOR PLUS E 10W-40 50KG(57L)",
    short_desc:
      "DYNAMAX TRACTOR PLUS E 10W-40 redukuje usadeniny na piestoch, znižuje spotrebu oleja a dovoľuje dlhšie výmenné intervaly. Je supervýkonný syntetický dieselový „Super High Performance Diesel Oil“ (SHPDO) motorový olej poskytujúci najvyšší výkon a dlhý pracovný potenciál pre vysoko výkonné, rýchlobežné, preplňované motory pracujúce za ťažkých podmienok.",
    desc: "DYNAMAX TRACTOR PLUS E 10W-40 redukuje usadeniny na piestoch, znižuje spotrebu oleja a dovoľuje dlhšie výmenné intervaly. Je supervýkonný syntetický dieselový „Super High Performance Diesel Oil“ (SHPDO) motorový olej poskytujúci najvyšší výkon a dlhý pracovný potenciál pre vysoko výkonné, rýchlobežné, preplňované motory pracujúce za ťažkých podmienok.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501500,
    brand: "DYNAMAX",
    image: "img6808",
    src: "6808.jpg",
    name: "DYNAMAX TRACTOR + E 10W40 175KG",
    short_desc: "NÁBOJ KOLESA/ULOZENIE",
    desc: "NÁBOJ KOLESA/ULOZENIE",
    ean: 4031185355063,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501501,
    brand: "DYNAMAX",
    image: "img6809",
    src: "6809.jpg",
    name: "DYNAMAX TRACTOR PLUS L 15W40 20L",
    short_desc:
      "Motorový olej DYNAMAX TRACTOR PLUS L 15W-40 je predstaviteľ novej generácie motorových olejov SHPDO, spĺňajúci požiadavky najnáročnejších naftových motorov. Je to celoročný olej s vysokým obsahom výkonnostných prísad, ktoré zabezpečujú vynikajúcu ochranu motora aj pri predĺžených výmenných intervaloch. Je vhodný aj na mazanie motorov ľahkých dodávkových automobilov s naftovým motorom.",
    desc: "Motorový olej DYNAMAX TRACTOR PLUS L 15W-40 je predstaviteľ novej generácie motorových olejov SHPDO, spĺňajúci požiadavky najnáročnejších naftových motorov. Je to celoročný olej s vysokým obsahom výkonnostných prísad, ktoré zabezpečujú vynikajúcu ochranu motora aj pri predĺžených výmenných intervaloch. Je vhodný aj na mazanie motorov ľahkých dodávkových automobilov s naftovým motorom.",
    ean: 4031185355087,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501506,
    brand: "DYNAMAX",
    image: "img6812",
    src: "6812.jpg",
    name: "DYNAMAX CHAIN SAW OIL 100 1L",
    short_desc:
      "DYNAMAX CHAIN SAW OIL 100 je vysoko kvalitný olej určený pre mazanie reťazových píl, zabraňuje ich poškodeniu alebo zaseknutiu.",
    desc: "DYNAMAX CHAIN SAW OIL 100 je vysoko kvalitný olej určený pre mazanie reťazových píl, zabraňuje ich poškodeniu alebo zaseknutiu. Je obohatený o špeciálnu prísadu, ktorá zabezpečuje lepšiu priľnavosť oleja k reťazi, čím sa minimalizujú straty oleja. Olej nie je vhodný pre mazanie motora!",
    ean: 8586016012661,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501507,
    brand: "DYNAMAX",
    image: "img6813",
    src: "6813.jpg",
    name: "DYNAMAX CHAIN SAW OIL 100 4L",
    short_desc:
      "DYNAMAX CHAIN SAW OIL 100 je vysoko kvalitný olej určený pre mazanie reťazových píl, zabraňuje ich poškodeniu alebo zaseknutiu.",
    desc: "DYNAMAX CHAIN SAW OIL 100 je vysoko kvalitný olej určený pre mazanie reťazových píl, zabraňuje ich poškodeniu alebo zaseknutiu. Je obohatený o špeciálnu prísadu, ktorá zabezpečuje lepšiu priľnavosť oleja k reťazi, čím sa minimalizujú straty oleja. Olej nie je vhodný pre mazanie motora!",
    ean: 8586016012678,
    package: 3,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501508,
    brand: "DYNAMAX",
    image: "img6814",
    src: "6814.jpg",
    name: "DYNAMAX CHAIN SAW OIL BIO 80 1L",
    short_desc:
      "DYNAMAX CHAIN SAW OIL BIO je biologicky odbúrateľný olej určený pre mazanie reťazových píl, zabraňuje ich poškodeniu alebo zaseknutiu.",
    desc: "DYNAMAX CHAIN SAW OIL BIO je biologicky odbúrateľný olej určený pre mazanie reťazových píl, zabraňuje ich poškodeniu alebo zaseknutiu. Je obohatený o špeciálnu prísadu, ktorá zabezpečuje lepšiu priľnavosť oleja k reťazi, čím sa minimalizujú strat y oleja. Chráni pred koróziou. Olej má výborné vlastnosti aj pri nízkych teplotách.",
    ean: 8586016012685,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501509,
    brand: "DYNAMAX",
    image: "img6815",
    src: "6815.jpg",
    name: "DYNAMAX CHAIN SAW OIL BIO 80 4L",
    short_desc:
      "DYNAMAX CHAIN SAW OIL BIO je biologicky odbúrateľný olej určený pre mazanie reťazových píl, zabraňuje ich poškodeniu alebo zaseknutiu.",
    desc: "DYNAMAX CHAIN SAW OIL BIO je biologicky odbúrateľný olej určený pre mazanie reťazových píl, zabraňuje ich poškodeniu alebo zaseknutiu. Je obohatený o špeciálnu prísadu, ktorá zabezpečuje lepšiu priľnavosť oleja k reťazi, čím sa minimalizujú straty oleja. Chráni pred koróziou. Olej má výborné vlastnosti aj pri nízkych teplotách.",
    ean: 8586016012692,
    package: 3,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501521,
    brand: "DYNAMAX",
    image: "img6818",
    src: "6818.jpg",
    name: "DXG1-ČISTIČ NA OKNÁ 500ML",
    short_desc:
      "Čistiaci prostriedok na sklo a zrkadlo. Odstraňuje mastnotu, smog, nikotín, hmyz a zvyšky vosku. Zanecháva dokonalý lesk bez šmúh a je príjemne parfumovaný. Čistiaca odmasťovacia pena má silné rozpúšťacie vlastnosti.",
    desc: "Čistiaci prostriedok na sklo a zrkadlo. Odstraňuje mastnotu, smog, nikotín, hmyz a zvyšky vosku. Zanecháva dokonalý lesk bez šmúh a je príjemne parfumovaný. Čistiaca odmasťovacia pena má silné rozpúšťacie vlastnosti.Použitie: Naneste rovnomerne na akýkoľvek druh skla alebo zrkadla a potom dosucha vyutierajte suchou handričkou alebo hodvábnym papierom.",
    ean: 8586016012258,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501522,
    brand: "DYNAMAX",
    image: "img108015",
    src: "108015.jpg",
    name: "DXG2 - TEKUTÝ STIERAČ 500ML",
    short_desc:
      "Zlepšuje viditeľnosť v mokrom počasí, počas hmly a pri snežení! DYNAMAX Rain off funguje na báze technológie zlučovania sa dažďových kvapiek pre zvýšenie viditeľnosti počas jazdy bez použitia stieračov. Znižuje priľnavosť nečistôt a hmyzu, napomáha k vyhľadeniu mikroskopických škrabancov na skle a znižuje odrazy svetla na týchto miestach.",
    desc: "Zlepšuje viditeľnosť v mokrom počasí, počas hmly a pri snežení! DYNAMAX Rain off funguje na báze technológie zlučovania sa dažďových kvapiek pre zvýšenie viditeľnosti počas jazdy bez použitia stieračov. Odpudzuje dážď tým, že spôsobí zlúčenie sa kvapiek. Znižuje priľnavosť nečistôt a hmyzu, napomáha k vyhľadeniu mikroskopických škrabancov na skle a znižuje odrazy svetla na týchto miestach. Tento antistatický prostriedok tiež znižuje tvorbu námrazy a zabraňuje jej opätovnému vzniku. Použitie: Rýchle a jednoduché použitie - stačí nastriekať a vyleštiť. Nastriekajte priamo na očistený a suchý povrch skla vozidla a utrieť do sucha.",
    ean: 8586016012432,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501524,
    brand: "DYNAMAX",
    image: "img6820",
    src: "6820.jpg",
    name: "DXE1-AUTOŠAMPÓN 1L",
    short_desc:
      "Vysoko koncentrovaný pH neutrálny autošampón s bohatým penovým efektom. Čistí, odmasťuje a nezanecháva žiadne zvyšky. Je zvlášť šetrný k laku a plastovým častiam auta, ľahko oplachovateľný a odolný voči tvrdej vode. Zanecháva vysoký lesk.",
    desc: "Vysoko koncentrovaný pH neutrálny autošampón s bohatým penovým efektom. Čistí, odmasťuje a nezanecháva žiadne zvyšky. Je zvlášť šetrný k laku a plastovým častiam auta, ľahko oplachovateľný a odolný voči tvrdej vode. Zanecháva vysoký lesk. Určený najmä na ručné umývanie. Ručné umývanie predlžuje životnosť autolakov. Použitie: Prípravok sa riedi s vodou v pomere 1:200. Pomocou špongie umyť znečistený povrch a opláchnuť čistou vodou.",
    ean: 8586016012296,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501525,
    brand: "DYNAMAX",
    image: "img6821",
    src: "6821.jpg",
    name: "DXE1-AUTOŠAMPÓN 10KG",
    short_desc:
      "Vysoko koncentrovaný pH neutrálny autošampón s bohatým penovým efektom. Čistí, odmasťuje a nezanecháva žiadne zvyšky. Je zvlášť šetrný k laku a plastovým častiam auta, ľahko oplachovateľný a odolný voči tvrdej vode. Zanecháva vysoký lesk.",
    desc: "Vysoko koncentrovaný pH neutrálny autošampón s bohatým penovým efektom. Čistí, odmasťuje a nezanecháva žiadne zvyšky. Je zvlášť šetrný k laku a plastovým častiam auta, ľahko oplachovateľný a odolný voči tvrdej vode. Zanecháva vysoký lesk. Určený najmä na ručné umývanie. Ručné umývanie predlžuje životnosť autolakov. Použitie: Prípravok sa riedi s vodou v pomere 1:200. Pomocou špongie umyť znečistený povrch a opláchnuť čistou vodou.",
    ean: 8586016012821,
    package: 1,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501526,
    brand: "DYNAMAX",
    image: "img6822",
    src: "6822.jpg",
    name: "DXE1-AUTOŠAMPÓN 25 KG",
    short_desc:
      "Vysoko koncentrovaný pH neutrálny autošampón s bohatým penovým efektom. Čistí, odmasťuje a nezanecháva žiadne zvyšky. Je zvlášť šetrný k laku a plastovým častiam auta, ľahko oplachovateľný a odolný voči tvrdej vode. Zanecháva vysoký lesk.",
    desc: "Vysoko koncentrovaný pH neutrálny autošampón s bohatým penovým efektom. Čistí, odmasťuje a nezanecháva žiadne zvyšky. Je zvlášť šetrný k laku a plastovým častiam auta, ľahko oplachovateľný a odolný voči tvrdej vode. Zanecháva vysoký lesk. Určený najmä na ručné umývanie. Ručné umývanie predlžuje životnosť autolakov. Použitie: Prípravok sa riedi s vodou v pomere 1:200. Pomocou špongie umyť znečistený povrch a opláchnuť čistou vodou.",
    ean: 8586016012838,
    package: 1,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501527,
    brand: "DYNAMAX",
    image: "img6823",
    src: "6823.jpg",
    name: "DXE4-ČISTIČ HLINÍKOVÝCH DISKOV 200L",
    short_desc:
      "Vysokoúčinný produkt na čistenie chrómovaných, poniklovaných a hliníkových diskov kolies. Obsahuje účinné látky zabraňujúce korózii. Jednoduché a ľahké použitie. Zanecháva povrch s vysokým leskom, čistý a jasný.",
    desc: "Vysokoúčinný produkt na čistenie chrómovaných, poniklovaných a hliníkových diskov kolies. Obsahuje účinné látky zabraňujúce korózii. Jednoduché a ľahké použitie. Zanecháva povrch s vysokým leskom, čistý a jasný. Použitie: Aplikujte, nechajte pôsobiť niekoľko sekúnd a opláchnite. Nepoužívajte na špeciálne, alebo natreté disky a na puklicové kryty z plastu.",
    ean: "",
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501528,
    brand: "DYNAMAX",
    image: "img6824",
    src: "6824.jpg",
    name: "DXE2-AUTOŠAMPÓN S VOSKOM 1L",
    short_desc:
      "Autošampón s vysoko leštiacim účinkom s obsahom ochranných voskov vhodný na každý typ autolaku vrátane metalízy. Prostriedok je jemný k laku, rýchlo oplachovateľný a schnúci, ktorý zanecháva povrch čistý so zvlášť vysokým leskom.",
    desc: "Autošampón s vysoko leštiacim účinkom s obsahom ochranných voskov vhodný na každý typ autolaku vrátane metalízy. Prostriedok je jemný k laku, rýchlo oplachovateľný a schnúci, ktorý zanecháva povrch čistý so zvlášť vysokým leskom. Použitie: 50 g autošampónu rozpustiť v 5-6 l vody (riedenie 1:100), vytvoriť bohatú penu. Naniesť špongiou na znečistený povrch a potom opláchnuť.",
    ean: 8586016012395,
    package: 12,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501529,
    brand: "DYNAMAX",
    image: "img6825",
    src: "6825.jpg",
    name: "DXE2-AUTOŠAMPÓN S VOSKOM 10KG",
    short_desc:
      "Autošampón s vysoko leštiacim účinkom s obsahom ochranných voskov vhodný na každý typ autolaku vrátane metalízy. Prostriedok je jemný k laku, rýchlo oplachovateľný a schnúci, ktorý zanecháva povrch čistý so zvlášť vysokým leskom.",
    desc: "Autošampón s vysoko leštiacim účinkom s obsahom ochranných voskov vhodný na každý typ autolaku vrátane metalízy. Prostriedok je jemný k laku, rýchlo oplachovateľný a schnúci, ktorý zanecháva povrch čistý so zvlášť vysokým leskom. Použitie: 50 g autošampónu rozpustiť v 5-6 l vody (riedenie 1:100), vytvoriť bohatú penu. Naniesť špongiou na znečistený povrch a potom opláchnuť.",
    ean: 8586016012845,
    package: 1,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501530,
    brand: "DYNAMAX",
    image: "img6826",
    src: "6826.jpg",
    name: "DXE2-AUTOŠAMPÓN S VOSKOM 25KG",
    short_desc:
      "Autošampón s vysoko leštiacim účinkom s obsahom ochranných voskov vhodný na každý typ autolaku vrátane metalízy. Prostriedok je jemný k laku, rýchlo oplachovateľný a schnúci, ktorý zanecháva povrch čistý so zvlášť vysokým leskom.",
    desc: "Autošampón s vysoko leštiacim účinkom s obsahom ochranných voskov vhodný na každý typ autolaku vrátane metalízy. Prostriedok je jemný k laku, rýchlo oplachovateľný a schnúci, ktorý zanecháva povrch čistý so zvlášť vysokým leskom. Použitie: 50 g autošampónu rozpustiť v 5-6 l vody (riedenie 1:100), vytvoriť bohatú penu. Naniesť špongiou na znečistený povrch a potom opláchnuť.",
    ean: 8586016012852,
    package: 1,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501531,
    brand: "DYNAMAX",
    image: "img6827",
    src: "6827.jpg",
    name: "DXE3-OŽIVOVAČ A LESK NA VONKAJŠIE  PLASTY 500ML",
    short_desc:
      "Unikátny tekutý prípravok na leštenie plastových dielov založený na báze prírodných voskov a silikónu, ktoré vynovujú a oživujú materiály z plastu, dreva, gumy, či mramoru.",
    desc: "Unikátny tekutý prípravok na leštenie plastových dielov založený na báze prírodných voskov a silikónu, ktoré vynovujú a oživujú materiály z plastu, dreva, gumy, či mramoru. Je antistatický a znižuje usadzovanie prachu. S jeho jednoduchou použiteľnosťou je ideálny pre starostlivosť a krásu automobilov, motocyklov, domy, karavany, atď. Použitie: Nastriekajte na čistú handričku a rozotrite.",
    ean: 8586016012272,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501532,
    brand: "DYNAMAX",
    image: "img6828",
    src: "6828.jpg",
    name: "DXE3-OŽIVOVAČ PLASTOV 10KG",
    short_desc:
      "Unikátny tekutý prípravok na leštenie plastových dielov založený na báze prírodných voskov a silikónu, ktoré vynovujú a oživujú materiály z plastu, dreva, gumy, či mramoru. Je antistatický a znižuje usadzovanie prachu.",
    desc: "Unikátny tekutý prípravok na leštenie plastových dielov založený na báze prírodných voskov a silikónu, ktoré vynovujú a oživujú materiály z plastu, dreva, gumy, či mramoru. Je antistatický a znižuje usadzovanie prachu. S jeho jednoduchou použiteľnosťou je ideálny pre starostlivosť a krásu automobilov, motocyklov, domy, karavany, atď. Použitie: Nastriekajte na čistú handričku a rozotrite.",
    ean: 8586016012869,
    package: 1,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501533,
    brand: "DYNAMAX",
    image: "img6829",
    src: "6829.jpg",
    name: "DXE4-ČISTIČ HLINÍKOVÝCH DISKOV 500ML",
    short_desc:
      "Vysokoúčinný produkt na čistenie chrómovaných, poniklovaných a hliníkových diskov kolies. Obsahuje účinné látky zabraňujúce korózii. Jednoduché a ľahké použitie. Zanecháva povrch s vysokým leskom, čistý a jasný.",
    desc: "Vysokoúčinný produkt na čistenie chrómovaných, poniklovaných a hliníkových diskov kolies. Obsahuje účinné látky zabraňujúce korózii. Jednoduché a ľahké použitie. Zanecháva povrch s vysokým leskom, čistý a jasný. Použitie: Aplikujte, nechajte pôsobiť niekoľko sekúnd a opláchnite. Nepoužívajte na špeciálne, alebo natreté disky a na puklicové kryty z plastu.",
    ean: 8586016012265,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501534,
    brand: "DYNAMAX",
    image: "img6830",
    src: "6830.jpg",
    name: "DXE4-PRÍPRAVOK NA HLINÍKOVÉ ČASTI 10KG",
    short_desc:
      "Vysoko účinný produkt na čistenie chrómovaných, poniklovaných a hliníkových diskov kolies. Obsahuje účinné látky zabraňujúce korózii. Jednoduché a ľahké použitie. Zanecháva povrch s vysokým leskom, čistý a jasný",
    desc: "Vysoko účinný produkt na čistenie chrómovaných, poniklovaných a hliníkových diskov kolies. Obsahuje účinné látky zabraňujúce korózii. Jednoduché a ľahké použitie. Zanecháva povrch s vysokým leskom, čistý a jasný. Použitie: Aplikujte, nechajte pôsobiť niekoľko sekúnd a opláchnite. Nepoužívajte na špeciálne, alebo natreté disky a na puklicové kryty z plastu.",
    ean: 8586016012951,
    package: 1,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501535,
    brand: "DYNAMAX",
    image: "img6831",
    src: "6831.jpg",
    name: "DXE4-PRÍPRAVOK NA HLINÍKOVÉ ČASTI 25KG",
    short_desc:
      "Vysoko účinný produkt na čistenie chrómovaných, poniklovaných a hliníkových diskov kolies. Obsahuje účinné látky zabraňujúce korózii. Jednoduché a ľahké použitie. Zanecháva povrch s vysokým leskom, čistý a jasný.",
    desc: "Vysoko účinný produkt na čistenie chrómovaných, poniklovaných a hliníkových diskov kolies. Obsahuje účinné látky zabraňujúce korózii. Jednoduché a ľahké použitie. Zanecháva povrch s vysokým leskom, čistý a jasný. Použitie: Aplikujte, nechajte pôsobiť niekoľko sekúnd a opláchnite. Nepoužívajte na špeciálne, alebo natreté disky a na puklicové kryty z plastu.",
    ean: 8586016012968,
    package: 1,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501536,
    brand: "DYNAMAX",
    image: "img6832",
    src: "6832.jpg",
    name: "DXE5-LESK NA PNEUMATIKY 500ML",
    short_desc:
      "Vysokoaktívny roztok čistí a oživuje všetky druhy pneumatík. Vďaka svojmu špeciálnemu zloženiu rozpúšťa nečistoty a tak dodá pneumatikám nový lesk. Prípravok dlhodobo ošetruje a chráni pneumatiky pred opotrebovaním, popraskaním a vznikom trhlín.",
    desc: "Vysokoaktívny roztok čistí a oživuje všetky druhy pneumatík. Vďaka svojmu špeciálnemu zloženiu rozpúšťa nečistoty a tak dodá pneumatikám nový lesk. Prípravok dlhodobo ošetruje a chráni pneumatiky pred opotrebovaním, popraskaním a vznikom trhlín. Doporučujeme nanášať na suchú pneumatiku. Použitie: Nastriekajte priamo na čistý povrch a nechajte zaschnúť.",
    ean: 8586016012470,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501538,
    brand: "DYNAMAX",
    image: "img6833",
    src: "6833.jpg",
    name: "DXE5-LESK NA PNEUMATIKY 10KG",
    short_desc:
      "Vysoko aktívny roztok čistí a oživuje všetky druhy pneumatík. Vďaka svojmu špeciálnemu zloženiu rozpúšťa nečistoty a tak dodá pneumatikám nový lesk. Prípravok dlhodobo ošetruje a chráni pneumatiky pred opotrebovaním, popraskaním a vznikom trhlín.",
    desc: "Vysoko aktívny roztok čistí a oživuje všetky druhy pneumatík. Vďaka svojmu špeciálnemu zloženiu rozpúšťa nečistoty a tak dodá pneumatikám nový lesk. Prípravok dlhodobo ošetruje a chráni pneumatiky pred opotrebovaním, popraskaním a vznikom trhlín. Doporučujeme nanášať na suchú pneumatiku. Použitie: Nastriekajte priamo na čistý povrch a nechajte zaschnúť.",
    ean: 8586016012913,
    package: 1,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501539,
    brand: "DYNAMAX",
    image: "img6834",
    src: "6834.jpg",
    name: "DXE5-LESK NA PNEUMATIKY 25KG",
    short_desc:
      "Vysokoaktívny roztok čistí a oživuje všetky druhy pneumatík. Vďaka svojmu špeciálnemu zloženiu rozpúšťa nečistoty a tak dodá pneumatikám nový lesk. Prípravok dlhodobo ošetruje a chráni pneumatiky pred opotrebovaním, popraskaním a vznikom trhlín.",
    desc: "Vysokoaktívny roztok čistí a oživuje všetky druhy pneumatík. Vďaka svojmu špeciálnemu zloženiu rozpúšťa nečistoty a tak dodá pneumatikám nový lesk. Prípravok dlhodobo ošetruje a chráni pneumatiky pred opotrebovaním, popraskaním a vznikom trhlín. Doporučujeme nanášať na suchú pneumatiku. Použitie: Nastriekajte priamo na čistý povrch a nechajte zaschnúť.",
    ean: 8586016012920,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501540,
    brand: "DYNAMAX",
    image: "img6835",
    src: "6835.jpg",
    name: "DXE6-ODSTRAŇOVAČ  HMYZU 500ML",
    short_desc:
      "Špeciálny čistiaci prostriedok odstraňujúci zvyšky hmyzu zo skiel a karosérie. Nespôsobuje žiadne poškodenie. Príjemne parfumovaný.",
    desc: "Špeciálny čistiaci prostriedok odstraňujúci zvyšky hmyzu zo skiel a karosérie. Nespôsobuje žiadne poškodenie. Príjemne parfumovaný. Použitie: Nastriekajte, špongiou rozotrite a opláchnite.",
    ean: 8586016012289,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501541,
    brand: "DYNAMAX",
    image: "img6836",
    src: "6836.jpg",
    name: "DXE6-ODSTRAŇOVAČ HMYZU 25KG",
    short_desc:
      "Špeciálny čistiaci prostriedok odstraňujúci zvyšky hmyzu zo skiel a karosérie. Nespôsobuje žiadne poškodenie. Príjemne parfumovaný.",
    desc: "Špeciálny čistiaci prostriedok odstraňujúci zvyšky hmyzu zo skiel a karosérie. Nespôsobuje žiadne poškodenie. Príjemne parfumovaný. Použitie: Nastriekajte, špongiou rozotrite a opláchnite.",
    ean: 8586016012906,
    package: 1,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501542,
    brand: "DYNAMAX",
    image: "img6837",
    src: "6837.jpg",
    name: "DXI2-UNIVERZÁLNY ČISTIČ INTERIÉRU 500ML",
    short_desc:
      "Vysokoúčinný univerzálny čistiaci prostriedok, ktorý bezpečne odmasťuje a odstraňuje nečistoty z plastových a gumených povrchov, skla, kovu, imitácie kože, mechanických dielov, smaltovaného, či lakovaného povrchu a iných materiálov.",
    desc: "Vysokoúčinný univerzálny čistiaci prostriedok, ktorý bezpečne odmasťuje a odstraňuje nečistoty z plastových a gumených povrchov, skla, kovu, imitácie kože, mechanických dielov, smaltovaného, či lakovaného povrchu a iných materiálov.",
    ean: 8586016012487,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501543,
    brand: "DYNAMAX",
    image: "img6838",
    src: "6838.jpg",
    name: "DXI2-UNIVERZÁLNY ČISTIČ INTERIÉRU 10KG",
    short_desc:
      "Vysokoúčinný univerzálny čistiaci prostriedok, ktorý bezpečne odmasťuje a odstraňuje nečistoty z plastových a gumených povrchov, skla, kovu, imitácie kože, mechanických dielov, smaltovaného, či lakovaného povrchu a iných materiálov.",
    desc: "Vysokoúčinný univerzálny čistiaci prostriedok, ktorý bezpečne odmasťuje a odstraňuje nečistoty z plastových a gumených povrchov, skla, kovu, imitácie kože, mechanických dielov, smaltovaného, či lakovaného povrchu a iných materiálov.",
    ean: 8586016012937,
    package: 1,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501544,
    brand: "DYNAMAX",
    image: "img6839",
    src: "6839.jpg",
    name: "DXI2-UNIVERZÁLNY ČISTIČ INTERIÉRU 25KG",
    short_desc:
      "Vysokoúčinný univerzálny čistiaci prostriedok, ktorý bezpečne odmasťuje a odstraňuje nečistoty z plastových a gumených povrchov, skla, kovu, imitácie kože, mechanických dielov, smaltovaného, či lakovaného povrchu a iných materiálov.",
    desc: "Vysokoúčinný univerzálny čistiaci prostriedok, ktorý bezpečne odmasťuje a odstraňuje nečistoty z plastových a gumených povrchov, skla, kovu, imitácie kože, mechanických dielov, smaltovaného, či lakovaného povrchu a iných materiálov.",
    ean: 8586016012944,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501546,
    brand: "DYNAMAX",
    image: "img6840",
    src: "6840.jpg",
    name: "DYNAMAX PRÍPRAVOK NA HYDRAULICKÉ ZDVIHÁTKA 300ML",
    short_desc:
      "Predchádza opotrebeniu hydraulických zdvíhadiel. Vytvára ochrannú vrstvu pre zníženie hluku. Prípravok znižuje poškodenie hydraulických zdvíhadiel pri vzájomnom trení a tým aj hluk produkovaný opotrebovaním zdvíhadiel.",
    desc: "Predchádza opotrebeniu hydraulických zdvíhadiel. Vytvára ochrannú vrstvu pre zníženie hluku. Prípravok znižuje poškodenie hydraulických zdvíhadiel pri vzájomnom trení a tým aj hluk produkovaný opotrebovaním zdvíhadiel. Čistí ventily a otvory na zdviháku a tým podporuje optimálnu prevádzku a zlepšuje studený štart. Účinkuje: počas jazdy. Riedenie: 300 ml na 6 l oleja. Odporúčaná aplikácia: po každej výmene oleja.",
    ean: 8586016012456,
    package: 12,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501547,
    brand: "DYNAMAX",
    image: "img6841",
    src: "6841.jpg",
    name: "DYNAMAX ČISTENIE OLEJOVÉHO SYSTÉMU 300ML",
    short_desc:
      "Rozpúšťa znečistenia v celom olejovom systéme. Zlepšená a stabilná kompresia vo všetkých valcoch. Zabraňuje kontaminácií čerstvého oleja. Prípravok slúži na odstraňovanie usadenín a nečistôt usadených v olejovom systéme, čím obnovuje kompresiu piestnych krúžkov.",
    desc: "Rozpúšťa znečistenia v celom olejovom systéme. Zlepšená a stabilná kompresia vo všetkých valcoch. Zabraňuje kontaminácií čerstvého oleja. Prípravok slúži na odstraňovanie usadenín a nečistôt usadených v olejovom systéme, čím obnovuje kompresiu piestnych krúžkov. Prečisťuje ventily a tým znižuje hlučnosť a zvyšuje účinnosť spaľovania. Aplikuje sa naliatim do starého oleja pri vypnutom motore. Následne sa nechá voľnobeh po dobu 15–20 min. Nakoniec sa olej vypustí a vymení sa olejový filter. Účinkuje: pred výmenou oleja. Riedenie: 300 ml na 5 l oleja. Odporúčaná aplikácia: pred každou výmenou oleja.",
    ean: 8586016012463,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501548,
    brand: "DYNAMAX",
    image: "img6842",
    src: "6842.jpg",
    name: "DXC6-UNIVERZÁLNY ČISTIČ EXTERIÉRU 5L",
    short_desc:
      "Vysoko koncentrovaný alkalický prípravok ideálny na čistenie akéhokoľvek druhu vozidla. Je to dvojzložková zmes najvyššej kvality nepostrádateľná pri profesionálnom umývaní vozidiel. Je vhodná na odmasťovanie a čistenie všetkých druhov nečistôt (tukov, smogu, špiny, škvŕn od krvi, zvyškov ropných látok) z povrchov áut, plachiet, podvozkov a kolies.",
    desc: "Vysoko koncentrovaný alkalický prípravok ideálny na čistenie akéhokoľvek druhu vozidla. Je to dvojzložková zmes najvyššej kvality nepostrádateľná pri profesionálnom umývaní vozidiel. Je vhodná na odmasťovanie a čistenie všetkých druhov nečistôt (tukov, smogu, špiny, škvŕn od krvi, zvyškov ropných látok) z povrchov áut, plachiet, podvozkov a kolies. Obsahuje vysoko disperzné povrchovo aktívne látky, ktoré umožňujú zachovať jeho umývacie vlastnosti aj pri použití vody s vysokým obsahom solí. Použitie: Prípravok najskôr zrieďte s vodou v pomere: 1:70–100 (predumývanie), 1:40–60 (normálne čistenie), 1:6–12 (kolesá a motory).",
    ean: 8586016012524,
    package: 1,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501549,
    brand: "DYNAMAX",
    image: "img6843",
    src: "6843.jpg",
    name: "DXC6-UNIVERZÁLNY ČISTIČ EXTERIÉRU 10KG",
    short_desc:
      "Vysoko koncentrovaný alkalický prípravok ideálny na čistenie akéhokoľvek druhu vozidla. Je to dvojzložková zmes najvyššej kvality nepostrádateľná pri profesionálnom umývaní vozidiel. Je vhodná na odmasťovanie a čistenie všetkých druhov nečistôt (tukov, smogu, špiny, škvŕn od krvi, zvyškov ropných látok) z povrchov áut, plachiet, podvozkov a kolies.",
    desc: "Vysoko koncentrovaný alkalický prípravok ideálny na čistenie akéhokoľvek druhu vozidla. Je to dvojzložková zmes najvyššej kvality nepostrádateľná pri profesionálnom umývaní vozidiel. Je vhodná na odmasťovanie a čistenie všetkých druhov nečistôt (tukov, smogu, špiny, škvŕn od krvi, zvyškov ropných látok) z povrchov áut, plachiet, podvozkov a kolies. Obsahuje vysoko disperzné povrchovo aktívne látky, ktoré umožňujú zachovať jeho umývacie vlastnosti aj pri použití vody s vysokým obsahom solí. Použitie: Prípravok najskôr zrieďte s vodou v pomere: 1:70–100 (predumývanie), 1:40–60 (normálne čistenie), 1:6–12 (kolesá a motory).",
    ean: 8586016012814,
    package: 1,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501550,
    brand: "DYNAMAX",
    image: "img6844",
    src: "6844.jpg",
    name: "DXC6-UNIVERZÁLNY ČISTIČ EXTERIÉRU 25KG",
    short_desc:
      "Vysoko koncentrovaný alkalický prípravok ideálny na čistenie akéhokoľvek druhu vozidla. Je to dvojzložková zmes najvyššej kvality nepostrádateľná pri profesionálnom umývaní vozidiel. Je vhodná na odmasťovanie a čistenie všetkých druhov nečistôt (tukov, smogu, špiny, škvŕn od krvi, zvyškov ropných látok) z povrchov áut, plachiet, podvozkov a kolies.",
    desc: "Vysoko koncentrovaný alkalický prípravok ideálny na čistenie akéhokoľvek druhu vozidla. Je to dvojzložková zmes najvyššej kvality nepostrádateľná pri profesionálnom umývaní vozidiel. Je vhodná na odmasťovanie a čistenie všetkých druhov nečistôt (tukov, smogu, špiny, škvŕn od krvi, zvyškov ropných látok) z povrchov áut, plachiet, podvozkov a kolies. Obsahuje vysoko disperzné povrchovo aktívne látky, ktoré umožňujú zachovať jeho umývacie vlastnosti aj pri použití vody s vysokým obsahom solí. Použitie: Prípravok najskôr zrieďte s vodou v pomere: 1:70–100 (predumývanie), 1:40–60 (normálne čistenie), 1:6–12 (kolesá a motory).",
    ean: 8586016012807,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501551,
    brand: "DYNAMAX",
    image: "img6845",
    src: "6845.jpg",
    name: "DYNAMAX TRACTOR PLUS TLV 20L",
    short_desc:
      "Je vysoko kvalitný hydraulický a prevodový olej. Tento vysoko výkonný univerzálny traktorový prevodový olej (UTTO) bol vyvinutý pre ťažko zaťažené hydraulické a prevodové systémy s alebo bez mokrých bŕzd poľnohospodárskych a stavebných strojov.",
    desc: "Je vysoko kvalitný hydraulický a prevodový olej. Tento vysoko výkonný univerzálny traktorový prevodový olej (UTTO) bol vyvinutý pre ťažko zaťažené hydraulické a prevodové systémy s alebo bez mokrých bŕzd poľnohospodárskych a stavebných strojov. Má vysoký a stabilný viskozitný index, mimoriadne nízky bod tuhnutia, veľmi dobrú stabilitu a odolnosť voči oxidácii, vysokým tlakom a proti oderové vlastnosti.",
    ean: 8586016012753,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501590,
    brand: "DYNAMAX",
    image: "img6852",
    src: "6852.jpg",
    name: "DYNAMAX TRUCKMAN PLUS  LE 10W-30 4L",
    short_desc:
      "DYNAMAX TRUCKMAN PLUS LE 10W30 je supervýkonný dieselový „Super High Performance Diesel“ (SHPD) motorový olej poskytujúci najvyšší výkon a dlhý pracovný potenciál pre vysoko výkonné, rýchlobežné, preplňované motory pracujúce za ťažkých podmienok.",
    desc: "DYNAMAX TRUCKMAN PLUS LE 10W30 je supervýkonný dieselový „Super High Performance Diesel“ (SHPD) motorový olej poskytujúci najvyšší výkon a dlhý pracovný potenciál pre vysoko výkonné, rýchlobežné, preplňované motory pracujúce za ťažkých podmienok. Redukuje usadeniny na piestoch, chráni pred opotrebením, znižuje spotrebu oleja a dovoľuje dlhšie výmenné intervaly. Je odporúčaný pre vozidlá s modernými systémami následného spracovania výfukových plynov (DPF, EGR alebo SCR) v kombinácii s motorovou naftou s nízkym obsahom síry, spĺňajúcich požiadavky normy Euro 4 a 5.",
    ean: 8586016013309,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501591,
    brand: "DYNAMAX",
    image: "img6853",
    src: "6853.jpg",
    name: "DYNAMAX TRUCKMAN PLUS  LM 10W-40 4L",
    short_desc:
      "DYNAMAX TRUCKMAN PLUS LM je vysoko výkonný syntetický olej pre dieselové motory s nízkym obsahom popola, fosforu a síry (SAPS). Bol špeciálne vyvinutý pre motory s filtrom pevných častíc (DPF) alebo zariadeniami na následnú úpravu výfukových plynov SCR (selektívna katalytická redukcia).",
    desc: "DYNAMAX TRUCKMAN PLUS LM je vysoko výkonný syntetický olej pre dieselové motory s nízkym obsahom popola, fosforu a síry (SAPS). Bol špeciálne vyvinutý pre motory s filtrom pevných častíc (DPF) alebo zariadeniami na následnú úpravu výfukových plynov SCR (selektívna katalytická redukcia). DYNAMAX TRUCKMAN PLUS LM je doporučovaný pre použitie v dieslových motoroch spĺňajúcich emisné požiadavky EURO 4 a 5, ale aj nižšie emisné normy.",
    ean: 8586016013293,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501592,
    brand: "DYNAMAX",
    image: "img6854",
    src: "6854.jpg",
    name: "DYNAMAX TRUCKMAN PLUS  M 10W-40 4L",
    short_desc:
      "DYNAMAX Truckman Plus M 10W-40 je vysoko výkonný syntetický motorový olej, ktorý je určený na mazanie dieselových motorov s turbo preplňovaním i nepreplňovaním. Má vynikajúcu tepelnú a oxidačnú stabilitu a vysokú odolnosť proti starnutiu, zvlášť pri vysokých teplotách. Spĺňa požiadavky na emisie podľa Euro 3.",
    desc: "DYNAMAX Truckman Plus M 10W-40 je vysoko výkonný syntetický motorový olej, ktorý je určený na mazanie dieselových motorov s turbo preplňovaním i nepreplňovaním. Má vynikajúcu tepelnú a oxidačnú stabilitu a vysokú odolnosť proti starnutiu, zvlášť pri vysokých teplotách. Spĺňa požiadavky na emisie podľa Euro 3. Olej je odporúčaný pre dieselové motory pracujúce za veľmi ťažkých prevádzkových podmienok napr. predĺžené intervaly výmeny olejov.",
    ean: 8586016013286,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501593,
    brand: "DYNAMAX",
    image: "img6855",
    src: "6855.jpg",
    name: "DYNAMAX TRUCKMAN PLUS SHPD 15W-40 4L",
    short_desc:
      "Je olej novej generácie typu SHPDO (Super High Performance Diesel Oil), odporúčaný pre vysoko namáhané naftové motory s turbo preplňovaním aj nepreplňovaním, s vylepšenými vlastnosťami, čo sa týka čistoty piestu, leštenia povrchu valca, zníženia opotrebenia, znečistenia sadzami a odolnosti proti stárnutiu.",
    desc: "Je olej novej generácie typu SHPDO (Super High Performance Diesel Oil), odporúčaný pre vysoko namáhané naftové motory s turbo preplňovaním aj nepreplňovaním, s vylepšenými vlastnosťami, čo sa týka čistoty piestu, leštenia povrchu valca, zníženia opotrebenia, znečistenia sadzami a odolnosti proti stárnutiu. Umožňuje dosahovať veľmi dlhé výmenné intervaly.",
    ean: 8586016013279,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501594,
    brand: "DYNAMAX",
    image: "img6856",
    src: "6856.jpg",
    name: "DXC8-SHDE–JEDNOZLOŽKOVÝ UNIVERZÁLNY ČISTIČ EXTERIÉRU 10KG",
    short_desc:
      "Vysoko koncentrovaný SHDE (Super Heavy Duty External) čistiaci alkalický prípravok vhodný na odmasťovanie a čistene všetkých druhov nečistôt z karosérie, plachiet, motorov alebo kolies. Vďaka jednozložkovej kompozícii je vhodný aj do umývacích strojov.",
    desc: "Vysoko koncentrovaný SHDE (Super Heavy Duty External) čistiaci alkalický prípravok vhodný na odmasťovanie a čistene všetkých druhov nečistôt z karosérie, plachiet, motorov alebo kolies. Vďaka jednozložkovej kompozícii je vhodný aj do umývacích strojov. Použitie: Prípravok zrieďte podľa manuálu s vodou, naneste na znečistený povrch, nechajte niekoľko minút pôsobiť a opláchnite vodou. Pri vyššej koncentrácií zabráňte dlhšiemu kontaktu s hliníkovým povrchom a jeho zliatinami.",
    ean: 8586016013347,
    package: "",
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501595,
    brand: "DYNAMAX",
    image: "img6857",
    src: "6857.jpg",
    name: "DXC8-SHDE–JEDNOZLOŽKOVÝ UNIVERZÁLNY ČISTIČ EXTERIÉRU 25KG",
    short_desc:
      "Vysoko koncentrovaný SHDE (Super Heavy Duty External) čistiaci alkalický prípravok vhodný na odmasťovanie a čistene všetkých druhov nečistôt z karosérie, plachiet, motorov alebo kolies. Vďaka jednozložkovej kompozícii je vhodný aj do umývacích strojov.",
    desc: "Vysoko koncentrovaný SHDE (Super Heavy Duty External) čistiaci alkalický prípravok vhodný na odmasťovanie a čistene všetkých druhov nečistôt z karosérie, plachiet, motorov alebo kolies. Vďaka jednozložkovej kompozícii je vhodný aj do umývacích strojov. Použitie: Prípravok zrieďte podľa manuálu s vodou, naneste na znečistený povrch, nechajte niekoľko minút pôsobiť a opláchnite vodou. Pri vyššej koncentrácií zabráňte dlhšiemu kontaktu s hliníkovým povrchom a jeho zliatinami.",
    ean: 8586016013354,
    package: "",
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501596,
    brand: "DYNAMAX",
    image: "img16594",
    src: "16594.jpg",
    name: "DYNAMAX ULTRA LONGLIFE 5W-30 1L",
    short_desc:
      "Doporučuje sa hlavne pre najnovšiu generáciu vysoko výkonných benzínových a dieselových osobných automobilov a dodávok, ktoré sú vybaven",
    desc: "Motorový olej DYNAMAX ULTRA LONGLIFE 5W-30 je vhodný pre použitie pre všetky benzínové a naftové motory osobných vozidiel vyžadujúcich motorový olej spĺňajúci špecifikácie VW 504.00, 507.00, čo znamená že spľňa predľžený výmenný interval /30.000 km/.",
    ean: 8586016013057,
    package: 12,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501597,
    brand: "DYNAMAX",
    image: "img16072",
    src: "16072.jpg",
    name: "DYNAMAX ULTRA LONGLIFE 5W-30 4 L",
    short_desc:
      "Doporučuje sa hlavne pre najnovšiu generáciu vysoko výkonných benzínových a dieselových osobných automobilov a dodávok vyžadujúcich motorový olej spĺňajúci špecifikácie VW 504.00, 507.00.",
    desc: "Motorový olej DYNAMAX ULTRA LONGLIFE 5W-30 je vhodný pre použitie pre všetky benzínové a naftové motory osobných vozidiel vyžadujúcich motorový olej spĺňajúci špecifikácie VW 504.00, 507.00, čo znamená že spľňa predľžený výmenný interval /30.000 km/.",
    ean: 8586016013064,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501599,
    brand: "DYNAMAX",
    image: "img27183",
    src: "27183.jpg",
    name: "DYNAMAX ULTRA PLUS PD 5W-40 1L",
    short_desc:
      "Syntetický motorový DYNAMAX ULTRA PLU S PD je najviac doporučovaný pre najnovšiu generáciu vysoko zaťažovaných benzínových, LPG a dieselov",
    desc: "Motorový olej DYNAMAX ULTRA PLUS PD je vysoko výkonný nízkoemisný syntetický celoročný motorový olej spĺňajúci požiadavky mid SAPS (Sulphated Ash, Phosphorus - Sulphur). Je vyrobený tak, aby predĺžil životnosť motora a životnosť zariadenia pre ná slednú úpravu výfukových plynov, ktoré používa posledná generácia benzínových a dieselových motorov u osobných automobilov.DYNAMAX ULTRA PLUS PD znižuje tvorbu popola v dieselových časticových filtroch (DPF).",
    ean: 8586016013071,
    package: 12,
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501600,
    brand: "DYNAMAX",
    image: "img24242",
    src: "24242.jpg",
    name: "DYNAMAX ULTRA PLUS PD 5W-40 4L",
    short_desc:
      "Syntetický motorový DYNAMAX ULTRA PLUS PD je najviac doporučovaný pre najnovšiu generáciu vysoko zaťažovaných benzínových, LPG a dieselových motorov.",
    desc: "Motorový olej DYNAMAX ULTRA PLUS PD je vysoko výkonný nízkoemisný syntetický celoročný motorový olej spĺňajúci požiadavky mid SAPS (Sulphated Ash, Phosphorus - Sulphur). Je vyrobený tak, aby predĺžil životnosť motora a životnosť zariadenia pre následnú úpravu výfukových plynov, ktoré používa posledná generácia benzínových a dieselových motorov u osobných automobilov.DYNAMAX ULTRA PLUS PD znižuje tvorbu popola v dieselových časticových filtroch (DPF).",
    ean: 8586016013088,
    package: 3,
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501601,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX ULTRA PLUS PD 5W40 20L",
    short_desc: "",
    desc: 0,
    ean: 8586016013422,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501602,
    brand: "DYNAMAX",
    image: "img16073",
    src: "16073.jpg",
    name: "DYNAMAX PREMIUM ULTRA 5W-40 1L",
    short_desc:
      "Syntetický motorový DYNAMAX ULTRA svojimi vlastnosťami prevyšuje požiadavky európskych, japonských a amerických automobilových výrobcov.",
    desc: "Je určený pre použitie na mazanie vysoko zaťažovaných benzínových motorov s predĺženým intervalom výmeny oleja. Je taktiež určený pre vysokozaťažované dieselové motory osobných automobilov a ľahkých dodávok, hlavne s priamym vstrekovaním s predlž eným intervalom výmeny stanoveným výrobcom motora, kde je požadovaná špeciálna kvalita oleja.",
    ean: 8586016013095,
    package: 12,
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501603,
    brand: "DYNAMAX",
    image: "img31987",
    src: "31987.jpg",
    name: "DYNAMAX PREMIUM ULTRA 5W-40 4L",
    short_desc:
      "Je určený pre použitie na mazanie vysoko zaťažovaných benzínových motorov s predĺženým intervalom výmeny oleja. Je taktiež určený pre vysokozaťažované dieselové motory osobných automobilov a ľahkých dodávok, hlavne s priamym vstrekovaním s predĺženým intervalom výmeny stanoveným výrobcom motora, kde je požadovaná špeciálna kvalita oleja.",
    desc: "Je určený pre použitie na mazanie vysoko zaťažovaných benzínových motorov s predĺženým intervalom výmeny oleja. Je taktiež určený pre vysokozaťažované dieselové motory osobných automobilov a ľahkých dodávok, hlavne s priamym vstrekovaním s predĺženým intervalom výmeny stanoveným výrobcom motora, kde je požadovaná špeciálna kvalita oleja. Syntetický motorový DYNAMAX ULTRA svojimi vlastnosťami prevyšuje požiadavky európskych, japonských a amerických automobilových výrobcov. Používa sa na mazanie vysoko zaťažovaných benzínových motorov s predĺženým intervalom výmeny oleja. Je taktiež určený pre vysoko zaťažované dieselové motory osobných automobilov a ľahkých dodávok hlavne s priamym vstrekovaním s predĺženým intervalom výmeny stanovený m výrobcom motora, kde je požadovaná špeciálna kvalita. DYNAMAX ULTRA je vhodný na mazanie preplňovaných a nepreplňovaných benzínových a naftových štvortaktných motorov osobných automobilov. DYNAMAX ULTRA je vhodný pre vozidlá s katalyzátorom výfukových plynov (EGR) atď. Zlepšené trecie vlastnosti vedú k dlhotrvajúcej úspore paliva.",
    ean: 4031185273824,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501605,
    brand: "DYNAMAX",
    image: "img18682",
    src: "18682.jpg",
    name: "DYNAMAX ULTRA 5W40 209L",
    short_desc:
      "Syntetický motorový DYNAMAX ULTRA svojimi vlastnosťami prevyšuje požiadavky európskych, japonských a amerických automobilových výrobcov.",
    desc: "Je určený pre použitie na mazanie vysoko zaťažovaných benzínových motorov s predĺženým intervalom výmeny oleja. Je taktiež určený pre vysokozaťažované dieselové motory osobných automobilov a ľahkých dodávok, hlavne s priamym vstrekovaním s predlž eným intervalom výmeny stanoveným výrobcom motora, kde je požadovaná špeciálna kvalita oleja.",
    ean: 4031185273848,
    package: "",
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501613,
    brand: "DYNAMAX",
    image: "img13884",
    src: "13884.jpg",
    name: "DYNAMAX TURBO PLUS 15W-40 1L",
    short_desc:
      "DYNAMAX TURBO PLUS je určený pre použitie v autobusoch, v nákladných automobiloch pracujúcich v najnáročnejších prevádzkových podmienkach.",
    desc: "Dynamax TURBO PLUS je určený pre takmer všetky typy motorových benzínových i naftových štvortaktných motorov,a to nepreplňovaných ako aj preplňovaných, vrátane motorov s katalyzátorom.",
    ean: 8586016013156,
    package: 12,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501614,
    brand: "DYNAMAX",
    image: "img26834",
    src: "26834.jpg",
    name: "DYNAMAX TURBO PLUS 15W-40 4L",
    short_desc:
      "Dynamax TURBO PLUS je určený pre takmer všetky typy motorových benzínových i naftových štvortaktných motorov,a to nepreplňovaných ako aj preplňovaných, vrátane motorov s katalyzátorom.",
    desc: "Dynamax TURBO PLUS je určený pre takmer všetky typy motorových benzínových i naftových štvortaktných motorov,a to nepreplňovaných ako aj preplňovaných, vrátane motorov s katalyzátorom. DYNAMAX TURBO PLUS je určený pre použitie v autobusoch, v ná kladných automobiloch pracujúcich v najnáročnejších prevádzkových podmienkach, v lodných motoroch, traktoroch a zemných strojoch.",
    ean: 8586016013163,
    package: 3,
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501616,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX TRUCKMAN PLUS FE 10W40 20L",
    short_desc: "",
    desc: 0,
    ean: 8586016015617,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501618,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX TRUCKMAN X 15W40 4L",
    short_desc: "",
    desc: 0,
    ean: 8586016013187,
    package: 3,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501619,
    brand: "DYNAMAX",
    image: "img16074",
    src: "16074.jpg",
    name: "DYNAMAX AUTOMATIC ATF IID 1L",
    short_desc:
      "Vysokokvalitný minerálny olej určený pre použitie v automatických prevodovkách osobných aj nákladných automobilov, autobusov, u ktorých výrobca doporučuje použitie oleja podľa GM DEXRON IID.",
    desc: "Vysokokvalitný minerálny olej určený pre použitie v automatických prevodovkách osobných aj nákladných automobilov, autobusov, u ktorých výrobca doporučuje použitie oleja podľa GM DEXRON IID. Olej sa doporučuje tiež používať v posilňovačoch riadeni a v hydraulických spojkách osobných a nákladných automobilov a tiež v hydraulických systémoch, ktoré vyžadujú použitie oleja typu ATF.",
    ean: 8586016013194,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501622,
    brand: "DYNAMAX",
    image: "img25037",
    src: "25037.jpg",
    name: "DYNAMAX AUTOMATIC ATF III 1L",
    short_desc:
      '<span style="color:#000000;font-family:GeogrotesqueWeb;font-size:large;font-style:normal;font-weight:normal;letter-spacing:normal;text-align:left;text-indent:0px;text-transform:none;white-space:normal;word-spacing:0px;background-color:#ffffff;float:none;"> Olej sa doporučuje tiež používať v posilňovačoch riadenia v hydraulických spojkách osobných a nákladných automobilov a tiež v hydraulických systémoch, ktoré vyžadujú použitie oleja typu ATF. <span style="color:#000000;font-family:GeogrotesqueWeb;font-size:large;font-style:normal;font-weight:normal;letter-spacing:normal;text-align:left;text-indent:0px;text-transform:none;white-space:normal;word-spacing:0px;background-color:#ffffff;float:none;">',
    desc: "Vysokokvalitný olej určený pre použitie v automatických prevodovkách osobných aj nákladných automobilov, autobusov, u ktorých výrobca doporučuje použitie oleja podľa GM DEXRON IIIG.",
    ean: 8586016013200,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501623,
    brand: "DYNAMAX",
    image: "img26381",
    src: "26381.jpg",
    name: "DYNAMAX HYPOL PP75W-90 GL-5 1L",
    short_desc:
      "Prevodový olej DYNAMAX HYPOL GL-5 75W-90 je určený na mazanie mechanických prevodov automobilov a hnacích náprav.",
    desc: 'Automobilový prevodový olej DYNAMAX HYPOL GL-5 75W-90 je syntetický olej s nízkym trením a špičkovým výkonom. Obsahuje špeciálne prísady na zvýšenie ochrany proti korózii, na zníženie opotrebenia materiálu. Tento prevodový olej má veľmi dobré nízkoteplotné vlastnosti, ktoré umožňujú optimálnu prevádzku všetkých pohyblivých častí a uľahčenie radenia prevodových stupňov „za studena".',
    ean: 8586016013217,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501624,
    brand: "DYNAMAX",
    image: "img18946",
    src: "18946.jpg",
    name: "DYNAMAX G- HYPOL PP 80W-90  GL4 1L",
    short_desc:
      "Dynamax HYPOL 80W-90 GL-4 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu.",
    desc: "Dynamax HYPOL 80W-90 GL-4 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Minerálny olej zaručujúci vždy dobré mazacie vlastnosti, vysokú odolnosť voči oxidácii a vysokú schopnosť prenášať zaťaženia.",
    ean: 8586016013224,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501625,
    brand: "DYNAMAX",
    image: "img51983",
    src: "51983.jpg",
    name: "DYNAMAX HYPOL PP 80W-90 GL4 4L",
    short_desc:
      "Dynamax HYPOL 80W-90 GL-4 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Minerálny olej zaručujúci vždy dobré mazacie vlastnosti, vysokú odolnosť voči oxidácii a vysokú schopnosť prenášať zaťaženia.",
    desc: "Dynamax HYPOL 80W-90 GL-4 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Minerálny olej zaručujúci vždy dobré mazacie vlastnosti, vysokú odolnosť voči oxidácii a vysokú schopnosť prenášať zaťaženia.",
    ean: 8586016017093,
    package: 3,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501626,
    brand: "DYNAMAX",
    image: "img18947",
    src: "18947.jpg",
    name: "DYNAMAX G- HYPOL PP 80W-90 GL5 1L",
    short_desc:
      "Automobilový prevodový olej DYNAMAX HYPOL GL-5 80W-90 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Minerálny olej s veľmi dobrými vlastnosťami: mazacími, protikoróznymi, antioxidačnými a protipeniacimi.",
    desc: "Automobilový prevodový olej DYNAMAX HYPOL GL-5 80W-90 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Minerálny olej s veľmi dobrými vlastnosťami: mazacími, protikoróznymi, antioxidačnými a protipeniacimi.",
    ean: 8586016013248,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501627,
    brand: "DYNAMAX",
    image: "img16075",
    src: "16075.jpg",
    name: "DYNAMAX M7ADX 15W-40 1L",
    short_desc:
      "Univerzálny automobilový motorový olej DYNAMAX M7ADX je zvlášť vhodný pre staršie typy osobných automobilov LADA a DACIA.",
    desc: "Celoročný univerzálny motorový olej určený na mazanie všetkých benzínových štvortaktných motorov. Možno ho tiež použiť na mazanie štvortaktných naftových motorov. DYNAMAX M7ADX obsahuje prísady, ktoré ho robia optimálnym pre stredoeurópske pásmo.",
    ean: 8586016013255,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501628,
    brand: "DYNAMAX",
    image: "img13885",
    src: "13885.jpg",
    name: "DYNAMAX M7ADX 15W-40 4L",
    short_desc:
      "Univerzálny automobilový motorový olej DYNAMAX M7ADX je zvlášť vhodný pre staršie typy osobných automobilov LADA a DACIA.",
    desc: "Univerzálny automobilový motorový olej DYNAMAX M7ADX je zvlášť vhodný pre staršie typy osobných automobilov LADA a DACIA. Celoročný univerzálny motorový olej určený na mazanie všetkých benzínových štvortaktných motorov. Možno ho tiež použiť na mazanie štvortaktných naftových motorov. DYNAMAX M7ADX obsahuje prísady, ktoré ho robia optimálnym pre stredoeurópske pásmo.",
    ean: 8586016013262,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501629,
    brand: "DYNAMAX",
    image: "img11017",
    src: "11017.jpg",
    name: "DYNAMAX OKVC 100 1 L",
    short_desc:
      "DYNAMAX OKVC 100 je určený na mazanie vzduchových piestových kompresorov a rotačných lopatkových kompresorov, s kvapkovým mazaním v nenáročných pracovných podmienkach.",
    desc: "Kompresorový olej DYNAMAX OKVC 100 je hydrogenačne rafinovaný ropný olej s veľkou chemickou stálosťou aj pri vyšších teplotách. Obsahuje prísady na zvýšenie viskozitného indexu a zníženie bodu tuhnutia.",
    ean: 8586016013323,
    package: 12,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501632,
    brand: "DYNAMAX",
    image: "img16307",
    src: "16307.jpg",
    name: "DYNAMAX M8AD 15W-50 10L",
    short_desc:
      "Motorový olej DYNAMAX M8AD je určený pre mazanie benzínových a dieselových štvortak tných motorov automobilov.",
    desc: "Celoročný motorový olej DYNAMAX M8AD je ropný olej vyrobený modernou technológiou, obsahujúci viskozitné výkonnostné prísady.Olej si počas celej doby používania zachováva svoju výkonnostnú triedu. Je určený na celoročné mazanie benzínových a die selových štvortaktných motorov automobilov. Umožňuje veľmi dobré štartovanie motorov pri nízkych teplotách a zároveň má značnú rezervu viskozity pre letné obdobie.",
    ean: 8586016013378,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501640,
    brand: "DYNAMAX",
    image: "img6858",
    src: "6858.jpg",
    name: "DXE8-ČISTIČ HLINÍKOVÝCH ČASTÍ A DISKOV 10KG",
    short_desc:
      "Čistič hliníkových častí a diskov založený na alkalickej báze (obsahuje silnú zásadu) je alternatívou pre podobné prípravky, ktoré sú postavené na kyslej báze (obsahujú silné kyseliny). Má vysokú účinnosť, rýchlo a dokonale odstraňuje oxidy a brzdový prach z akéhokoľvek typu disku bez mechanického pôsobenia. Nezanecháva škvrny, nepoškodzuje farbu, lak.",
    desc: "Čistič hliníkových častí a diskov založený na alkalickej báze (obsahuje silnú zásadu) je alternatívou pre podobné prípravky, ktoré sú postavené na kyslej báze (obsahujú silné kyseliny). Má vysokú účinnosť, rýchlo a dokonale odstraňuje oxidy a brzdový prach z akéhokoľvek typu disku bez mechanického pôsobenia. Nezanecháva škvrny, nepoškodzuje farbu, lak. Je vhodný aj na disky z hliníka a jeho zliatin. POUŽITIE: Prípravok zrieďte s vodou v pomere 1:3–6. Naneste na znečistený povrch, nechajte chvíľu pôsobiť a opláchnite vodou.",
    ean: "",
    package: 1,
    type: "doplnok",
    sub_category: "brzdovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501642,
    brand: "DYNAMAX",
    image: "img6859",
    src: "6859.jpg",
    name: "DXE8-ČISTIČ HLINÍKOVÝCH ČASTÍ A DISKOV 25KG",
    short_desc:
      "Čistič hliníkových častí a diskov založený na alkalickej báze (obsahuje silnú zásadu), je alternatívou pre podobné prípravky, ktoré sú postavené na kyslej báze (obsahujú silné kyseliny). Má vysokú účinnosť, rýchlo a dokonale odstraňuje oxidy a brzdový prach z akéhokoľvek typu disku bez mechanického pôsobenia. Nezanecháva škvrny, nepoškodzuje farbu, lak.",
    desc: "Čistič hliníkových častí a diskov založený na alkalickej báze (obsahuje silnú zásadu), je alternatívou pre podobné prípravky, ktoré sú postavené na kyslej báze (obsahujú silné kyseliny). Má vysokú účinnosť, rýchlo a dokonale odstraňuje oxidy a brzdový prach z akéhokoľvek typu disku bez mechanického pôsobenia. Nezanecháva škvrny, nepoškodzuje farbu, lak. Je vhodný aj na disky z hliníka a jeho zliatin. POUŽITIE: Prípravok zrieďte s vodou v pomere 1:3–6. Naneste na znečistený povrch, nechajte chvíľu pôsobiť a opláchnite vodou.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "brzdovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501643,
    brand: "DYNAMAX",
    image: "img6860",
    src: "6860.jpg",
    name: "DXE7 -  ČISTIACA AKTÍVNA PENA 10KG",
    short_desc:
      "Koncentrovaný výrobok na báze špeciálnych povrchovo aktívnych látok s vysokou čistiacou účinnosťou. Vytvára bohatú, hustú penu s vysokou odmasťovacou schopnosťou, ktorá zaručuje perfektné rozpustenie nečistôt – čistenie.",
    desc: "Koncentrovaný výrobok na báze špeciálnych povrchovo aktívnych látok s vysokou čistiacou účinnosťou. Vytvára bohatú, hustú penu s vysokou odmasťovacou schopnosťou, ktorá zaručuje perfektné rozpustenie nečistôt – čistenie. Ľahko sa oplachuje, nezanecháva žiadne zvyšky a neovplyvňuje pôsobenie sušiaceho vosku. POUŽITIE: Pri použití do automatických mycích liniek prípravok zrieďte s vodou v pomere 1:5–10.",
    ean: "",
    package: 1,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501644,
    brand: "DYNAMAX",
    image: "img11010",
    src: "11010.jpg",
    name: "DXE7 - ČISTIACA AKTÍVNA PENA 25KG",
    short_desc:
      "Koncentrovaný výrobok na báze špeciálnych povrchovo aktívnych látok s vysokou čistiacou účinnosťou. Vytvára bohatú, hustú penu s vysokou odmasťovacou schopnosťou, ktorá zaručuje perfektné rozpustenie nečistôt – čistenie.",
    desc: "Koncentrovaný výrobok na báze špeciálnych povrchovo aktívnych látok s vysokou čistiacou účinnosťou. Vytvára bohatú, hustú penu s vysokou odmasťovacou schopnosťou, ktorá zaručuje perfektné rozpustenie nečistôt – čistenie. Ľahko sa oplachuje, nezane cháva žiadne zvyšky a neovplyvňuje pôsobenie sušiaceho vosku.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501660,
    brand: "DYNAMAX",
    image: "img103468",
    src: "103468.jpg",
    name: "DYNAMAX LETNA ZMES 25L 1:100",
    short_desc:
      "Je to učinná kvapalina do ostrekovačov určená pre všetky typy motorových vozidiel v letnom období. Výrobok sa riedi v pomere 1:100 (1 diel zmesi a 1 00 dielov vody). Z 250 ml sa zarobí 25 l letnej zmesi.",
    desc: "Je to učinná kvapalina do ostrekovačov určená pre všetky typy motorových vozidiel v letnom období. Výrobok sa riedi v pomere 1:100 (1 diel zmesi a 1 00 dielov vody). Z 250 ml sa zarobí 25 l letnej zmesi.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501682,
    brand: "DYNAMAX",
    image: "img6865",
    src: "6865.jpg",
    name: "DYNAMAX COOL 11 R 1L",
    short_desc:
      "Koncentrovaná nízkotuhnúca chladiaca kvapalina celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla.",
    desc: "Koncentrovaná nízkotuhnúca chladiaca kvapalina celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Spľňa požiadavky výrobcov automobilov Renault a Volkswagen podľa normy AST M D 3306. Chladiaca kvapalina DYNAMAX G11 R je špeciálne vyvinutá pre motorové vozidlá značky Renault. Aplikuje sa do čistého chladiaceho systému podľa postupu výrobcu automobilu.",
    ean: 8586016013651,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501683,
    brand: "DYNAMAX",
    image: "img6866",
    src: "6866.jpg",
    name: "DYNAMAX MOTOFORCE  2T SYNTECH 1L",
    short_desc:
      "Dynamax Motoforce 2T Syntech je vysoko kvalitný syntetický olej odporúčaný pre dvojtaktné motory u motocyklov a skútrov. Je založený na vysoko kvalitných syntetických základových olejoch v kombinácii so špeciálnymi aditívami.",
    desc: "Dynamax Motoforce 2T Syntech je vysoko kvalitný syntetický olej odporúčaný pre dvojtaktné motory u motocyklov a skútrov. Je založený na vysoko kvalitných syntetických základových olejoch v kombinácii so špeciálnymi aditívami. Chráni piest pred odie raním a časti motora pred predčasným opotrebením. Má skvelú miešateľnosť s benzínom, čím vzniká homogénna a stabilná zmes aj pri nízkej teplote okolia. Potláča tvorbu úsad v piestnych drážkach, na výfukových kanáloch alebo na elektródach sviečok. Predlžuje životnosť motora bez straty výkonu.",
    ean: 8586016013545,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501684,
    brand: "DYNAMAX",
    image: "img6867",
    src: "6867.jpg",
    name: "DYNAMAX MOTOFORCE 2T SUPER 1L",
    short_desc:
      "Dynamax Motoforce 2T Super je vysoko kvalitný polosyntetický olej odporúčaný pre vysoko výkonné dvojtaktné vzduchom chladené benzínové motory. Je vhodný pre systém priameho vstrekovania oleja ako aj pre mazacie systémy s vopred zamiešanou zmesou.",
    desc: "Dynamax Motoforce 2T Super je vysoko kvalitný polosyntetický olej odporúčaný pre vysoko výkonné dvojtaktné vzduchom chladené benzínové motory. Je vhodný pre systém priameho vstrekovania oleja ako aj pre mazacie systémy s vopred zamiešanou zmesou. Je založený na vysoko kvalitných minerálnych a syntetických základových olejoch v kombinácii so špeciálnymi aditívami. Chráni piest pred odieraním a časti motora pred predčasným opotrebením. Má skvelú miešateľnosť s benzínom, čím vzniká homogénna a stabilná zmes aj pri nízkej teplote okolia. Potláča tvorbu usadenín v piestnych drážkach, na výfukových kanáloch alebo na elektródach sviečok. Predlžuje životnosť motora bez straty výkonu. Odporúčané miešanie od 50:1 do 25:1.",
    ean: 8586016013552,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501687,
    brand: "DYNAMAX",
    image: "img108016",
    src: "108016.jpg",
    name: "DYNAMAX MOTOFORCE 4T SYNTECH 10W40 1L",
    short_desc:
      "Dynamax Motoforce 4T Syntech Scooter je vysoko kvalitný syntetický olej odporúčaný pre vysoko výkonné štvortaktné benzínové motory u motocyklov.",
    desc: "Dynamax Motoforce 4T Syntech Scooter je vysoko kvalitný syntetický olej odporúčaný pre vysoko výkonné štvortaktné benzínové motory u motocyklov. Je založený na vysoko kvalitných syntetických základných zložkách v kombinácii so špeciálnymi aditívami . Olej má vynikajúcu termooxidačnú stabilitu, čím minimalizuje tvorbu usadenín a nečistôt. Poskytuje dokonalú ochranu motora, prevodovky a mokrej spojky, a to aj pri ťažkých prevádzkových podmienkach. Eliminuje preklzovanie spojky a zlepšuje jazdné vlastnosti. Umožňuje jednoduché štartovanie a zaisťuje efektívnu ochranu pred opotrebovaním pri štartovaní aj pri nízkych teplotách.",
    ean: 8586016013583,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501687,
    brand: "DYNAMAX",
    image: "img6870",
    src: "6870.jpg",
    name: "DYNAMAX MOTOFORCE 4T SYNTECH 10W-40 1L",
    short_desc:
      "Dynamax Motoforce 4T Syntech Scooter je vysoko kvalitný syntetický olej odporúčaný pre vysoko výkonné štvortaktné benzínové motory u motocyklov. Je založený na vysoko kvalitných syntetických základných zložkách v kombinácii so špeciálnymi aditívami.",
    desc: "Dynamax Motoforce 4T Syntech Scooter je vysoko kvalitný syntetický olej odporúčaný pre vysoko výkonné štvortaktné benzínové motory u motocyklov. Je založený na vysoko kvalitných syntetických základných zložkách v kombinácii so špeciálnymi aditívami. Olej má vynikajúcu termooxidačnú stabilitu, čím minimalizuje tvorbu usadenín a nečistôt. Poskytuje dokonalú ochranu motora, prevodovky a mokrej spojky, a to aj pri ťažkých prevádzkových podmienkach. Eliminuje preklzovanie spojky a zlepšuje jazdné vlastnosti. Umožňuje jednoduché štartovanie a zaisťuje efektívnu ochranu pred opotrebovaním pri štartovaní aj pri nízkych teplotách.",
    ean: 8586016013583,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501690,
    brand: "DYNAMAX",
    image: "img107987",
    src: "107987.jpg",
    name: "DYNAMAX COOL 11 R 4L",
    short_desc:
      "Koncentrovaná nízkotuhnúca chladiaca kvapalina celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Spľňa požiadavky výrobcov automobilov Renault a Volkswagen podľa normy AST M D 3306.",
    desc: "Koncentrovaná nízkotuhnúca chladiaca kvapalina celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Spľňa požiadavky výrobcov automobilov Renault a Volkswagen podľa normy AST M D 3306. Chladiaca kvapalina DYNAMAX G11 R je špeciálne vyvinutá pre motorové vozidlá značky Renault. Aplikuje sa do čistého chladiaceho systému podľa postupu výrobcu automobilu.",
    ean: 8586016013668,
    package: 3,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501691,
    brand: "DYNAMAX",
    image: "img6873",
    src: "6873.jpg",
    name: "DYNAMAX COOL 11 R 25L",
    short_desc:
      "Koncentrovaná nízkotuhnúca chladiaca kvapalina celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Spľňa požiadavky výrobcov automobilov Renault a Volkswagen podľa normy AST M D 3306.",
    desc: "Koncentrovaná nízkotuhnúca chladiaca kvapalina celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Spľňa požiadavky výrobcov automobilov Renault a Volkswagen podľa normy AST M D 3306. Chladiaca kvapalina DYNAMAX G11 R je špeciálne vyvinutá pre motorové vozidlá značky Renault. Aplikuje sa do čistého chladiaceho systému podľa postupu výrobcu automobilu.",
    ean: 8586016013675,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501693,
    brand: "DYNAMAX",
    image: "img6875",
    src: "6875.jpg",
    name: "DYNAMAX COOL 11 R 200L",
    short_desc: "",
    desc: "Koncentrovaná nízkotuhnúca chladiaca kvapalina celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Spľňa požiadavky výrobcov automobilov Renault a Volkswagen podľa normy AST M D 3306. Chladiaca kvapalina DYNAMAX G11 R je špeciálne vyvinutá pre motorové vozidlá značky Renault. Aplikuje sa do čistého chladiaceho systému podľa postupu výrobcu automobilu.",
    ean: 4031185069724,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501694,
    brand: "DYNAMAX",
    image: "img6876",
    src: "6876.jpg",
    name: "DYNAMAX MOTOFORCE 4T SUPER 10W-50 1L",
    short_desc:
      "Dynamax Motoforce 4T Super 10W-50 je vysoko kvalitný polosyntetický olej odporúčaný pre vysoko výkonné štvortaktné vodou chladené benzínové motory u motocyklov. Je založený na vysoko kvalitných minerálnych a syntetických základových olejov v kombinácii so špeciálnymi aditívami.",
    desc: "Dynamax Motoforce 4T Super 10W-50 je vysoko kvalitný polosyntetický olej odporúčaný pre vysoko výkonné štvortaktné vodou chladené benzínové motory u motocyklov. Je založený na vysoko kvalitných minerálnych a syntetických základových olejov v kombinácii so špeciálnymi aditívami. Poskytuje dokonalú ochranu motora, prevodovky a mokrej spojky. Eliminuje preklzovanie spojky a zlepšuje jazdné vlastnosti. Olej má vysokú teplotnú stabilitu, chráni pred opotrebením, penením a koróziou. Obsahuje benzensulfónovú kyselinu, propénovanú, vápenatú soľ, prealkalizovanú. Môže spôsobiť alergickú reakciu.",
    ean: 8586016013606,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501695,
    brand: "DYNAMAX",
    image: "img6877",
    src: "6877.jpg",
    name: "DYNAMAX MF 4T SYNTECH SCOOTER 1L 5W40",
    short_desc: "",
    desc: "Dynamax Motoforce 4T Syntech 10W-40 je vysoko výkonný syntetický olej odporúčaný pre štvortaktné motory u motocyklov, ktorý je kompatibilný s mokrými spojkami. Je založený na vysoko kvalitných syntetických základových olejoch v kombinácii so špe ciálnymi aditívami. Olej má vysoký a stabilný viskozitný index a vysokú teplotnú stabilitu, čo zaručuje optimálne mazanie aj v tých najnáročnejších podmienkach. Chráni pred opotrebením, penením a koróziou. Olej bol vyrábaný a testovaný v spolupráci s výrobcami motocyklov.",
    ean: 4046577410688,
    package: 12,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501724,
    brand: "DYNAMAX",
    image: "img52195",
    src: "52195.jpg",
    name: "DYNAMAX HYPOL PP80W-90 GL-4 20L",
    short_desc:
      "Prevodový ole j DYNAMAX HYPOL 80W-90 GL-4 je určený na mazanie mechanických prevodov automobilov a hnacích náprav, kde sú požadované oleje o <span style=\"color:#000000;font-family:'Droid Sans', Arial, Helvetica, sans-serif;font-size:13px;font-style:normal;font-weight:normal;letter-spacing:normal;text-indent:0px;text-transform:none;white-space:normal;word-spacing:0px;float:none;\">vlastnostiach SAE 80W-90 s výkonnostnou úrovňou API GL-4.",
    desc: '<span style="color:#000000;font-family:\'Droid Sans\', Arial, Helvetica, sans-serif;font-size:13px;font-style:normal;font-weight:normal;letter-spacing:normal;text-indent:0px;text-transform:none;white-space:normal;word-spacing:0px;float:none;">DYNAMAX HYPOL 80W-90 GL-4 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Minerálny olej zaručujúci vždy dobré mazacie vlastnosti, vysokú odolnosť voči oxidácii a vysokú schopnosť prenášať zaťaženia,<span style="color:#000000;font-family:\'Droid Sans\', Arial, Helvetica, sans-serif;font-size:13px;font-style:normal;font-weight:normal;letter-spacing:normal;text-indent:0px;text-transform:none;white-space:normal;word-spacing:0px;float:none;"> je určený na mazanie mechanických prevodov automobilov a hnacích náprav, kde sú požadované oleje o vlastnostiach SAE 80W-90 s výkonnostnou úrovňou API GL-4. Je určený pre mazanie vozov, ktoré pracujú v ťažkých prevádzkových podmienkach.<span class="Apple-converted-space">',
    ean: 8586016014023,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501725,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX TRUCKMAN PLUS 15W40 200L",
    short_desc: "",
    desc: 0,
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501732,
    brand: "DYNAMAX",
    image: "img6880",
    src: "6880.jpg",
    name: "DYNAMAX COOL 11 R 10L",
    short_desc:
      "Koncentrovaná nízkotuhnúca chladiaca kvapalina celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Spľňa požiadavky výrobcov automobilov Renault a Volkswagen podľa normy AST M D 3306.",
    desc: "Koncentrovaná nízkotuhnúca chladiaca kvapalina celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Spľňa požiadavky výrobcov automobilov Renault a Volkswagen podľa normy AST M D 3306. Chladiaca kvapalina DYNAMAX G11 R je špeciálne vyvinutá pre motorové vozidlá značky Renault. Aplikuje sa do čistého chladiaceho systému podľa postupu výrobcu automobilu.",
    ean: 8586016014030,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501739,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX CHAIN SAW OIL 100 10L",
    short_desc:
      "DYNAMAX CHAIN SAW OIL 100 je vysoko kvalitný olej určený pre mazanie reťazových píl, zabraňuje ich poškodeniu alebo zaseknutiu.",
    desc: "DYNAMAX CHAIN SAW OIL 100 je vysoko kvalitný olej určený pre mazanie reťazových píl, zabraňuje ich poškodeniu alebo zaseknutiu. Je obohatený o špeciálnu prísadu, ktorá zabezpečuje lepšiu priľnavosť oleja k reťazi, čím sa minimalizujú straty oleja. Olej nie je vhodný pre mazanie motora!",
    ean: 8586016014450,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501743,
    brand: "DYNAMAX",
    image: "img52299",
    src: "52299.jpg",
    name: "DYNAMAX C-TURBO PLUS 15W-40 20L",
    short_desc:
      "Motorový olej DYNAMAX M8AD je určený pre mazanie benzínových a dieselových štvortaktných motorov automobilov. Celoročný motorový olej DYNAMAX M8 AD je ropný olej vyrobený modernou technológiou, obsahujúci viskozitné výkonnostné prísady.",
    desc: "Motorový olej DYNAMAX M8AD je určený pre mazanie benzínových a dieselových štvortaktných motorov automobilov. Celoročný motorový olej DYNAMAX M8 AD je ropný olej vyrobený modernou technológiou, obsahujúci viskozitné výkonnostné prísady. Olej si po čas celej doby používania zachováva svoju výkonnostnú triedu. Je určený na celoročné mazanie benzínových a dieselových štvortaktných motorov automobilov. Umožňuje veľmi dobré štartovanie motorov pri nízkych teplotách a zároveň má značnú rezervu viskozity pre letné obdobie.",
    ean: 8586016014733,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501766,
    brand: "DYNAMAX",
    image: "img6889",
    src: "6889.jpg",
    name: "DYNAMAX ATF SUPER DSG 20L",
    short_desc: "",
    desc: "Dynamax ATF Super DSG je plnesyntetická vysoko výkonná kvapalina pre automatické prevodovky, špeciálne vyvinutá pre dvoj-spojové prevodovky skupiny VAG pre veľmi rýchle a športové radenie rýchlostí. Má vysoký a stabilný viskozitný index, mimoriadn e nízky bod tuhnutia. Má veľmi dobrú stabilitu a odolnosť voči oxidácii, opotrebeniu, korózii a peneniu.",
    ean: "",
    package: 1,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501820,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX COOL AL C11 -25 1L",
    short_desc: "",
    desc: 0,
    ean: 8586016014535,
    package: 12,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501821,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX COOL AL C11 -25 4L",
    short_desc: "",
    desc: 0,
    ean: 8586016014542,
    package: 3,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501823,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX HYPOL 80W90 GL-5 20L",
    short_desc: "",
    desc: 0,
    ean: 8586016014689,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501840,
    brand: "DYNAMAX",
    image: "img22623",
    src: "22623.jpg",
    name: "DYNAMAX M4T GARDENS SUPER 10W-30 1L",
    short_desc:
      "DYNAMAX M4T GARDENS SUPER 10W-30 je určený pre štvortaktné motory modernej záhradnej techniky (kosačky, pluhy, snehové frézy). Je tiež určený pre benzínové motory s alebo bez katalyzátora.",
    desc: "DYNAMAX M4T GARDENS SUPER 10W-30 je vysoko kvalitný ropný olej vyrobený modernou technológiou, obsahujúci vysoko obohacujúce prísady. Vytvára trvalý mazací film odolný voči mechanickému zaťaženiu aj pri vysokých teplotách. Má veľmi dobrú odolnosť voči oxidácii, chráni pred koróziou, zabraňuje tvorbe usadenín. Je plne miešateľný s ostanými olejmi rovnakej kvality a viskozity. DYNAMAX M4T SUPER 10W-30 je určený pre štvortaktné motory modernej záhradnej techniky (kosačky, pluhy, snehové frézy). Je tiež určený pre benzínové motory s alebo bez katalyzátora.",
    ean: 8586016014696,
    package: 12,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501841,
    brand: "DYNAMAX",
    image: "img88957",
    src: "88957.jpg",
    name: "DYNAMAX ATF IID 20L",
    short_desc:
      "Vysokokvalitný minerálny olej pre použitie v automatických prevodovkách osobných aj nákladných automobilov, autobusov, u ktorých výrobca doporučuje použitie oleja podľa GM DEXRON II D.",
    desc: "Vysokokvalitný minerálny olej pre použitie v automatických prevodovkách osobných aj nákladných automobilov, autobusov, u ktorých výrobca doporučuje použitie oleja podľa GM DEXRON II D. Olej sa doporučuje tiež používať v posilňovačoch riadenia v hydraulických spojkách osobných anákladných automobilov a tiež v hydraulických systémoch, ktoré vyžadujú použitie oleja typu ATF.",
    ean: 8586016014788,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501843,
    brand: "DYNAMAX",
    image: "img52297",
    src: "52297.jpg",
    name: "DYNAMAX AUTOMATIC ATF III 20L",
    short_desc:
      "Olej sa doporučuje tiež používať v posilňovačoch riadenia v h ydraulických spojkách osobných a nákladných automobilov a tiež v hydraulic",
    desc: "Vysokokvalitný olej určený pre použitie v automatických prevodovkách osobných aj nákladných automobilov, autobusov, u ktorých výrobca doporučuje použitie oleja podľa GM DEXRON IIIG.",
    ean: 8586016014795,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501852,
    brand: "DYNAMAX",
    image: "img42779",
    src: "42779.jpg",
    name: "DYNAMAX ADBLUE 4,7 L",
    short_desc:
      "Vodný roztok močoviny s vysokou chemickou čistotou podla ISO 22241 pre prevádzku SCR katalyzátorov. Pokyny a doporučenia: Skladujte pri teplote od -5°C do +25°C.",
    desc: "Vodný roztok močoviny s vysokou chemickou čistotou podla ISO 22241 pre prevádzku SCR katalyzátorov. Pokyny a doporučenia: Skladujte pri teplote od -5°C do +25°C. Neskladujte na priamom slnku. Skladujte iba v tomto originálnom obale. Nikdy neprelievajte AdBlue do použitých obalov (napr. od pohonných hmôt, prevádzkových kvapalín). Nebezpečenstvo kontaminácie AdBlue a poškodenie katalyzátora. Minimálna trvanlivosť: 1 rok od dátumu výroby.",
    ean: 8586016014825,
    package: 3,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501855,
    brand: "DYNAMAX",
    image: "img52298",
    src: "52298.jpg",
    name: "DYNAMAX OHHM 68 VG68 20L",
    short_desc:
      "Hydraulické oleje DYNAMAX OHHM 68 sú určené pre hydrostatické mechanizmy s vysokým mechanickým aj tepelným namáhaním.",
    desc: "DYNAMAX OHHM 68 je hydrogenačne rafinovaný ropný olej zušľachtený prísadami na zlepšenie oxidačnej stálosti, protikoróznych a protioderových vlastností a prísadami proti peneniu. Obsahujú modifikátor viskozity s depresantným účinkom.",
    ean: 8586016014849,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501882,
    brand: "DYNAMAX",
    image: "img18685",
    src: "18685.jpg",
    name: "DYNAMAX TURBO PLUS 15W-40 60L (53,5KG)",
    short_desc:
      "Dynamax TURBO PLUS je určený pre takmer všetky typy motorových benzínových i naftových štvortaktných motorov,a to nepreplňovaných ako aj preplňovaných, vrátane motorov s katalyzátorom.",
    desc: "Dynamax TURBO PLUS je určený pre takmer všetky typy motorových benzínových i naftových štvortaktných motorov,a to nepreplňovaných ako aj preplňovaných, vrátane motorov s katalyzátorom. DYNAMAX TURBO PLUS je určený pre použitie v autobusoch, v ná kladných automobiloch pracujúcich v najnáročnejších prevádzkových podmienkach, v lodných motoroch, traktoroch a zemných strojoch.",
    ean: 8586016015013,
    package: "",
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501883,
    brand: "DYNAMAX",
    image: "img18686",
    src: "18686.jpg",
    name: "DYNAMAX TURBO PLUS 15W-40 209L (185KG)",
    short_desc:
      "Dynamax TURBO PLUS je určený pre takmer všetky typy motorových benzínových i naftových štvortaktných motorov,a to nepreplňovaných ako aj preplňovaných, vrátane motorov s katalyzátorom.",
    desc: "Dynamax TURBO PLUS je určený pre takmer všetky typy motorových benzínových i naftových štvortaktných motorov,a to nepreplňovaných ako aj preplňovaných, vrátane motorov s katalyzátorom. DYNAMAX TURBO PLUS je určený pre použitie v autobusoch, v ná kladných automobiloch pracujúcich v najnáročnejších prevádzkových podmienkach, v lodných motoroch, traktoroch a zemných strojoch.",
    ean: 8586016015150,
    package: "",
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501886,
    brand: "DYNAMAX",
    image: "img63810",
    src: "63810.jpg",
    name: "DYNAMAX MF 2T 1L",
    short_desc:
      "Dynamax Motoforce 2T je vysoko kvalitný ropný olej vyrobený modernou technológiou, obsahujúci prísady potláčajúce tvorbu úsad v piestnych drážkach, na výfukových kanáloch a na elektródach sviečok, ako aj prísady zlepšujúce mazacie schopnosti oleja.",
    desc: "Dynamax Motoforce 2T je vysoko kvalitný ropný olej vyrobený modernou technológiou, obsahujúci prísady potláčajúce tvorbu úsad v piestnych drážkach, na výfukových kanáloch a na elektródach sviečok, ako aj prísady zlepšujúce mazacie schopnosti oleja. Chráni piest pred odieraním a časti motora pred predčasným opotrebením. Má skvelú miešateľnosť s benzínom, čím vzniká homogénna a stabilná zmes aj pri nízkej teplote okolia. Olej je odporúčaný pre dvojtaktné motory u motocyklov alebo skútrov vyžadujúcich kvalitu API TC a JASO FB. Je vhodný tak pre priame vstrekovanie oleja ako aj pre mazacie systémy s vopred zamiešanou zmesou.",
    ean: 8586016014887,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501887,
    brand: "DYNAMAX",
    image: "img62906",
    src: "62906.jpg",
    name: "DYNAMAX MOTOFORCE 2T SUPER SCOOTER 1L",
    short_desc:
      "Dynamax Motoforce 2T Super Scooter je motorový olej určený na celoročné mazanie vysoko zatažených dvojtaktných motorov mazaných zmesou oleja s benzínom.",
    desc: "Dynamax Motoforce 2T Super Scooter je motorový olej určený na celoročné mazanie vysoko zatažených dvojtaktných motorov mazaných zmesou oleja s benzínom. Používa sa na mazanie náročných dvojtaktných motorov automobilov, motocyklov, snežných skútrov , vodných čerpadiel a generátorov.",
    ean: 8586016014894,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501889,
    brand: "DYNAMAX",
    image: "img19122",
    src: "19122.jpg",
    name: "DYNAMAX OHHM 46 VG 46 209 L (184KG)",
    short_desc:
      "DYNAMAX OHHM 46 je hydrogenačne rafinovaný ropný olej zušľachtený prísadami na zlepšenie oxidačnej stálosti, protikoróznych a protioderových vlastností a prísadami proti peneniu.",
    desc: "DYNAMAX OHHM 46 je hydrogenačne rafinovaný ropný olej zušľachtený prísadami na zlepšenie oxidačnej stálosti, protikoróznych a protioderových vlastností a prísadami proti peneniu. Obsahujú modifikátor viskozity s depresantným účinkom. Hydraulický o lej OHHM 46 je určený pre hydrostatické mechanizmy s vysokým mechanickým aj tepelným namáhaním pre stabilné aj mobilné stroje pracujúce v nechránenom prostredí. Sú použiteľné celoročne a sú kompatibilné s väčšinou hydraulických olejov iných výrobcov.",
    ean: 8586016015051,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501892,
    brand: "DYNAMAX",
    image: "img16079",
    src: "16079.jpg",
    name: "DYNAMAX UNI PLUS 10W-40 1L",
    short_desc:
      "Je polosyntetický motorový olej vhodný pre benzínové i dieselové motory. Syntetická zložka oleja zlepšuje mazanie motora v záťažových podmienkach a zároveň zachováva výborné vlastnosti oleja.",
    desc: "Je polosyntetický motorový olej vhodný pre benzínové i dieselové motory. Syntetická zložka oleja zlepšuje mazanie motora v záťažových podmienkach a zároveň zachováva výborné vlastnosti oleja. Je vhodný na celoročné používanie. Má vyhovujúce vlastn osti pri nízkych teplotách v zimnom období a tiež pri vysokých teplotách v letnom období.",
    ean: 8586016014863,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501893,
    brand: "DYNAMAX",
    image: "img11256",
    src: "11256.jpg",
    name: "DYNAMAX UNI PLUS 10W-40 4 L",
    short_desc:
      "Je polosyntetický motorový olej vhodný pre benzínové i dieselové motory. Syntetická zložka oleja zlepšuje mazanie motora v záťažových podmienkach a zároveň zachováva výborné vlastnosti oleja. Je vhodný na celoročné používanie. Má vyhovujúce vlastnosti pri nízkych teplotách v zimnom období a tiež pri vysokých teplotách v letnom období.",
    desc: "Je polosyntetický motorový olej vhodný pre benzínové i dieselové motory. Syntetická zložka oleja zlepšuje mazanie motora v záťažových podmienkach a zároveň zachováva výborné vlastnosti oleja. Je vhodný na celoročné používanie. Má vyhovujúce vlastnosti pri nízkych teplotách v zimnom období a tiež pri vysokých teplotách v letnom období.",
    ean: 8586016014917,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501894,
    brand: "DYNAMAX",
    image: "img19203",
    src: "19203.jpg",
    name: "DYNAMAX UNI PLUS 10W-40 60L(52,5KG)",
    short_desc:
      "Je polosyntetický motorový olej vhodný pre benzínové i dieselové motory. Syntetická zložka oleja zlepšuje mazanie motora v záťažových podmienkach a zároveň zachováva výborné vlastnosti oleja.",
    desc: "Je polosyntetický motorový olej vhodný pre benzínové i dieselové motory. Syntetická zložka oleja zlepšuje mazanie motora v záťažových podmienkach a zároveň zachováva výborné vlastnosti oleja. Je vhodný na celoročné používanie. Má vyhovujúce vlastn osti pri nízkych teplotách v zimnom období a tiež pri vysokých teplotách v letnom období.",
    ean: 8586016014993,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501895,
    brand: "DYNAMAX",
    image: "img19204",
    src: "19204.jpg",
    name: "DYNAMAX UNI PLUS 10W-40 209L(182,5KG)",
    short_desc:
      "Je polosyntetický motorový olej vhodný pre benzínové i dieselové motory. Syntetická zložka oleja zlepšuje mazanie motora v záťažových podmienkach a zároveň zachováva výborné vlastnosti oleja.",
    desc: "Je polosyntetický motorový olej vhodný pre benzínové i dieselové motory. Syntetická zložka oleja zlepšuje mazanie motora v záťažových podmienkach a zároveň zachováva výborné vlastnosti oleja. Je vhodný na celoročné používanie. Má vyhovujúce vlastnosti pri nízkych teplotách v zimnom období a tiež pri vysokých teplotách v letnom období.",
    ean: 8586016015006,
    package: 1,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501900,
    brand: "DYNAMAX",
    image: "img81623",
    src: "81623.jpg",
    name: "DYNAMAX ATF III COLORLESS 1L",
    short_desc:
      "Vysokokvalitná bezfarebná kvapalina pre automatické prevodovky vyrobená na báze PAO základových olejov s pridaním špeciálnych aditív pre zaistenie dokonalého mazania a ochrany proti opotrebeniu.",
    desc: "Vysokokvalitná bezfarebná kvapalina pre automatické prevodovky vyrobená na báze PAO základových olejov s pridaním špeciálnych aditív pre zaistenie dokonalého mazania a ochrany proti opotrebeniu. Je vhodná pre všetky typy automatických prevodoviek vyžadujúcich špecifikáciu Dexron III G s alebo bez GKÜB (riadené uzamykanie spojky). EUH208 Obsahuje C12-14-terc-alkylamíny. Môže vyvolať alergickú reakciu. P273 Zabráňte uvoľneniu do životného prostredia. P501 Zneškodnite obsah/nádobu ako nebezpečný odpad podľa platných právnych predpisov. Min. doba trvanlivosti: 3 roky od dátumu výroby.",
    ean: 8586016015211,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501902,
    brand: "DYNAMAX",
    image: "img74838",
    src: "74838.jpg",
    name: "DYNAMAX SL PLUS 20W-50 1L",
    short_desc:
      "Vysokovýkonný motorový olej vyrobený na báze minerálneho základového oleja s pridaním aditív pre zlepšenie teplotnej a oxidačnej stability. Je vhodný pre moderné benzínové, dieselové a LPG motory osobných automobilov a dodávok s alebo bez preplňovania. Olej navyše zaručuje ochranu proti opotrebeniu, peneniu a korózií.",
    desc: "Vysokovýkonný motorový olej vyrobený na báze minerálneho základového oleja s pridaním aditív pre zlepšenie teplotnej a oxidačnej stability. Je vhodný pre moderné benzínové, dieselové a LPG motory osobných automobilov a dodávok s alebo bez preplňovania. Olej navyše zaručuje ochranu proti opotrebeniu, peneniu a korózií.",
    ean: 8586016015228,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501903,
    brand: "DYNAMAX",
    image: "img14300",
    src: "14300.jpg",
    name: "DYNAMAX MF 4T SUPER SCOOTER 60L",
    short_desc:
      "Vysoko výkonný polosyntetický motorový olej určený pre vzduchom chladené 4T motory. Olej poskytuje dokonalú ochranu motora, prevodovky a mokrej spojky a to aj pri ťažkých prevádzkových podmienkach.",
    desc: "Vysoko výkonný polosyntetický motorový olej určený pre vzduchom chladené 4T motory. Olej poskytuje dokonalú ochranu motora, prevodovky a mokrej spojky a to aj pri ťažkých prevádzkových podmienkach. Eliminuje preklzovanie spojky a zlepšuje jazdné vlastnosti.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501907,
    brand: "DYNAMAX",
    image: "img29392",
    src: "29392.jpg",
    name: "DYNAMAX TRACTOR PLUS TXM 85W 10L",
    short_desc:
      "Olej obsahuje aditívum pre zlepšenie indexu šmykovej stability, čím zabezpečuje skvelú tekutosť pri nízkych teplotách.",
    desc: 'DYNAMAX TRACT OR PLUS TXM 85W je vysoko kvalitný takzvaný UTTO olej (Universal Tractor Transmission Oil), zložený zo starostlivo vybraných minerálnych základných zložiek a moderných aditív. Je určený pre použitie vo vysoko výkonných traktoroch, ktoré vyžadujú jeden olej pre hydraulický systém, prevodovku, diferenciál, vývodový hriadeľ alebo tzv. „mokré brzdy".',
    ean: 8586016015433,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501908,
    brand: "DYNAMAX",
    image: "img54172",
    src: "54172.jpg",
    name: "DYNAMAX RACING SM 5W-50 1L",
    short_desc:
      "Je vysokovýkonný plne syntetický motorový olej výnimočnej kvality. Poskytuje maximálny výkon v benzínových, dieselových a LPG motoroch s, alebo bez preplňovania pracujúcich v náročných teplotných podmienkach.",
    desc: "Je vysokovýkonný plne syntetický motorový olej výnimočnej kvality. Poskytuje maximálny výkon v benzínových, dieselových a LPG motoroch s, alebo bez preplňovania pracujúcich v náročných teplotných podmienkach.",
    ean: 8586016015235,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501909,
    brand: "DYNAMAX",
    image: "img54171",
    src: "54171.jpg",
    name: "DYNAMAX RACING SL 10W-60 1L",
    short_desc:
      "Je vysokovýkonný plne syntetický motorový olej výnimočnej kvality. Poskytuje maximálny výkon v benzínových, dieselových a LPG motoroch s, alebo bez preplňovania pracujúcich v náročných teplotných podmienkach.",
    desc: "Je vysokovýkonný plne syntetický motorový olej výnimočnej kvality. Poskytuje maximálny výkon v benzínových, dieselových a LPG motoroch s, alebo bez preplňovania pracujúcich v náročných teplotných podmienkach.",
    ean: 8586016015242,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501911,
    brand: "DYNAMAX",
    image: "img66219",
    src: "66219.jpg",
    name: "DYNAMAX MF 4T SUPER SCOOTER 1L 10W40",
    short_desc:
      "Dynamax Motoforce 4T SuperScooter je vysoko kvalitný polosyntetický olej odporúčaný pre vysoko výkonné štvortaktné vzduchom chladené benzínové motory motocyklov.",
    desc: "Dynamax Motoforce 4T SuperScooter je vysoko kvalitný polosyntetický olej odporúčaný pre vysoko výkonné štvortaktné vzduchom chladené benzínové motory motocyklov. Je založený na vysoko kvalitných minerálnych a syntetických základových olejoch v k ombinácii so špeciálnymiaditívami. Olej má vynikajúce protioderové a protikorózne vlastnosti. Poskytuje dokonalú ochranu motora, prevodovky a mokrej spojky a to aj pri ťažkých prevádzkových podmienkach. Eliminuje preklzovanie spojky a zlepšuje jazdné vlastnosti. Obsahuje benzensulfónovú kyselinu, propénovanú, vápenatú soľ, prealkalizovanú. Môže spôsobiť alergickú reakciu.",
    ean: 8586016015457,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501912,
    brand: "DYNAMAX",
    image: "img101210",
    src: "101210.jpg",
    name: "DYNAMAX MOTOFORCE 4T SYNTECH SCOOTER 5W40 1L",
    short_desc:
      "Dynamax Motoforce 4T Syntech Scooter 5W-40 je motorový olej vyrobený na báze plne syntetického základového oleja s pridaním špeciálnych aditív pre zaistenie dokonalého mazania aj v náročných podmienkach.",
    desc: "Dynamax Motoforce 4T Syntech Scooter 5W-40 je motorový olej vyrobený na báze plne syntetického základového oleja s pridaním špeciálnych aditív pre zaistenie dokonalého mazania aj v náročných podmienkach. Je určený pre vysokovýkonné 4T motory moder ných motocyklov. Poskytuje kvalitné mazanie motora, prevodovky a mokrej spojky.",
    ean: 8586016015464,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501913,
    brand: "DYNAMAX",
    image: "img63578",
    src: "63578.jpg",
    name: "DYNAMAX MF 4T SUPER 10W-40 1",
    short_desc:
      "Dynamax Motoforce 4T Super 10W-40 je vysoko kvalitný polosyntetický olej odporúčaný pre štvortaktné motory u motocyklov, ktorý je kompatibilný s mokrými spojkami.",
    desc: "Dynamax Motoforce 4T Super 10W-40 je vysoko kvalitný polosyntetický olej odporúčaný pre štvortaktné motory u motocyklov, ktorý je kompatibilný s mokrými spojkami. Je založený na vysoko kvalitných syntetických a minerálnych základových olejoch v kombinácii so špeciálnymi aditívami. Olej má vysoký a stabilný viskozitný index, vysokú teplotnú stabilitu, dobré nízkoteplotné vlastnosti, chráni pred opotrebením, penením a koróziou. Olej bol vyrábaný a testovaný v spolupráci s výrobcami motocyklov.",
    ean: 8586016015389,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501922,
    brand: "DYNAMAX",
    image: "img101211",
    src: "101211.jpg",
    name: "DYNAMAX MOTOFORCE 2T SYNTECH 1L",
    short_desc:
      "Dynamax Motoforce 2T Syntech je vysoko kvalitný syntetický olej odporúčaný pre dvojtaktné motory u motocyklov a skútrov. Je založený na vysoko kvalitných syntetických základových olejoch v kombinácii so špeciálnymi aditívami.",
    desc: "Dynamax Motoforce 2T Syntech je vysoko kvalitný syntetický olej odporúčaný pre dvojtaktné motory u motocyklov a skútrov. Je založený na vysoko kvalitných syntetických základových olejoch v kombinácii so špeciálnymi aditívami. Chráni piest pred odie raním a časti motora pred predčasným opotrebením. Má skvelú miešateľnosť s benzínom, čím vzniká homogénna a stabilná zmes aj pri nízkej teplote okolia. Potláča tvorbu úsad v piestnych drážkach, na výfukových kanáloch alebo na elektródach sviečok. Predlžuje životnosť motora bez straty výkonu .",
    ean: 8586016015372,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501926,
    brand: "DYNAMAX",
    image: "img18042",
    src: "18042.jpg",
    name: "DYNAMAX ULTRA LONG LIFE 5W-30 60 L",
    short_desc:
      "Doporučuje sa hlavne pre najnovšiu generáciu vysoko výkonných benzínových a dieselových osobných automobilov a dodávok, ktoré sú vybaven",
    desc: "Motorový olej DYNAMAX ULTRA LONGLIFE 5W-30 je vhodný pre použitie pre všetky benzínové a naftové motory osobných vozidiel vyžadujúcich motorový olej spĺňajúci špecifikácie VW 504.00, 507.00, čo znamená že spľňa predľžený výmenný interval /30.000 km/.",
    ean: 8586016015518,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501927,
    brand: "DYNAMAX",
    image: "img18950",
    src: "18950.jpg",
    name: "DYNAMAX ULTRA PLUS PD 5W-40 60L (51KG)",
    short_desc:
      "Syntetický motorový DYNAMAX ULTRA PLUS PD je najviac doporučovaný pre najnovšiu generáciu vysoko zaťažovaných benzínových, LPG a dieselových motorov v osobných a ľahkých dodávkových automobiloch vyžadujúcich splnenie špecifikácie ACEA A3/B4 a AC EA C3 vrátane emisnej normy EURO IV.",
    desc: "Syntetický motorový DYNAMAX ULTRA PLUS PD je najviac doporučovaný pre najnovšiu generáciu vysoko zaťažovaných benzínových, LPG a dieselových motorov v osobných a ľahkých dodávkových automobiloch vyžadujúcich splnenie špecifikácie ACEA A3/B4 a AC EA C3 vrátane emisnej normy EURO IV. Motorový olej DYNAMAX ULTRA PLUS PD je vysoko výkonný nízkoemisný syntetický celoročný motorový olej spĺňajúci požiadavky mid SAPS (Sulphated Ash, Phosphorus + Sulphur). Je vyrobený tak, aby predĺžil životnosť motora a životnosť zariadenia pre následnú úpravu výfukových plynov, ktoré používa posledná generácia benzínových a dieselových motorov u osobných automobilov. DYNAMAX ULTRA PLUS PD znižuje tvorbu popola v dieselových časticových filtroch (DPF).",
    ean: 8586016015525,
    package: "",
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501928,
    brand: "DYNAMAX",
    image: "img18687",
    src: "18687.jpg",
    name: "DYNAMAX PREMIUM ULTRA 5W-40 60L (51,5KG)",
    short_desc:
      "DYNAMAX ULTRA je vhodný na mazanie preplňovaných a nepreplňovaných benzínových a naftových štvortaktných motorov osobných automobilov.",
    desc: "Je určený pre použitie na mazanie vysoko zaťažovaných benzínových motorov s predĺženým intervalom výmeny oleja. Je taktiež určený pre vysokozaťažované dieselové motory osobných automobilov a ľahkých dodávok, hlavne s priamym vstrekovaním s predĺženým intervalom výmeny stanoveným výrobcom motora, kde je požadovaná špeciálna kvalita oleja. Syntetický motorový DYNAMAX ULTRA svojimi vlastnosťami prevyšuje požiadavky európskych, japonských a amerických automobilových výrobcov. Používa sa na mazanie vysoko zaťažovaných benzínových motorov s predĺženým intervalom výmeny oleja. Je taktiež určený pre vysoko zaťažované dieselové motory osobných automobilov a ľahkých dodávok hlavne s priamym vstrekovaním s predĺženým intervalom výmeny stanovený m výrobcom motora, kde je požadovaná špeciálna kvalita. DYNAMAX ULTRA je vhodný na mazanie preplňovaných a nepreplňovaných benzínových a naftových štvortaktných motorov osobných automobilov. DYNAMAX ULTRA je vhodný pre vozidlá s katalyzátorom výfukových plynov (EGR) atď. Zlepšené trecie vlastnosti vedú k dlhotrvajúcej úspore paliva.",
    ean: 8586016015532,
    package: "",
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501929,
    brand: "DYNAMAX",
    image: "img18688",
    src: "18688.jpg",
    name: "DYNAMAX M6AD SAE30 209L(184KG)",
    short_desc:
      "Letný motorový olej na mazanie benzínových a nepreplňovaných naftových štvortaktných motorov, najmä starších typov, v nenáročných prevádzkových podmienkach.",
    desc: "Letný motorový olej na mazanie benzínových a nepreplňovaných naftových štvortaktných motorov, najmä starších typov, v nenáročných prevádzkových podmienkach. Automobilový motorový olej DYNAMAX M6AD sa používa predo-všetkým pre staršie typy nákla dných automobilov a ľahkých dodávkových automobilov.",
    ean: 8586016015549,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501930,
    brand: "DYNAMAX",
    image: "img108161",
    src: "108161.jpg",
    name: "DYNAMAX ATF III 60L",
    short_desc:
      "Olej sa doporučuje tiež používať v posilňovačoch riadenia v hydraulických spojkách osobných a nákladných automobilov a tiež v hydraulických systémoch, ktoré vyžadujú použitie oleja typu ATF.",
    desc: "Vysokokvalitný olej určený pre použitie v automatických prevodovkách osobných aj nákladných automobilov, autobusov, u ktorých výrobca doporučuje použitie oleja podľa GM DEXRON IIIG.",
    ean: 8586016015556,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501931,
    brand: "DYNAMAX",
    image: "img18951",
    src: "18951.jpg",
    name: "DYNAMAX AUTOMATIC ATF IID 60 L (52,5KG)",
    short_desc:
      "Vysokokvalitný minerálny olej určený pre použitie v automatických prevodovkách osobných aj nákladných automobilov, autobusov, u ktorých výrobca doporučuje použitie oleja podľa GM DEXRON IID.",
    desc: "Vysokokvalitný minerálny olej určený pre použitie v automatických prevodovkách osobných aj nákladných automobilov, autobusov, u ktorých výrobca doporučuje použitie oleja podľa GM DEXRON IID. Olej sa doporučuje tiež používať v posilňovačoch riadeni a v hydraulických spojkách osobných a nákladných automobilov a tiež v hydraulických systémoch, ktoré vyžadujú použitie oleja typu ATF.",
    ean: 8586016015563,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501932,
    brand: "DYNAMAX",
    image: "img21955",
    src: "21955.jpg",
    name: "DYNAMAX PP 80 SAE 80W 1L",
    short_desc:
      "Prevodový olej DYNAMAX PP 80 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mecha",
    desc: "Prevodový olej DYNAMAX PP80 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu.",
    ean: 8586016015471,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501933,
    brand: "DYNAMAX",
    image: "img18952",
    src: "18952.jpg",
    name: "DYNAMAX HYPOL 80W-90 GL4 60L (53,5KG)",
    short_desc:
      "Dynamax HYPOL 80W-90 GL-4 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Minerálny olej zaručujúci vždy dobré mazacie vlastnosti, vysokú odolnosť voči oxidácii a vysokú schopnosť prenášať zaťaženia.",
    desc: "Dynamax HYPOL 80W-90 GL-4 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Minerálny olej zaručujúci vždy dobré mazacie vlastnosti, vysokú odolnosť voči oxidácii a vysokú schopnosť prenášať zaťaženia.",
    ean: 8586016015570,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501935,
    brand: "DYNAMAX",
    image: "img18689",
    src: "18689.jpg",
    name: "DYNAMAX TRUCKMAN + FE 10W-40 209L (182,5KG)",
    short_desc:
      "DYNAMAX TRUCKMAN PLUS FE je olej určený pre prevádzku naftových motorov zvlášť pre veľké nákladné automobily, stavebnú techniku a autobusy.",
    desc: "DYNAMAX TRUCKMAN PLUS FE je olej určený pre prevádzku naftových motorov zvlášť pre veľké nákladné automobily, stavebnú techniku a autobusy. DYNAMAX TRUCKMAN PLUS FE je vhodný pre použitie v preplňovaných aj nepreplňovaných naftových štvortaktných motoroch s nízkymi emisiami, ktoré používajú systémy recirkulácie výfukových plynov (EGR), spĺňajúcich požiadavky normy EURO IV. Je motorový olej novej generácie typu SHPDO (Super High Performance Diesel Oil), doporučovaný pre vysoko namáhané naft ové motory s turbopreplňovaním aj nepreplňovaním, s vylepšenými vlastnosťami, čo sa týka čistoty piestu, leštenia povrchu valca, zníženia opotrebenia, znečistenia sadzami a odolnosti proti stárnutiu. Umožňuje dosahovať veľmi dlhé výmenné intervaly.",
    ean: 8586016015587,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501936,
    brand: "DYNAMAX",
    image: "img69798",
    src: "69798.jpg",
    name: "DYNAMAX ATF SUPER DSG 1L",
    short_desc:
      "Dynamax ATF Super DSG je plne syntetická vysoko výkonná kvapalina pre automatické prevodovky, špeciálne vyvinutá pre dvoj-spojové prevodovky skupiny VAG pre veľmi rýchle a športové radenie rýchlostí.",
    desc: "Dynamax ATF Super DSG je plne syntetická vysoko výkonná kvapalina pre automatické prevodovky, špeciálne vyvinutá pre dvoj-spojové prevodovky skupiny VAG pre veľmi rýchle a športové radenie rýchlostí. Má vysoký a stabilný viskozitný index,mimoriadne nízky bod tuhnutia. Má veľmi dobrú stabilitu a odolnosť voči oxidácii, opotrebeniu, korózii a peneniu.",
    ean: 8586016015358,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501939,
    brand: "DYNAMAX",
    image: "img18953",
    src: "18953.jpg",
    name: "DYNAMAX HYPOL PP 75W-90 GL-5 20L",
    short_desc:
      "Automobilový prevodový olej DYNAMAX HYPOL GL-5 75W-90 je syntetický olej s nízkym trením a špičkovým výkonom. Obsahuje špeciálne prísady na zvýšenie ochrany proti korózii, na zníženie opotrebenia materiálu.",
    desc: 'Automobilový prevodový olej DYNAMAX HYPOL GL-5 75W-90 je syntetický olej s nízkym trením a špičkovým výkonom. Obsahuje špeciálne prísady na zvýšenie ochrany proti korózii, na zníženie opotrebenia materiálu. Tento prevodový olej má veľmi dobré níz koteplotné vlastnosti, ktoré umožňujú optimálnu prevádzku všetkých pohyblivých častí a uľahčenie radenia prevodových stupňov „za studena".',
    ean: "",
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501940,
    brand: "DYNAMAX",
    image: "img34002",
    src: "34002.jpg",
    name: "DYNAMAX HYPOL 80W-90 GL4 209L(186,5KG)",
    short_desc:
      'Prevodový ole j DYNAMAX HYPOL 80W-90 GL-4 je určený na mazanie mechanických prevodov automobilov a hnacích náprav, kde sú požadované oleje o <span style="color:#000000;font-family:\'Droid Sans\', Arial, Helvetica, sans-serif;font-size:13px;font-style:normal;font-weight:normal;letter-spacing:normal;text-indent:0px;text-transform:none;white-space:normal;word-spacing:0px;float:none;"><span class="Apple-converted-space"> vlastnostiach SAE 80W-90 s výkonnostnou úrovňou API GL-4.',
    desc: "Dynamax HYPOL 80W-90 GL-4 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Minerálny olej zaručujúci vždy dobré mazacie vlastnosti, vysokú odolnosť voči oxidácii a vysokú schopnosť prenášať zaťaženia.",
    ean: 8586016015594,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501953,
    brand: "DYNAMAX",
    image: "img6894",
    src: "6894.jpg",
    name: "DYNAMAX 265 DOT 5.1 0,5L",
    short_desc:
      "Je špeciálna brzdová kvapalina vyvinutá pre použitie v hydraulických brzdových a spojkových systémoch najmodernejších vozidiel a vysoko zaťažených závodných vozidiel, ako aj v ABS, EDS a ESP systémoch.",
    desc: "Je špeciálna brzdová kvapalina vyvinutá pre použitie v hydraulických brzdových a spojkových systémoch najmodernejších vozidiel a vysoko zaťažených závodných vozidiel, ako aj v ABS, EDS a ESP systémoch.",
    ean: 8586016015266,
    package: 16,
    type: "olej",
    sub_category: "brzdovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501960,
    brand: "DYNAMAX",
    image: "img40331",
    src: "40331.jpg",
    name: "DYNAMAX ULTRA LONGLIFE 5W-30 5L",
    short_desc:
      "Doporučuje sa hlavne pre najnovšiu generáciu vysoko výkonných benzínových a dieselových osobných automobilov a dodávok, ktoré sú vybavené zariadeniami ako sú časticové filtre, katalyzátory, recirkulácia výfukových plynov (EGR) atď. Zlepšené trecie vlastnosti vedú k dlhotrvajúcej úspore paliva.",
    desc: "Motorový olej DYNAMAX ULTRA LONGLIFE 5W-30 je vhodný pre použitie pre všetky benzínové a naftové motory osobných vozidiel vyžadujúcich motorový olej spĺňajúci špecifikácie VW 504.00, 507.00, čo znamená že spľňa predľžený výmenný interval /30.000 km/.",
    ean: 8586016015686,
    package: 3,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501961,
    brand: "DYNAMAX",
    image: "img51277",
    src: "51277.jpg",
    name: "DYNAMAX ULTRA 5W40 5L",
    short_desc:
      "Syntetický motorový DYNAMAX ULTRA svojimi vlastnosťami prevyšuje požiadavky európskych, japonských a amerických automobilových výrobcov. Je určený pre použitie na mazanie vysoko zaťažovaných benzínových motorov s predĺženým intervalom výmeny oleja.",
    desc: "Je určený pre použitie na mazanie vysoko zaťažovaných benzínových motorov s predĺženým intervalom výmeny oleja. Je taktiež určený pre vysokozaťažované dieselové motory osobných automobilov a ľahkých dodávok, hlavne s priamym vstrekovaním s predlž eným intervalom výmeny stanoveným výrobcom motora, kde je požadovaná špeciálna kvalita oleja.",
    ean: 8586016015693,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501962,
    brand: "DYNAMAX",
    image: "img39156",
    src: "39156.jpg",
    name: "DYNAMAX UNI PLUS 10W-40 5L",
    short_desc:
      "Polosyntetický motorový olej vhodný pre benzínové i dieselové motory. Syntetická zložka oleja zlepšuje mazanie motora v záťažových podmienkach a zároveň zachováva výborné vlastnosti oleja.",
    desc: "Polosyntetický motorový olej vhodný pre benzínové i dieselové motory. Syntetická zložka oleja zlepšuje mazanie motora v záťažových podmienkach a zároveň zachováva výborné vlastnosti oleja. Je vhodný na celoročné používanie. Má vyhovujúce vlastnosti pri nízkych teplotách v zimnom období a tiež pri vysokých teplotách v letnom období.",
    ean: 8586016015709,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501963,
    brand: "DYNAMAX",
    image: "img16614",
    src: "16614.jpg",
    name: "DYNAMAX COOL 12 ULTRA 25L",
    short_desc:
      "DYNAMAX COOLANT ULTRA G12 je koncentrovaná nízkotuhnúca chladiaca kvapalina určená pre najmodernejšie druhy motorov.",
    desc: "DYNAMAX COOLANT ULTRA G12 je koncentrovaná nízkotuhnúca chladiaca kvapalina určená pre najmodernejšie druhy motorov. Je vysoko kvalitná nízkotuhnúca zmes vyrobená z monoetylénglykolu s vysoko progresívnymi antikoróznymi prísadami, zvlášť vhodná p re chladiče moderných hliníkových a zliatinových chladiacich sústav spaľovacích motorov. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. V roku 2008 získala chladiaca kvap alina DYNAMAX COOLANT ULTRA G12 prestížne ocenenie Zlatú medailu a Certifikát ochrannej známky kvality Slovak Gold. Obsahuje látku brániacu požitiu chladiacej kvapaliny. Plní sa do čistého chladiaceho systému podľa pokynov výrobcu automobilu. Je rie diteľná pitnou alebo demineralizovanou vodou na požadovaný bod tuhnutia podľa učených pomerov výrobcu. DYNAMAX COOLANT ULTRA G12 chladiaca kvapalina je miešateľná s nízkotuhnúcimi kvapalinami na báze monoetylén-glykolu (etylénglykolu a propylénglyko lu).",
    ean: 8586016015716,
    package: "",
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501964,
    brand: "DYNAMAX",
    image: "img17799",
    src: "17799.jpg",
    name: "DYNAMAX COOL 11 AL  25L KONCENTRÁT",
    short_desc:
      "Nízkotuhnúca zmes do chladičov automobilov na báze monoetylénglykolu s antikoróznymi prísadami je zvlášť vhodná pre chladiace sústavy spaľovacích motorov z ľahkých zliatin.",
    desc: "Nízkotuhnúca zmes do chladičov automobilov na báze monoetylénglykolu s antikoróznymi prísadami je zvlášť vhodná pre chladiace sústavy spaľovacích motorov z ľahkých zliatin. Celoročne chráni chladiaci systém motorového vozdila pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Prípravok neobsahuje dusitany, amíny a fosfáty. Plní sa do čistého chladiaceho systému podľa pokynov výrobcu automobilu. Je rieditelná pitnou alebo demineralizovanou vodou na požadovaný bod tuhnutia podľa doporučených pomerov výrobcu. Chladiaca kvapalina DYNAMAX COOLANT AL G11 je miešatelná s nízkotuhnúcimi kvapalinami na báze monoetylénglykolu (etylén-glykolu a propylénglykolu).",
    ean: 8586016015723,
    package: "",
    type: "doplnok",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501965,
    brand: "DYNAMAX",
    image: "img108001",
    src: "108001.jpg",
    name: "DYNAMAX GOLDLINE FUEL ECO 0W-16 1L",
    short_desc:
      "Vysoko kvalitný plnesyntetický motorový olej určený na použitie v benzínových a dieselových motoroch osobných automobilov vybavených s alebo bez turbopreplňovania a priameho vstrekovania.",
    desc: "Vysoko kvalitný plnesyntetický motorový olej určený na použitie v benzínových a dieselových motoroch osobných automobilov vybavených s alebo bez turbopreplňovania a priameho vstrekovania. Olej je špeciálne vyvinutý pre hybridné motory. Vyznačuj e sa vynikajúcim štartom za studena a minimalizáciou spotreby paliva, trenia a opotrebenia.",
    ean: 8586016015877,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501976,
    brand: "DYNAMAX",
    image: "img19767",
    src: "19767.jpg",
    name: "DYNAMAX MOTOFORCE COOLANT -37 1L",
    short_desc:
      "Určená do chladičov motorov u motoriek vyrobených z ľahkých zliatin. Nízkotuhnúca chladiaca kvapalina celoročne chráni chladiaci systém motorky pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla.",
    desc: "Určená do chladičov motorov u motoriek vyrobených z ľahkých zliatin. Nízkotuhnúca chladiaca kvapalina celoročne chráni chladiaci systém motorky pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla.",
    ean: 8586016015679,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501981,
    brand: "DYNAMAX",
    image: "img6904",
    src: "6904.jpg",
    name: "DYNAMAX NANO OSTREKOVAČ  4L",
    short_desc:
      "DYNAMAX NANO SCREENWASH je vysokokvalitná letná zmes do ostrekovačov vyrobená na báze NANO technológie s príjemnou zmesou vôní melónu a kiwi.",
    desc: "DYNAMAX NANO SCREENWASH je vysokokvalitná letná zmes do ostrekovačov vyrobená na báze NANO technológie s príjemnou zmesou vôní melónu a kiwi. Vytvára na skle účinnú ochrannú vrstvu, ktorej hlavnou úlohou je minimalizovať usadzovanie nečistôt a tým zlepšiť viditeľnosť na vašich cestách. Zmes zároveň napomáha k odstraňovaniu dažďovej vody a je šetrná k vašim svetlometom.",
    ean: 8586016015983,
    package: 3,
    type: "doplnok",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501982,
    brand: "DYNAMAX",
    image: "img11012",
    src: "11012.jpg",
    name: "DYNAMAX NANO OSTREKOVAČ 25L",
    short_desc:
      "DYNAMAX NANO SCREENWASH je vysokokvalitná letná zmes do ostrekovačov vyrobená na báze NANO technológie s príjemnou zmesou vôní melónu a kiwi. Vytvára na skle účinnú ochrannú vrstvu, ktorej hlavnou úlohou je minimalizovať usadzovanie nečistôt a tým zlepšiť viditeľnosť na vašich cestách. Zmes zároveň napomáha k odstraňovaniu dažďovej vody a je šetrná k vašim svetlometom.",
    desc: "DYNAMAX NANO SCREENWASH je vysokokvalitná letná zmes do ostrekovačov vyrobená na báze NANO technológie s príjemnou zmesou vôní melónu a kiwi. Vytvára na skle účinnú ochrannú vrstvu, ktorej hlavnou úlohou je minimalizovať usadzovanie nečistôt a tým zlepšiť viditeľnosť na vašich cestách. Zmes zároveň napomáha k odstraňovaniu dažďovej vody a je šetrná k vašim svetlometom.",
    ean: 8586016015990,
    package: "",
    type: "olej",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501993,
    brand: "DYNAMAX",
    image: "img107988",
    src: "107988.jpg",
    name: "DYNAMAX COOL 13 ULTRA 1L",
    short_desc:
      "Chladiaca kvapalina optimalizovaná pre všetky typy moderných automobilov s vynikajúcou miešateľnosťou s inými druhmi chladiacich kvapalín (G11, G12, G12++...). Je špeciálne vyvinutá pre najnovšie automobily VW group (VW, ŠKODA, SEAT, AUDI).",
    desc: "Chladiaca kvapalina optimalizovaná pre všetky typy moderných automobilov s vynikajúcou miešateľnosťou s inými druhmi chladiacich kvapalín (G11, G12, G12++...). Je špeciálne vyvinutá pre najnovšie automobily VW group (VW, ŠKODA, SEAT, AUDI). Poskytuje výbornú ochranu pred mrazom, vysokými teplotami a zároveň chráni pred koróziou. DOPORUČENÉ POMERY RIEDENIA:1 diel DYNAMAX COOLANT ULTRA G13: 1 diel DYNAQUA - použitie do - 37 °C. 1 diel DYNAMAX COOLANT ULTRA G13 : 1,5 dielu DYNAQUA - použitie do - 26 °C.1 diel DYNAMAX COOLANT ULTRA G13: 2 diely DYNAQUA - použitie do - 17 °C.",
    ean: 8586016015419,
    package: 12,
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501994,
    brand: "DYNAMAX",
    image: "img107991",
    src: "107991.jpg",
    name: "DYNAMAX COOL 13 ULTRA 4L",
    short_desc:
      "Chladiaca kvapalina optimalizovaná pre všetky typy moderných automobilov s vynikajúcou miešateľnosťou s inými druhmi chladiacich kvapalín (G11, G12, G12++...). Je špeciálne vyvinutá pre najnovšie automobily VW group (VW, ŠKODA, SEAT, AUDI).",
    desc: "Chladiaca kvapalina optimalizovaná pre všetky typy moderných automobilov s vynikajúcou miešateľnosťou s inými druhmi chladiacich kvapalín (G11, G12, G12++...). Je špeciálne vyvinutá pre najnovšie automobily VW group (VW, ŠKODA, SEAT, AUDI). Poskytuje výbornú ochranu pred mrazom, vysokými teplotami a zároveň chráni pred koróziou. DOPORUČENÉ POMERY RIEDENIA:1 diel DYNAMAX COOLANT ULTRA G13: 1 diel DYNAQUA - použitie do - 37 °C. 1 diel DYNAMAX COOLANT ULTRA G13 : 1,5 dielu DYNAQUA - použitie do - 26 °C.1 diel DYNAMAX COOLANT ULTRA G13: 2 diely DYNAQUA - použitie do - 17 °C.",
    ean: 8586016015426,
    package: 3,
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501995,
    brand: "DYNAMAX",
    image: "img30783",
    src: "30783.jpg",
    name: "DYNAMAX M7AD 10W-40 4L",
    short_desc:
      "Motorový olej DYNAMAX M7AD je určený pre mazanie benzínových a naftových štvortaktných motorov starších konštrukcií.",
    desc: "Motorový olej DYNAMAX M7AD je určený pre mazanie benzínových a naftových štvortaktných motorov starších konštrukcií. Celoročný motorový olej určený predovšetkým na mazanie benzínových štvortaktných motorov starších konštrukcií. Vysoký viskozitný index oleja, vysoká odolnosť oleja voči šmykovému namáhaniu a kvalita výkonnostnej prísady zabezpečujú výborné viskozitné mazacie vlastnosti oleja v širokom rozsahu pracovných teplôt. Umožňuje veľmi dobré štartovanie motorov aj pri veľmi nízkych teplotách v zimnom období a zároveň má značnú rezervu viskozity pre letné obdobie.",
    ean: 8586016016010,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501996,
    brand: "DYNAMAX",
    image: "img62908",
    src: "62908.jpg",
    name: "DYNAMAX PREMIUM ULTRA F 5W-30 4L",
    short_desc:
      "Je vhodný pre použitie na mazanie benzínových a dieselových motorov, s alebo bez preplňovania, v osobných a dodávkových automobiloch. Tento",
    desc: "Dynamax Ultra F 5W-30 je moderný syntetický ľahkobežný motorový olej vyrobený zo špeciálne vybraných syntetických základových olejov a vyvážených starostlivo vybraných, moderných aditív.",
    ean: 8586016016065,
    package: 3,
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501997,
    brand: "DYNAMAX",
    image: "img17292",
    src: "17292.jpg",
    name: "DYNAMAX M7AD 10W-40 1L",
    short_desc:
      "Motorový olej DYNAMAX M7AD je určený pre mazanie benzínových a naftových štvortaktných motorov starších konštrukcií.",
    desc: "Celoročný motorový olej určený predovšetkým na mazanie benzínových štvortaktných motorov starších konštrukcií. Vysoký viskozitný index oleja, vysoká odolnosť oleja voči šmykovému namáhaniu a kvalita výkonnostnej prísady zabezpečujú výborné viskozitné mazacie vlastnosti oleja v širokom rozsahu pracovných teplôt. Umožňuje veľmi dobré štartovanie motorov aj pri veľmi nízkych teplotách v zimnom období a zároveň má značnú rezervu viskozity pre letné obdobie.",
    ean: 8586016016003,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501998,
    brand: "DYNAMAX",
    image: "img67463",
    src: "67463.jpg",
    name: "DYNAMAX PREMIUM ULTRA F 5W-30 1L",
    short_desc:
      "Dynamax Ultra F 5W-30 je moderný syntetický ľahkobežný motorový olej vyrobený zo špeciálne vybraných syntetických základových olejov a vyvážených starostlivo vybraných, moderných aditív.",
    desc: "Dynamax Ultra F 5W-30 je moderný syntetický ľahkobežný motorový olej vyrobený zo špeciálne vybraných syntetických základových olejov a vyvážených starostlivo vybraných, moderných aditív. Je vhodný pre použitie na mazanie benzínových a dieselových motorov, s alebo bez preplňovania, v osobných a dodávkových automobiloch. Tento olej bol špeciálne vyvinutý pre motory, ktoré požadujú motorové oleje s najnovším schválením od výrobcu Ford.",
    ean: 8586016015365,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 501999,
    brand: "DYNAMAX",
    image: "img17881",
    src: "17881.jpg",
    name: "DYNAMAX M7AD 10W-40 60 L(52,5KG)",
    short_desc:
      "Motorový olej DYNAMAX M7AD je určený pre mazanie benzínových a naftových štvortaktných motorov starších konštrukcií. Celoročný motorový olej určený predovšetkým na mazanie benzínových štvortaktných motorov starších konštrukcií.",
    desc: "Motorový olej DYNAMAX M7AD je určený pre mazanie benzínových a naftových štvortaktných motorov starších konštrukcií. Celoročný motorový olej určený predovšetkým na mazanie benzínových štvortaktných motorov starších konštrukcií. Vysoký viskozitný index oleja, vysoká odolnosť oleja voči šmykovému namáhaniu a kvalita výkonnostnej prísady zabezpečujú výborné viskozitné mazacie vlastnosti oleja v širokom rozsahu pracovných teplôt. Umožňuje veľmi dobré štartovanie motorov aj pri veľmi nízkych teplotách v zimnom období a zároveň má značnú rezervu viskozity pre letné obdobie.",
    ean: 8586016016041,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502000,
    brand: "DYNAMAX",
    image: "img33900",
    src: "33900.jpg",
    name: "DYNAMAX M7ADX 15W-40 60L(53KG)",
    short_desc:
      "Univerzálny automobilový motorový olej DYNAMAX M7ADX je zvlášť vhodný pre staršie typy osobných automobilov LADA a DACIA. Celoročný univerzálny motorový olej určený na mazanie všetkých benzínových štvortaktných motorov.",
    desc: "Univerzálny automobilový motorový olej DYNAMAX M7ADX je zvlášť vhodný pre staršie typy osobných automobilov LADA a DACIA. Celoročný univerzálny motorový olej určený na mazanie všetkých benzínových štvortaktných motorov. Možno ho tiež použiť na mazanie štvortaktných naftových motorov. DYNAMAX M7ADX obsahuje prísady, ktoré ho robia optimálnym pre stredoeurópske pásmo.",
    ean: 8586016016058,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502002,
    brand: "DYNAMAX",
    image: "img74835",
    src: "74835.jpg",
    name: "DYNAMAX SL PLUS 20W-50 4L",
    short_desc:
      "Vysokovýkonný motorový olej vyrobený na báze minerálneho základového oleja s pridaním aditív pre zlepšenie teplotnej a oxidačnej stability. Je vhodný pre moderné benzínové, dieselové a LPG motory osobných automobilov a dodávok s alebo bez preplňovania. Olej navyše zaručuje ochranu proti opotrebeniu, peneniu a korózií.",
    desc: "Vysokovýkonný motorový olej vyrobený na báze minerálneho základového oleja s pridaním aditív pre zlepšenie teplotnej a oxidačnej stability. Je vhodný pre moderné benzínové, dieselové a LPG motory osobných automobilov a dodávok s alebo bez preplňovania. Olej navyše zaručuje ochranu proti opotrebeniu, peneniu a korózií.",
    ean: 8586016016072,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502010,
    brand: "DYNAMAX",
    image: "img18691",
    src: "18691.jpg",
    name: "DYNAMAX PP 90 SAE90 1L",
    short_desc:
      "Prevodový olej Dynamax PP90 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov.",
    desc: "Prevodový olej DYNAMAX PP90 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu.",
    ean: 8586016016096,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502011,
    brand: "DYNAMAX",
    image: "img62909",
    src: "62909.jpg",
    name: "DYNAMAX ATF VI 1L",
    short_desc:
      "Je vysokovýkonná kvapalina pre automatické prevodovky s predĺženou životnosťou špeciálne vyvinutá pre všetky GM vozidlá vyrobené v roku 2006 a neskôr vybavené Hydramatic automatickou prevodovkou.",
    desc: "Je vysokovýkonná kvapalina pre automatické prevodovky s predĺženou životnosťou špeciálne vyvinutá pre všetky GM vozidlá vyrobené v roku 2006 a neskôr vybavené Hydramatic automatickou prevodovkou. Je taktiež odporúčaná pre automatické prevodovky vyžadujúce DEXRON® III (G+H), DEXRON® IID a DEXRON® IIE kvapalinu.",
    ean: 8586016016102,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502019,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX SL PLUS 20W50 5L",
    short_desc: "",
    desc: 0,
    ean: 8586016016126,
    package: 3,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502020,
    brand: "DYNAMAX",
    image: "img28197",
    src: "28197.jpg",
    name: "DYNAMAX PREMIUM ULTRA GMD 5W-30 5L",
    short_desc:
      "Motorový olej vyrobený na báze 100% syntetickej technológie špeciálne vyvinutý pre najnovšiu generáciu benzínových a dieselových Opel/GM motorov vyžadujúcich normu GM dexos 2. Je spätne kompatibilný s motormi, ktoré vyžadujú normu oleja GM-LL- A-025/B- 025.",
    desc: "Motorový olej vyrobený na báze 100% syntetickej technológie špeciálne vyvinutý pre najnovšiu generáciu benzínových a dieselových Opel/GM motorov vyžadujúcich normu GM dexos 2. Je spätne kompatibilný s motormi, ktoré vyžadujú normu oleja GM-LL- A-025/B- 025.",
    ean: 8586016016133,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502021,
    brand: "DYNAMAX",
    image: "img13889",
    src: "13889.jpg",
    name: "DYNAMAX M7ADX 15W-40 5L",
    short_desc:
      "Univerzálny automobilový motorový olej DYNAMAX M7ADX je zvlášť vhodný pre staršie typy osobných automobilov LADA a DACIA.",
    desc: "Univerzálny automobilový motorový olej DYNAMAX M7ADX je zvlášť vhodný pre staršie typy osobných automobilov LADA a DACIA. Celoročný univerzálny motorový olej určený na mazanie všetkých benzínových štvortaktných motorov. Možno ho tiež použiť na maz anie štvortaktných naftových motorov. DYNAMAX M7ADX obsahuje prísady, ktoré ho robia optimálnym pre stredoeurópske pásmo.",
    ean: 8586016016157,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502022,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX M7AD 10W40 5L",
    short_desc: "",
    desc: 0,
    ean: 8586016016140,
    package: 3,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502023,
    brand: "DYNAMAX",
    image: "img18692",
    src: "18692.jpg",
    name: "DYNAMAX M8AD 15W-50 5L",
    short_desc:
      "Motorový olej DYNAMAX M8AD je určený pre mazanie benzínových a dieselových štvortaktných motorov automobilov.",
    desc: "Celoročný motorový olej DYNAMAX M8AD je ropný olej vyrobený modernou technológiou, obsahujúci viskozitné výkonnostné prísady.Olej si počas celej doby používania zachováva svoju výkonnostnú triedu. Je určený na celoročné mazanie benzínových a dieselových štvortaktných motorov automobilov. Umožňuje veľmi dobré štartovanie motorov pri nízkych teplotách a zároveň má značnú rezervu viskozity pre letné obdobie.",
    ean: 8586016016164,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502033,
    brand: "DYNAMAX",
    image: "img18693",
    src: "18693.jpg",
    name: "DYNAMAX TRUCKMAN  X 15W-40 20 L",
    short_desc:
      "DYNAMAX TRUCKMAN X 15W-40 je zvlášť vhodný pre použitie v preplňovaných a nepreplňovaných naftových štvortaktných motoroch nákladných automobilov v diaľkovej nákladnej doprave, v autobusovej doprave, v stavebníctve a v lodnej doprave.",
    desc: "DYNAMAX TRUCKMAN X 15W-40 je zvlášť vhodný pre použitie v preplňovaných a nepreplňovaných naftových štvortaktných motoroch nákladných automobilov v diaľkovej nákladnej doprave, v autobusovej doprave, v stavebníctve a v lodnej doprave. Je vhodný aj na mazanie motorov ľahkých dodávkových automobilov s naftovým motorom. Je olej novej generácie typu SHPDO (Super High Performance Diesel Oil), odporúčaný pre vysoko namáhané naftové motory s turbopreplňovaním aj nepreplňovaním, s vylepšenými vlastnosťami, čo sa týka čistoty piestu, leštenia povrchu valca, zníženia opotrebenia, znečistenia sadzami a odolnosti proti stárnutiu. Umožňuje dosahovať veľmi dlhé výmenné intervaly.",
    ean: 8586016016348,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502034,
    brand: "DYNAMAX",
    image: "img108113",
    src: "108113.jpg",
    name: "DYNAMAX HYPOL 75W90 GL5 209L(184KG)",
    short_desc:
      "Automobilový prevodový olej DYNAMAX HYPOL 75W-90 GL-5 je syntetický olej s nízkym trením a špičkovým výkonom. Obsahuje špeciálne prísady na zvýšenie ochrany proti korózii, na zníženie opotrebenia materiálu. Tento prevodový olej má veľmi dobré nízkoteplotné vlastnosti, ktoré umožňujú optimálnu prevádzku všetkých pohyblivých častí a uľahčenie radenia prevodových stupňov „za studena“.",
    desc: "Prevodový olej DYNAMAX HYPOL 75W-90 GL-5 je určený na mazanie mechanických prevodov automobilov a hnacích náprav, kde sú požadované oleje o vlastnostiach SAE 75W-90 s výkonnostnou úrovňou API GL-5. Je určený pre mazanie vozov, ktoré pracujú vo veľmi ťažkých prevádzkových podmienkach. Je použiteľný na mazanie mechanických prevodoviek a rozvodoviek moderných osobných a nákladných automobilov, stavebných strojov, poľnohospodárskej techniky a ďalších prevodových aplikácií. Schválenia: MIL-L 2105D, MB 235.0, MAN 342 Typ M-1, ZF TE-ML 05A, 07A,16B/C/D, 17B, 19B, Volvo 97310",
    ean: 8586016016546,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502036,
    brand: "DYNAMAX",
    image: "img16708",
    src: "16708.jpg",
    name: "DYNAMAX COOL 11 AL 60L KONCENTRÁT",
    short_desc:
      "Nízkotuhnúca zmes do chladičov automobilov na báze monoetylénglykolu s antikoróznymi prísadami je zvlášť vhodná pre chladiace sústavy spaľovacích motorov z ľahkých zliatín.",
    desc: "Nízkotuhnúca zmes do chladičov automobilov na báze monoetylénglykolu s antikoróznymi prísadami je zvlášť vhodná pre chladiace sústavy spaľovacích motorov z ľahkých zliatín. Celoročne chráni chladiaci systém motorového vozidila pred pôsobením mra zu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Prípravok neobsahuje dusitany, amíny a fosfáty. Plní sa do čistého chladiaceho systému podľa pokynov výrobcu automobilu. Je riediteľná pitnou alebo demineralizovanou vodou na požadovaný bod tuhnutia podľa doporučených pomerov výrobcu. Chladiaca kvapalina DYNAMAX COOLANT AL G11 je miešateľná s nízkotuhnúcimi kvapalinami na báze monoetylénglykolu (etylén-glykolu a propylénglykolu).",
    ean: 8586016016478,
    package: "",
    type: "doplnok",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502037,
    brand: "DYNAMAX",
    image: "img18694",
    src: "18694.jpg",
    name: "DYNAMAX COOL AL 11 209 L KONCENTRÁT",
    short_desc:
      "Nízkotuhnúca zmes do chladičov automobilov na báze monoetylénglykolu s antikoróznymi prí-sadami je zvlášť vhodná pre chladiace sústavy spaľovacích motorov z ľahkých zliatin.",
    desc: "Nízkotuhnúca zmes do chladičov automobilov na báze monoetylénglykolu s antikoróznymi prí-sadami je zvlášť vhodná pre chladiace sústavy spaľovacích motorov z ľahkých zliatin. Celoročne chráni chladiaci systém motorového vozidila pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Prípravok neobsahuje dusitany, amíny a fosfáty. Plní sa do čistého chladiaceho systému podľa pokynov výrobcu automobilu. Je riediteľná pitnou alebo demineralizovanou vodou na požadovaný bod tuhnutia podľa doporučených pomerov výrobcu. Chladiaca kvapalina DYNAMAX COOLANT AL G11 je miešateľná s nízkotuhnúcimi kvapalinami na báze monoetylénglykolu (etylén-glykolu a propylénglykolu).",
    ean: 8586016016492,
    package: "",
    type: "doplnok",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502038,
    brand: "DYNAMAX",
    image: "img81499",
    src: "81499.jpg",
    name: "DYNAMAX PREMIUM ULTRA F 5W-30 5L",
    short_desc:
      "Dynamax Ultra F 5W-30 je moderný syntetický ľahkobežný motorový olej vyrobený zo špeciálne vybraných syntetických základových olejov a vyvážených starostlivo vybraných, moderných aditív.",
    desc: "Dynamax Ultra F 5W-30 je moderný syntetický ľahkobežný motorový olej vyrobený zo špeciálne vybraných syntetických základových olejov a vyvážených starostlivo vybraných, moderných aditív. Je vhodný pre použitie na mazanie benzínových a dieselových motorov, s alebo bez preplňovania, v osobných a dodávkových automobiloch. Tento olej bol špeciálne vyvinutý pre motory, ktoré požadujú motorové oleje s najnovším schválením od výrobcu Ford.",
    ean: 8586016016171,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502039,
    brand: "DYNAMAX",
    image: "img81498",
    src: "81498.jpg",
    name: "DYNAMAX PREMIUM ULTRA C4 5W-30 5L",
    short_desc:
      "Vysokovýkonný LOW SAPS motorový olej vyrobený na báze 100% syntetickej technológie určený na použitie v benzínových a dieselových motoroch Renault a Nissan najnovšej generácie. Je vhodný na použitie v motoroch s filtrami pevných častíc (DPF).",
    desc: "Vysokovýkonný LOW SAPS motorový olej vyrobený na báze 100% syntetickej technológie určený na použitie v benzínových a dieselových motoroch Renault a Nissan najnovšej generácie. Je vhodný na použitie v motoroch s filtrami pevných častíc (DPF).",
    ean: 8586016016188,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502040,
    brand: "DYNAMAX",
    image: "img81495",
    src: "81495.jpg",
    name: "DYNAMAX ULTRA PLUS PD 5W40 5L",
    short_desc:
      '<span style="color:#333333;font-family:Geogrotesque;font-size:large;font-style:normal;font-weight:400;letter-spacing:normal;text-indent:0px;text-transform:none;white-space:normal;word-spacing:0px;background-color:#ffffff;float:none;">Syntetický motorový DYNAMAX ULTRA PLUS PD je najviac doporučovaný pre najnovšiu generáciu vysoko zaťažovaných benzínových, LPG a dieselových motorov v osobných a ľahkých dodávkových automobiloch vyžadujúcich splnenie špecifikácie ACEA A3/B4 a ACEA C3 vrátane emisnej normy EURO IV.',
    desc: "Motorový olej DYNAMAX ULTRA PLUS PD je vysoko výkonný nízkoemisný syntetický celoročný motorový olej spĺňajúci požiadavky mid SAPS (Sulphated Ash, Phosphorus - Sulphur). Je vyrobený tak, aby predĺžil životnosť motora a životnosť zariadenia pre ná slednú úpravu výfukových plynov, ktoré používa posledná generácia benzínových a dieselových motorov u osobných automobilov.DYNAMAX ULTRA PLUS PD znižuje tvorbu popola v dieselových časticových filtroch (DPF).",
    ean: 8586016016195,
    package: 3,
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502042,
    brand: "DYNAMAX",
    image: "img19206",
    src: "19206.jpg",
    name: "DYNAMAX TRUCK + SHPD 15W-40 209L(180KG)",
    short_desc:
      "Je olej novej generácie typu SHPDO (Super High Performance Diesel Oil), odporúčaný pre vysoko namáhané naftové motory s turbopreplňovaním aj nepreplňovaním, s vylepšenými vlastnosťami, čo sa týka čistoty piestu, leštenia povrchu valca, zníženia opotrebenia, znečistenia sadzami a odolnosti proti stárnutiu.",
    desc: '<span style="color:#000000;font-family:GeogrotesqueWeb;font-style:normal;font-weight:normal;letter-spacing:normal;text-align:left;text-indent:0px;text-transform:none;white-space:normal;word-spacing:0px;background-color:#ffffff;font-size:large;"><span style="color:#000000;font-family:GeogrotesqueWeb;font-style:normal;font-weight:normal;letter-spacing:normal;text-align:left;text-indent:0px;text-transform:none;white-space:normal;word-spacing:0px;background-color:#ffffff;font-size:large;"> Je olej novej generácie typu SHPDO (Super High Performance Diesel Oil), odporúčaný pre vysoko namáhané naftové motory s turbopreplňovaním aj nepreplňovaním, s vylepšenými vlastnosťami, čo sa týka čistoty piestu, leštenia povrchu valca, zníženia opotrebenia, znečistenia sadzami a odolnosti proti stárnutiu. Umožňuje dosahovať veľmi dlhé výmenné intervaly. Supervýkonný dieselový „Super High Performance Diesel“  (SHPD) motorový olej vyrobený na báze 100% syntetickej technológie  s pridaním špeciálnych aditív pre zaistenie dokonalého mazania  vysoko zaťažených nákladných automobilov. Spĺňa požiadavky EURO 4  a EURO 5, teda je vhodný pre motory s filtrami pevných častíc (DPF),  EGR, alebo so systémami následnej úpravy výfukových plynov (SCR).',
    ean: 8586016016331,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502043,
    brand: "DYNAMAX",
    image: "img18695",
    src: "18695.jpg",
    name: "DYNAMAX TRUCKMAN X 15W-40 209L (185KG)",
    short_desc:
      "DYNAMAX TRUCKMAN X 15W-40 je zvlášť vhodný pre použitie v preplňovaných a nepreplňovaných naftových štvortaktných motoroch nákladných automobilov v diaľkovej nákladnej doprave, v autobusovej doprave, v stavebníctve a v lodnej doprave.",
    desc: "DYNAMAX TRUCKMAN X 15W-40 je zvlášť vhodný pre použitie v preplňovaných a nepreplňovaných naftových štvortaktných motoroch nákladných automobilov v diaľkovej nákladnej doprave, v autobusovej doprave, v stavebníctve a v lodnej doprave. Je vhodný aj na mazanie motorov ľahkých dodávkových automobilov s naftovým motorom. Je olej novej generácie typu SHPDO (Super High Performance Diesel Oil), odporúčaný pre vysoko namáhané naftové motory s turbopreplňovaním aj nepreplňovaním, s vylepšenými vlastnosťami, čo sa týka čistoty piestu, leštenia povrchu valca, zníženia opotrebenia, znečistenia sadzami a odolnosti proti stárnutiu. Umožňuje dosahovať veľmi dlhé výmenné intervaly.",
    ean: 8586016016355,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502044,
    brand: "DYNAMAX",
    image: "img19207",
    src: "19207.jpg",
    name: "DYNAMAX PREMIUM ULTRA FEB 5W-20 1L",
    short_desc:
      "Vysokokvalitný motorový olej na báze 100% syntetickej technológie špeciálne vyvinutý pre najnovšiu generáciu benzínových motorov Ford Ecoboost. Je tiež vhodný pre motory vyžadujúce ACEA A1/B1 špecifikáciu.",
    desc: "Vysokokvalitný motorový olej na báze 100% syntetickej technológie špeciálne vyvinutý pre najnovšiu generáciu benzínových motorov Ford Ecoboost. Je tiež vhodný pre motory vyžadujúce ACEA A1/B1 špecifikáciu.",
    ean: 8586016016393,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502045,
    brand: "DYNAMAX",
    image: "img19208",
    src: "19208.jpg",
    name: "DYNAMAX PREMIUM ULTRA FEB 5W-20 4L",
    short_desc:
      "Vysokokvalitný motorový olej na báze 100% syntetickej technológie špeciálne vyvinutý pre najnovšiu generáciu benzínových motorov Ford Ecoboost. Je tiež vhodný pre motory vyžadujúce ACEA A1/B1 špecifikáciu.",
    desc: "Vysokokvalitný motorový olej na báze 100% syntetickej technológie špeciálne vyvinutý pre najnovšiu generáciu benzínových motorov Ford Ecoboost. Je tiež vhodný pre motory vyžadujúce ACEA A1/B1 špecifikáciu.",
    ean: 8586016016409,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502046,
    brand: "DYNAMAX",
    image: "img28278",
    src: "28278.jpg",
    name: "DYNAMAX PREMIUM ULTRA C2 5W-30 1L",
    short_desc:
      "Vysokovýkonný motorový olej vyrobený na báze 100% syntetickej technológie určený na použitie v benzínových a dieselových motoroch vyžadujúcich normu PSA B71 2290. Olej je tiež vhodný pre motory vyžadujúce ACEA A5/B5 ACEA C2 špecifikáciu.",
    desc: "Vysokovýkonný motorový olej vyrobený na báze 100% syntetickej technológie určený na použitie v benzínových a dieselových motoroch vyžadujúcich normu PSA B71 2290. Olej je tiež vhodný pre motory vyžadujúce ACEA A5/B5 ACEA C2 špecifikáciu.",
    ean: 8586016015914,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502047,
    brand: "DYNAMAX",
    image: "img28277",
    src: "28277.jpg",
    name: "DYNAMAX PREMIUM ULTRA C2 5W-30 4L",
    short_desc:
      "Vysokovýkonný motorový olej vyrobený na báze 100% syntetickej technológie určený na použitie v benzínových a dieselových motoroch vyžadujúcich normu PSA B71 2290. Olej je tiež vhodný pre motory vyžadujúce ACEA A5/B5 ACEA C2 špecifikáciu.",
    desc: "Vysokovýkonný motorový olej vyrobený na báze 100% syntetickej technológie určený na použitie v benzínových a dieselových motoroch vyžadujúcich normu PSA B71 2290. Olej je tiež vhodný pre motory vyžadujúce ACEA A5/B5 ACEA C2 špecifikáciu.",
    ean: 8586016016362,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502048,
    brand: "DYNAMAX",
    image: "img19209",
    src: "19209.jpg",
    name: "DYNAMAX PREMIUM ULTRA C4 5W30 1L",
    short_desc:
      "Vysokovýkonný LOW SAPS motorový olej vyrobený na báze 100% syntetickej technológie určený na použitie v benzínových a dieselových motoroch Renault a Nissan najnovšej generácie. Je vhodný na použitie v motoroch s filtrami pevných častíc.",
    desc: "Vysokovýkonný LOW SAPS motorový olej vyrobený na báze 100% syntetickej technológie určený na použitie v benzínových a dieselových motoroch Renault a Nissan najnovšej generácie. Je vhodný na použitie v motoroch s filtrami pevných častíc.",
    ean: 8586016015907,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502049,
    brand: "DYNAMAX",
    image: "img27637",
    src: "27637.jpg",
    name: "DYNAMAX PREMIUM ULTRA C4 5W-30 4L",
    short_desc:
      "Vysokovýkonný LOW SAPS motorový olej vyrobený na báze  100% syntetickej technológie určený na použitie v benzínových  a dieselových motoroch Renault a Nissan najnovšej generácie.  Je vhodný na použitie v motoroch s filtrami pevných častíc (DPF).",
    desc: "Vysokovýkonný LOW SAPS motorový olej vyrobený na báze  100% syntetickej technológie určený na použitie v benzínových  a dieselových motoroch Renault a Nissan najnovšej generácie.  Je vhodný na použitie v motoroch s filtrami pevných častíc (DPF).",
    ean: 8586016016379,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502053,
    brand: "DYNAMAX",
    image: "img31507",
    src: "31507.jpg",
    name: "DYNAMAX PREMIUM ULTRA GMD 5W-30 1L",
    short_desc:
      "Motorový olej vyrobený na báze 100% syntetickej technológie špeciálne vyvinutý pre najnovšiu generáciu benzínových a dieselových Opel/GM motorov vyžadujúcich normu GM dexos 2. Je spätne kompatibilný s motormi, ktoré vyžadujú normu oleja GM-LL- A-025/B- 025.",
    desc: "Motorový olej vyrobený na báze 100% syntetickej technológie špeciálne vyvinutý pre najnovšiu generáciu benzínových a dieselových Opel/GM motorov vyžadujúcich normu GM dexos 2. Je spätne kompatibilný s motormi, ktoré vyžadujú normu oleja GM-LL- A-025/B- 025.",
    ean: 8586016016454,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502060,
    brand: "DYNAMAX",
    image: "img28001",
    src: "28001.jpg",
    name: "DYNAMAX COOL 13 ULTRA 25L",
    short_desc:
      "Chladiaca kvapalina optimalizovaná pre všetky typy moderných automobilov s vynikajúcou miešateľnosťou s inými druhmi chladiacich kvapalín (G11, G12, G12++...).",
    desc: "Chladiaca kvapalina optimalizovaná pre všetky typy moderných automobilov s vynikajúcou miešateľnosťou s inými druhmi chladiacich kvapalín (G11, G12, G12++...). Je špeciálne vyvinutá pre najnovšie automobily VW group (VW, ŠKODA, SEAT, AUDI). Poskyt uje výbornú ochranu pred mrazom, vysokými teplotami a zároveň chráni pred koróziou. DOPORUČENÉ POMERY RIEDENIA:1 diel DYNAMAX COOLANT ULTRA G13: 1 diel DYNAQUA - použitie do - 37 °C. 1 diel DYNAMAX COOLANT ULTRA G13 : 1,5 dielu DYNAQUA - použitie do - 26 °C.1 diel DYNAMAX COOLANT ULTRA G13: 2 diely DYNAQUA - použitie do - 17 °C.",
    ean: 8586016017475,
    package: "",
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502061,
    brand: "DYNAMAX",
    image: "img18696",
    src: "18696.jpg",
    name: "DYNAMAX COOL 13 ULTRA 200L",
    short_desc:
      "Chladiaca kvapalina optimalizovaná pre všetky typy moderných automobilov s vynikajúcou miešateľnosťou s inými druhmi chladiacich kvapalín (G11, G12, G12++...).",
    desc: "Chladiaca kvapalina optimalizovaná pre všetky typy moderných automobilov s vynikajúcou miešateľnosťou s inými druhmi chladiacich kvapalín (G11, G12, G12++...). Je špeciálne vyvinutá pre najnovšie automobily VW group (VW, ŠKODA, SEAT, AUDI). Poskyt uje výbornú ochranu pred mrazom, vysokými teplotami a zároveň chráni pred koróziou. DOPORUČENÉ POMERY RIEDENIA:1 diel DYNAMAX COOLANT ULTRA G13: 1 diel DYNAQUA - použitie do - 37 °C. 1 diel DYNAMAX COOLANT ULTRA G13 : 1,5 dielu DYNAQUA - použitie do - 26 °C.1 diel DYNAMAX COOLANT ULTRA G13: 2 diely DYNAQUA - použitie do - 17 °C.",
    ean: 8586016018359,
    package: "",
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502073,
    brand: "DYNAMAX",
    image: "img101213",
    src: "101213.jpg",
    name: "DYNAMAX PREMIUM ULTRA FEB 5W20 5L",
    short_desc:
      "Vysokokvalitný motorový olej na báze 100% syntetickej technológie špeciálne vyvinutý pre najnovšiu generáciu benzínových motorov Ford Ecoboost. Je tiež vhodný pre motory vyžadujúce ACEA A1/B1 špecifikáciu.",
    desc: "Vysokokvalitný motorový olej na báze 100% syntetickej technológie špeciálne vyvinutý pre najnovšiu generáciu benzínových motorov Ford Ecoboost. Je tiež vhodný pre motory vyžadujúce ACEA A1/B1 špecifikáciu.",
    ean: 8586016016560,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502074,
    brand: "DYNAMAX",
    image: "img31508",
    src: "31508.jpg",
    name: "DYNAMAX PREMIUM ULTRA C2 5W-30 5L",
    short_desc:
      "Vysokovýkonný motorový olej vyrobený na báze 100% syntetickej technológie určený na použitie v benzínových a dieselových motoroch vyžadujúcich normu PSA B71 2290. Olej je tiež vhodný pre motory vyžadujúce ACEA A5/B5 ACEA C2 špecifikáciu.",
    desc: "Vysokovýkonný motorový olej vyrobený na báze 100% syntetickej technológie určený na použitie v benzínových a dieselových motoroch vyžadujúcich normu PSA B71 2290. Olej je tiež vhodný pre motory vyžadujúce ACEA A5/B5 ACEA C2 špecifikáciu.",
    ean: 8586016016577,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502075,
    brand: "DYNAMAX",
    image: "img27729",
    src: "27729.jpg",
    name: "DYNAMAX COOL 13 ULTRA 5L",
    short_desc:
      "Chladiaca kvapalina optimalizovaná pre všetky typy moderných automobilov s vynikajúcou miešateľnosťou s inými druhmi chladiacich kvapalín (G11, G12, G12++...).",
    desc: "Chladiaca kvapalina optimalizovaná pre všetky typy moderných automobilov s vynikajúcou miešateľnosťou s inými druhmi chladiacich kvapalín (G11, G12, G12++...). Je špeciálne vyvinutá pre najnovšie automobily VW group (VW, ŠKODA, SEAT, AUDI). Poskyt uje výbornú ochranu pred mrazom, vysokými teplotami a zároveň chráni pred koróziou. DOPORUČENÉ POMERY RIEDENIA:1 diel DYNAMAX COOLANT ULTRA G13: 1 diel DYNAQUA - použitie do - 37 °C. 1 diel DYNAMAX COOLANT ULTRA G13 : 1,5 dielu DYNAQUA - použitie do - 26 °C.1 diel DYNAMAX COOLANT ULTRA G13: 2 diely DYNAQUA - použitie do - 17 °C.",
    ean: 8586016016584,
    package: 3,
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502078,
    brand: "DYNAMAX",
    image: "img31244",
    src: "31244.jpg",
    name: "DYNAMAX SCREENWASH NANO MELON KIWI 1L",
    short_desc:
      "DYNAMAX NANO SCREENWASH je vysokokvalitná letná zmes do ostrekovačov vyrobená na báze NANO technológie s príjemnou zmesou vôní melónu a kiwi.",
    desc: "DYNAMAX NANO SCREENWASH je vysokokvalitná letná zmes do ostrekovačov vyrobená na báze NANO technológie s príjemnou zmesou vôní melónu a kiwi. Vytvára na skle účinnú ochrannú vrstvu, ktorej hlavnou úlohou je minimalizovať usadzovanie nečistôt a tým zlepšiť viditeľnosť na vašich cestách. Zmes zároveň napomáha k odstraňovaniu dažďovej vody a je šetrná k vašim svetlometom.",
    ean: 8586016016591,
    package: 12,
    type: "doplnok",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502079,
    brand: "DYNAMAX",
    image: "img31509",
    src: "31509.jpg",
    name: "DYNAMAX PREMIUM ULTRA GMD 5W-30 4L",
    short_desc:
      "Motorový olej vyrobený na báze 100% syntetickej technológie špeciálne vyvinutý pre najnovšiu generáciu benzínových a dieselových Opel/GM motorov vyžadujúcich normu GM dexos 2. Je spätne kompatibilný s motormi, ktoré vyžadujú normu oleja GM-LL- A-025/B- 025.",
    desc: "Motorový olej vyrobený na báze 100% syntetickej technológie špeciálne vyvinutý pre najnovšiu generáciu benzínových a dieselových Opel/GM motorov vyžadujúcich normu GM dexos 2. Je spätne kompatibilný s motormi, ktoré vyžadujú normu oleja GM-LL- A-025/B- 025.",
    ean: 8586016016508,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502080,
    brand: "DYNAMAX",
    image: "img18955",
    src: "18955.jpg",
    name: "DYNAMAX TRUCKMAN + LE 10W-30 20L",
    short_desc:
      'DYNAMAX TRUCKMAN PLUS LE 10W30 je supervýkonný dieselový „Super High Performance Diesel" (SHPD) motorový olej poskytujúci najvyšší výkon a dlhý pracovný potenciál pre vysoko výkonné, rýchlobežné, preplňované motory pracujúce za ťažkých podmienok.',
    desc: 'DYNAMAX TRUCKMAN PLUS LE 10W30 je supervýkonný dieselový „Super High Performance Diesel" (SHPD) motorový olej poskytujúci najvyšší výkon a dlhý pracovný potenciál pre vysoko výkonné, rýchlobežné, preplňované motory pracujúce za ťažkých podmienok. Redukuje usadeniny na piestoch, chráni pred opotrebením, znižuje spotrebu oleja a dovoľuje dlhšie výmenné intervaly. Je odporúčaný pre vozidlá s modernými systémami následného spracovania výfukových plynov (DPF, EGR alebo SCR) v kombinácii s motorovou naftou s nízkym obsahom síry, spĺňajúcich požiadavky normy Euro 4 a 5.',
    ean: 8586016016690,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502082,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX ATF III COLORLESS 20L",
    short_desc: "",
    desc: 0,
    ean: 8586016017031,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502083,
    brand: "DYNAMAX",
    image: "img18697",
    src: "18697.jpg",
    name: "DYNAMAX ULTRA LONG LIFE 5W-30 209L",
    short_desc:
      "Doporučuje sa hlavne pre najnovšiu generáciu vysoko výkonných benzínových a dieselových osobných automobilov a dodávok.",
    desc: "Motorový olej DYNAMAX ULTRA LONGLIFE 5W-30 je vhodný pre použitie pre všetky benzínové a naftové motory osobných vozidiel vyžadujúcich motorový olej spĺňajúci špecifikácie VW 504.00, 507.00, čo znamená že spľňa predľžený výmenný interval /30.000 km/.",
    ean: 8586016016607,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502084,
    brand: "DYNAMAX",
    image: "img18698",
    src: "18698.jpg",
    name: "DYNAMAX COOL ULTRA G 12 60 L",
    short_desc:
      "Je vysoko kvalitná nízkotuhnúca zmes vyrobená z monoetylénglykolu s vysoko progresívnymi antikoróznymi prísadami, zvlášť vhodná p re chladiče moderných hliníkových a zliatinových chladiacich sústav spaľovacích motorov.",
    desc: "DYNAMAX COOLANT ULTRA G12 je koncentrovaná nízkotuhnúca chladiaca kvapalina určená pre najmodernejšie druhy motorov. Je vysoko kvalitná nízkotuhnúca zmes vyrobená z monoetylénglykolu s vysoko progresívnymi antikoróznymi prísadami, zvlášť vhodná p re chladiče moderných hliníkových a zliatinových chladiacich sústav spaľovacích motorov. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. V roku 2008 získala chladiaca kvap alina DYNAMAX COOLANT ULTRA G12 prestížne ocenenie Zlatú medailu a Certifikát ochrannej známky kvality Slovak Gold. Obsahuje látku brániacu požitiu chladiacej kvapaliny. Plní sa do čistého chladiaceho systému podľa pokynov výrobcu automobilu. Je rie diteľná pitnou alebo demineralizovanou vodou na požadovaný bod tuhnutia podľa učených pomerov výrobcu. DYNAMAX COOLANT ULTRA G12 chladiaca kvapalina je miešateľná s nízkotuhnúcimi kvapalinami na báze monoetylén-glykolu (etylénglykolu a propylénglykolu).",
    ean: 8586016016867,
    package: "",
    type: "doplnok",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502085,
    brand: "DYNAMAX",
    image: "img18699",
    src: "18699.jpg",
    name: "DYNAMAX COOL ULTRA G 12 209 L",
    short_desc:
      "Je vysoko kvalitná nízkotuhnúca zmes vyrobená z monoetylénglykolu s vysoko progresívnymi antikoróznymi prísadami, zvlášť vhod ná pre chladiče moderných hliníkových a zliatinových chladiacich sústav spaľovacích motorov.",
    desc: "DYNAMAX COOLANT ULTRA G12 je koncentrovaná nízkotuhnúca chladiaca kvapalina určená pre najmodernejšie druhy motorov. Je vysoko kvalitná nízkotuhnúca zmes vyrobená z monoetylénglykolu s vysoko progresívnymi antikoróznymi prísadami, zvlášť vhod ná pre chladiče moderných hliníkových a zliatinových chladiacich sústav spaľovacích motorov. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. V roku 2008 získala chladiaca kv apalina DYNAMAX COOLANT ULTRA G12 prestížne ocenenie Zlatú medailu a Certifikát ochrannej známky kvality Slovak Gold. Obsahuje látku brániacu požitiu chladiacej kvapaliny.Plní sa do čistého chladiaceho systému podľa pokynov výrobcu automobilu. Je riediteľná pitnou alebo demineralizovanou vodou na požadovaný bod tuhnutia podľa určených pomerov výrobcu. DYNAMAX COOLANT ULTRA G12 chladiaca kvapalina je miešateľná s nízkotuhnúcimi kvapalinami na báze monoetylén-glykolu (etylénglykolu a propylé nglykolu).",
    ean: 8586016016782,
    package: "",
    type: "doplnok",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502087,
    brand: "DYNAMAX",
    image: "img16081",
    src: "16081.jpg",
    name: "DYNAMAX M6AD SAE 30 1L",
    short_desc:
      "Automobilový motorový olej DYNAMAX M6AD sa používa predovšetkým pre staršie typy nákl adných automobilov a ľahkých dodávkových automobilov.",
    desc: "Letný motorový olej na mazanie benzínových a nepreplňovaných naftových štvortaktných motorov, najmä starších typov, v nenáročných prevádzkových podmienkach.",
    ean: 8586016016706,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502088,
    brand: "DYNAMAX",
    image: "img26294",
    src: "26294.jpg",
    name: "DYNAMAX M6AD SAE30 4L",
    short_desc:
      "Letný motorový olej na mazanie benzínových a nepreplňovaných naftových štvortaktných motorov, najmä starších typov, v nenáročných prevádzkových podmienkach.",
    desc: "Letný motorový olej na mazanie benzínových a nepreplňovaných naftových štvortaktných motorov, najmä starších typov, v nenáročných prevádzkových podmienkach. Automobilový motorový olej DYNAMAX M6AD sa používa predo-všetkým pre staršie typy náklad ných automobilov a ľahkých dodávkových automobilov.",
    ean: 8586016016713,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502089,
    brand: "DYNAMAX",
    image: "img96333",
    src: "96333.jpg",
    name: "DYNAMAX GOLDLINE LONGLIFE 0W-30 1L",
    short_desc:
      "Vysokovýkonný plnesyntetický motorový olej určený pre benzínové a dieselové motory osobných automobilov s alebo bez turbo preplňovania.",
    desc: 'Vysokovýkonný plnesyntetický motorový olej určený pre benzínové a dieselové motory osobných automobilov s alebo bez turbo preplňovania. Je obzvlášť vhodný pre "Pumpa- Dýza" (PD) motory a pre motory s predĺženým výmenným intervalom (30 000- 50 000 km / 24 mesiacov). Je vhodný pre motory s alebo bez filtra pevných častíc (DPF).',
    ean: 8586016016904,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502091,
    brand: "DYNAMAX",
    image: "img108000",
    src: "108000.jpg",
    name: "DYNAMAX GOLDLINE LONGLIFE 0W-30 4L",
    short_desc:
      "Vysokovýkonný plne syntetický motorový olej určený pre benzínové a dieselové motory osobných automobilov s alebo bez turbo preplňovania.",
    desc: 'Vysokovýkonný plne syntetický motorový olej určený pre benzínové a dieselové motory osobných automobilov s alebo bez turbo preplňovania. Je obzvlášť vhodný pre "Pumpa- Dýza" (PD) motory a pre motory s predĺženým výmenným intervalom (30 000- 50 000 km / 24 mesiacov). Je vhodný pre motory s alebo bez filtra pevných častíc (DPF).',
    ean: 8586016016911,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502093,
    brand: "DYNAMAX",
    image: "img18956",
    src: "18956.jpg",
    name: "DYNAMAX TRUCKMAN + LE 10W-30 209L (180KG",
    short_desc:
      'DYNAMAX TRUCKMAN PLUS LE 10W30 je supervýkonný dieselový „Super High Performance Diesel" (SHPD) motorový olej poskytujúci najvyšší výkon a dlhý pracovný potenciál pre vysoko výkonné, rýchlobežné, preplňované motory pracujúce za ťažkých podmienok . Redukuje usadeniny na piestoch, chráni pred opotrebením, znižuje spotrebu oleja a dovoľuje dlhšie výmenné intervaly. Je odporúčaný pre vozidlá s modernými systémami následného spracovania výfukových plynov (DPF, EGR alebo SCR) v kombinácii s motor ovou naftou s nízkym obsahom síry, spĺňajúcich požiadavky normy Euro 4 a 5.',
    desc: 'DYNAMAX TRUCKMAN PLUS LE 10W30 je supervýkonný dieselový „Super High Performance Diesel" (SHPD) motorový olej poskytujúci najvyšší výkon a dlhý pracovný potenciál pre vysoko výkonné, rýchlobežné, preplňované motory pracujúce za ťažkých podmienok . Redukuje usadeniny na piestoch, chráni pred opotrebením, znižuje spotrebu oleja a dovoľuje dlhšie výmenné intervaly. Je odporúčaný pre vozidlá s modernými systémami následného spracovania výfukových plynov (DPF, EGR alebo SCR) v kombinácii s motor ovou naftou s nízkym obsahom síry, spĺňajúcich požiadavky normy Euro 4 a 5.',
    ean: 8586016016850,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502094,
    brand: "DYNAMAX",
    image: "img18700",
    src: "18700.jpg",
    name: "DYNAMAX TRUCKMAN + FE 10W-40 60 L",
    short_desc:
      "DYNAMAX TRUCKMAN PLUS FE je olej určený pre prevádzku naftových motorov zvlášť pre veľké nákladné automobily, stavebnú techniku a autobusy.",
    desc: "DYNAMAX TRUCKMAN PLUS FE je olej určený pre prevádzku naftových motorov zvlášť pre veľké nákladné automobily, stavebnú techniku a autobusy. DYNAMAX TRUCKMAN PLUS FE je vhodný pre použitie v preplňovaných aj nepreplňovaných naftových štvortaktných motoroch s nízkymi emisiami, ktoré používajú systémy recirkulácie výfukových plynov (EGR), spĺňajúcich požiadavky normy EURO IV. Je motorový olej novej generácie typu SHPDO (Super High Performance Diesel Oil), doporučovaný pre vysoko namáhané naftové motory s turbopreplňovaním aj nepreplňovaním, s vylepšenými vlastnosťami, čo sa týka čistoty piestu, leštenia povrchu valca, zníženia opotrebenia,znečistenia sadzami a odolnosti proti stárnutiu. Umožňuje dosahovať veľmi dlhé výmenné intervaly.",
    ean: 8586016016836,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502095,
    brand: "DYNAMAX",
    image: "img18701",
    src: "18701.jpg",
    name: "DYNAMAX TRUCKMAN X 15W-40 60L (53,5KG)",
    short_desc:
      "DYNAMAX TRUCKMAN X 15W-40 je zvlášť vhodný pre použitie v preplňovaných a nepreplňovaných naftových štvortaktných motoroch nákladných automobilov v diaľkovej nákladnej doprave, v autobusovej doprave, v stavebníctve a v lodnej doprave.",
    desc: "DYNAMAX TRUCKMAN X 15W-40 je zvlášť vhodný pre použitie v preplňovaných a nepreplňovaných naftových štvortaktných motoroch nákladných automobilov v diaľkovej nákladnej doprave, v autobusovej doprave, v stavebníctve a v lodnej doprave. Je vhodný aj na mazanie motorov ľahkých dodávkových automobilov s naftovým motorom. Je olej novej generácie typu SHPDO (Super High Performance Diesel Oil), odporúčaný pre vysoko namáhané naftové motory s turbopreplňovaním aj nepreplňovaním, s vylepšenými vlas tnosťami, čo sa týka čistoty piestu, leštenia povrchu valca, zníženia opotrebenia, znečistenia sadzami a odolnosti proti stárnutiu. Umožňuje dosahovať veľmi dlhé výmenné intervaly.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502110,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX COOL 11 AL 5L",
    short_desc: "",
    desc: 0,
    ean: 4031185338035,
    package: 3,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502114,
    brand: "DYNAMAX",
    image: "img81497",
    src: "81497.jpg",
    name: "DYNAMAX GOLDLINE LONGLIFE 0W-30 5L",
    short_desc:
      'Vysokovýkonný plne syntetický motorový olej určený pre benzínové a dieselové motory osobných automobilov s alebo bez turbo preplňovania. Je obzvlášť vhodný pre "Pumpa- Dýza" (PD) motory a pre motory s predĺženým výmenným intervalom (30 000- 50 000 km / 24 mesiacov). Je vhodný pre motory s alebo bez filtra pevných častíc (DPF).',
    desc: 'Vysokovýkonný plne syntetický motorový olej určený pre benzínové a dieselové motory osobných automobilov s alebo bez turbo preplňovania. Je obzvlášť vhodný pre "Pumpa- Dýza" (PD) motory a pre motory s predĺženým výmenným intervalom (30 000- 50 000 km / 24 mesiacov). Je vhodný pre motory s alebo bez filtra pevných častíc (DPF).',
    ean: 8586016016928,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502116,
    brand: "DYNAMAX",
    image: "img107999",
    src: "107999.jpg",
    name: "DYNAMAX GOLDLINE FUEL ECO 0W-16 5L",
    short_desc:
      "Vysoko kvalitný plnesyntetický motorový olej určený na použitie v benzínových a dieselových motoroch osobných automobilov vybavených s alebo bez turbopreplňovania a priameho vstrekovania.",
    desc: "Vysoko kvalitný plnesyntetický motorový olej určený na použitie v benzínových a dieselových motoroch osobných automobilov vybavených s alebo bez turbopreplňovania a priameho vstrekovania. Olej je špeciálne vyvinutý pre hybridné motory. Vyznačuje sa vynikajúcim štartom za studena a minimalizáciou spotreby paliva, trenia a opotrebenia.",
    ean: 8586016016942,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502118,
    brand: "DYNAMAX",
    image: "img31427",
    src: "31427.jpg",
    name: "DYNAMAX TRUCKMAN + SHPD 15W-40 20L",
    short_desc:
      "Supervýkonný dieselový „Super High Performance Diesel“  (SHPD) motorový olej vyrobený na báze 100% syntetickej technológie  s pridaním špeciálnych aditív pre zaistenie dokonalého mazania  vysoko zaťažených nákladných automobilov.",
    desc: "Supervýkonný dieselový „Super High Performance Diesel“  (SHPD) motorový olej vyrobený na báze 100% syntetickej technológie  s pridaním špeciálnych aditív pre zaistenie dokonalého mazania  vysoko zaťažených nákladných automobilov. Spĺňa požiadavky EURO 4  a EURO 5, teda je vhodný pre motory s filtrami pevných častíc (DPF),  EGR, alebo so systémami následnej úpravy výfukových plynov (SCR).",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502120,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX COOL ULTRA G12 -18 4L",
    short_desc: "",
    desc: 0,
    ean: 8586016016614,
    package: 3,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502124,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX UNI PLUS 10W40 20L",
    short_desc: "",
    desc: 0,
    ean: 8586016016829,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502125,
    brand: "DYNAMAX",
    image: "img18702",
    src: "18702.jpg",
    name: "DYNAMAX COOL 12++ ULTRA 25L",
    short_desc:
      "Základnou funkciou je veľmi dobrý prevod tepla a ochrana motora prípadne chladiacej sústavy. Pre celoročnú ochranu chladiacich systémov.",
    desc: "DYNAMAX COOLANT ULTRA G12 ++ je vhodný do chladičov hliníkových a liatinových chladiacich sústav spaľovacích motorov u najnovších automobilov.",
    ean: 4031185221252,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502143,
    brand: "DYNAMAX",
    image: "img31893",
    src: "31893.jpg",
    name: "DYNAMAX EMULGOL DS 30 209L",
    short_desc:
      "DYNAMAX Emulgol DS 30 sa používa vo forme vodnej chladiaco-mazacej emulzie pri sústružení ocele, liatiny, neželezných kovov.",
    desc: "DYNAMAX Emulgol DS 30 sa používa vo forme vodnej chladiaco-mazacej emulzie pri sústružení ocele, liatiny, neželezných kovov. Doporučená pracovná koncentrácia emulzie (pripravená vo vode so stupňom tvrdosti do 20°N) v závislosti od druhu obrábania a obrábaného materiálu: brúsenie 3-5%, sústruženie, frézovanie, vŕtanie 5-10%, závitovanie 10-15%.",
    ean: 8586016017192,
    package: "",
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502147,
    brand: "DYNAMAX",
    image: "img18703",
    src: "18703.jpg",
    name: "DYNAMAX M7AD 10W-40 209 L (183KG)",
    short_desc:
      "Motorový olej DYNAMAX M7AD je určený pre mazanie benzínových a naftových štvortaktných motorov starších konštrukcií. Celoročný motorový olej určený predovšetkým na mazanie benzínových štvortaktných motorov starších konštrukcií.",
    desc: "Motorový olej DYNAMAX M7AD je určený pre mazanie benzínových a naftových štvortaktných motorov starších konštrukcií. Celoročný motorový olej určený predovšetkým na mazanie benzínových štvortaktných motorov starších konštrukcií. Vysoký viskozitný i ndex oleja, vysoká odolnosť oleja voči šmykovému namáhaniu a kvalita výkonnostnej prísady zabezpečujú výborné viskozitné mazacie vlastnosti oleja v širokom rozsahu pracovných teplôt. Umožňuje veľmi dobré štartovanie motorov aj pri veľmi nízkych teplotách v zimnom období a zároveň má značnú rezervu viskozity pre letné obdobie.",
    ean: 8586016017253,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502149,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX TRUCKMAN PLUS M 10W40 20L",
    short_desc:
      "DYNAMAX Truckman Plus M 10W40 je vysoko výkonný syntetický motorový olej, ktorý je určený na mazanie dieselových motorov s turbo preplňovaním i nepreplňovaním. Má vynikajúcu tepelnú a oxidačnú stabilitu a vysokú odolnosť proti starnutiu, zvlášť pri vysokých teplotách. Spĺňa požiadavky na emisie podľa Euro 3.",
    desc: "Olej je odporúčaný pre dieselové motory pracujúce za veľmi ťažkých prevádzkových podmienok napr. predĺžené intervaly výmeny olejov podľa odporúčania výrobcov motorov, resp. tam, kde sa vyžaduje špeciálna kvalita oleja. Je určený pre prevádzku naftových motorov zvlášť pre veľké nákladné automobily, stavebnú techniku aktívna ochrana ventilov a autobusy. Schválenia: MAN M 3277; MB-Approval 228.5; MB-Approval 229.1; Renault RVI RXD; Volvo VDS-2; TATRA T815-2, T163 (T3B-928, T3C-928, T3D-928) MTU Oil Type 3; MAN M3275; Volkswagen 505.00; DAF HP-2; Iveco; Cummins CES 20076/20077; Caterpillar ECF-1a; Mack EO-M Plus",
    ean: 8586016017215,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502150,
    brand: "DYNAMAX",
    image: "img108112",
    src: "108112.jpg",
    name: "DYNAMAX TRUCKMAN PLUS M 10W40 209L",
    short_desc:
      "DYNAMAX Truckman Plus M 10W40 je vysoko výkonný syntetický motorový olej, ktorý je určený na mazanie dieselových motorov s turbo preplňovaním i nepreplňovaním. Má vynikajúcu tepelnú a oxidačnú stabilitu a vysokú odolnosť proti starnutiu, zvlášť pri vysokých teplotách. Spĺňa požiadavky na emisie podľa Euro 3.",
    desc: "Olej je odporúčaný pre dieselové motory pracujúce za veľmi ťažkých prevádzkových podmienok napr. predĺžené intervaly výmeny olejov podľa odporúčania výrobcov motorov, resp. tam, kde sa vyžaduje špeciálna kvalita oleja. Je určený pre prevádzku naftových motorov zvlášť pre veľké nákladné automobily, stavebnú techniku aktívna ochrana ventilov a autobusy. Schválenia: MAN M 3277; MB-Approval 228.5; MB-Approval 229.1; Renault RVI RXD; Volvo VDS-2; TATRA T815-2, T163 (T3B-928, T3C-928, T3D-928) MTU Oil Type 3; MAN M3275; Volkswagen 505.00; DAF HP-2; Iveco; Cummins CES 20076/20077; Caterpillar ECF-1a; Mack EO-M Plus",
    ean: 8586016017222,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502151,
    brand: "DYNAMAX",
    image: "img31894",
    src: "31894.jpg",
    name: "DYNAMAX OHHM 68 209L(186,5KG)",
    short_desc:
      "Hydraulické oleje DYNAMAX OHHM 68 sú určené pre hydrostatické mechanizmy s vysokým mechanickým aj tepelným namáhaním pre stabilné aj mobilné stroje pracujúce v nechránenom prostredí.",
    desc: "DYNAMAX OHHM 68 je hydrogenačne rafinovaný ropný olej zušľachtený prísadami na zlepšenie oxidačnej stálosti, protikoróznych a protioderových vlastností a prísadami proti peneniu. Obsahujú modifikátor viskozity s depresantným účinkom.",
    ean: 8586016017246,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502152,
    brand: "DYNAMAX",
    image: "img18704",
    src: "18704.jpg",
    name: "DYNAMAX M7ADX 209 L",
    short_desc:
      "Univerzálny automobilový motorový olej DYNAMAX M7ADX je zvlášť vhodný pre staršie typy osobných automobilov LADA a DACIA.",
    desc: "Univerzálny automobilový motorový olej DYNAMAX M7ADX je zvlášť vhodný pre staršie typy osobných automobilov LADA a DACIA. Celoročný univerzálny motorový olej určený na mazanie všetkých benzínových štvortaktných motorov. Možno ho tiež použiť na maz anie štvortaktných naftových motorov. DYNAMAX M7ADX obsahuje prísady, ktoré ho robia optimálnym pre stredoeurópske pásmo.",
    ean: 8586016017239,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502154,
    brand: "DYNAMAX",
    image: "img27728",
    src: "27728.jpg",
    name: "DYNAMAX TURBO PLUS 15W-40 5L",
    short_desc:
      "Dynamax TURBO PLUS je určený pre takmer všetky typy motorových benzínových i naftových štvortaktných motorov,a to nepreplňovaných ako aj preplňovaných, vrátane motorov s katalyzátorom.",
    desc: "Dynamax TURBO PLUS je určený pre takmer všetky typy motorových benzínových i naftových štvortaktných motorov,a to nepreplňovaných ako aj preplňovaných, vrátane motorov s katalyzátorom. DYNAMAX TURBO PLUS je určený pre použitie v autobusoch, v nákladných automobiloch pracujúcich v najnáročnejších prevádzkových podmienkach, v lodných motoroch, traktoroch a zemných strojoch.",
    ean: 8586016017260,
    package: 3,
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502157,
    brand: "DYNAMAX",
    image: "img18705",
    src: "18705.jpg",
    name: "DYNAMAX M7ADX 15W-40 20 L",
    short_desc:
      "Univerzálny automobilový motorový olej DYNAMAX M7ADX je zvlášť vhodný pre staršie typy osobných automobilov LADA a DACIA.",
    desc: "Univerzálny automobilový motorový olej DYNAMAX M7ADX je zvlášť vhodný pre staršie typy osobných automobilov LADA a DACIA. Celoročný univerzálny motorový olej určený na mazanie všetkých benzínových štvortaktných motorov. Možno ho tiež použiť na maz anie štvortaktných naftových motorov. DYNAMAX M7ADX obsahuje prísady, ktoré ho robia optimálnym pre stredoeurópske pásmo.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502160,
    brand: "DYNAMAX",
    image: "img47469",
    src: "47469.jpg",
    name: "DYNAMAX M7AD 10W-40 10L",
    short_desc:
      "Motorový olej DYNAMAX M7AD je určený pre mazanie benzínových a naftových štvortaktných motorov starších konštrukcií.Celoročný motorový olej určený predovšetkým na mazanie benzínových štvortaktných motorov starších konštrukcií.",
    desc: "Motorový olej DYNAMAX M7AD je určený pre mazanie benzínových a naftových štvortaktných motorov starších konštrukcií.Celoročný motorový olej určený predovšetkým na mazanie benzínových štvortaktných motorov starších konštrukcií. Vysoký viskozitný index oleja, vysoká odolnosť oleja voči šmykovému namáhaniu a kvalita výkonnostnej prísady zabezpečujú výborné viskozitné mazacie vlastnosti oleja v širokom rozsahu pracovných teplôt. Umožňuje veľmi dobré štartovanie motorov aj pri veľmi nízkych teplotách v zimnom období a zároveň má značnú rezervu viskozity pre letné obdobie.",
    ean: 8586016017390,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502192,
    brand: "DYNAMAX",
    image: "img18957",
    src: "18957.jpg",
    name: "DYNAMAX SCREENWASH -80 209 L",
    short_desc:
      "Nemrznúca kvapalina do ostrekovačov automobilov. Spoľahlivo odstraňuje zo skla automobilu mastnotu a iné nečistoty.",
    desc: "Je vysoko účinná, celoročná mrazuvzdorná kvapalina do všetkých typov ostrekovačov motorových vozidiel. Chráni zariadenie ostrekovačov pred koróziou.",
    ean: 8586016017499,
    package: "",
    type: "olej",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502193,
    brand: "DYNAMAX",
    image: "img28280",
    src: "28280.jpg",
    name: "DYNAMAX PREMIUM ULTRA C2 5W-30 209L",
    short_desc:
      "Vysokovýkonný motorový olej vyrobený na báze 100% syntetickej technológie určený na použitie v benzínových a dieselových motoroch vyžadujúcich normu PSA B71 2290. Olej je tiež vhodný pre motory vyžadujúce ACEA A5/B5 ACEA C2 špecifikáciu.",
    desc: "Vysokovýkonný motorový olej vyrobený na báze 100% syntetickej technológie určený na použitie v benzínových a dieselových motoroch vyžadujúcich normu PSA B71 2290. Olej je tiež vhodný pre motory vyžadujúce ACEA A5/B5 ACEA C2 špecifikáciu.",
    ean: 8586016017956,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502194,
    brand: "DYNAMAX",
    image: "img18958",
    src: "18958.jpg",
    name: "DYNAMAX ULTRA PLUS PD 5W-40 209L",
    short_desc:
      "Syntetický motorový DYNAMAX ULTRA PLU S PD je najviac doporučovaný pre najnovšiu generáciu vysoko zaťažovaných benzínových, LPG a dieselových motorov u osobných automobilov.",
    desc: "Motorový olej DYNAMAX ULTRA PLUS PD je vysoko výkonný nízkoemisný syntetický celoročný motorový olej spĺňajúci požiadavky mid SAPS (Sulphated Ash, Phosphorus - Sulphur). Je vyrobený tak, aby predĺžil životnosť motora a životnosť zariadenia pre ná slednú úpravu výfukových plynov, ktoré používa posledná generácia benzínových a dieselových motorov u osobných automobilov.DYNAMAX ULTRA PLUS PD znižuje tvorbu popola v dieselových časticových filtroch (DPF).",
    ean: 8586016017574,
    package: "",
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502231,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX OHHM 68 VG68 10L",
    short_desc: "",
    desc: 0,
    ean: 8586016017536,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502251,
    brand: "DYNAMAX",
    image: "img6905",
    src: "6905.jpg",
    name: "DYNAMAX ČISTENIE A OCHRANA BENZÍNOVÉHO SYSTÉMU 300ML",
    short_desc:
      "Odstraňuje nečistoty a zvyšky nespáleného uhlíka v palivovom systéme. Rozpúšťa znečistenia z karburátoru a vstrekovacieho systému. Viaže vlhkosť a skondenzovanú vodu. Účinkuje: počas jazdy. Riedenie: 300 ml na 60 l benzínu. Odporúčaná aplikácia: každých 6 mesiacov pred tankovaním.",
    desc: "Odstraňuje nečistoty a zvyšky nespáleného uhlíka v palivovom systéme. Rozpúšťa znečistenia z karburátoru a vstrekovacieho systému. Viaže vlhkosť a skondenzovanú vodu. Zaisťuje efektívne čistenie celého benzínového palivového systému od nádrže až po spaľovaciu komoru. Odstraňuje prevádzkou spôsobené znečistenia a zabraňuje tvorbe usadenín. Vhodný aj počas studených štartov v zimnom období. Účinkuje: počas jazdy. Riedenie: 300 ml na 60 l benzínu. Odporúčaná aplikácia: každých 6 mesiacov pred tankovaním.",
    ean: 8586016017581,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502252,
    brand: "DYNAMAX",
    image: "img6906",
    src: "6906.jpg",
    name: "DYNAMAX ČISTIČ VENTILOV A VSTREKOVANIA 300ML",
    short_desc:
      "Optimalizuje spotrebu paliva a emisie výfukových plynov. Čistí vstrekovacie trysky. Zaisťuje efektívne čistenie ventilov, vstrekovacích trysiek a vstupného priestoru bez nutnosti demontáže. Odstraňuje prevádzkou spôsobené znečistenia v celom systém e vstrekovania benzínu.",
    desc: "Optimalizuje spotrebu paliva a emisie výfukových plynov. Čistí vstrekovacie trysky. Zaisťuje efektívne čistenie ventilov, vstrekovacích trysiek a vstupného priestoru bez nutnosti demontáže. Odstraňuje prevádzkou spôsobené znečistenia v celom systém e vstrekovania benzínu.",
    ean: 4031185042314,
    package: 12,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502253,
    brand: "DYNAMAX",
    image: "img6907",
    src: "6907.jpg",
    name: "DYNAMAX ZVÝŠENIE OKTÁNOVÉHO ČÍSLA 300ML",
    short_desc:
      "Zvýšenie oktánového čísla až o 3 body. Zlepšené štartovacie a výkonnostné vlastnosti. Prípravok pre zvýšenie oktánového čísla pre nízko oktánové palivá, alebo pre použitie v motoroch s vysoko oktánovými požiadavkami.",
    desc: "Zvýšenie oktánového čísla až o 3 body. Zlepšené štartovacie a výkonnostné vlastnosti. Prípravok pre zvýšenie oktánového čísla pre nízko oktánové palivá, alebo pre použitie v motoroch s vysoko oktánovými požiadavkami. Účinkuje: počas jazdy. Riedenie: 300 ml na 60 l benzínu. Odporúčaná aplikácia: pred každým tankovaním.",
    ean: 8586016017604,
    package: 12,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502254,
    brand: "DYNAMAX",
    image: "img6908",
    src: "6908.jpg",
    name: "DYNAMAX DPF ČISTIČ 300 ML",
    short_desc:
      "Redukuje sadze a emisie výfukových plynov. Podporuje regeneráciu filtra pevných častíc Vysoko výkonný prípravok pre použitie vo všetkých dieselových agregátoch na zníženie emisií výfukových plynov, sadzí a zvýšenie výkonu motora. Vhodný pre všetky druhy motorovej nafty. Účinkuje počas jazdy. Balenie 300 ml na 60 l nafty. Odporúčaná aplikácia: každých 5 000 km aplikovať pri natankovaní",
    desc: "Redukuje sadze a emisie výfukových plynov. Podporuje regeneráciu filtra pevných častíc. Vysoko výkonný prípravok pre použitie vo všetkých dieselových agregátoch na zníženie emisií výfukových plynov, sadzí a zvýšenie výkonu motora. Vhodný pre všetky druhy motorovej nafty. Účinkuje počas jazdy. Balenie 300 ml na 60 l nafty. Odporúčaná aplikácia: každých 5 000 km aplikovať pri natankovaní.",
    ean: 8586016017611,
    package: 12,
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502255,
    brand: "DYNAMAX",
    image: "img6909",
    src: "6909.jpg",
    name: "DYNAMAX DPF ČISTIACA KVAPALINA 1L",
    short_desc:
      "Rozpúšťa usadeniny a nečistoty. Regeneruje plnú funkčnosť DPF. Vysoko účinná prísada pre čistenie demontovaného filtra pevných častíc (DPF). Rozpúšťa znečistenie vo filtri a regeneruje jeho plnú funkčnosť. Použitie: vhodné pre všetky DPF.",
    desc: "Vysoko účinná prísada pre čistenie demontovaného filtra pevných častíc (DPF). Rozpúšťa znečistenie vo filtri a regeneruje jeho plnú funkčnosť. Použitie: vhodné pre všetky DPF.  1. Zrieďte prípravok s vodou v pomere 1:4 (v prípade silného znečistenia 1:1). 2. Odmontujte DPF a naplňte ho prípravkom od 3 do 5 litrov (v závislosti od veľkosti DPF). 3. Nechajte prípravok účinkovať približne 8-10 hodín.  4. Pravidelne kontrolujte stav naplnenia a v prípade potreby doplňte hladinu. 5. Vyprázdnite DPF 6. Dôkladne opláchnite DPF čistou vodou. 7. Namontujte DPF a vykonajte skúšobnú jazdu po dobu aspoň 15 minút.",
    ean: 8586016017635,
    package: 12,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502256,
    brand: "DYNAMAX",
    image: "img6910",
    src: "6910.jpg",
    name: "DYNAMAX DPF STREKACIA KVAPALINA 1L",
    short_desc:
      "Použitie bez demontovania DPF. Rozpúšťa usadeniny a nečistoty. Regeneruje plnú funkčnosť DPF. Vysoko účinná čistiaca kvapalina na čistenie DPF. Rozpúšťa znečistenia a regeneruje jeho plnú funkčnosť.",
    desc: "Vysoko účinná čistiaca kvapalina na čistenie DPF. Rozpúšťa znečistenia a regeneruje jeho plnú funkčnosť. Použitie: Uistite sa, že výfukový systém nemá žiadne úniky a pracuje správne. 1. Demontujte snímač teploty a / alebo tlaku. 2. Zrieďte kvapalinu s vodou v pomere 1:3 (pri silnejšom znečistení 1:2) 3. Naplňte striekaciu pištoľ kvapalinou a nastavte v nej tlak (2.5-4.0 bar). 4. Naštartujte motor a nechajte ho počas čistenia na voľnobehu.  Striekajte produkt v 5 sekundových intervaloch cez demontovaný otvor. Odporúčame použiť min. 500 ml produktu v závislosti od znečistenia. V prípade potreby postup opakujte. 5. Namontujte snímače a vykonajte skúšobnú jazdu. Sadze, ktoré boli v priebehu čistenia rozpustené budú spálené počas pravidelnej regenerácie.",
    ean: 8586016017642,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502257,
    brand: "DYNAMAX",
    image: "img6911",
    src: "6911.jpg",
    name: "DYNAMAX ČISTENIE A OCHRANA DIESELOVÉHO SYSTÉMU 300ML",
    short_desc:
      "Odstraňuje nečistoty v celom palivovom systéme. Optimalizuje spotrebu paliva. Vhodné pre common rail technológiu aj vstrekovanie čerpadlom. Obsahuje vybranú kombináciu účinných látok pre ochranu palivového systému voči opotrebeniu. Účinkuje: Počas jazdy. Riedenie: 300 ml na 80 l nafty. Odporúčaná aplikácia: každých 6 mesiacov pred tankovaním.",
    desc: "Odstraňuje nečistoty v celom palivovom systéme. Optimalizuje spotrebu paliva. Vhodné pre common rail technológiu aj vstrekovanie čerpadlom. Obsahuje vybranú kombináciu účinných látok pre ochranu palivového systému voči opotrebeniu. Účinne rozpúšť a usadeniny a zvyšky uhlíka, oleja a sadze. Zaisťuje dlhodobé mazanie vstrekovacieho čerpadla a všetkých pohyblivých častí. Prípravok je vhodný aj pre vysokotlakové systémy s priamym vstrekovaním a systémom Common rail. Vhodné pre common rail technológiu aj vstrekovanie čerpadlom. Účinkuje: Počas jazdy. Riedenie: 300 ml na 80 l nafty. Odporúčaná aplikácia: každých 6 mesiacov pred tankovaním.",
    ean: 8586016017659,
    package: 12,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502258,
    brand: "DYNAMAX",
    image: "img6912",
    src: "6912.jpg",
    name: "DYNAMAX  JEDNORÁZOVÁ ZIMNÁ STAROSTLIVOSŤ O NAFTU 150ML",
    short_desc:
      "Zlepšené prietokové a mazacie vlastnosti. Prevencia voči parafínovým krištáľom až do - 28°C. Zaisťuje zlepšenie prietokových vlastností motorovej nafty. Je vhodný pre použitie vo všetkých dieselových agregátoch s alebo bez DPF. Balenie obsahuje dávkovač. Riedenie: 500 ml na 500 l nafty. Odporúčaná aplikácia: počas zimného obdobia pred tankovaním.",
    desc: 'Je tu zimné obdobie a s ním spojené komplikácie najmä u naftových motorov. Funkcie aditív dokážu eliminovať negatívny dopad nízkych teplôt na palivový systém a často tak ušetriť peňaženku od nečakaných investícií. Zabraňuje korózii. Moderné palivové systémy sú omnoho menej tolerantné ku akýmkoľvek formám korózie, než u ich predchodcov. Tieto systémy vybavené pumpami, ci vstrekovačmi pracujúcimi pod extrémnymi tlakmi sú omnoho náchylnejšie na poruchy práve v zimnom období, kedy výskyt korózie v palivových systémoch je zapríčinený prítomnosťou vody. Každé palivo obsahuje malé percento vody, no problém nastane až vtedy, keď sa toto percento nadmerne zväčší a voda tzv. emulguje. Emulgáciou sa vytvorí samostatná zložka (vid obrázok dole), ktorú už samotné palivo bez pomoci aditíva nedokáže absorbovať. Voda sa do systému vie dostať mnohými spôsobmi a práve v zime je to najčastejšie kondenzáciou, kedy poklesom teploty sa molekuly vody premieňajú z plynného skupenstva na kvapalné. Ďalšími častými spôsobmi sú dážď, vysokotlakové umývanie, ci únikom z atmosféry (vlhkosť). Emulgovaná voda má nižšiu viskozitu než nafta, a preto poskytuje tenšiu mazaciu vrstvu medzi dvoma pohybujúcimi sa kovovými dielmi. Vytvára sa tzv. abrazívny efekt, ktorý z týchto dielov odstráni ochrannú vrstvu, bez ktorej všetky typy železných  i neželezných kovov v spojení s emulgovanou vodou automaticky korodujú. Korózia sa najčastejšie vyskytuje práve pri vstrekovačoch, kedy v prípade ich výmeny sa investícia pohybuje na úrovni niekoľkých stoviek eur. Zimné aditívum do nafty je overená prevencia voči poruchám tohto typu a to vďaka obsahu lubrikačnej zložky, ktorá vytvorí ochranný film na povrchu všetkých komponentov v palivovom systéme. Zamedzí tak abrazívnemu efektu a kovové časti zostanú naďalej chránené pred možným vznikom korózie. </div> <div class="fusion-text"> <h4><span style="color:#cc0000;">Lepší studený štart</h4> V zimnom období sú studené štarty komplikáciou pre všetky naftové automobily. Za studený štart sa považuje každý, pri ktorom motor nie je zahriaty na prevádzkovú teplotu, teda pred cestou do práce, z práce, ale aj medzi nákupmi, ci inými prestávkami medzi jazdami. Aj v tomto prípade stojí za náročným ranným štartovaním voda. Nie je v tom však jediná. Okrem nej na nízke zimné teploty negatívne reagujú aj uhľovodíky, ktoré tvoria základ každého paliva. Výrobcovia na základe zmiešania rôznych druhov uhľovodíkov vedia ovplyvniť ich bod mrazu, no má to vplyv na cenu paliva. <span style="color:#cc0000;font-size:xx-large;">»<span style="font-size:x-large;">Zlepšuje filtrovateľnosť nafty až o -13°C Voda počas tuhej zimy v palive zmrzne a jej kryštáliky ladu sa v palivovom systéme správajú, ako každé iné pevné teleso. Palivový filter chrániaci vstrekovače a motor tieto telesá cez seba jednoducho nepustí, co vo väčšom množstve môže Uhľovodíky majú takisto svoj bod tuhnutia, no na rozdiel od vody nevytvárajú lad, ale hustú gélovú hmotu tzv. parafín. Ten môže vo väčšom množstve takisto zamedziť prietok paliva cez filter, alebo znížiť výbušnosť nafty. Uvedené príklady nepriaznivého pôsobenia zimy na palivo sú príčinou toho, keď ráno nenaštartujete, alebo naštartujete, no po chvíli motor auta zhasne. Zimné aditívum do nafty dokáže účinne potlačiť tvorbu parafínu a zlepšuje filtrovateľnosť paliva až o – 13 °C v závislosti od kvality paliva. Takisto dokáže naviazať vodu s palivom a vytvorí tak hmotu, ktorú je motor schopný spáliť bez ďalších negatívnych dopadov na proces. </div> <div class="imageframe-align-center"> <div class="imageframe-liftup"><span class="fusion-imageframe imageframe-none imageframe-2"><a href="https://www.dynamaxoil.com/wp-content/uploads/2018/04/Image-53.jpg" class="fusion-lightbox" title="Image (53)"><img src="https://www.dynamaxoil.com/wp-content/uploads/2018/04/Image-53.jpg" alt="" class="img-responsive wp-image-3286" width="931" height="682" /></a></div> </div> <div class="fusion-text"> <p style="text-align:left;"><em>V skúmavke vľavo môžete vidieť príklad emulgovanej vody, ktorá klesne na dno a vytvorí v nafte samostatnú zložku. </em> </div>',
    ean: 8586016017734,
    package: 12,
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502259,
    brand: "DYNAMAX",
    image: "img6913",
    src: "6913.jpg",
    name: "DYNAMAX ODSTRAŇOVAČ BAKTÉRIÍ V NAFTE 150 ML",
    short_desc:
      "Dezinfikuje kompletný dieselový systém / skladovacie nádrže. Zabraňuje tvorbe baktérií, hubám a plesniam. Vhodný na použitie vo všetkých dieselových agregátoch a skladovacích nádržiach. Dezinfikuje kompletný dieselový systém/skladovacie nádrže. Zabraňuje tvorbe baktérií, hubám a plesniam. Účinkuje: ihneď po aplikácií. Riedenie: 150 ml na 150 l nafty. Odporúčaná aplikácia: každých 6 mesiacov.",
    desc: "Dezinfikuje kompletný dieselový systém / skladovacie nádrže. Zabraňuje tvorbe baktérií, hubám a plesniam. Vhodný na použitie vo všetkých dieselových agregátoch a skladovacích nádržiach. Vysoko výkonný koncentrát so širokým spektrom účinku na ničenie a prevenciu voči baktériám, hubám a plesniam v zariadeniach s dlhšou dobou mimo prevádzky. Dezinfikuje kompletný dieselový systém/skladovacie nádrže. Zabraňuje tvorbe baktérií, hubám a plesniam. Účinkuje: ihneď po aplikácií. Riedenie: 150 ml na 150 l nafty. Odporúčaná aplikácia: každých 6 mesiacov.",
    ean: 8586016017741,
    package: 12,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502260,
    brand: "DYNAMAX",
    image: "img6914",
    src: "6914.jpg",
    name: "DYNAMAX STAROSTLIVOSŤ A OCHRANA MOTORA 300ML",
    short_desc:
      "Zvýšená ochrana proti opotrebeniu. Kompatibilný s minerálnymi aj syntetickými olejmi. Chráni proti zriedeniu oleja. Obsahuje vysoko účinný balík aditív pre zvýšenie ochranných vlastností všetkých druhov motorových olejov voči opotrebovaniu.",
    desc: "Zvýšená ochrana proti opotrebeniu. Kompatibilný s minerálnymi aj syntetickými olejmi. Chráni proti zriedeniu oleja. Obsahuje vysoko účinný balík aditív pre zvýšenie ochranných vlastností všetkých druhov motorových olejov voči opotrebovaniu. Podpor uje zníženie trenia a zvyšuje prevádzkovú spoľahlivosť pri vysokých teplotách. Účinkuje: počas jazdy. Riedenie: 300 ml na 5 l oleja. Odporúčaná aplikácia: s každou výmenou oleja.",
    ean: 8586016017758,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502261,
    brand: "DYNAMAX",
    image: "img6915",
    src: "6915.jpg",
    name: "DYNAMAX KERAMICKÁ PRÍSADA DO OLEJA 300ML",
    short_desc:
      "Vytvára ochrannú vrstvu proti opotrebeniu. Zníženie prevádzkovej hlučnosti, trenia a opotrebenia. Obsahuje vysoko účinný balík aditív pre zvýšenie ochranných vlastností všetkých druhov motorových olejov voči opotrebovaniu. Podporuje zníženie treni a a zvyšuje prevádzku. NEOBSAHUJE CHLÓR !",
    desc: 'KERAMICKÁ OCHRANA MOTORA Pri slovnom spojení keramická ochrana väčšine automaticky napadne ochrana karosérie. Keramika však môže fungovať aj na iných miestach, napríklad vnútri motora. Keramická ochrana motora  obsahuje keramickú zložku, ktorá znižuje trenie pohybujúcich sa častí (piestov, ojníc, hriadeľov a podobne). Znížením trenia tak dochádza k zníženiu opotrebenia pohyblivých častí motora a to má vplyv aj na zníženie spotreby paliva. No v prvom rade to zlepší hladkosť chodu motora. <img class="alignnone size-large wp-image-5157" src="https://www.dynamaxoil.com/wp-content/uploads/2018/12/DSC_9864-1024x576.jpg" alt="" width="1024" height="576" /> <div> V prípade väčšiny motorových vozidiel sa 25 % energie vytvorenej pohonnými hmotami spotrebuje na prekonanie trenia. Práve toto číslo DYNAMAX Ceramic Oil Additive znižuje. Prvotným vplyvom Ceramic Oil Aditíva je zušľachťovanie kovových povrchov. Výsledkom je zabezpečenie ideálnych podmienok pre olejový film, tým pádom sa zníži opotrebovanie motora a náklady na údržbu. </div> <div class="clearfix editor block adblock"> DYNAMAX Ceramic Oil Additive dopĺňa mazacie vlastnosti motorového oleja o najmodernejšie komponenty bez popola. Okrem toho, pomocou motorového oleja sa nano-keramické častice dostanú na tie miesta, kde môže vzniknúť trenie. Tieto nanočastice sa dostanú do povrchových nerovností (valcov, piestov, ložísk, piestnych krúžkov, ozubených kolies, atď.) a tam priľnú. Nanočastice okrem zníženia trenia vylepšia aj problémy tesnenia. Spolu s tým ide ruka v ruke aj zníženie spotreby oleja, ktorú každý spaľovací motor zo svojho princípu má. Polykeramika má v modernej mazacej technike veľký význam. Drsnosť kovových trecích povrchov v motoroch je veľmi nízka, často len 1 mikrón, väčšie častice sa neprichytia (neprilepia) na kovový povrch. Filtračné prvky olejových filtrov majú vo väčšine prípadov filtračnú štruktúru a jemnosť vo veľkosti 15-25 mikrónov (super jemné filtre majú jemnosť 1-3 mikrónov) a tak tieto nie sú schopné vyfiltrovať polykeramické nanočastice produktu DYNAMAX Ceramic Oil. </div> <img class="alignnone size-large wp-image-5159" src="https://www.dynamaxoil.com/wp-content/uploads/2018/12/DSC_9872-1024x576.jpg" alt="" width="1024" height="576" /> <h4>Zníženie spotreby ale aj hlučnosti</h4> DYNAMAX Ceramic Oil sa pod tlakom dostáva do chemickej reakcie s kovmi a zušľachťuje tak ich povrch. Takto vzniknutý mimoriadne tvrdý a hladký povrch odoláva porušeniam a poškodeniam vyplývajúcich z trenia, a to aj v prípade extrémnych záťaží zabezpečí ideálne podmienky pre mazanie. Tým uľahčuje vnútorné fungovanie motora, ako aj pohyb súčiastok, čo je spojené so zvyšovaním výkonu motora alebo znižovaním spotreby pohonných hmôt. V dôsledku zníženého trenia sa tiež zníži miera hlučnosti. <div class="clearfix editor block adblock"> <div class="clearfix editor block adblock"> Pri pravidelnom používaní v nových zariadeniach sa garantuje trikrát dlhšia životnosť. Používanie DYNAMAX Ceramic Oil odstraňuje tiež problémy pri studenom štarte, a istý čas ochraňuje zariadenie pred problémami spôsobenými čiastočným nedostatkom oleja, dokonca aj v prípade straty celkového tlaku oleja. Môže sa tiež zmiešať s akýmkoľvek olejom na syntetickej, polosyntetickej a minerálnej báze. Mazacie látky zariadení, ktoré boli ošetrené , strácajú svoju mazaciu schopnosť až neskôr, ako tie neošetrené a to kvôli ideálnejšiemu mazaciemu prostrediu. A pre aké motory je určený? Pre všetky zážihové (aj na plyn), vznetové, nové aj staršie motory. Jedno balenie s obsahom 300 ml vystačí na ošetrenie 6 l olejovej náplne, pridáva sa vždy po výmene do nového zohriateho oleja. Optimálnu účinnosť dosahuje po približne 400 až 600 km. </div> </div>',
    ean: 8586016017765,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502263,
    brand: "DYNAMAX",
    image: "img6916",
    src: "6916.jpg",
    name: "DYNAMAX ČISTIČ CHLADIACEHO SYSTÉMU 300ML",
    short_desc:
      "Zvyšuje výkon termostatu a vodnej pumpy. Odstraňuje prevádzkou spôsobené znečistenia. Vhodný pre použitie do všetkých vodou chladených chladiacich systémoch. Obsahuje rýchlo reagujúce komponenty pre odstránenie znečistenia z bežného používania. Rozpúšťa a odstraňuje usadeniny, zlepšuje výkon ventilov, termostatu a vodnej pumpy.",
    desc: "Vhodný pre použitie do všetkých vodou chladených chladiacich systémoch. Obsahuje rýchlo reagujúce komponenty pre odstránenie znečistenia z bežného používania. Rozpúšťa a odstraňuje usadeniny, zlepšuje výkon ventilov, termostatu a vodnej pumpy. Použitie: 300 ml na 10 l chladiacej kvapaliny. 1. Nalejte do chladiaceho systému pred každou výmenou chladiacej kvapaliny. 2. Zapnite kúrenie na “horúco“. 3. Nechajte na voľnobehu 30 min. 4. Vypustite kompletne systém, prepláchnite čistou vodou a napustite novou chladiacou kvapalinou. Účinkuje: pred výmenou chladiacej kvapaliny. Odporúčaná aplikácia: pred každou výmenou chladiacej kvapaliny.",
    ean: 8586016017796,
    package: 12,
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502264,
    brand: "DYNAMAX",
    image: "img6917",
    src: "6917.jpg",
    name: "DYNAMAX UTESŇOVAČ CHLADIČA 300 ML",
    short_desc:
      "Utesňuje praskliny a malé úniky chladiacej kvapaliny. Pomáha vyhnúť sa drahej oprave Vhodný pre použitie vo všetkých vodou chladených chladiacich systémoch. Spoľahlivo, rýchlo a jednoducho utesní praskliny a malé úniky chladiacej kvapaliny. Vhodné aj ako prevencia.",
    desc: "Vhodný pre použitie vo všetkých vodou chladených chladiacich systémoch. Spoľahlivo, rýchlo a jednoducho utesní praskliny a malé úniky chladiacej kvapaliny. Vhodné aj ako prevencia. Použitie: 300 ml na 12 l chladiacej kvapaliny. 1. Skontrolujte hladinu chladiacej kvapaliny. 2. Pridajte prípravok do zohriateho chladiaceho systému a zapnite kúrenie na “horúco“. 3. Nechajte na voľnobehu 10 min. 4. Znovu skontrolujte hladinu chladiacej kvapaliny. Účinkuje: počas jazdy. Riedenie: 300 ml na 12 l chladiacej kvapaliny. Odporúčaná aplikácia: v prípade potreby.",
    ean: 8586016017802,
    package: 12,
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502265,
    brand: "DYNAMAX",
    image: "img6918",
    src: "6918.jpg",
    name: "DYNAMAX ČISTIČ ATF SYSTÉMU 300ML",
    short_desc:
      "Odstraňuje znečistenie a usadeniny z prevodovky. Zaisťuje hladké radenie. Vysoko výkonný čistič pre automatické prevodovky s, alebo bez meniča krútiaceho momentu vhodný pre všetky typy 4 - 8 rýchlostných prevodoviek.",
    desc: "Vysoko výkonný čistič pre automatické prevodovky s, alebo bez meniča krútiaceho momentu vhodný pre všetky typy 4 - 8 rýchlostných prevodoviek. Odstraňuje prevádzkou spôsobené znečistenia a usadeniny, chráni pred koróziou a predčasným opotrebovaním. Použitie: 300 ml na 8 l oleja. Nalejte do prevodovky pred výmenou oleja a spustite motor na 15 min s častými zmenami zaťaženia za jazdy (použite všetky rýchlostné stupne). Následne olej vypustite a nalejte nový. Účinkuje: pred výmenou oleja. Riedenie: 300 ml na 8 l oleja. Odporúčaná aplikácia: pred každou výmenou oleja.",
    ean: 8586016017819,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502269,
    brand: "DYNAMAX",
    image: "img18706",
    src: "18706.jpg",
    name: "DYNAMAX  PP 80 SAE 80W 209 L(184KG)",
    short_desc:
      "Prevodový olej DYNAMAX PP 80 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov vystavených nízkym teplotám.",
    desc: "Prevodový olej DYNAMAX PP 80 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov vystavených nízkym teplotám. Prevodový olej DYNAMAX PP80 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Prevodový olej Dynamax PP 80 je vhodný do prevodoviek vozidiel TATRA 148 a 815, PRAGA V3S a S5T.",
    ean: 8586016017840,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502280,
    brand: "DYNAMAX",
    image: "img18959",
    src: "18959.jpg",
    name: "DYNAMAX TRUCKMAN ULTRA 5W-30 60L (53KG)",
    short_desc:
      "DYNAMAX TRUCKMAN ULTRA je špeciálny vysokovýkonný syntetický olej pre všetky dieselové a turbodieselové motory s veľkou záťažou. Spĺňa požiadavky moderných európskych motorov v súlade s požiadavkami emisných noriem EURO 4.",
    desc: "DYNAMAX TRUCKMAN ULTRA je špeciálny vysokovýkonný syntetický olej pre všetky dieselové a turbodieselové motory s veľkou záťažou. Spĺňa požiadavky moderných európskych motorov v súlade s požiadavkami emisných noriem EURO 4. Skladá sa zo základných kvapalín špičkovej kvality a špičkového aditívneho systému zabezpečuje výbornú ochranu motorov a výrazne predlžuje výmenné intervaly. Tento olej spĺňa najnovšie špecifikácie ACEA E7 a ACEA E6 technológiami za použitia starostlivo vyváženého aditív neho systému.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502281,
    brand: "DYNAMAX",
    image: "img18960",
    src: "18960.jpg",
    name: "DYNAMAX TRUCKMAN ULTRA 5W-30 209 L(184KG)",
    short_desc:
      "DYNAMAX TRUCKMAN ULTRA je špeciálny vysokovýkonný syntetický olej pre všetky dieselové a turbodieselové motory s veľkou záťažou. Spĺňa požiadavky moderných európskych motorov v súlade s požiadavkami emisných noriem EURO 4.",
    desc: "DYNAMAX TRUCKMAN ULTRA je špeciálny vysokovýkonný syntetický olej pre všetky dieselové a turbodieselové motory s veľkou záťažou. Spĺňa požiadavky moderných európskych motorov v súlade s požiadavkami emisných noriem EURO 4. Skladá sa zo základných kvapalín špičkovej kvality a špičkového aditívneho systému zabezpečuje výbornú ochranu motorov a výrazne predlžuje výmenné intervaly. Tento olej spĺňa najnovšie špecifikácie ACEA E7 a ACEA E6 technológiami za použitia starostlivo vyváženého aditív neho systému.",
    ean: 8586016014832,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502282,
    brand: "DYNAMAX",
    image: "img18961",
    src: "18961.jpg",
    name: "DYNAMAX TRUCKMAN + LM 10W-40 209 L(180KG)",
    short_desc:
      "DYNAMAX TRUCKMAN PLUS LM je vysoko výkonný syntetický olej pre dieselové motory s nízkym obsahom popola, fosforu a síry (SAPS).",
    desc: "DYNAMAX TRUCKMAN PLUS LM je vysoko výkonný syntetický olej pre dieselové motory s nízkym obsahom popola, fosforu a síry (SAPS). Bol špeciálne vyvinutý pre motory s filtrom pevných častíc (DPF) alebo zariadeniami na následnú úpravu výfukových plynov SCR (selektívna katalytická redukcia). DYNAMAX TRUCKMAN PLUS LM je doporučovaný pre použitie v dieslových motoroch spĺňajúcich emisné požiadavky EURO 4 a 5, ale aj nižšie emisné normy.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502284,
    brand: "DYNAMAX",
    image: "img108111",
    src: "108111.jpg",
    name: "DYNAMAX TRACTOR PLUS E 10W40 209L",
    short_desc:
      "Je supervýkonný syntetický dieselový „Super High Performance Diesel Oil“ (SHPDO) motorový olej poskytujúci najvyšší výkon a dlhý pracovný potenciál pre vysoko výkonné, rýchlobežné, preplňované motory pracujúce za ťažkých podmienok.",
    desc: "DYNAMAX TRACT OR PLUS E 10W-40 redukuje usadeniny na piestoch, znižuje spotrebu oleja a dovoľuje dlhšie výmenné intervaly. Olej prekračuje požiadavky svetových výrobcov automobilov a prevyšuje najnáročnejšie medzinárodné normy. Je vhodný pre použitie v preplňovaných aj nepreplňovaných naftových štvortaktných motoroch s nízkymi emisiami, ktoré používajú systémy recirkulácie výfukových plynov (EGR), spĺňajúcich požiadavky normy EURO 4. Schválenia: MAN M 3275, MB 228.3, Renault RLD-2, Volvo VDS-3, MTU Type 2, Mack EO-M Plus, Cummins CES 20077/20078, Caterpillar ECF-1, Scania LDF-2",
    ean: 8586016018038,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502285,
    brand: "DYNAMAX",
    image: "img108116",
    src: "108116.jpg",
    name: "DYNAMAX TRACTOR PLUS L 15W40 209L",
    short_desc:
      "Motorový olej DYNAMAX TRACTOR PLUS L 15W-40 je predstaviteľ novej generácie motorových olejov SHPDO, spĺňajúci požiadavky najnáročnejších naftových motorov.",
    desc: "Je to celoročný olej s vysokým obsahom výkonnostných prísad, ktoré zabezpečujú vynikajúcu ochranu motora aj pri predĺžených výmenných intervaloch. Je vhodný aj na mazanie motorov ľahkých dodávkových automobilov s naftovým motorom.",
    ean: 8586016018069,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502287,
    brand: "DYNAMAX",
    image: "img31897",
    src: "31897.jpg",
    name: "DYNAMAX TRACTOR PLUS TX 10W-40 209L",
    short_desc:
      "DYNAMAX TRACTOR PLUS TX 10W-40 je vysoko kvalitný takzvaný STOU olej (Super Tractor Oil Universal), zložený zo starostlivo vybraných minerálnych základných zložiek a moderných aditív.",
    desc: 'DYNAMAX TRACTOR PLUS TX 10W-40 je vysoko kvalitný takzvaný STOU olej (Super Tractor Oil Universal), zložený zo starostlivo vybraných minerálnych základných zložiek a moderných aditív. Tento olej bol navrhnutý tak, aby slúžil aj v hydraulickom systéme, mazal prevodovku, vývodový hriadeľ, rozvodovku a tzv. „mokré brzdy". Má viskozimetrické charakteristiky, ktoré umožňujú skvelé štartovanie za studena počas zimného obdobia. Zabezpečuje optimálnu ochranu motora, efektívne zabraňuje opotrebovaniu a nečistotám.',
    ean: "",
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502300,
    brand: "DYNAMAX",
    image: "img18963",
    src: "18963.jpg",
    name: "DYNAMAX M2T SUPER HP 1L",
    short_desc:
      "ynamax M2T SUPER HP je vysoko kvalitný ropný olej vyrobený modernou technológiou, obsahujúci prísady potláčajúce tvorbu úsad v piestnych drážkach, na výfukových kanáloch a na elektródach sviečok, ako aj prísady zlepšujúce mazacie schopnosti oleja.",
    desc: "Dynamax M2T SUPER HP je vysoko kvalitný ropný olej vyrobený modernou technológiou, obsahujúci prísady potláčajúce tvorbu úsad v piestnych drážkach, na výfukových kanáloch a na elektródach sviečok, ako aj prísady zlepšujúce mazacie schopnosti oleja. Chráni piest pred odieraním a časti motora pred predčasným opotrebením. Má skvelú miešateľnosť s benzínom, čím vzniká homogénna a stabilná zmes aj pri nízkej teplote okolia. Olej je odporúčaný pre dvojtaktné motory u motocyklov, skútrov, alebo v ručnom motorovom náradí vyžadujúcich kvalitu API TC a JASO FB. Je vhodný tak pre priam vstrekovanie oleja ako aj pre mazacie systémy s vopred zamiešanou zmesou.",
    ean: 8586016017987,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502311,
    brand: "DYNAMAX",
    image: "img28281",
    src: "28281.jpg",
    name: "DYNAMAX PREMIUM ULTRA C2 5W-30 60L",
    short_desc:
      "Vysokovýkonný motorový olej vyrobený na báze 100% syntetickej technológie určený na použitie v benzínových a dieselových motoroch vyžadujúcich normu PSA B71 2290. Olej je tiež vhodný pre motory vyžadujúce ACEA A5/B5 ACEA C2 špecifikáciu.",
    desc: "Vysokovýkonný motorový olej vyrobený na báze 100% syntetickej technológie určený na použitie v benzínových a dieselových motoroch vyžadujúcich normu PSA B71 2290. Olej je tiež vhodný pre motory vyžadujúce ACEA A5/B5 ACEA C2 špecifikáciu.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502312,
    brand: "DYNAMAX",
    image: "img108110",
    src: "108110.jpg",
    name: "DYNAMAX SL PLUS 20W50 60L",
    short_desc:
      "Vysokovýkonný motorový olej vyrobený na báze minerálneho základového oleja s pridaním aditív pre zlepšenie teplotnej a oxidačnej stability.",
    desc: "Je vhodný pre moderné benzínové, dieselové a LPG motory osobných automobilov a dodávok s alebo bez preplňovania. Olej navyše zaručuje ochranu proti opotrebeniu, peneniu a korózií.",
    ean: 8586016018083,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502321,
    brand: "DYNAMAX",
    image: "img108123",
    src: "108123.jpg",
    name: "DYNAMAX COOL 11 R 209L",
    short_desc:
      "Koncentrovaná nízkotuhnúca chladiaca kvapalina celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Spľňa požiadavky výrobcov automobilov Renault a Volkswagen podľa normy AST M D 3306.",
    desc: "Koncentrovaná nízkotuhnúca chladiaca kvapalina celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Spľňa požiadavky výrobcov automobilov Renault a Volkswagen podľa normy AST M D 3306. Chladiaca kvapalina DYNAMAX G11 R je špeciálne vyvinutá pre motorové vozidlá značky Renault. Aplikuje sa do čistého chladiaceho systému podľa postupu výrobcu automobilu.",
    ean: 8586016018090,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502324,
    brand: "DYNAMAX",
    image: "img31900",
    src: "31900.jpg",
    name: "DYNAMAX OHHM 68 60L(53,5KG)",
    short_desc:
      "Hydraulické oleje DYNAMAX OHHM 68 sú určené pre hydrostatické mechanizmy s vysokým mechanickým aj tepelným namáhaním pre stabilné aj mobilné stroje pracujúce v nechránenom prostredí.",
    desc: "DYNAMAX OHHM 68 je hydrogenačne rafinovaný ropný olej zušľachtený prísadami na zlepšenie oxidačnej stálosti, protikoróznych a protioderových vlastností a prísadami proti peneniu. Obsahujú modifikátor viskozity s depresantným účinkom.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502390,
    brand: "DYNAMAX",
    image: "img11662",
    src: "11662.jpg",
    name: "DYNAMAX G-PP 90 SAE 90 209L (186KG)",
    short_desc:
      "Prevodový olej DYNAMAX PP90 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Prevodový olej DYNAMAX PP 90 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov, ktoré majú predpísaný olej s vyššou viskozitou.",
    desc: "Prevodový olej DYNAMAX PP90 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Prevodový olej DYNAMAX PP 90 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov, ktoré majú predpísaný olej s vyššou viskozitou. Prevodový olej Dynamax PP 90 je vhodný do prevodoviek vozidiel AVIA 21 a 31, LIAZ, KAROSA, IKARUS 280.",
    ean: 8586016018236,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502391,
    brand: "DYNAMAX",
    image: "img11663",
    src: "11663.jpg",
    name: "DYNAMAX G-PP 90 SAE 90 60 L (53,5KG)",
    short_desc:
      "Prevodový olej DYNAMAX PP90 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Prevodový olej DYNAMAX PP 90 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov, ktoré majú predpísaný olej s vyššou viskozitou.",
    desc: "Prevodový olej DYNAMAX PP90 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Prevodový olej DYNAMAX PP 90 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov, ktoré majú predpísaný olej s vyššou viskozitou. Prevodový olej Dynamax PP 90 je vhodný do prevodoviek vozidiel AVIA 21 a 31, LIAZ, KAROSA, IKARUS 280.",
    ean: 8586016018229,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502410,
    brand: "DYNAMAX",
    image: "img13799",
    src: "13799.jpg",
    name: "DYNAMAX OTHP 32 VG32 60L(52KG)",
    short_desc:
      "DYNAMAX OTHP 32 je ropný olej s prídavkom výkonnostnej prísady a modifikátorom viskozity s depresantným účinkom. Je vhodný na mazanie automatických prevodoviek, posilňovačov bŕzd a riadenia.",
    desc: "DYNAMAX OTHP 32 je ropný olej s prídavkom výkonnostnej prísady a modifikátorom viskozity s depresantným účinkom. Je vhodný na mazanie automatických prevodoviek, posilňovačov bŕzd a riadenia. Tiež je vhodný ako náplň hydrodynamických sústav autobusov, stavebných strojov, vysokozdvižných vozíkov a pod. Hydraulický olej DYNAMAX OTHP 32 je určený hlavne na použitie vo veľmi záťažových sústavách prenosu sily a hydraulického riadenia tj. hydraulických prevodoch, regulačných a riadiacich mechanizmoch a podobných zariadeniach, v ktorých vznikajú pracovné podmienky (tlak do 25 MPa v ozubených čerpadlách a tlak 35 MPa v piestových čerpadlách) a všade tam, kde sa vyskytuje zvýšená teplota a vlhkosť prostredia.",
    ean: 8586016018243,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502411,
    brand: "DYNAMAX",
    image: "img13800",
    src: "13800.jpg",
    name: "DYNAMAX OHHM 46 VG46 60L(53KG)",
    short_desc:
      "DYNAMAX OHHM 46 je hydrogenačne rafinovaný ropný olej zušľachtený prísadami na zlepšenie oxidačnej stálosti, protikoróznych a protioderových vlastností a prísadami proti peneniu.",
    desc: "DYNAMAX OHHM 46 je hydrogenačne rafinovaný ropný olej zušľachtený prísadami na zlepšenie oxidačnej stálosti, protikoróznych a protioderových vlastností a prísadami proti peneniu. Obsahujú modifikátor viskozity s depresantným účinkom. Hydraulický o lej OHHM 46 je určený pre hydrostatické mechanizmy s vysokým mechanickým aj tepelným namáhaním pre stabilné aj mobilné stroje pracujúce v nechránenom prostredí. Sú použiteľné celoročne a sú kompatibilné s väčšinou hydraulic-kých olejov iných výrobcov.",
    ean: 8586016018250,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502413,
    brand: "DYNAMAX",
    image: "img108120",
    src: "108120.jpg",
    name: "DYNAMAX ADBLUE 209L",
    short_desc:
      "Vodný roztok močoviny s vysokou chemickou čistotou podla ISO 22241 pre prevádzku SCR katalyzátorov. AdBlue do použitých obalov (napr. od pohonných hmôt, prevádzkových kvapalín).",
    desc: "Vodný roztok močoviny s vysokou chemickou čistotou podla ISO 22241 pre prevádzku SCR katalyzátorov. Pokyny a doporučenia: Skladujte pri teplote od -5°C do +25°C. Neskladujte na priamom slnku. Skladujte iba v tomto originálnom obale. Nikdy neprelievajte AdBlue do použitých obalov (napr. od pohonných hmôt, prevádzkových kvapalín). Nebezpečenstvo kontaminácie AdBlue a poškodenie katalyzátora. Minimálna trvanlivosť: 1 rok od dátumu výroby.",
    ean: 8586016019035,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502420,
    brand: "DYNAMAX",
    image: "img33904",
    src: "33904.jpg",
    name: "DYNAMAX COOL 13 ULTRA 60L",
    short_desc:
      "hladiaca kvapalina optimalizovaná pre všetky typy moderných automobilov s vynikajúcou miešateľnosťou s inými druhmi chladiacich kvapalín (G11, G12, G12++...).",
    desc: "Chladiaca kvapalina optimalizovaná pre všetky typy moderných automobilov s vynikajúcou miešateľnosťou s inými druhmi chladiacich kvapalín (G11, G12, G12++...). Je špeciálne vyvinutá pre najnovšie automobily VW group (VW, ŠKODA, SEAT, AUDI). Poskyt uje výbornú ochranu pred mrazom, vysokými teplotami a zároveň chráni pred koróziou. DOPORUČENÉ POMERY RIEDENIA:1 diel DYNAMAX COOLANT ULTRA G13: 1 diel DYNAQUA - použitie do - 37 °C. 1 diel DYNAMAX COOLANT ULTRA G13 : 1,5 dielu DYNAQUA - použitie do - 26 °C.1 diel DYNAMAX COOLANT ULTRA G13: 2 diely DYNAQUA - použitie do - 17 °C.",
    ean: 8586016018380,
    package: "",
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502443,
    brand: "DYNAMAX",
    image: "img17034",
    src: "17034.jpg",
    name: "DYNAMAX TRUCKMAN + LM 10W-40 60L(52KG)",
    short_desc:
      "DYNAMAX TRUCKMAN PLUS LM je vysoko výkonný syntetický olej pre dieselové motory s nízkym obsahom popola, fosforu a síry (SAPS).",
    desc: "DYNAMAX TRUCKMAN PLUS LM je vysoko výkonný syntetický olej pre dieselové motory s nízkym obsahom popola, fosforu a síry (SAPS). Bol špeciálne vyvinutý pre motory s filtrom pevných častíc (DPF) alebo zariadeniami na následnú úpravu výfukových plynov SCR (selektívna katalytická redukcia). DYNAMAX TRUCKMAN PLUS LM je doporučovaný pre použitie v dieslových motoroch spĺňajúcich emisné požiadavky EURO 4 a 5, ale aj nižšie emisné normy.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502444,
    brand: "DYNAMAX",
    image: "img35353",
    src: "35353.jpg",
    name: "DYNAMAX OTHP 32 VG32 209L(181KG)",
    short_desc:
      "DYNAMAX OTHP 32 je ropný olej s prídavkom výkonnostnej prísady a modifikátorom viskozity s depresantným účinkom. Je vhodný na mazanie automatických prevodoviek, posilňovačov bŕzd a riadenia.",
    desc: "DYNAMAX OTHP 32 je ropný olej s prídavkom výkonnostnej prísady a modifikátorom viskozity s depresantným účinkom. Je vhodný na mazanie automatických prevodoviek, posilňovačov bŕzd a riadenia. Tiež je vhodný ako náplň hydrodynamických sústav autobusov, stavebných strojov, vysokozdvižných vozíkov a pod. Hydraulický olej DYNAMAX OTHP 32 je určený hlavne na použitie vo veľmi záťažových sústavách prenosu sily a hydraulického riadenia tj. hydraulických prevodoch, regulačných a riadiacich mechanizmoch a podobných zariadeniach, v ktorých vznikajú pracovné podmienky (tlak do 25 MPa v ozubených čerpadlách a tlak 35 MPa v piestových čerpadlách) a všade tam, kde sa vyskytuje zvýšená teplota a vlhkosť prostredia.",
    ean: 8586016017772,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502445,
    brand: "DYNAMAX",
    image: "img90331",
    src: "90331.jpg",
    name: "DYNAMAX TRUCKMAN PLUS M 10W-40 60L",
    short_desc:
      "Olej je odporúčaný pre dieselové motory pracujúce za veľmi ťažkých prevádzkových podmienok napr. predĺžené intervaly výmeny olejov podľa odporúčania výrobcov motorov, resp. tam, kde sa vyžaduje špeciálna kvalita oleja. Je určený pre prevádzku naftových motorov zvlášť pre veľké nákladné automobily, stavebnú techniku a autobusy.",
    desc: "DYNAMAX Truckman Plus M 10W40 je vysoko výkonný syntetický motorový olej, ktorý je určený na mazanie dieselových motorov s turbo preplňovaním i nepreplňovaním. Má vynikajúcu tepelnú a oxidačnú stabilitu a vysokú odolnosť proti starnutiu, zvlášť pri vysokých teplotách. Spĺňa požiadavky na emisie podľa Euro 3.",
    ean: 8586016013958,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502446,
    brand: "DYNAMAX",
    image: "img108109",
    src: "108109.jpg",
    name: "DYNAMAX PREMIUM ULTRA F 5W30 60L",
    short_desc:
      "Dynamax Ultra F 5W-30 je moderný syntetický ľahkobežný motorový olej vyrobený zo špeciálne vybraných syntetických základových olejov a vyvážených starostlivo vybraných, moderných aditív.",
    desc: '<div id="dokument" class="obsah"> <div><span style="font-size:large;">Je vhodný pre použitie na mazanie benzínových a dieselových motorov, s alebo bez preplňovania, v osobných a dodávkových automobiloch. Tento olej bol špeciálne vyvinutý pre motory, ktoré požadujú motorové oleje s najnovším schválením od výrobcu Ford.</div> </div>',
    ean: 8586016018410,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502447,
    brand: "DYNAMAX",
    image: "img100782",
    src: "100782.jpg",
    name: "DYNAMAX PREMIUM ULTRA 5W-40 20L",
    short_desc:
      "Syntetický motorový DYNAMAX ULTRA svojimi vlastnosťami prevyšuje požiadavky európskych, japonských a amerických automobilových výrobcov.",
    desc: "Je určený pre použitie na mazanie vysoko zaťažovaných benzínových motorov s predĺženým intervalom výmeny oleja. Je taktiež určený pre vysoko zaťažované dieselové motory osobných automobilov a ľahkých dodávok, hlavne s priamym vstrekovaním s predĺženým intervalom výmeny stanoveným výrobcom motora, kde je požadovaná špeciálna kvalita oleja.",
    ean: 8586016018595,
    package: "",
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502450,
    brand: "DYNAMAX",
    image: "img108108",
    src: "108108.jpg",
    name: "DYNAMAX PREMIUM ULTRA F 5W30 209L",
    short_desc:
      "Dynamax Ultra F 5W-30 je moderný syntetický ľahkobežný motorový olej vyrobený zo špeciálne vybraných syntetických základových olejov a vyvážených starostlivo vybraných, moderných aditív.",
    desc: "Je vhodný pre použitie na mazanie benzínových a dieselových motorov, s alebo bez preplňovania, v osobných a dodávkových automobiloch. Tento olej bol špeciálne vyvinutý pre motory, ktoré požadujú motorové oleje s najnovším schválením od výrobcu Ford.",
    ean: 8586016018502,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502463,
    brand: "DYNAMAX",
    image: "img37982",
    src: "37982.jpg",
    name: "DYNAMAX LETNÁ ZMES 5L LESNÉ OVOCIE",
    short_desc:
      "Nová letná zmes do ostrekovačov, s príjemnou vôňou ovocia. Účinná letná zmes do ostrekovačov, ktorá odstráni aj zvyšky hmyzu. Použitie vám uľahčí nalievacie hrdlo, ktoré je súčasťou balenia.",
    desc: "Nová letná zmes do ostrekovačov, s príjemnou vôňou ovocia. Účinná letná zmes do ostrekovačov, ktorá odstráni aj zvyšky hmyzu. Použitie vám uľahčí nalievacie hrdlo, ktoré je súčasťou balenia.",
    ean: 8586016018557,
    package: 3,
    type: "doplnok",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502464,
    brand: "DYNAMAX",
    image: "img34007",
    src: "34007.jpg",
    name: "DYNAMAX G-PP 80 SAE80W 60L(53KG)",
    short_desc:
      "Prevodový olej DYNAMAX PP 80 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov vystavených nízkym teplotám.",
    desc: "Prevodový olej DYNAMAX PP 80 je určený na mazanie mechanických prevodoviek a rozvodoviek (s výnimkou hypoidných) automobilov a mobilných mechanizmov vystavených nízkym teplotám. Prevodový olej DYNAMAX PP80 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Prevodový olej Dynamax PP 80 je vhodný do prevodoviek vozidiel TATRA 148 a 815, PRAGA V3S a S5T.",
    ean: 8586016018588,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502470,
    brand: "DYNAMAX",
    image: "img33905",
    src: "33905.jpg",
    name: "DYNAMAX M6AD SAE30 60L(53KG)",
    short_desc:
      "Letný motorový olej na mazanie benzínových a nepreplňovaných naftových štvortaktných motorov, najmä starších typov, v nenáročných prevádzkových podmienkach.",
    desc: "Automobilový motorový olej DYNAMAX M6AD sa používa predovšetkým pre staršie typy nákladných automobilov a ľahkých dodávkových automobilov. Letný motorový olej na mazanie benzínových a nepreplňovaných naftových štvortaktných motorov, najmä starších typov, v nenáročných prevádzkových podmienkach.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502473,
    brand: "DYNAMAX",
    image: "img59288",
    src: "59288.jpg",
    name: "DYNAMAX DXE7 POLITÚRA A VOSK 500 ML",
    short_desc:
      "Polish and wax je kombinácia leštiacej pasty s vysokým leštiacim účinkom a vynikajúcou ochranou laku bez šmúh. Polish and wax je možné použiť na všetky typy laku. Odstraňuje malé a stredné škrabance a ochraňuje farbu bez šmúh po dobu niekoľkých týždňov.",
    desc: "Polish and wax je kombinácia leštiacej pasty s vysokým leštiacim účinkom a vynikajúcou ochranou laku bez šmúh. Polish and wax je možné použiť na všetky typy laku. Odstraňuje malé a stredné škrabance a ochraňuje farbu bez šmúh po dobu niekoľkých týždňov. Polish and wax je možné použiť veľmi jednoducho, rýchlo a ľahko ručne alebo leštičkou na auto. Použitie: Vozidlo musí byť umyté a z laku odstránené všetky nečistoty. Aplikáciu je možné vykonať na suché alebo mierne vlhké vozidlo. Nepoužívať na horúce povrchy a auto by nemalo stáť v páliacom slnku. Polish and wax nanesieme na špongiu alebo leštiacu handričku a leštíme v krúživých pohyboch na čiastočných plochách, cca. 0,5 - 1 m². Potom ich vyleštíme s čistou a suchou utierkou. Opakujeme tento postup, kým nevyleštíme celú plochu auta. Min. doba trvanlivosti: 2 roky od dátumu výroby.",
    ean: 8586016018625,
    package: 12,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502475,
    brand: "DYNAMAX",
    image: "img59287",
    src: "59287.jpg",
    name: "DYNAMAX DXI3 ČISTENIE A OCHANA KOŽE 500 ML",
    short_desc:
      "Čistič na kožu čistí a chráni všetky hladké kože, ako sú kožené sedadlá, kožené odevy, kožená batožina a mnoho ďalšieho. Mierny až silný čistiaci účinok. Obnovuje prirodzený kožený efekt, pružnosť a prírodný matný lesk. Chráni kožu proti znečisteniu. UV žiareniu a vyschnutiu. Neobsahuje rozpúšťadlá nevhodné pre textil alebo semiš.",
    desc: "Čistič na kožu čistí a chráni všetky hladké kože, ako sú kožené sedadlá, kožené odevy, kožená batožina a mnoho ďalšieho. Mierny až silný čistiaci účinok. Obnovuje prirodzený kožený efekt, pružnosť a prírodný matný lesk. Chráni kožu proti znečisteniu. UV žiareniu a vyschnutiu. Neobsahuje rozpúšťadlá nevhodné pre textil alebo semiš. Použitie: Skontrolujte kompatibilitu materiálu na skrytom mieste pred použitím starostlivosti o kožu. Nepoužívať na horúce povrchy alebo na priamom slnečnom svetle . Naneste trochu Starostlivosti o kožu na špongiu alebo leštiacu handričku. Aplikujte krúživými pohybmi na povrchu. Nechajte vsiaknuť a pôsobiť pár minút. Nakoniec kožu vyleštite pomocou handričky. Min. doba trvanlivosti: 2 roky od dátumu výroby.",
    ean: 8586016018618,
    package: 12,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502484,
    brand: "DYNAMAX",
    image: "img108107",
    src: "108107.jpg",
    name: "DYNAMAX M7ADSIII 20W40 60L",
    short_desc:
      "DYNAMAX M7ADSIII sa používa predovšetkým v nákladnej automo-bilovej doprave, v mestskej a diaľkovej autobusovej doprave, v lodnej doprave a v železničnej doprave.",
    desc: "Celoročný motorový olej určený pre štvortaktné naftové motory preplňované aj nepreplňované. Vysoká kvalita oleja je garantovaná použitím kvalitného základového oleja a starostlivo vyváženou kombináciou viskozitných,antioxidačných, detergentných a iných prísad. Umožňuje veľmi dobré štartovanie motorov pri nízkych teplotách a zároveň má značnú rezervu viskozity pre letné obdobie.",
    ean: 8586016018663,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502485,
    brand: "DYNAMAX",
    image: "img91663",
    src: "91663.jpg",
    name: "DYNAMAX COOL 10 60L",
    short_desc:
      "Koncentrovaná nízko tuhnúca chladiaca kvapalina na báze etylénglykolu je určená pre všetky typy starších motorových vozidiel, poľnohospodárske a stavebné stroje. Celoročne chráni chladiaci systém pred koróziou a zabraňuje prehriatiu motorov v letných mesiacoch. Odporúčaná výmena je po troch rokoch.",
    desc: "Koncentrovaná nízko tuhnúca chladiaca kvapalina na báze etylénglykolu je určená pre všetky typy starších motorových vozidiel, poľnohospodárske a stavebné stroje. Celoročne chráni chladiaci systém pred koróziou a zabraňuje prehriatiu motorov v letných mesiacoch. Odporúčaná výmena je po troch rokoch. Výrobca zabezpečuje konzultácie a neručí za škody spôsobené nesprávnym použitím výrobku. Plní sa do čistého chladiaceho systému podľa pokynov výrobcu automobilu. Je riediteľná pitnou alebo demineralizovanou vodou na požadovaný bod tuhnutia podľa určených pomerov výrobcu. Chladiaca kvapalina DYNAMAX COOLANT G10 je miešateľná s nízkotuhnúcimi kvapalinami na báze monoetylénglykolu (etylénglykolu a propylénglykolu).",
    ean: 8586016019660,
    package: "",
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502486,
    brand: "DYNAMAX",
    image: "img33906",
    src: "33906.jpg",
    name: "DYNAMAX COOL 10 209L",
    short_desc:
      "Koncentrovaná nízkotuhnúca chladiaca kvapalina na báze etylénglykolu je určená pre všetky typy starších motorových vozidiel, poľnohospodárske a stavebné stroje. Celoročne chráni chladiaci systém pred koróziou a zabraňuje prehriatiu motorov v letných mesiacoch.",
    desc: "Koncentrovaná nízkotuhnúca chladiaca kvapalina na báze etylénglykolu je určená pre všetky typy starších motorových vozidiel, poľnohospodárske a stavebné stroje. Celoročne chráni chladiaci systém pred koróziou a zabraňuje prehriatiu motorov v letných mesiacoch. Odporúčaná výmena je po troch rokoch. Výrobca zabezpečuje konzultácie a neručí za škody spôsobené nesprávnym použitím výrobku. Plní sa do čistého chladiaceho systému podľa pokynov výrobcu automobilu. Je riediteľná pitnou alebo demineralizovanou vodou na požadovaný bod tuhnutia podľa určených pomerov výrobcu. Chladiaca kvapalina DYNAMAX COOLANT G10 je miešateľná s nízkotuhnúcimi kvapalinami na báze monoetylénglykolu (etylénglykolu a propylénglykolu).",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502487,
    brand: "DYNAMAX",
    image: "img33907",
    src: "33907.jpg",
    name: "DYNAMAX COOL 12++ ULTRA 60L",
    short_desc:
      "Základnou funkciou je veľmi dobrý prevod tepla a ochrana motora prípadne chladiacej sústavy. Pre ce loročnú ochranu chladiacich systémov sú",
    desc: "DYNAMAX COOLANT ULTRA G12 ++ je vhodný do chladičov hliníkových a liatinových chladiacich sústav spaľovacích motorov u najnovších automobilov.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502489,
    brand: "DYNAMAX",
    image: "img33908",
    src: "33908.jpg",
    name: "DYNAMAX M2T SUPER 60L",
    short_desc:
      "Olej pre dvojtaktné benzínové motory DYNAMAX M2T SUPER je ropný olej vyrobený modernou technológiou, obsahujúci prísady potláčajúce tvorbu usadenín v piestnych drážkach, na výfukových kanáloch a na elektródach sviečok, ako aj prísady zlepšujúce mazacie schopnosti oleja.",
    desc: "Olej pre dvojtaktné benzínové motory DYNAMAX M2T SUPER je ropný olej vyrobený modernou technológiou, obsahujúci prísady potláčajúce tvorbu usadenín v piestnych drážkach, na výfukových kanáloch a na elektródach sviečok, ako aj prísady zlepšujúce mazacie schopnosti oleja.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502490,
    brand: "DYNAMAX",
    image: "img34462",
    src: "34462.jpg",
    name: "DYNAMAX M8AD 15W-50 60L",
    short_desc:
      "Motorový olej DYNAMAX M8AD je určený pre mazanie benzínových a dieselových štvortak tných motorov automobilov.",
    desc: "Celoročný motorový olej DYNAMAX M8AD je ropný olej vyrobený modernou technológiou, obsahujúci viskozitné výkonnostné prísady.Olej si počas celej doby používania zachováva svoju výkonnostnú triedu. Je určený na celoročné mazanie benzínových a die selových štvortaktných motorov automobilov. Umožňuje veľmi dobré štartovanie motorov pri nízkych teplotách a zároveň má značnú rezervu viskozity pre letné obdobie.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502491,
    brand: "DYNAMAX",
    image: "img34008",
    src: "34008.jpg",
    name: "DYNAMAX M8AD 209L",
    short_desc:
      "Motorový olej DYNAMAX M8AD je určený pre mazanie benzínových a dieselových štvortaktných motorov automobilov. Celoročný motorový olej DYNAMAX M8 AD je ropný olej vyrobený modernou technológiou, obsahujúci viskozitné výkonnostné prísady.",
    desc: "Motorový olej DYNAMAX M8AD je určený pre mazanie benzínových a dieselových štvortaktných motorov automobilov. Celoročný motorový olej DYNAMAX M8 AD je ropný olej vyrobený modernou technológiou, obsahujúci viskozitné výkonnostné prísady. Olej si po čas celej doby používania zachováva svoju výkonnostnú triedu. Je určený na celoročné mazanie benzínových a dieselových štvortaktných motorov automobilov. Umožňuje veľmi dobré štartovanie motorov pri nízkych teplotách a zároveň má značnú rezervu viskozity pre letné obdobie.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502492,
    brand: "DYNAMAX",
    image: "img108106",
    src: "108106.jpg",
    name: "DYNAMAX M6ADSII SAE30 60L",
    short_desc:
      "Motorový olej DYNAMAX M6ADSII sa používa na mazanie automobilových, traktorových, lodných a stacionárnych naftových motorov moderných konštrukcií.",
    desc: "Motorový olej na mazanie náročných druhov nepreplňovaných a preplňovaných naftových štvortaktných motorov, pracujúcich za sťažených podmienok, najmä v prechodnom a letnom období.",
    ean: 8586016018816,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502493,
    brand: "DYNAMAX",
    image: "img108105",
    src: "108105.jpg",
    name: "DYNAMAX M6ADSII SAE30 209L",
    short_desc:
      "Motorový olej DYNAMAX M6ADSII sa používa na mazanie automobilových, traktorových, lodných a stacionárnych naftových motorov moderných konštrukcií.",
    desc: "Motorový olej na mazanie náročných druhov nepreplňovaných a preplňovaných naftových štvortaktných motorov, pracujúcich za sťažených podmienok, najmä v prechodnom a letnom období.",
    ean: 8586016019004,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502494,
    brand: "DYNAMAX",
    image: "img53970",
    src: "53970.jpg",
    name: "DYNAMAX M7ADSIII 20W-40 209L",
    short_desc:
      "DYNAMAX M7AD SIII sa používa predovšetkým v nákladnej automobilovej doprave, v mestskej a diaľkovej autobusovej doprave, v lodnej doprave a v železničnej doprave.",
    desc: "DYNAMAX M7AD SIII sa používa predovšetkým v nákladnej automobilovej doprave, v mestskej a diaľkovej autobusovej doprave, v lodnej doprave a v železničnej doprave. Celoročný motorový olej určený pre štvortaktné naftové motory preplňované aj nepreplňované. Vysoká kvalita oleja je garantovaná použitím kvalitného základového oleja a starostlivo vyváženou kombináciou viskozitných,antioxidačných, detergentných a iných prísad. Umožňuje veľmi dobré štartovanie motorov pri nízkych teplotách a zároveň má značnú rezervu viskozity pre letné obdobie.",
    ean: 8586016018755,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502495,
    brand: "DYNAMAX",
    image: "img59972",
    src: "59972.jpg",
    name: "DYNAMAX HYPOL 80W-90 GL5 60L",
    short_desc:
      "Automobilový prevodový olej DYNAMAX HYPOL GL-5 80W-90 je ropný olej, ktorý obsahuje prísady na zvýšenie únosnosti mazacieho filmu. Minerálny olej s veľmi dobrými vlastnosťami: mazacími, protikoróznymi, antioxidačnými a protipeniacimi.",
    desc: "Prevodový olej DYNAMAX HYPOL GL-5 80W-90 je určený na mazaniemechanických prevodov automobilov a hnacích náprav, kde sú požadované oleje o vlastnostiach SAE 80W-90 s výkonnostnou úrovňou API GL-5. Je určený pre mazanie vozov, ktoré pracujú vo veľmi ťažkých prevádzkových podmienkach. Je použiteľný na mazanie mechanických prevodoviek a rozvodoviek moderných osobných a nákladných automobilov, stavebných strojov, poľnohospodárskej techniky a ďalších prevodových aplikácií.",
    ean: 8586016018854,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502498,
    brand: "DYNAMAX",
    image: "img108104",
    src: "108104.jpg",
    name: "DYNAMAX TRUCKMAN PLUS SHPD 15W40 60L",
    short_desc:
      "Supervýkonný dieselový „Super High Performance Diesel“ (SHPD) motorový olej vyrobený na báze 100% syntetickej technológie s pridaním špeciálnych aditív pre zaistenie dokonalého mazania vysoko zaťažených nákladných automobilov.",
    desc: "Spĺňa požiadavky EURO 4 a EURO 5, teda je vhodný pre motory s filtrami pevných častíc (DPF), EGR, alebo so systémami následnej úpravy výfukových plynov (SCR).",
    ean: 8586016018724,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502499,
    brand: "DYNAMAX",
    image: "img108171",
    src: "108171.jpg",
    name: "DYNAMAX COOL G11 R 60L",
    short_desc:
      "Je koncentrovaná nízkotuhnúca chladiaca kvapalina. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Spĺňa požiadavky výrobcov automobilov Renault.",
    desc: "DOPORUČENÉ POMERY RIEDENIA: 1 diel DYNAMAX COOLANT G11R : 1 diel voda – použitie do – 32 °C1 diel DYNAMAX COOLANT G11R : 1,5 dielu voda – použitie do – 26 °C1 diel DYNAMAX COOLANT G11R : 2 diely voda – použitie do – 17 °C Schválenia : VW TL 774C, BS 6580:1992, ÖNORM V5123, ASTM D 3306",
    ean: 8586016019462,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502502,
    brand: "DYNAMAX",
    image: "img35249",
    src: "35249.jpg",
    name: "DYNAMAX EMULGOL DS 30 60L",
    short_desc: "",
    desc: 0,
    ean: 4031185355094,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502503,
    brand: "DYNAMAX",
    image: "img31901",
    src: "31901.jpg",
    name: "DYNAMAX TRACTOR PLUS L 15W-40 60L",
    short_desc:
      "Je to celoročný olej s vysokým obsahom výkonnostných prísad, ktoré zabezpečujú vynikajúcu ochranu motora aj pri predĺžených výmenných intervaloch.",
    desc: "Motorový olej DYNAMAX TRACTOR PLUS L 15W-40 je predstaviteľ novej generácie motorových olejov SHPDO, spĺňajúci požiadavky najnáročnejších naftových motorov. Je to celoročný olej s vysokým obsahom výkonnostných prísad, ktoré zabezpečujú vynikajúcu ochranu motora aj pri predĺžených výmenných intervaloch. Je vhodný aj na mazanie motorov ľahkých dodávkových automobilov s naftovým motorom.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502508,
    brand: "DYNAMAX",
    image: "img35250",
    src: "35250.jpg",
    name: "DYNAMAX OK VC100 209L",
    short_desc:
      "DYNAMAX OKVC 100 je určený na mazanie v zduchových piestových kompresorov a rotačných lopatkových kompresorov, s kvapkovým mazaním v nenáročných podmienkach.",
    desc: "Kompresorový olej DYNAMAX OKVC 100 je hydrogenačne rafinovaný ropný olej s veľkou chemickou stálosťou aj pri vyšších teplotách. Obsahuje prísady na zvýšenie viskozitného indexu a zníženie bodu tuhnutia.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502509,
    brand: "DYNAMAX",
    image: "img35248",
    src: "35248.jpg",
    name: "DYNAMAX OK VC100 60L",
    short_desc:
      "DYNAMAX OKVC 100 je určený na mazanie v zduchových piestových kompresorov a rotačných lopatkových kompresorov, s kvapkovým mazaním v nenáročných podmienkach.",
    desc: "Kompresorový olej DYNAMAX OKVC 100 je hydrogenačne rafinovaný ropný olej s veľkou chemickou stálosťou aj pri vyšších teplotách. Obsahuje prísady na zvýšenie viskozitného indexu a zníženie bodu tuhnutia.",
    ean: 8586016018984,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502510,
    brand: "DYNAMAX",
    image: "img34874",
    src: "34874.jpg",
    name: "DYNAMAX OL 68 209L",
    short_desc:
      "DYNAMAX OL 68 je vhodný najmä na mazanie strojových častí pracovných a hnacích strojov s nižšími otáčkami a väčším mechanickým zaťažením.",
    desc: "Ložiskové oleje sú ropné oleje s dobrou oxidačnou stálosťou.Obsahujú zušľachťujúce prísady, ktoré priaznivo vplývajú na životnosť ložísk. Sú určené na krátkodobé mazanie sústav pri normálnych teplotách, okrem mazania sústav s veľkou prietokovou rýchlosťou. Sú vhodné aj ako náplň do nenáročných hydraulických sústav.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502511,
    brand: "DYNAMAX",
    image: "img34875",
    src: "34875.jpg",
    name: "DYNAMAX OL 68 60L",
    short_desc:
      "DYNAMAX OL 68 je vhodný najmä na mazanie strojových častí pracovných a hnacích strojov s nižšími otáčkami a väčším mechanickým zaťažením.",
    desc: "Ložiskové oleje sú ropné oleje s dobrou oxidačnou stálosťou.Obsahujú zušľachťujúce prísady, ktoré priaznivo vplývajú na životnosť ložísk. Sú určené na krátkodobé mazanie sústav pri normálnych teplotách, okrem mazania sústav s veľkou prietokovou rýchlosťou. Sú vhodné aj ako náplň do nenáročných hydraulických sústav.",
    ean: 8586016019028,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502512,
    brand: "DYNAMAX",
    image: "img34876",
    src: "34876.jpg",
    name: "DYNAMAX OL 46 209L",
    short_desc:
      "DYNAMAX OL 46 sa používa na mazanie ložísk väčších elektromotorov, ventilátorov a pod., tiež pre dlhodobé náplne mazacích sústav obrábacích strojov.",
    desc: "Ložiskové oleje sú ropné oleje s dobrou oxidačnou stálosťou. Obsahujú zušľachťujúce prísady, ktoré priaznivo vplývajú na životnosť ložísk. Sú určené na krátkodobé mazanie sústav pri normálnych teplotách, okrem mazania sústav s veľkou prietokovou rýchlosťou. Sú vhodné aj ako náplň do nenáročných hydraulických sústav.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502514,
    brand: "DYNAMAX",
    image: "img34877",
    src: "34877.jpg",
    name: "DYNAMAX OL 46 60L",
    short_desc:
      "DYNAMAX OL 46 sa používa na mazanie ložísk väčších elektromotorov, ventilátorov a pod., tiež pre dlhodobé náplne mazacích sústav obrábacích strojov.",
    desc: "Ložiskové oleje sú ropné oleje s dobrou oxidačnou stálosťou. Obsahujú zušľachťujúce prísady, ktoré priaznivo vplývajú na životnosť ložísk. Sú určené na krátkodobé mazanie sústav pri normálnych teplotách, okrem mazania sústav s veľkou prietokovou rýchlosťou. Sú vhodné aj ako náplň do nenáročných hydraulických sústav.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502515,
    brand: "DYNAMAX",
    image: "img34878",
    src: "34878.jpg",
    name: "DYNAMAX OL 32 209L",
    short_desc:
      "DYNAMAX OL 32 sa používa na mazanie ložísk elektromotorov a rotačných strojov menších výkonov a na mazanie ložísk a prevodov obrábacích strojov.",
    desc: "Ložiskové oleje akostné sú odparafínované a rafinované ropné oleje s dobrou oxidačnou stálosťou. Obsahujú zušľachťujúce prísady, ktoré priaznivo vplývajú na životnosť ložísk. Sú určené na krátkodobé mazanie sústav pri normálnych teplotách, okrem mazania sústav s veľkou prietokovou rýchlosťou. Sú vhodné aj ako náplň do nenáročných hydraulických sústav.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502516,
    brand: "DYNAMAX",
    image: "img34879",
    src: "34879.jpg",
    name: "DYNAMAX OL 32 60L",
    short_desc:
      "DYNAMAX OL 32 sa používa na mazanie ložísk elektromotorov a rotačných strojov menších výkonov a na mazanie ložísk a prevodov obrábacích strojov.",
    desc: "Ložiskové oleje akostné sú odparafínované a rafinované ropné oleje s dobrou oxidačnou stálosťou. Obsahujú zušľachťujúce prísady, ktoré priaznivo vplývajú na životnosť ložísk. Sú určené na krátkodobé mazanie sústav pri normálnych teplotách, okrem mazania sústav s veľkou prietokovou rýchlosťou. Sú vhodné aj ako náplň do nenáročných hydraulických sústav.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502517,
    brand: "DYNAMAX",
    image: "img34880",
    src: "34880.jpg",
    name: "DYNAMAX OL 22 209L",
    short_desc:
      "DYNAMAX OL 22 je určený pre ložiská a prevody rýchlobežných, málonamáhaných strojov a zariadení, hydrostatické mechanizmy starších konštrukcií.",
    desc: "Ložiskové oleje akostné sú odparafínované a rafinované ropné oleje s dobrou oxidačnou stálosťou. Obsahujú zušľachťujúce prísady, ktoré priaznivo vplývajú na životnosť ložísk. Sú určené na krátkodobé mazanie sústav pri normálnych teplotách, okrem mazania sústav s veľkou prietokovou rýchlosťou. Sú vhodné aj ako náplň do nenáročných hydraulických sústav.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502518,
    brand: "DYNAMAX",
    image: "img34881",
    src: "34881.jpg",
    name: "DYNAMAX OL 22 60L",
    short_desc:
      "DYNAMAX OL 22 je určený pre ložiská a prevody rýchlobežných, málo namáhaných strojov a zariadení, hydrostatické mechanizmy starších konštrukcií.",
    desc: "Ložiskové oleje akostné sú odparafínované a rafinované ropné oleje s dobrou oxidačnou stálosťou. Obsahujú zušľachťujúce prísady, ktoré priaznivo vplývajú na životnosť ložísk. Sú určené na krátkodobé mazanie sústav pri normálnych teplotách, okrem mazania sústav s veľkou prietokovou rýchlosťou. Sú vhodné aj ako náplň do nenáročných hydraulických sústav.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502520,
    brand: "DYNAMAX",
    image: "img108103",
    src: "108103.jpg",
    name: "DYNAMAX TB 46 60L",
    short_desc:
      "DYNAMAX TB 46 je turbínový olej na ropnej báze s antioxidačnými a antikoróznymi prísadami, ktoré zlepšujú ich úžitkové vlastnosti. Vyznačuje sa výbornou oxidačnou stálosťou, dobrými protikoróznymi, protipenivostnými a deemulgačnými vlastnosťami.",
    desc: "Je určený na mazanie parných, plynových a vodných turbín, turbokompresorov, rýchlobežných prevodoviek na turbo-sústrojoch, môže byť tiež používaný ako hydraulická kvapalina v sústavách riadenia turbín a na mazanie okrem iného: lodných turbonakladačov hlavných a pomocných motorov poháňaných výfukovými plynmi, v cirkulačných systémoch strojov vyžadujúcich olejov kvality turbínových olejov, napr. turbokompresoroch a turbínových čerpadlách.",
    ean: 8586016018809,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502530,
    brand: "DYNAMAX",
    image: "img35254",
    src: "35254.jpg",
    name: "DYNAMAX OHHV 46 209L",
    short_desc:
      "Olej DYNAMAX OHHV 46 je určený na použitie hlavne pre vysokotlaké hydrostatické mechanizmy mobilných strojov pracujúcich v širokom rozsahu prác.",
    desc: "Hydraulický olej OHHV 46 je hydrogenačne rafinovaný ropný olej zušľachtený prísadami proti oxidácii, korózii, na zníženie opotrebenia, proti peneniu a na zlepšenie viskozitných vlastností.",
    ean: 8586016018793,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502531,
    brand: "DYNAMAX",
    image: "img35247",
    src: "35247.jpg",
    name: "DYNAMAX OHHV 46 60L",
    short_desc:
      "Olej DYNAMAX OHHV 46 je určený na použitie hlavne pre vysokotlaké hydrostatické mechanizmy mobilných strojov pracujúcich v širokom rozsahu prác.",
    desc: "Hydraulický olej OHHV 46 je hydrogenačne rafinovaný ropný olej zušľachtený prísadami proti oxidácii, korózii, na zníženie opotrebenia, proti peneniu a na zlepšenie viskozitných vlastností.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502532,
    brand: "DYNAMAX",
    image: "img35252",
    src: "35252.jpg",
    name: "DYNAMAX OHHV 32 209L",
    short_desc:
      "Olej DYNAMAX OHHV 32 je určený na použitie hlavne pre vysokotlaké hydrostatické mechanizmy mobilných strojov pracujúcich v širokom rozsahu prác.",
    desc: "DYNAMAX OHHV 32 je hydrogenačne rafinovaný ropný olej zušľachtený prísadami proti oxidácii, korózii, na zníženie opotrebenia a na zlepšenie viskozitných vlastností.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502533,
    brand: "DYNAMAX",
    image: "img35253",
    src: "35253.jpg",
    name: "DYNAMAX OHHV 32 60L",
    short_desc:
      "Olej DYNAMAX OHHV 32 je určený na použitie hlavne pre vysokotlaké hydrostatické mechanizmy mobilných strojov pracujúcich v širokom rozsahu prác.",
    desc: "DYNAMAX OHHV 32 je hydrogenačne rafinovaný ropný olej zušľachtený prísadami proti oxidácii, korózii, na zníženie opotrebenia a na zlepšenie viskozitných vlastností.",
    ean: 8586016018892,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502534,
    brand: "DYNAMAX",
    image: "img35251",
    src: "35251.jpg",
    name: "DYNAMAX OHHM 32 209L",
    short_desc:
      "Hydraulický olej DYNAMAX OHHM 32 je určený pre hydrostatické mechanizmy s vysokým mechanickým aj tepelným namáhaním.",
    desc: "DYNAMAX OHHM 32 je hydrogenačne rafinovaný ropný olej zušľachtený prísadami na zlepšenie oxidačnej stálosti, protikoróznych a protioderových vlastností a prísadami proti peneniu. Obsahujú modifikátor viskozity s depresantným účinkom.",
    ean: 8586016018847,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502535,
    brand: "DYNAMAX",
    image: "img34768",
    src: "34768.jpg",
    name: "DYNAMAX OHHM 32 60L",
    short_desc:
      "DYNAMAX OHHM 32 je hydrogenačne rafinovaný ropný olej zušľachtený prísadami na zlepšenie oxidačnej stálosti, protikoróznych a protioderových vlastností a prísadami proti peneniu. Obsahujú modifikátor viskozity s depresantným účinkom.",
    desc: "DYNAMAX OHHM 32 je hydrogenačne rafinovaný ropný olej zušľachtený prísadami na zlepšenie oxidačnej stálosti, protikoróznych a protioderových vlastností a prísadami proti peneniu. Obsahujú modifikátor viskozity s depresantným účinkom.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502537,
    brand: "DYNAMAX",
    image: "img34882",
    src: "34882.jpg",
    name: "DYNAMAX FORMEX 2 60L",
    short_desc:
      "Olej odformovací DYNAMAX FORMEX 2 je rafinát ľahkého minerálneho a rastlinného oleja s prísadami. Používa sa na vymazávanie oceľových foriem pri výrobe prefabrikátov.",
    desc: "Olej odformovací DYNAMAX FORMEX 2 je rafinát ľahkého minerálneho a rastlinného oleja s prísadami. Používa sa na vymazávanie oceľových foriem pri výrobe prefabrikátov. Má dobrú roztierateľnosť a schopnosť, že už jemná vrstva chráni proti prilepeniu. Odformovací olej zaisťuje dokonalé oddelenie betónu od formy, pôsobí konzervačne na formu, znižuje jej opotrebenie a zlepšuje kvalitu povrchových vrstiev betónu. Najvýhodnejšie nanášanie na povrch formy je rozprašovaním, je ho tiež možno nanášať natieraním.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502540,
    brand: "DYNAMAX",
    image: "img33909",
    src: "33909.jpg",
    name: "DYNAMAX SCREENWASH -20 209L",
    short_desc:
      "Je vysoko účinná, celoročná mrazuvzdorná kvapalina do všetkých typov ostrekovačov motorových vozidiel. DYNAMAX Screenwash -20 °C je nemrznúca kvapalina do ostrekovačov automobilov. Spoľahlivo odstraňuje zo skla automobilu mastnotu a iné nečistoty.",
    desc: "Je vysoko účinná, celoročná mrazuvzdorná kvapalina do všetkých typov ostrekovačov motorových vozidiel. DYNAMAX Screenwash -20 °C je nemrznúca kvapalina do ostrekovačov automobilov. Spoľahlivo odstraňuje zo skla automobilu mastnotu a iné nečistoty. Chráni ostrekovací systém pred zamŕzaním a vytváraním vodného kameňa. Zlepšuje viditeľnosť počas nepriaznivého zimného počasia. DYNAMAX Screenwash -20 °C sa používa neriedený alebo po nariedení podľa tabuľky.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502541,
    brand: "DYNAMAX",
    image: "img33910",
    src: "33910.jpg",
    name: "DYNAMAX SCREENWASH -40 209L",
    short_desc:
      "Kvapalina do ostrekovačov sa plní do zásobnej nádržky ostrekovača a podľa potreby sa aplikuje na čelné sklo automobilu, pri slabších mrazo",
    desc: "Nemrznúci koncentrát je vysokoúčinná náplň do ostrekovačov automobilov. Zo skla automobilu spoľahlivo odstraňuje mastnotu a iné nečistoty. Chráni ostrekovací systém pred zamŕzaním až do -40°C a vytváraním vodného kameňa. Zlepšuje viditeľnosť počas nepriaznivého počasia. Spríjemňuje jazdu. Zvyšuje bezpečnosť jazdy v zimnom období.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502542,
    brand: "DYNAMAX",
    image: "img108100",
    src: "108100.jpg",
    name: "DYNAMAX ATF IID 209L",
    short_desc:
      "Vysokokvalitný minerálny olej určený pre použitie v automatických prevodovkách osobných aj nákladných automobilov, autobusov, u ktorých výrobca doporučuje použitie oleja podľa GM DEXRON IID.",
    desc: "Olej sa doporučuje tiež používať v posilňovačoch riadenia, v hydraulických spojkách osobných a nákladných automobilov a tiež v hydraulických systémoch, ktoré vyžadujú použitie oleja typu ATF. Schválenia: Voith G607, ZF TE-ML 02F, 03D, 04D, 14A, 17C GM Dexron® II D, Allison C-4",
    ean: 8586016019950,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502548,
    brand: "DYNAMAX",
    image: "img108102",
    src: "108102.jpg",
    name: "DYNAMAX PREMIUM ULTRA C4 5W30 60L",
    short_desc:
      "Vysokovýkonný LOW SAPS motorový olej vyrobený na báze 100% syntetickej technológie určený na použitie v benzínových a dieselových motoroch Renault a Nissan najnovšej generácie. Je vhodný na použitie v motoroch s filtrami pevných častíc (DPF).",
    desc: 0,
    ean: 8586016018830,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502570,
    brand: "DYNAMAX",
    image: "img107449",
    src: "107449.jpg",
    name: "DYNAMAX SCREENWASH  NANO RACING 4L",
    short_desc:
      "NANO technológia so sviežou vôňou, ktorá vytvára ochrannú vrstvu na skle. Vysokokvalitná letná zmes do ostrekovačov vyrobená na báze NANO technológie so sviežou vôňou.",
    desc: "NANO technológia so sviežou vôňou, ktorá vytvára ochrannú vrstvu na skle. Vysokokvalitná letná zmes do ostrekovačov vyrobená na báze NANO technológie so sviežou vôňou. Vytvára na skle účinnú ochrannú vrstvu, ktorej hlavnou úlohou je minimalizovať usadzovanie nečistôt a tým zlepšiť viditeľnosť na vašich cestách. Zmes zároveň napomáha k odstraňovaniu dažďovej vody a je šetrná k vašim svetlometom. Balenie: 4l",
    ean: 8586016019240,
    package: 3,
    type: "doplnok",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502575,
    brand: "DYNAMAX",
    image: "img45489",
    src: "45489.jpg",
    name: "DYNAMAX COOL ULTRA 12 (READYMIX) 1L -37°",
    short_desc:
      "Je určená do chladičov moderných hliníkových a liatinových chladiacich sústav spaľovacích motorov. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou.",
    desc: "Je určená do chladičov moderných hliníkových a liatinových chladiacich sústav spaľovacích motorov. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Je miešateľná s chladiacimi kvapalinami na báze monoetylénglykolu a propylénglykolu. Prípravok neobsahuje dusitany, amíny a fosfáty. Odporúčaná výmena je po troch rokoch. Použitie: V nezriedenom stave nalejte do chladiaceho systému.",
    ean: 8586016019318,
    package: 12,
    type: "doplnok",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502577,
    brand: "DYNAMAX",
    image: "img45490",
    src: "45490.jpg",
    name: "DYNAMAX COOL ULTRA 12 (READYMIX) 4L -37°",
    short_desc:
      "Je určená do chladičov moderných hliníkových a liatinových chladiacich sústav spaľovacích motorov. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou.",
    desc: "Je určená do chladičov moderných hliníkových a liatinových chladiacich sústav spaľovacích motorov. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Je miešateľná s chladiacimi kvapalinami na báze monoetylénglykolu a propylénglykolu. Prípravok neobsahuje dusitany, amíny a fosfáty. Odporúčaná výmena je po troch rokoch. Použitie: V nezriedenom stave nalejte do chladiaceho systému.",
    ean: 8586016019332,
    package: 3,
    type: "doplnok",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502578,
    brand: "DYNAMAX",
    image: "img108118",
    src: "108118.jpg",
    name: "DYNAMAX COOL ULTRA 12 (READYMIX) 5L -37°",
    short_desc:
      "Je určená do chladičov moderných hliníkových a liatinových chladiacich sústav spaľovacích motorov. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou.",
    desc: "Je určená do chladičov moderných hliníkových a liatinových chladiacich sústav spaľovacích motorov. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Je miešateľná s chladiacimi kvapalinami na báze monoetylénglykolu a propylénglykolu. Prípravok neobsahuje dusitany, amíny a fosfáty. Odporúčaná výmena je po troch rokoch. Použitie: V nezriedenom stave nalejte do chladiaceho systému.",
    ean: 8586016019349,
    package: 3,
    type: "doplnok",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502579,
    brand: "DYNAMAX",
    image: "img45491",
    src: "45491.jpg",
    name: "DYNAMAX COOL ULTRA 13 (READYMIX) 1L -37°",
    short_desc:
      "Je určená do chladičov moderných hliníkových a liatinových chladiacich sústav spaľovacích motorov. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla.",
    desc: "Je určená do chladičov moderných hliníkových a liatinových chladiacich sústav spaľovacích motorov. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Je miešateľná s chladiacimi kvapalinami na báze monoetylénglykolu a propylénglykolu. Prípravok neobsahuje dusitany, amíny a fosfáty. Odporúčaná výmena je po troch rokoch. Použitie: V nezriedenom stave nalejte do chladiaceho systému.",
    ean: 8586016019356,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502581,
    brand: "DYNAMAX",
    image: "img45492",
    src: "45492.jpg",
    name: "DYNAMAX COOL ULTRA 13 (READYMIX) 4L -37°",
    short_desc:
      "Je určená do chladičov moderných hliníkových a liatinových chladiacich sústav spaľovacích motorov. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla.",
    desc: "Je určená do chladičov moderných hliníkových a liatinových chladiacich sústav spaľovacích motorov. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Je miešateľná s chladiacimi kvapalinami na báze monoetylénglykolu a propylénglykolu. Prípravok neobsahuje dusitany, amíny a fosfáty. Odporúčaná výmena je po troch rokoch. Použitie: V nezriedenom stave nalejte do chladiaceho systému.",
    ean: 8586016019370,
    package: 4,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502583,
    brand: "DYNAMAX",
    image: "img45487",
    src: "45487.jpg",
    name: "DYNAMAX COOL AL 11 (READYMIX) 1L -37°",
    short_desc:
      "Je určená do chladičov motorov vyrobených z ľahkých zliatin. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla.",
    desc: "Je určená do chladičov motorov vyrobených z ľahkých zliatin. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Je miešateľná s chladiacimi kvapalinami na báze monoetylénglykolu a propylénglykolu. Neobsahuje dusitany, amíny a fosfáty. Odporúčaná výmena je po troch rokoch. Použitie: V nezriedenom stave nalejte do chladiaceho systému.",
    ean: 8586016019271,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502585,
    brand: "DYNAMAX",
    image: "img45488",
    src: "45488.jpg",
    name: "DYNAMAX COOL AL 11 (READYMIX) 4L -37°",
    short_desc:
      "Je určená do chladičov motorov vyrobených z ľahkých zliatin. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla.",
    desc: "Je určená do chladičov motorov vyrobených z ľahkých zliatin. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Je miešateľná s chladiacimi kvapalinami na báze monoetylénglykolu a propylénglykolu. Neobsahuje dusitany, amíny a fosfáty. Odporúčaná výmena je po troch rokoch. Použitie: V nezriedenom stave nalejte do chladiaceho systému.",
    ean: 8586016019295,
    package: 3,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502586,
    brand: "DYNAMAX",
    image: "img108119",
    src: "108119.jpg",
    name: "DYNAMAX COOL AL 11 (READYMIX) 5L -37°",
    short_desc:
      "Je určená do chladičov motorov vyrobených z ľahkých zliatin. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla.",
    desc: "Je určená do chladičov motorov vyrobených z ľahkých zliatin. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Je miešateľná s chladiacimi kvapalinami na báze monoetylénglykolu a propylénglykolu. Neobsahuje dusitany, amíny a fosfáty. Odporúčaná výmena je po troch rokoch. Použitie: V nezriedenom stave nalejte do chladiaceho systému.",
    ean: 8586016019301,
    package: 3,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502590,
    brand: "DYNAMAX",
    image: "img108089",
    src: "108089.jpg",
    name: "DYNAMAX SCREENWASH -30°C RACING 4L",
    short_desc:
      "Nemrznúca zmes do ostrekovačov automobilov s príjemnou arómou energetického nápoja, obľúbeného u motoristov v atraktívnom farebnom prevedení.",
    desc: "Nemrznúca zmes do ostrekovačov automobilov s príjemnou arómou energetického nápoja, obľúbeného u motoristov v atraktívnom farebnom prevedení. Spoľahlivo odstraňuje zo skla a svetlometov automobilu mastnotu a iné nečistoty. Chráni ostrekovací systém automobilu pred zamŕzaním a vytváraním vodného kameňa. Zlepšuje viditeľnosť počas nepriaznivého zimného počasia.",
    ean: 8586016019455,
    package: 3,
    type: "doplnok",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502630,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX ULTRA LONGLIFE 5W30 20L",
    short_desc: "",
    desc: 0,
    ean: 8586016019677,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502640,
    brand: "DYNAMAX",
    image: "img108122",
    src: "108122.jpg",
    name: "DYNAMAX COOL ULTRA G13 209L",
    short_desc:
      "Chladiaca kvapalina optimalizovaná pre všetky typy moderných automobilov s vynikajúcou miešateľnosťou s inými druhmi chladiacich kvapalín (G11, G12, G12++...).",
    desc: "Chladiaca kvapalina optimalizovaná pre všetky typy moderných automobilov s vynikajúcou miešateľnosťou s inými druhmi chladiacich kvapalín (G11, G12, G12++...). Je špeciálne vyvinutá pre najnovšie automobily VW group (VW, ŠKODA, SEAT, AUDI). Poskyt uje výbornú ochranu pred mrazom, vysokými teplotami a zároveň chráni pred koróziou. DOPORUČENÉ POMERY RIEDENIA:1 diel DYNAMAX COOLANT ULTRA G13: 1 diel DYNAQUA - použitie do - 37 °C. 1 diel DYNAMAX COOLANT ULTRA G13 : 1,5 dielu DYNAQUA - použitie do - 26 °C.1 diel DYNAMAX COOLANT ULTRA G13: 2 diely DYNAQUA - použitie do - 17 °C.",
    ean: 8586016019684,
    package: "",
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502647,
    brand: "DYNAMAX",
    image: "img81858",
    src: "81858.jpg",
    name: "DYNAMAX PREMIUM SN PLUS 10W-40 1L",
    short_desc:
      "Univerzálny vysokovýkonný polosyntetický olej pre benzínové a naftové motory osobných automobilov a ľahkých dodávok s alebo bez turba. Nie je vhodný pre naftové motory vybavené filtrom pevných častíc (DPF)",
    desc: "Univerzálny vysokovýkonný polosyntetický olej pre benzínové a naftové motory osobných automobilov a ľahkých dodávok s alebo bez turba. Nie je vhodný pre naftové motory vybavené filtrom pevných častíc (DPF).",
    ean: 8586016019691,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502648,
    brand: "DYNAMAX",
    image: "img81859",
    src: "81859.jpg",
    name: "DYNAMAX PREMIUM SN PLUS 10W-40 4L",
    short_desc:
      "Univerzálny vysokovýkonný polosyntetický olej pre benzínové a naftové motory osobných automobilov a ľahkých dodávok s alebo bez turba. Nie je vhodný pre naftové motory vybavené filtrom pevných častíc (DPF).",
    desc: "Univerzálny vysokovýkonný polosyntetický olej pre benzínové a naftové motory osobných automobilov a ľahkých dodávok s alebo bez turba. Nie je vhodný pre naftové motory vybavené filtrom pevných častíc (DPF).",
    ean: 8586016019707,
    package: 3,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502654,
    brand: "DYNAMAX",
    image: "img59969",
    src: "59969.jpg",
    name: "DYNAMAX OL 68 20L",
    short_desc:
      "DYNAMAX OL 68 je vhodný najmä na mazanie strojových častí pracovných a hnacích strojov s nižšími otáčkami a väčším mechanickým zaťažením.",
    desc: "Ložiskové oleje sú ropné oleje s dobrou oxidačnou stálosťou.Obsahujú zušľachťujúce prísady, ktoré priaznivo vplývajú na životnosť ložísk. Sú určené na krátkodobé mazanie sústav pri normálnych teplotách, okrem mazania sústav s veľkou prietokovou rýchlosťou. Sú vhodné aj ako náplň do nenáročných hydraulických sústav.",
    ean: 8586016019820,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502670,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX PREMIUM ULTRA C2 5W30 20L",
    short_desc: "",
    desc: 0,
    ean: 8586016019929,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502690,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX COOL AL 11 1L -37 BLUE",
    short_desc: "",
    desc: 0,
    ean: 8586016019974,
    package: 12,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502691,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX TB 32 20L",
    short_desc: "",
    desc: 0,
    ean: 8586011472071,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502692,
    brand: "DYNAMAX",
    image: "img81489",
    src: "81489.jpg",
    name: "DXI3-DYNAMAX OSVIEŽOVAČ VZDUCHU 500 ML",
    short_desc:
      "Vysoko účinný neutralizátor zápachu, ktorý odstraňuje nepríjemné zápachy rýchlo, bezpečne a trvalo. Pôsobí proti rôznym zápachom ako nikotín, zápachu domácich zvierat a mnohým ďalším zápachom. Zanecháva príjemnú vôňu. Ideálne pre použitie vo vozidlách, na látky, domáce potreby a viac.",
    desc: "Vysoko účinný neutralizátor zápachu, ktorý odstraňuje nepríjemné zápachy rýchlo, bezpečne a trvalo. Pôsobí proti rôznym zápachom ako nikotín, zápachu domácich zvierat a mnohým ďalším zápachom. Zanecháva príjemnú vôňu. Ideálne pre použitie vo vozidlách, na látky, domáce potreby a viac. ZLOŽENIE (Nariadenie 648/2004/EÚ): neiónové povrchovo aktívne látky, BENZYL BENZOATE, METHYLISOTHIAZOLINONE, BENZISOTHIAZOLINONE menej ako 5%. Ostatné zložky: parfum. Núdzové telefónne číslo: Národné toxikologické informačné centrum, Limbová 5, 833 05 Bratislava, tel. 02/54 77 41 66. SKLADOVANIE: Skladujte v originálnom balení na dobre vetraných miestach pri teplote do 40 °C v suchej miestnosti. Minimálna trvanlivosť: 3 roky od dátumu výroby.",
    ean: 8586016019981,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502693,
    brand: "DYNAMAX",
    image: "img81488",
    src: "81488.jpg",
    name: "DXE9-DYNAMAX SPRAY WAX 500ML",
    short_desc:
      "Rýchla a jednoduchá starostlivosť o farbu. Zanecháva vysoký lesk aj pri tmavých a citlivých farbách. Perfektné pre vozidlá, kde tento výrobok možno použiť aj ako leštiaci prostriedok.",
    desc: "Rýchla a jednoduchá starostlivosť o farbu. Zanecháva vysoký lesk aj pri tmavých a citlivých farbách. Perfektné pre vozidlá, kde tento výrobok možno použiť aj ako leštiaci prostriedok. Použitie: Pred použitím prípravku opláchnite auto od nečistôt a  vysušte. Ľahko rozprašujte prípravok na ošetrovaný povrch a následne ľahko pretrite handričkou. SKLADOVANIE: Skladujte v originálnom balení na dobre vetraných miestach pri teplote do 40 °C v suchej miestnosti. Minimálna trvanlivosť: 3 roky od dátumu výroby.",
    ean: 8586016019998,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502700,
    brand: "DYNAMAX",
    image: "img81490",
    src: "81490.jpg",
    name: "DXM5 DX MOTOR CLEANER - ROZPRAŠOVAČ 500 ML",
    short_desc:
      "Univerzálny čistič bez rozpúšťadiel. Dynamax motor cleaner čistí motory, prevodovky, plachty pre nákladné automobily, autá a člny, podlahy v dielňach a iné plochy znečistené olejom, ktorý nezanecháva žiadne zvyšky.",
    desc: "Univerzálny čistič bez rozpúšťadiel. Dynamax motor cleaner čistí motory, prevodovky, plachty pre nákladné automobily, autá a člny, podlahy v dielňach a iné plochy znečistené olejom, ktorý nezanecháva žiadne zvyšky. Použitie: Prípravok nastriekajte na znečistený povrch. Po nanesení nechajte prípravok pôsobiť 5-10 minút a potom dokonale opláchnite vodou. Nenanášajte na rozžeravené predmety, na elektrické časti auta alebo iného zariadenia. NEBEZPEČENSTVO. Obsahuje izotridekanol etoxylovaný; C1 2-14 alkylalkoholy, etoxylované, sulfáty, sodné soli. H318 Spôsobuje vážne poškodenie očí. P101 Ak je potrebná lekárska pomoc, majte k dispozícii obal alebo etiketu výrobku. P102 Uchovávajte mimo dosahu detí. P280 Noste ochranné rukavice/ochranný od ev/ochranné okuliare/ochranu tváre. P305+P351+P338 PO ZASIAHNUTÍ OČÍ: Niekoľko minút ich opatrne vyplachujte vodou. Ak používate kontaktné šošovky a ak je to možné, odstráňte ich. Pokračujte vo vyplachovaní. P310 Okamžite volajte TOXIKOLOGICKÉ INFOR MAČNÉ CENTRUM/ lekára/. P501 Zneškodnite obsah/nádobu ako nebezpečný odpad podľa platných právnych predpisov. Zloženie (Nariadenie 648/2004/EÚ): neiónové povrchovo aktívne látky 5% - 15%, aniónové povrchovo aktívne látky, METHYLISOTHIAZOLINONE, BE NZISOTHIAZOLINONE menej ako 5%. Ostatné zložky: parfum. Núdzové telefónne číslo: Národné toxikologické informačné centrum, Limbová 5, 833 05 Bratislava, tel. 02/54 77 41 66. SKLADOVANIE: Skladujte v originálnom balení na dobre vetraných miestach pri teplote do 40 °C v suchej miestnosti. Minimálna trvanlivosť: 3 roky od dátumu výroby",
    ean: 8586011472040,
    package: 6,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502713,
    brand: "DYNAMAX",
    image: "img104184",
    src: "104184.jpg",
    name: "DYNAMAX ČISTIČ CHLADIČA 2-ZLOŽKOVÝ",
    short_desc:
      "Odstraňuje usadeniny oleja spôsobené uvoľnením tesnenia hlavy valca a účinne čistí celý chladiaci systém. Ventily, termostaty a vodné čerpadlá sa vrátia k ich optimálnemu výkonu. Zvyšuje prevádzkovú výkonnosť chladiaceho systému a predlžuje životnosť všetkých agregátov.",
    desc: "DYNAMAX ČISTIČ CHLADIČA 2-ZLOŽKOVÝ - komponent č. 1 + č. 2 je bezfarebná kvapalina. Použitie: Je vhodný do chladiacich systémov s objemom 5 až 10 litrov. Vhodný pre uzavreté vodné chladiace systémy a tiež pre výmenníky tepla. Môže byť zmiešaný so všetkými bežnými chladiacimi zmesami. 1. Pred použitím oba produkty dôkladne pretrepať. 2. Celý obsah naliať do chladiaceho systému. 3. Otvorte vykurovací ventil a nechajte motor bežať cca. 15 minút pri stredných otáčkach, aby sa dosiahla optimálna prevádzková teplota. 4. Vypustite chladiacu kvapalinu. Odmontujte všetky expanzné nádobky, ktoré nie sú súčasťou okruhu chladiacej kvapaliny a vyčistite ich ručne. 5. Dôkladne opláchnite celý chladiaci systém čistou vodou. 6. Doplňte systém chladiacou zmesou.",
    ean: 8586011472057,
    package: 12,
    type: "olej",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502714,
    brand: "DYNAMAX",
    image: "img82774",
    src: "82774.jpg",
    name: "DYNAMAX  CETANE BOOSTER 1:1000 150ML",
    short_desc:
      "Pre lepšiu horľavosť paliva. Zvyšuje cetánové číslo paliva až o 5 bodov. Lepší štart za studena. Použitie: Pridajte do nádrže 150 ml na 60 litrov motorovej nafty pred každým tankovaním.",
    desc: "Pre lepšiu horľavosť paliva. Zvyšuje cetánové číslo paliva až o 5 bodov. Lepší štart za studena. Použitie: Pridajte do nádrže 150 ml na 60 litrov motorovej nafty pred každým tankovaním. POZOR. Obsahuje: 2-etylhexyl-nitrát. H302 Škodlivý po požití . H312 Škodlivý pri kontakte s pokožkou. H332 Škodlivý pri vdýchnutí. H411 Toxický pre vodné organizmy, s dlhodobými účinkami. EUH044 Riziko výbuchu pri zahrievaní v uzavretom priestore. EUH066 Opakovaná expozícia môže spôsobit’ vysušenie alebo popraskanie pokožky. P261 Zabráňte vdychovaniu pár. P271 Používajte iba na voľnom priestranstve alebo v dobre vetranom priestore. P273 Zabráňte uvoľneniu do životného prostredia. P280 Noste ochranné rukavice/ochranný odev/ochranné okuliare/ochranu tváre . P301+P312 PO POŽITÍ: Pri zdravotných problémoch volajte TOXIKOLOGICKÉ INFORMAČNÉ CENTRUM/ lekára/.P302 +P352 PRI KONTAKTE S POKOŽKOU: Umyte veľkým množstvom vody. P304+P340 PO VDÝCHNUTÍ: Presuňte osobu na čerstvý vzduch a umožnite jej pohodlne dýchať. P501 Zneškodnite obsah/nádobu ako nebezpečný odpad podľa platných právnych predpisov. Minimálna trvanlivosť: 3 roky od dátumu výroby.",
    ean: 8586011472064,
    package: 12,
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502715,
    brand: "DYNAMAX",
    image: "img107997",
    src: "107997.jpg",
    name: "DYNAMAX GOLDLINE FS 0W-40 5L",
    short_desc:
      "Syntetický motorový olej pre benzínové a naftové motory s, alebo bez preplňovania a priameho vstrekovania. Je charakterizovaný vynikajúcimi vlastnosťami studeného štartu, minimalizáciou spotreby paliva, trenia a opotrebenia.",
    desc: "Syntetický motorový olej pre benzínové a naftové motory s, alebo bez preplňovania a priameho vstrekovania. Je charakterizovaný vynikajúcimi vlastnosťami studeného štartu, minimalizáciou spotreby paliva, trenia a opotrebenia.",
    ean: 8586011472088,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502717,
    brand: "DYNAMAX",
    image: "img107996",
    src: "107996.jpg",
    name: "DYNAMAX PREMIUM ULTRA LE 5W-30 5L",
    short_desc:
      "Vysokovýkonný MID SAPS motorový olej vyrobený na 100% syntetickej technológii pre použitie v najnovších generáciách benzínových a dieselových motorov osobných automobilov a ľahkých dodávok s alebo bez turba a systému na úpravu výfukových plynov.",
    desc: "Vysokovýkonný MID SAPS motorový olej vyrobený na 100% syntetickej technológii pre použitie v najnovších generáciách benzínových a dieselových motorov osobných automobilov a ľahkých dodávok s alebo bez turba a systému na úpravu výfukových plynov.",
    ean: 8586011472101,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502718,
    brand: "DYNAMAX",
    image: "img81491",
    src: "81491.jpg",
    name: "DYNAMAX ATF CVT 1L",
    short_desc:
      "Vysoko výkonná prevodová kvapalina s obsahom vybraných základných surovín špeciálne odporúčaná pre použitie v najnovších generáciách prevodoviek s plynulou zmenou prevodu (CVT) - prenášajú trakciu pomocou oceľových ťažných reťazí alebo tlačidiel.",
    desc: "Vysoko výkonná prevodová kvapalina s obsahom vybraných základných surovín špeciálne odporúčaná pre použitie v najnovších generáciách prevodoviek s plynulou zmenou prevodu (CVT) - prenášajú trakciu pomocou oceľových ťažných reťazí alebo tlačidiel.",
    ean: 8586011472118,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502719,
    brand: "DYNAMAX",
    image: "img81493",
    src: "81493.jpg",
    name: "DYNAMAX ATF MV 1L",
    short_desc:
      "Vysoko kvalitná syntetická kvapalina špeciálne navrhnutá s pokročilou technológiou pre širokú škálu vozidiel. Prevyšuje komplexné požiadavky výrobcov automatických prevodoviek.",
    desc: "Vysoko kvalitná syntetická kvapalina špeciálne navrhnutá s pokročilou technológiou pre širokú škálu vozidiel. Prevyšuje komplexné požiadavky výrobcov automatických prevodoviek.",
    ean: 8586011472125,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502720,
    brand: "DYNAMAX",
    image: "img81492",
    src: "81492.jpg",
    name: "DYNAMAX ATF MB 1L",
    short_desc:
      "Vysokokvalitná plne syntetická kvapalina špeciálne vyvinutá pre sedemstupňové automatické prevodovky MB (NAG-2) poslednej generácie. Spätne kompatibilná s automatickou prevodovkou, kde sa odporúča špecifikácia MB 236.12.",
    desc: "Vysokokvalitná plne syntetická kvapalina špeciálne vyvinutá pre sedemstupňové automatické prevodovky MB (NAG-2) poslednej generácie. Spätne kompatibilná s automatickou prevodovkou, kde sa odporúča špecifikácia MB 236.12.",
    ean: 8586011472132,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502721,
    brand: "DYNAMAX",
    image: "img82723",
    src: "82723.jpg",
    name: "DYNAMAX HYPOL 75W-140 LS GL5 1L",
    short_desc:
      "Syntetické vysokovýkonné multifunkčné mazivo prevodovky navrhnuté tak, aby poskytovalo efektívne mazanie v moderných vysokovýkonných osobných vozidlách, športových a úžitkových vozidlách vybavené diferenciálmi konvenkčnými, alebo s obmedzeným preklzom.",
    desc: "Syntetické vysokovýkonné multifunkčné mazivo prevodovky navrhnuté tak, aby poskytovalo efektívne mazanie v moderných vysokovýkonných osobných vozidlách, športových a úžitkových vozidlách vybavené diferenciálmi konvenkčnými, alebo s obmedzeným preklzom.",
    ean: 8586011472149,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502722,
    brand: "DYNAMAX",
    image: "img81494",
    src: "81494.jpg",
    name: "DYNAMAX HYPOL 75W-80 GL 4 1L",
    short_desc:
      "Vysoko kvalitná syntetická kvapalina špeciálne navrhnutá s pokročilou technológiou pre širokú škálu vozidiel. Prevyšuje komplexné požiadavky výrobcov automatických prevodoviek.",
    desc: "Vysoko kvalitná syntetická kvapalina špeciálne navrhnutá s pokročilou technológiou pre širokú škálu vozidiel. Prevyšuje komplexné požiadavky výrobcov automatických prevodoviek.",
    ean: 8586011472156,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502727,
    brand: "DYNAMAX",
    image: "img81860",
    src: "81860.jpg",
    name: "DYNAMAX 2T OUTBOARD 1L",
    short_desc:
      "Vysoko výkonný 2-taktný motorový olej, ktorý spĺňa požiadavky najnovších lodných motorov a snežných skútrov. Prevyšuje výkonnostné požiadavky NMMA TC-W3® asociácie národných výrobcov námorných lodí.",
    desc: "Vysoko výkonný 2-taktný motorový olej, ktorý spĺňa požiadavky najnovších lodných motorov a snežných skútrov. Prevyšuje výkonnostné požiadavky NMMA TC-W3® asociácie národných výrobcov námorných lodí.",
    ean: 8586011472217,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502728,
    brand: "DYNAMAX",
    image: "img81861",
    src: "81861.jpg",
    name: "DYNAMAX HYPOL 85W-140 GL5 1L",
    short_desc:
      "Vysokovýkonné prevodový olej navrhnutý tak, aby poskytoval vynikajúce mazanie v širokej škále automobilových prevodoviek, náprav a konečných pohonov. Je založený na kvalitnom rafinovanom základnom oleji v kombinácii so špeciálnym balíkom aditív.",
    desc: "Vysokovýkonné prevodový olej navrhnutý tak, aby poskytoval vynikajúce mazanie v širokej škále automobilových prevodoviek, náprav a konečných pohonov. Je založený na kvalitnom rafinovanom základnom oleji v kombinácii so špeciálnym balíkom aditív.",
    ean: 8586011472224,
    package: 12,
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502729,
    brand: "DYNAMAX",
    image: "img81621",
    src: "81621.jpg",
    name: "DYNAMAX GOLDLINE FS 0W40 1L",
    short_desc:
      "Syntetický motorový olej pre benzínové a naftové motory s, alebo bez preplňovania a priameho vstrekovania. Je charakterizovaný vynikajúcimi vlastnosťami studeného štartu, minimalizáciou spotreby paliva, trenia a opotrebenia.",
    desc: "Syntetický motorový olej pre benzínové a naftové motory s, alebo bez preplňovania a priameho vstrekovania. Je charakterizovaný vynikajúcimi vlastnosťami studeného štartu, minimalizáciou spotreby paliva, trenia a opotrebenia.",
    ean: 8586011472231,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502730,
    brand: "DYNAMAX",
    image: "img81862",
    src: "81862.jpg",
    name: "DYNAMAX PREMIUM ULTRA LE 5W-30 1L",
    short_desc:
      "Vysokovýkonný MID SAPS motorový olej vyrobený na 100% syntetickej technológii pre použitie v najnovších generáciách benzínových a dieselových motorov osobných automobilov a ľahkých dodávok s alebo bez turba a systému na úpravu výfukových plynov.",
    desc: "Vysokovýkonný MID SAPS motorový olej vyrobený na 100% syntetickej technológii pre použitie v najnovších generáciách benzínových a dieselových motorov osobných automobilov a ľahkých dodávok s alebo bez turba a systému na úpravu výfukových plynov.",
    ean: 8586011472248,
    package: 12,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502731,
    brand: "DYNAMAX",
    image: "img81863",
    src: "81863.jpg",
    name: "DYNAMAX PREMIUM ULTRA LE 5W-30 4L",
    short_desc:
      "Vysokovýkonný MID SAPS motorový olej vyrobený na 100% syntetickej technológii pre použitie v najnovších generáciách benzínových a dieselových motorov osobných automobilov a ľahkých dodávok s alebo bez turba a systému na úpravu výfukových plynov.",
    desc: "Vysokovýkonný MID SAPS motorový olej vyrobený na 100% syntetickej technológii pre použitie v najnovších generáciách benzínových a dieselových motorov osobných automobilov a ľahkých dodávok s alebo bez turba a systému na úpravu výfukových plynov.",
    ean: 8586011472255,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502732,
    brand: "DYNAMAX",
    image: "img81622",
    src: "81622.jpg",
    name: "DYNAMAX GOLDLINE FS 0W-40 4L",
    short_desc:
      "Syntetický motorový olej pre benzínové a naftové motory s, alebo bez preplňovania a priameho vstrekovania. Je charakterizovaný vynikajúcimi vlastnosťami studeného štartu, minimalizáciou spotreby paliva, trenia a opotrebenia.",
    desc: "Syntetický motorový olej pre benzínové a naftové motory s, alebo bez preplňovania a priameho vstrekovania. Je charakterizovaný vynikajúcimi vlastnosťami studeného štartu, minimalizáciou spotreby paliva, trenia a opotrebenia.",
    ean: 8586011472262,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502740,
    brand: "DYNAMAX",
    image: "img108121",
    src: "108121.jpg",
    name: "DYNAMAX COOL ULTRA 12 (READYMIX) 209L -37°",
    short_desc:
      "Je určená do chladičov moderných hliníkových a liatinových chladiacich sústav spaľovacích motorov. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou.",
    desc: "Je určená do chladičov moderných hliníkových a liatinových chladiacich sústav spaľovacích motorov. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Je miešateľná s chladiacimi kvapalinami na báze monoetylénglykolu a propylénglykolu. Prípravok neobsahuje dusitany, amíny a fosfáty. Odporúčaná výmena je po troch rokoch. Použitie: V nezriedenom stave nalejte do chladiaceho systému.",
    ean: 8586011472293,
    package: "",
    type: "doplnok",
    sub_category: "chladiaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502741,
    brand: "DYNAMAX",
    image: "img108117",
    src: "108117.jpg",
    name: "DYNAMAX COOL AL 11 209L -37°",
    short_desc:
      "Je určená do chladičov motorov vyrobených z ľahkých zliatin. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla.",
    desc: "Je určená do chladičov motorov vyrobených z ľahkých zliatin. Celoročne chráni chladiaci systém motorového vozidla pred pôsobením mrazu a pred koróziou. Zaručuje veľmi dobrý prevod tepla. Je miešateľná s chladiacimi kvapalinami na báze monoetylénglykolu a propylénglykolu. Neobsahuje dusitany, amíny a fosfáty. Odporúčaná výmena je po troch rokoch. Použitie: V nezriedenom stave nalejte do chladiaceho systému.",
    ean: 8586011472286,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502774,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX TRUCKMAN HD 20W50 4L",
    short_desc: "",
    desc: 0,
    ean: "",
    package: 3,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502783,
    brand: "DYNAMAX",
    image: "img108115",
    src: "108115.jpg",
    name: "DYNAMAX TRUCKMAN SUPER 20W50 209L",
    short_desc:
      "Motorový olej vyrobený na báze minerálnych základových olejov vhodný pre staršie typy nákladnych automobilov a mechanizmov bez DPF.",
    desc: 0,
    ean: 8586011472354,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502784,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX SUPER 40 4L",
    short_desc: "",
    desc: 0,
    ean: 8586011472590,
    package: 3,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502790,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX TRACTOR + 10W30 10L",
    short_desc: "",
    desc: 0,
    ean: 8586011472309,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502791,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX TRACTOR + 10W30 20L",
    short_desc: "",
    desc: 0,
    ean: 8586011472316,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502796,
    brand: "DYNAMAX",
    image: "img108170",
    src: "108170.jpg",
    name: "DYNAMAX ATF CVT 60L",
    short_desc:
      "Vysoko výkonná prevodová kvapalina s obsahom vybraných základných surovín špeciálne odporúčaná pre použitie v najnovších generáciách prevodoviek s plynulou zmenou prevodu (CVT) – prenášajú trakciu pomocou oceľových ťažných reťazí alebo tlačidiel.",
    desc: "Vysoko výkonná prevodová kvapalina s obsahom vybraných základných surovín špeciálne odporúčaná pre použitie v najnovších generáciách prevodoviek s plynulou zmenou prevodu (CVT) – prenášajú trakciu pomocou oceľových ťažných reťazí alebo tlačidiel.  SCHVÁLENIA: 236.20, FORD WSS-M2C928A, BMW 83 22 0 136 376/83 22 0 429 154, VW G 052 180, EZL 799",
    ean: 8586011472323,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502799,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX ATF MV 10L",
    short_desc:
      "Vysoko kvalitná syntetická kvapalina špeciálne navrhnutá s pokročilou technológiou pre širokú škálu vozidiel. Prevyšuje komplexné požiadavky výrobcov automatických prevodoviek.",
    desc: "<b>SCHVÁLENIA: </b> VW G 052 025,SUBARUATF,HP,VOLVO 1161640, FORD MERCON V, ALLISONC4, TES 295,CHRYSLER +3,+4,HONDA SP-III,Z1, JWS 3309/3314/3317, MAZDA ATF M-III,M5,VOLVO P/N 1161521,ZF TE ML 03D,04D,14A,14B,17C,LT 71141,LA 23634, MITSUBISHI SP-III,JASO M315-2004,MB- APPROVAL 236.3,5,6,9,TOYOTA T-III,T-IV, VW G 052 055,VOLVO 1161540,ETL-7045E,8072B,KIA SP-III,TEXACO N402,MB-APPROVAL 236.10,11,VOITH H55.6335.XX,VW G 052 162,CAT TO-2,DEXRON IID,IIIG/H,IDEMITSU K17,MAN 3391 V1/Z2,NISSAN MATICD,J,K,VOLVOSTD 1273.4,VW G 052 990,VOLVO CE 1273,41",
    ean: 8586011472491,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502802,
    brand: "DYNAMAX",
    image: "img108114",
    src: "108114.jpg",
    name: "DYNAMAX ATF MV 209L",
    short_desc:
      "Vysoko kvalitná syntetická kvapalina špeciálne navrhnutá s pokročilou technológiou pre širokú škálu vozidiel. Prevyšuje komplexné požiadavky výrobcov automatických prevodoviek.",
    desc: "SCHVÁLENIA: VW G 052 025,SUBARUATF,HP,VOLVO 1161640, FORD MERCON V, ALLISONC4, TES 295,CHRYSLER +3,+4,HONDA SP-III,Z1, JWS 3309/3314/3317, MAZDA ATF M-III,M5,VOLVO P/N 1161521,ZF TE ML 03D,04D,14A,14B,17C,LT 71141,LA 23634, MITSUBISHI SP-III,JASO M315-2004,MB- APPROVAL 236.3,5,6,9,TOYOTA T-III,T-IV, VW G 052 055,VOLVO 1161540,ETL-7045E,8072B,KIA SP-III,TEXACO N402,MB-APPROVAL 236.10,11,VOITH H55.6335.XX,VW G 052 162,CAT TO-2,DEXRON IID,IIIG/H,IDEMITSU K17,MAN 3391 V1/Z2,NISSAN MATICD,J,K,VOLVOSTD 1273.4,VW G 052 990,VOLVO CE 1273,41",
    ean: 8586011472484,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502804,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX ATF MB 10L",
    short_desc:
      "Vysokokvalitná plne syntetická kvapalina špeciálne vyvinutá pre sedemstupňové automatické prevodovky MB (NAG-2) poslednej generácie. Spätne kompatibilná s automatickou prevodovkou, kde sa odporúča špecifikácia MB 236.12.",
    desc: "<b>SCHVÁLENIA:  </b>MB-APPROVAL 236.14, SSANG-YONG",
    ean: 8586011472507,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502805,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX ATF MB 20L",
    short_desc:
      "Vysokokvalitná plne syntetická kvapalina špeciálne vyvinutá pre sedemstupňové automatické prevodovky MB (NAG-2) poslednej generácie. Spätne kompatibilná s automatickou prevodovkou, kde sa odporúča špecifikácia MB 236.12.",
    desc: "<b>SCHVÁLENIA:  </b>MB-APPROVAL 236.14, SSANG-YONG",
    ean: 8586011472514,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502809,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX HYPOL 85W140 GL5 10L",
    short_desc:
      "Vysokovýkonné prevodový olej navrhnutý tak, aby poskytoval vynikajúce mazanie v širokej škále automobilových prevodoviek, náprav a konečných pohonov. Je založený na kvalitnom rafinovanom základnom oleji v kombinácii so špeciálnym balíkom aditív.",
    desc: "<b>VISKOZITA</b>:  85W-140 <b>VÝKONNOSTNÝ PROFIL: </b> API GL-5 <b>SCHVÁLENIA:</b> MIL-L-2105D, MAN 342 M2, ZF TE-ML 05A, 07A, 12E, 16B/C/D, 17B, 19B, 21A",
    ean: 8586011472668,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502819,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX HYPOL 75W80 GL 4 10L",
    short_desc:
      "Vysoko kvalitná syntetická kvapalina špeciálne navrhnutá s pokročilou technológiou pre širokú škálu vozidiel. Prevyšuje komplexné požiadavky výrobcov automatických prevodoviek.",
    desc: "Vysoko kvalitná syntetická kvapalina špeciálne navrhnutá s pokročilou technológiou pre širokú škálu vozidiel. Prevyšuje komplexné požiadavky výrobcov automatických prevodoviek.",
    ean: 8586011472361,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502820,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX HYPOL 75W80 GL 4  20L",
    short_desc:
      "Vysoko kvalitná syntetická kvapalina špeciálne navrhnutá s pokročilou technológiou pre širokú škálu vozidiel. Prevyšuje komplexné požiadavky výrobcov automatických prevodoviek.",
    desc: "Vysoko kvalitná syntetická kvapalina špeciálne navrhnutá s pokročilou technológiou pre širokú škálu vozidiel. Prevyšuje komplexné požiadavky výrobcov automatických prevodoviek.",
    ean: 8586011472606,
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502830,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX SCREENWASH -20 0,25L",
    short_desc: "",
    desc: 0,
    ean: 8586011472378,
    package: 24,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502832,
    brand: "DYNAMAX",
    image: "img81853",
    src: "81853.jpg",
    name: "DYNAMAX ZIMNÉ ADITÍVUM DO BENZÍNU 300ML",
    short_desc:
      "Slúži ako prevencia usadzovania vody v palivovom systéme benzínových motorových vozidiel a následnému zamedzeniu tvorby mikrokryštálov ľadu. Vďaka svojmu zloženiu znižuje koróziu a kyslosť vzniknutú oxidáciou.",
    desc: 'Pred zimou určite z každej strany počúvate o dobrých vlastnostiach aditív do naftových motorov. Ale čo tie benzínové? Nezaslúžia si tiež nejaké lepšie palivo, prípadne vylepšené vlastnosti, ktorými môžete motoru dopomôcť k lepšiemu spaľovaniu? Určite. Zimné aditívum do benzínu môžu prospieť nielen vášmu motoru, ale v konečnom dôsledku aj peňaženke. Následná oprava palivového systému totiž môže výrazne zaťažiť rodinný rozpočet. Zážihový (benzínový) motor v zime nie je na studený štart taký náročný. Okrem “žhavičov” tiež nepotrebuje prekonať takú vysokú kompresiu. Benzínový motor tak má omnoho ľahšie štartovanie, avšak prečo mu s tým ešte nepomôcť? Minimálne napríklad znížením obsahu vody v palive. <img class="alignnone size-large wp-image-4957" src="https://www.dynamaxoil.com/wp-content/uploads/2018/11/1542569156-2018.dynamax.gasoline.winter.aditive.00-1-1024x768.jpg" alt="" width="1024" height="768" /> Práve <a href="https://www.dynamaxoil.com/produkt/dynamax-zimne-aditivum-do-benzinu/">zimné aditívum DYNAMAX do benzínu</a> ktoré komerčne predávajú pod anglickým označením Gasoline Winter Additive zamedzuje tvorbe mikrokryštálov ľadu. Slúži tak na prevenciu pred usadzovaním vody v palivovom systéme, čo je príznačné pre zimné obdobie a krátke trasy. Ďalej tiež znižuje koróziu celého systému a kyslosť vzniknutú oxidáciou. Práve voda je najväčším strašiakom benzínových motorov v zime. <img class="alignnone size-large wp-image-4959" src="https://www.dynamaxoil.com/wp-content/uploads/2018/11/1542569174-2018.dynamax.gasoline.winter.aditive.06-1-1024x768.jpg" alt="" width="1024" height="768" /> <h4>Benzín u nás nezamrzne, voda áno</h4> Samotný benzín totiž v našich podmienkach nezamŕza. To by museli teploty klesať pod -45 °C, čo je v našich podmienkach nereálne a vplyvom stále teplejšieho počasia už skoro úplne vylúčené. Problémom je tak spomínaná voda, ktorá sa v palive môže objaviť najprv natankovaním z nádrží alebo aj kondenzáciou, keď poklesom teploty samotné molekuly vody prechádzajú z plynného na kvapalné skupenstvo. <a href="https://www.dynamaxoil.com/produkt/dynamax-zimne-aditivum-do-benzinu/" class="fusion-no-lightbox"><img class="size-full wp-image-4960 aligncenter" src="https://www.dynamaxoil.com/wp-content/uploads/2018/11/1542215162-dynamax.1-1.jpg" alt="" width="583" height="557" /></a> <div class="clearfix editor adblock"> <div class="c_image_wide"> <p class="image_text">Zimné aditívum do benzínu od DYNAMAX chráni pred koróziou a zabraňuje tvorbe mikrokryštálov ľadu. </div> </div> <div class="clearfix editor block adblock">Pridávaním aditíva aj do benzínového motora tak prospievate jeho dlhšej životnosti a môžete zlepšiť jeho vlastnosti. Okrem aditív do benzínu pre zimné obdobie ponúka DYNAMAX aj aditíva do benzínu na čistenie vstrekovačov, na čistenie palivového systému alebo na zvýšenie oktánového čísla.</div>',
    ean: 8586011472385,
    package: 6,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502850,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX COOL AL 11 4L-37 BLUE",
    short_desc: "",
    desc: 0,
    ean: 8586011472477,
    package: 3,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502854,
    brand: "DYNAMAX",
    image: "img86322",
    src: "86322.jpg",
    name: "DYNAMAX ADBLUE 1,5L",
    short_desc:
      "Vodný roztok močoviny s vysokou chemickou čistotou podla ISO 22241 pre prevádzku SCR katalyzátorov. AdBlue do použitých obalov (napr. od pohonných hmôt, prevádzkových kvapalín).",
    desc: "Vodný roztok močoviny s vysokou chemickou čistotou podla ISO 22241 pre prevádzku SCR katalyzátorov. Pokyny a doporučenia: Skladujte pri teplote od -5°C do +25°C. Neskladujte na priamom slnku. Skladujte iba v tomto originálnom obale. Nikdy neprelievajte AdBlue do použitých obalov (napr. od pohonných hmôt, prevádzkových kvapalín). Nebezpečenstvo kontaminácie AdBlue a poškodenie katalyzátora. Minimálna trvanlivosť: 1 rok od dátumu výroby.",
    ean: 8586011472422,
    package: 8,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502878,
    brand: "DYNAMAX",
    image: "img107998",
    src: "107998.jpg",
    name: "DYNAMAX GOLDLINE FUEL ECO 0W-16 4L",
    short_desc:
      "Vysoko kvalitný plnesyntetický motorový olej určený na použitie v benzínových a dieselových motoroch osobných automobilov vybavených s alebo bez turbopreplňovania a priameho vstrekovania.",
    desc: "Vysoko kvalitný plnesyntetický motorový olej určený na použitie v benzínových a dieselových motoroch osobných automobilov vybavených s alebo bez turbopreplňovania a priameho vstrekovania. Olej je špeciálne vyvinutý pre hybridné motory. Vyznačuje sa vynikajúcim štartom za studena a minimalizáciou spotreby paliva, trenia a opotrebenia.",
    ean: 8586011472521,
    package: 3,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502898,
    brand: "DYNAMAX",
    image: "img108101",
    src: "108101.jpg",
    name: "DYNAMAX PREMIUM ULTRA GMD 5W30 60L",
    short_desc:
      "Motorový olej vyrobený na báze 100% syntetickej technológie špeciálne vyvinutý pre najnovšiu generáciu benzínových a dieselových Opel/GM motorov vyžadujúcich normu GM dexos 2.",
    desc: "Je spätne kompatibilný s motormi, ktoré vyžadujú normu oleja GM-LL-A-025/B-025. Výkonnostný profil: API SN/CF, ACEA A3/B4, C3 Schválenia: GM DEXOS, 2 MB 229.51, BMW LL-04, VW 502 00/505 00",
    ean: 8586011472545,
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502908,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX SUPER 40 1L",
    short_desc:
      "Olej vyrobený na báze minerálnych základových olejov určený pre ťažko namáhané motory nákladných automobilov, stavebnej a poľnohospodárskej techniky.",
    desc: "Olej vyrobený na báze minerálnych základových olejov určený pre ťažko namáhané motory nákladných automobilov, stavebnej a poľnohospodárskej techniky. VISKOZITA: 40 TRIEDA KVALITY: API CF-4/SG; ACEA E2 SCHVÁLENIA: MB 228.0, MAN 270",
    ean: 8586011472583,
    package: 12,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502910,
    brand: "DYNAMAX",
    image: "img108124",
    src: "108124.jpg",
    name: "DYNAMAX PREMIUM ULTRA GMD 5W30 209L",
    short_desc:
      "Motorový olej vyrobený na báze 100% syntetickej technológie špeciálne vyvinutý pre najnovšiu generáciu benzínových a dieselových Opel/GM motorov vyžadujúcich normu GM dexos 2.",
    desc: "Je spätne kompatibilný s motormi, ktoré vyžadujú normu oleja GM-LL-A-025/B-025. Výkonnostný profil: API SN/CF, ACEA A3/B4, C3 Schválenia: GM DEXOS, 2 MB 229.51, BMW LL-04, VW 502 00/505 00",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502981,
    brand: "DYNAMAX",
    image: "img108085",
    src: "108085.jpg",
    name: "DYNAMAX TURBO PLUS 15W-40 10L",
    short_desc:
      "Dynamax TURBO PLUS je určený pre takmer všetky typy motorových benzínových i naftových štvortaktných motorov,a to nepreplňovaných ako aj preplňovaných, vrátane motorov s katalyzátorom.",
    desc: 0,
    ean: 8586011472897,
    package: "",
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502990,
    brand: "DYNAMAX",
    image: "img108135",
    src: "108135.jpg",
    name: "DYNAMAX SCREENWASH -20 3L CITRÓN",
    short_desc:
      "Je vysoko účinná, celoročná mrazuvzdorná kvapalina do všetkých typov ostrekovačov motorových vozidiel.",
    desc: '<div id="dokument" class="obsah"> <div id="dynvideo" class="editor">DYNAMAX Screenwash -20 °C je nemrznúca kvapalina do ostrekovačov automobilov. Spoľahlivo odstraňuje zo skla automobilu mastnotu a iné nečistoty. Chráni ostrekovací systém pred zamŕzaním a vytváraním vodného kameňa. Zlepšuje viditeľnosť počas nepriaznivého zimného počasia. DYNAMAX Screenwash -20 °C sa používa neriedený alebo po nariedení podľa tabuľky.Doporučené pomery riedenia:Neriedený – použitie do -20°C;5 dielov DYNAMAX Screenwash -20 °C: 1 diel voda -použitie do -15°C5 dielov DYNAMAX Screenwash -20 °C: 2 diely voda – použitie do -10°C5 dielov DYNAMAX Screenwash -20 °C: 8,5 dielu voda – použitie do -5°C</div> </div>',
    ean: 8586011472903,
    package: 4,
    type: "olej",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 601433,
    brand: "DYNAMAX",
    image: "img7427",
    src: "7427.jpg",
    name: "DYNAMAX ZAPALOVAČ PIEZOELEKTRICKÝ",
    short_desc: "Kvalitný a dizajnovo zaujímavý zapalovač s logom Dynamax.",
    desc: "Kvalitný a dizajnovo zaujímavý zapalovač s logom Dynamax.",
    ean: 8590379317950,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 601536,
    brand: "DRACO",
    image: "img7435",
    src: "7435.jpg",
    name: "DRACO DREVENÉ UHLIE 2,5KG",
    short_desc:
      "Vhodné pre všetky typy grilov na drevené uhlie a brikety. Balené v papierových vreckách.",
    desc: "Vhodné pre všetky typy grilov na drevené uhlie a brikety. Balené v papierových vreckách.",
    ean: 8586011471609,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 601669,
    brand: "DRACO",
    image: "img7465",
    src: "7465.jpg",
    name: "DRACO GRILOVACIE BRIKETY 2,5KG",
    short_desc:
      "Vhodné pre všetky typy grilov na drevené uhlie a brikety. Balené v papierových vreckách.",
    desc: "Vhodné pre všetky typy grilov na drevené uhlie a brikety. Balené v papierových vreckách.",
    ean: 8586016010353,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 601838,
    brand: "DRACO",
    image: "img7515",
    src: "7515.jpg",
    name: "DRACO KRBOVÉ DREVO BUK 15DM3",
    short_desc:
      "Krbové a palivové drevo. Vhodné do krbov, kozubov, na opekanie alebo kúrenie.",
    desc: "Krbové a palivové drevo. Vhodné do krbov, kozubov, na opekanie alebo kúrenie.",
    ean: 8586011470176,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 601840,
    brand: "DRACO",
    image: "img7516",
    src: "7516.jpg",
    name: "DRACO TRIESKY NA PODPAĽOVANIE 1,5KG",
    short_desc: "Drevené triesky na založenie ohňa.",
    desc: "Drevené triesky na založenie ohňa.",
    ean: 8586011470343,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 601887,
    brand: "DRACO",
    image: "img7539",
    src: "7539.jpg",
    name: "DRACO KRBOVÉ DREVO BREZA 15DM3",
    short_desc:
      "Krbové a palivové drevo. Vhodné do krbov, kozubov, na opekanie alebo kúrenie.",
    desc: "Krbové a palivové drevo. Vhodné do krbov, kozubov, na opekanie alebo kúrenie.",
    ean: 8586011470183,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 601939,
    brand: "DRACO",
    image: "img7551",
    src: "7551.jpg",
    name: "DRACO TRIESKY NA PODPAĽOVANIE 2KG",
    short_desc: "Drevené triesky na založenie ohňa.",
    desc: "Drevené triesky na založenie ohňa.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 602185,
    brand: "DRACO",
    image: "img7626",
    src: "7626.jpg",
    name: "DRACO PODPAĽOVAČ TEKUTÝ 1L",
    short_desc:
      "Prípravok sa používa na podpaľovanie dreveného uhlia, brikiet alebo iného pevného paliva. Horí bez sadzí a zápachu. Vhodný je aj do záhradných a jednorazových grilov.",
    desc: "Prípravok sa používa na podpaľovanie dreveného uhlia, brikiet alebo iného pevného paliva. Horí bez sadzí a zápachu. Vhodný je aj do záhradných a jednorazových grilov.",
    ean: 8586016010377,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 602524,
    brand: "DYNAMAX",
    image: "img82482",
    src: "82482.jpg",
    name: "DXC3-PNEUPASTA  5L",
    short_desc:
      "Pasta na uľahčenie montáže a demontáže plášťov motorových vozidiel. Pasta nepoškodzuje gumu a lak.",
    desc: "Pasta na uľahčenie montáže a demontáže plášťov motorových vozidiel. Ráfik očistite od hrdze a nečistôt. Plochým štetcom naneste po celom obvode plášťa a ráfika, čím uľahčíte ich vzájomný pohyb. Po práci umyte pokožku a ošetrite reparačným krémom. Pasta nepoškodzuje gumu a lak.",
    ean: 8586016012074,
    package: "",
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 602606,
    brand: "DYNAMAX",
    image: "img101474",
    src: "101474.jpg",
    name: "DXC2-PNEUGEL  5KG",
    short_desc:
      "Prípravok na uľahčenie montáže a demontáže plášťov motorových vozidiel. Gél nepoškodzuje gumu a lak.",
    desc: "Prípravok na uľahčenie montáže a demontáže plášťov motorových vozidiel. Ráfik očistite od hrdze a nečistôt. Plochým štetcom naneste po celom obvode plášťa a ráfika, čím uľahčíte ich vzájomný pohyb. Po práci umyte pokožku a ošetrite reparačným krémom. Gél nepoškodzuje gumu a lak.",
    ean: 8586016012067,
    package: "",
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 603358,
    brand: "DYNAMAX",
    image: "img80559",
    src: "80559.jpg",
    name: "DYNAMAX HUBKA NA AUTO",
    short_desc: "Hubka na auto žltej farby, možnosť všestranného použitia.",
    desc: "Hubka na auto žltej farby, možnosť všestranného použitia.",
    ean: 8594016390221,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 603453,
    brand: "DYNAMAX",
    image: "img7901",
    src: "7901.jpg",
    name: "DXC7-PRÍPRAVOK DO UMÝVACÍCH STOLOV 20L",
    short_desc:
      "Prípravok DYNAMAX FLUID TO WASH TABLES je vhodný pre použitie do umývacích stolov a pračiek pre opakované umývanie.",
    desc: "Prípravok DYNAMAX FLUID TO WASH TABLES je vhodný pre použitie do umývacích stolov a pračiek pre opakované umývanie. Neriedený prípravok sa naleje do zásobnej nádržky. Znečistené časti sa umývajú pomocou čistiacej kefy alebo ponorením do prípravku. Doba pôsobenia na odmasťovaný predmet závisí od stupňa a druhu znečistenia. Po odmastení sa povrch ošetrí čistou suchou tkaninou. Viac sa neoplachuje.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 603454,
    brand: "DYNAMAX",
    image: "img11004",
    src: "11004.jpg",
    name: "DYNAMAX ČISTIČ  BŔZD 25 L",
    short_desc:
      "Čistič na brzdy DYNAMAX: prostriedok určený na čistenie brzdových kotúčov a bubnov automobilu od firmy Dynamax čistič na brzdy s extra silnými rozpúšťacími vlastnosťami pre čistenie a odmasťovanie brzdových, spojkových, prevodových a palivových častí vozidla vlastnosti výrobku.",
    desc: "Čistič na brzdy DYNAMAX: prostriedok určený na čistenie brzdových kotúčov a bubnov automobilu od firmy Dynamax čistič na brzdy s extra silnými rozpúšťacími vlastnosťami pre čistenie a odmasťovanie brzdových, spojkových, prevodových a palivových častí vozidla vlastnosti výrobku: má antikorózny účinok, nezanecháva zvyšky a je nevodivý rýchlo a účinne odstraňuje brzdovú kvapalinu, tuk, olej a ďalšie znečisťujúce látky zo súčastí bŕzd a spojok odmasťuje okamžite znižuje škrípanie kotúčových bŕzd.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "brzdovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 603610,
    brand: "DYNAMAX",
    image: "img7919",
    src: "7919.jpg",
    name: "DYNAMAX STOJAN",
    short_desc:
      "Dynamax stojan so štyrmi poličkami a hákmi po bokoch – obojstranný.",
    desc: "Dynamax stojan so štyrmi poličkami a hákmi po bokoch – obojstranný.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 604168,
    brand: "DYNAMAX",
    image: "img8010",
    src: "8010.jpg",
    name: "DYNAMAX AUTOLEKÁRNIČKA",
    short_desc: "Autolekárnička pre osobnú aj nákladnú dopravu.",
    desc: "Autolekárnička pre osobnú aj nákladnú dopravu.",
    ean: 8592038100132,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 605903,
    brand: "DYNAMAX",
    image: "img8165",
    src: "8165.jpg",
    name: "DYNAMAX LTA 2 EP 9 KG",
    short_desc:
      "Dynamax LTA 2EP je vysokovýkonné viacúčelové lítiové plastické mazivo, ktoré obsahuje antioxidačné prísady zlepšujúce antikorózne vlastnosti a tiež prísady proti vysokým tlakom (EP).",
    desc: "Dynamax LTA 2EP je vysokovýkonné viacúčelové lítiové plastické mazivo, ktoré obsahuje antioxidačné prísady zlepšujúce antikorózne vlastnosti a tiež prísady proti vysokým tlakom (EP). Je určené na mazanie valivých ložísk, pracujúcich pri vysokom zaťažení a vysokých tlakoch pri použití axiálnej i radiálnej sily (valcovne, lisy,drviče). Mazivo je tiež vhodné na mazanie ložísk centrálnych mazacích systémov. Doporučená prevádzková teplota je od -30°C do +130°C.",
    ean: 8586016011138,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 606135,
    brand: "DYNAMAX",
    image: "img8332",
    src: "8332.jpg",
    name: "DXG1 ČISTIČ NA OKNÁ SPREJ 500ML",
    short_desc:
      "Čistiaci prostriedok na sklo a zrkadlo. Odstraňuje mastnotu, smog, nikotín, hmyz a zvyšky vosku. Zanecháva dokonalý lesk bez šmúh a je príjemne parfumovaný. Čistiaca odmasťovacia pena má silné rozpúšťacie vlastnosti.",
    desc: "Čistiaci prostriedok na sklo a zrkadlo. Odstraňuje mastnotu, smog, nikotín, hmyz a zvyšky vosku. Zanecháva dokonalý lesk bez šmúh a je príjemne parfumovaný. Čistiaca odmasťovacia pena má silné rozpúšťacie vlastnosti. Použitie: Naneste rovnomerne na akýkoľvek druh skla alebo zrkadla a potom dosucha vyutierajte suchou handričkou alebo hodvábnym papierom.",
    ean: 8586016012494,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 606136,
    brand: "DYNAMAX",
    image: "img8334",
    src: "8334.jpg",
    name: "DXI1 COCKPIT SPRAY CITRÓN 500ML",
    short_desc:
      "Sprej na čistenie, ochranu a skrášlenie palubnej dosky a iných plastových komponentov v aute. Vlastnosti výrobku: Má jemnú vôňu, čistiaci efekt a trvalý lesk. Pôsobí antistaticky. Obsahuje silikóny.",
    desc: "Sprej na čistenie, ochranu a skrášlenie palubnej dosky a iných plastových komponentov v aute. Vlastnosti výrobku: Má jemnú vôňu, čistiaci efekt a trvalý lesk. Pôsobí antistaticky. Obsahuje silikóny. Vhodná teplota pre použitie: 5 – 30 °C. Použitie: Pred použitím pretrepte. Naneste na suchú, čistú handričku a rozotrite rovnomerne po povrchu, ktorý sa má ošetriť. Potom vyleštiť.",
    ean: 8586016012241,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 606137,
    brand: "DYNAMAX",
    image: "img8335",
    src: "8335.jpg",
    name: "DXI1 COCKPIT SPRAY VANILKA 500ML",
    short_desc:
      "Sprej na čistenie, ochranu a skrášlenie palubnej dosky a iných plastových komponentov v aute. Vlastnosti výrobku: Má jemnú vôňu, čistiaci efekt a trvalý lesk. Pôsobí antistaticky. Obsahuje silikóny.",
    desc: "Sprej na čistenie, ochranu a skrášlenie palubnej dosky a iných plastových komponentov v aute. Vlastnosti výrobku: Má jemnú vôňu, čistiaci efekt a trvalý lesk. Pôsobí antistaticky. Obsahuje silikóny. Vhodná teplota pre použitie: 5 – 30 °C. Použitie: Pred použitím pretrepte. Naneste na suchú, čistú handričku a rozotrite rovnomerne po povrchu, ktorý sa má ošetriť.",
    ean: 8586016012357,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 606138,
    brand: "DYNAMAX",
    image: "img8336",
    src: "8336.jpg",
    name: "DXI1 COCKPIT SPRAY JAHODA 500ML EV0005",
    short_desc:
      "P oužitie: Pred použitím pretrepte. Naneste na suchú, čistú handričku a rozotrite rovnomerne po povrchu, ktorý sa má ošetriť. Potom vyleš",
    desc: "Sprej na čistenie, ochranu a skrášlenie palubnej dosky a iných plastových komponentov v aute. Vlastnosti výrobku: Má jemnú vôňu, čistiaci efekt a trvalý lesk. Pôsobí antistaticky. Obsahuje silikóny. Vhodná teplota pre použitie: 5 – 30 °C.",
    ean: 5707286418783,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 606139,
    brand: "DYNAMAX",
    image: "img8338",
    src: "8338.jpg",
    name: "DXI2 UNI.CISTIC INT.SPREJ 500ML",
    short_desc:
      "Použitie: Aerosól by mal mať izbovú teplotu. Pred použitím pretrepte. Aplikujte a nechajte pôsobiť 1–2 minúty. Nečistoty odstráňte č",
    desc: "Účinná, univerzálna čistiaca pena na čistenie plastových a látkových častí interiéru a imitácií kože. Vlastnosti výrobku: Ľahko sa nanáša, má silné rozpúšťacie vlastnosti a jemnú vôňu.",
    ean: 5707286418790,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 606140,
    brand: "DYNAMAX",
    image: "img8339",
    src: "8339.jpg",
    name: "DXE5 PENA NA PNEUMATIKY 500ML",
    short_desc:
      "Penový čistič na pneumatiky, pena na čistenie a oživenie farby pneumatík. Chráni proti poveternostným vplyvom. Obsahuje silikóny. Neobsahuje rozpúšťadlá.",
    desc: "Penový čistič na pneumatiky, pena na čistenie a oživenie farby pneumatík. Chráni proti poveternostným vplyvom. Obsahuje silikóny. Neobsahuje rozpúšťadlá. Môže byť aplikovaný na mokrých pneumatikách. Aerosól skladujte pri izbových teplotách. Vhodná teplota pre použitie: 5 – 30 ° C. Použitie: Pred použitím pretrepte. Vyhnite sa aplikácii na brzdové diely. Aplikujte v tenkej vrstve, rovnomerne po bokoch pneumatiky.",
    ean: 8586016012210,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 606141,
    brand: "DYNAMAX",
    image: "img8341",
    src: "8341.jpg",
    name: "DXC1-ČISTIČ BŔZD 500ML",
    short_desc:
      "Čistič na brzdy s extra silnými rozpúšťacími vlastnosťami pre čistenie a odmasťovanie brzdových, spojkových, prevodových a palivových častí vozidla. Vlastnosti výrobku: má antikorózny účinok, nezanecháva zvyšky a je nevodivý.",
    desc: "Čistič na brzdy s extra silnými rozpúšťacími vlastnosťami pre čistenie a odmasťovanie brzdových, spojkových, prevodových a palivových častí vozidla. Vlastnosti výrobku: má antikorózny účinok, nezanecháva zvyšky a je nevodivý. Aerosól je pod vysokým tlakom. Použitie: Pred použitím pretrepte. Zakryte lakované a plastové komponenty. Aplikujte na súčiastky pokiaľ nečistoty nezmiznú.",
    ean: 8586016012197,
    package: 6,
    type: "olej",
    sub_category: "brzdovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 606142,
    brand: "DYNAMAX",
    image: "img8342",
    src: "8342.jpg",
    name: "DXT1-SPREJ NA DEFEKTY 400ML",
    short_desc:
      "Sprej na gumenej báze pre núdzové opravy na bezdušových aj dušových pneumatikách. Môže sa použiť bez demontovania pneumatiky.",
    desc: "Sprej na gumenej báze pre núdzové opravy na bezdušových aj dušových pneumatikách. Môže sa použiť bez demontovania pneumatiky. Teplota použitia je 5 – 30 °C. Použitie: Pred použitím pretrepte. Odstráňte predmet, ktorý spôsobil defekt. Držte sprej vo vertikálnej polohe, obrátený ventilom dolu.",
    ean: 8586016012234,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 606143,
    brand: "DYNAMAX",
    image: "img8343",
    src: "8343.jpg",
    name: "DXT2-SILIKONOVÝ SPREJ 400ML",
    short_desc:
      "Silikónový sprej určený na premazanie a ochranu plastových, kovových alebo gumených komponentov. Vlastnosti výrobku: Zabraňuje škrípaniu, pískaniu a korózii. Zabraňuje zamrznutiu a vysušeniu. Má vynikajúcu mechanickú a tepelnú stabilitu, je vodeodolný.",
    desc: "Silikónový sprej určený na premazanie a ochranu plastových, kovových alebo gumených komponentov. Vlastnosti výrobku: Zabraňuje škrípaniu, pískaniu a korózii. Zabraňuje zamrznutiu a vysušeniu. Má vynikajúcu mechanickú a tepelnú stabilitu, je vodeodolný. Použitie: Pred použitím pretrepte. Optimálne premazanie získate po odparení rozpúšťadla.",
    ean: 8586016012203,
    package: 6,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 606144,
    brand: "DYNAMAX",
    image: "img8344",
    src: "8344.jpg",
    name: "DXT3-SPREJ NA KONTAKTY 400ML",
    short_desc:
      "Sprej určený na elektrické kontakty, odpudzuje vlhkosť. Vlastnosti výrobku: Vodeodpudivý, účinne penetruje.",
    desc: "Sprej určený na elektrické kontakty, odpudzuje vlhkosť. Vlastnosti výrobku: Vodeodpudivý. Účinne penetruje. Použitie: Aerosól by mal mať izbovú teplotu. Pred použitím pretrepte. Aplikujte dostatočné množstvo na ošetrované časti. Po vyparení zanecháva priesvitný ochranný film.",
    ean: 8586016012180,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 606321,
    brand: "DYNAMAX",
    image: "img8504",
    src: "8504.jpg",
    name: "DXC4-PRÍPRAVOK NA ODSTRAŇOVANIE HRDZE 5L",
    short_desc:
      "Prípravok slúži na odstraňovanie hrdze. Vytvára tiež ochranný povlak, ktorý zvyšuje odolnosť voči pôsobeniu korózneho prostredia a zlepšuje priľnavosť prípadných náterov aplikovaných na povrch.",
    desc: "Prípravok slúži na odstraňovanie hrdze. Vytvára tiež ochranný povlak, ktorý zvyšuje odolnosť voči pôsobeniu korózneho prostredia a zlepšuje priľnavosť prípadných náterov aplikovaných na povrch. Použitie: Prípravok sa používa neriedený. V prípade povrchov menej poškodených hrdzou sa nariedi s vodou max. v pomere 1:1.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 606636,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX STOJAN KARTÓNOVÝ 2019",
    short_desc: "",
    desc: 0,
    ean: "",
    package: 3,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 606637,
    brand: "DYNAMAX",
    image: "img8521",
    src: "8521.jpg",
    name: "DYNAMAX AK 00EP 9KG",
    short_desc:
      "DYNAMAX AK 00EP je komplexné hlinité plastické mazivo veľmi dobre odolávajuce vode s vynikajúcou priľnavosťou ku kovovým povrchom.",
    desc: "DYNAMAX AK 00EP je komplexné hlinité plastické mazivo veľmi dobre odolávajúce vode s vynikajúcou priľnavosťou ku kovovým povrchom. Určené je na mazanie klzných častí podvozkov automobilov, pomalobežných ozubení, reťazí a klzných ložísk, pracujúcic h pri nízkych rýchlostiach a stredných tlakoch. Teplotný rozsah použitia: od -20 °C do +100 °C.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 606638,
    brand: "DYNAMAX",
    image: "img8522",
    src: "8522.jpg",
    name: "DYNAMAX LTA 3EP 9KG",
    short_desc:
      "Vysokovýkonné viacúčelové lítiové plastické mazivo znižuje opotrebenie a trenie a vynikajúco chráni proti korózii. Dobrá mechanická stálosť umožňuje predĺženú životnosť plastického maziva a tým aj ložiska. Vynikajúce EP vlastnosti a nízke trenie predlžujú životnosť zariadenia.",
    desc: "Vysokovýkonné viacúčelové lítiové plastické mazivo znižuje opotrebenie a trenie a vynikajúco chráni proti korózii. Dobrá mechanická stálosť umožňuje predĺženú životnosť plastického maziva a tým aj ložiska. Vynikajúce EP vlastnosti a nízke trenie predlžujú životnosť zariadenia. Vhodné najmä pre ložiskové aplikácie v mobilnej technike ale aj v priemysle. Odporúčané aj pri zvýšených tlakoch a rýchlostiach. Zvlášť vhodné pre ložiská koľajových vozidiel. Teplotný rozsah použitia: od -30 °C do +1 20 °C (krátkodobo do +140 ° C).",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 606639,
    brand: "DYNAMAX",
    image: "img8523",
    src: "8523.jpg",
    name: "DYNAMAX AK2G 9KG",
    short_desc:
      "DYNAMAX AK 2G je plastické mazivo vyrobené s použitím komplexného hlinitého spevňovadla a vysoko kvalitného rafinovaného základového oleja. Obsahuje antioxidačné prísady zlepšujúce antikorózne vlastnosti, s prídavkom grafitu pre zaistenie elektrickej vodivosti a ochranou proti zadretiu.",
    desc: "DYNAMAX AK 2G je plastické mazivo vyrobené s použitím komplexného hlinitého spevňovadla a vysoko kvalitnéhorafinovaného základového oleja. Obsahuje antioxidacné prísady zlepšujúce antikorózne vlastnosti, s prídavkom grafi tu pre zaistenie elektr ickej vodivosti a ochranou proti zadretiu. Je urcené na mazanie valivých a klznych ložísk, pracujúcich pri zvýšených tlakoch. Doporucená prevádzková teplota je od -25°C do +120°C (pri pravidelnom premazávaní až do +140°C).",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 606640,
    brand: "DYNAMAX",
    image: "img8524",
    src: "8524.jpg",
    name: "DYNAMAX AK2 9KG",
    short_desc:
      "DYNAMAX AK 2 je komplexné hlinité plastické mazivo, ktoré obsahuje antioxidačné prísady zlepšujúce antikorózne vlastnosti.",
    desc: "DYNAMAX AK 2 je komplexné hlinité plastické mazivo, ktoré obsahuje antioxidačné prísady zlepšujúce antikorózne vlastnosti. Je určené na mazanie valivých a klzných ložísk, pracujúcich pri stredných tlakoch. Doporučená prevádzková teplota je od -30 °C do +100°C (pri pravidelnom premazávaní až do +120°C).",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 606643,
    brand: "DYNAMAX",
    image: "img8528",
    src: "8528.jpg",
    name: "DYNAMAX AK2 180KG",
    short_desc:
      "Dynamax AK 2 je komplexné hlinité plastické mazivo, ktoré obsahuje antioxidačné prísady zlepšujúce antikorózne vlastnosti. Je určené na mazanie valivých a kĺznych ložísk, pracujúcich pri stredných tlakoch.",
    desc: "Dynamax AK 2 je komplexné hlinité plastické mazivo, ktoré obsahuje antioxidačné prísady zlepšujúce antikorózne vlastnosti. Je určené na mazanie valivých a kĺznych ložísk, pracujúcich pri stredných tlakoch. Doporučená prevádzková teplota je od -30°C do +100°C (pri pravidelnom premazávaní až do +120°C). S24/25 Zabráňte kontaktu s pokožkou a očami. S60 Tento materiál a príslušná nádoba musia byť zlikvidované ako nebezpečný odpad. S61 Zabráňte uvoľneniu do životného prostredia. Oboznámte sa so špeciálnymi inštrukciami, kartou bezpečnostných údajov.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 606644,
    brand: "DYNAMAX",
    image: "img8530",
    src: "8530.jpg",
    name: "DYNAMAX LTA 3EP 50KG",
    short_desc:
      "Vysokovýkonne viacúčelové litiové plastické mazivo znižuje opotrebenie a trenie a vynikajúco chráni proti korózii. Dobra mechanická stálosť umožňuje predĺženú životnosť plastického maziva a tým aj ložiska.",
    desc: "Vysokovýkonne viacúčelové litiové plastické mazivo znižuje opotrebenie a trenie a vynikajúco chráni proti korózii. Dobra mechanická stálosť umožňuje predĺženú životnosť plastického maziva a tým aj ložiska. Vynikajúce EP vlastnosti a nízke trenie predlžujú životnosť zariadenia. Vhodne najmä pre ložiskové aplikácie v mobilnej technike ale aj v priemysle. Odporúčane aj pri zvýšených tlakoch a rýchlostiach. Zvlášť vhodne pre ložiska koľajových vozidiel. Teplotný rozsah použitia: od -30 ・C do +120 ・C (krátkodobo do +140 C).",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 606645,
    brand: "DYNAMAX",
    image: "img8531",
    src: "8531.jpg",
    name: "DYNAMAX AK2G 50KG",
    short_desc:
      "Dynamax AK 2G je komplexné hlinité plastické mazivo s prídavkom grafitu, ktoré obsahuje antioxidačné prísady zlepšujúce antikorózne vlastnosti.",
    desc: "Dynamax AK 2G je komplexné hlinité plastické mazivo s prídavkom grafitu, ktoré obsahuje antioxidačné prísady zlepšujúce antikorózne vlastnosti. Je určené na mazanie valivých a kĺznych ložísk, pracujúcich pri zvýšených tlakoch. Doporučená prevádzková teplota je od -25°C do +120°C (pri pravidelnom premazávaní až do +140°C). S24/25 Zabráňte kontaktu s pokožkou a očami.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 606646,
    brand: "DYNAMAX",
    image: "img8532",
    src: "8532.jpg",
    name: "DYNAMAX AK2 50KG",
    short_desc:
      "Komplexné hlinité plastické mazivo obsahujúce antioxidačné a antikorózne prísady. Je určené na mazanie valivých a kĺznych ložísk pri prevádzkovej teplote od -30 °C do +100 °C (pri pravidelnom premazávani až do +120 °C).",
    desc: "Komplexné hlinité plastické mazivo obsahujúce antioxidačné a antikorózne prísady. Je určené na mazanie valivých a kĺznych ložísk pri prevádzkovej teplote od -30 °C do +100 °C (pri pravidelnom premazávani až do +120 °C).",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 610112,
    brand: "DYNAMAX",
    image: "img29485",
    src: "29485.jpg",
    name: "DXT4 MULTISPRAY (Multifunkčný sprej) 400ML",
    short_desc:
      "Vysokokvalitný multifunkčný sprej s 360° rozprašovačom. Účinne premazáva, uvoľňuje, zabraňuje korózií a chráni všetky typy mechanických častí.",
    desc: "Vysokokvalitný multifunkčný sprej s 360° rozprašovačom. Účinne premazáva, uvoľňuje, zabraňuje korózií a chráni všetky typy mechanických častí. Odporúča sa pre použitie v dielni, domácnosti, záhradnej technike, autoservisoch a vďaka odolnosti voči vysokým teplotám je tiež vhodný do priemyselných zariadení.",
    ean: 8586016015754,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 610114,
    brand: "DYNAMAX",
    image: "img29107",
    src: "29107.jpg",
    name: "DX MOTOFORCE MAZIVO NA REŤAZ 400ML",
    short_desc:
      "Vysoko výkonné mazivo navrhnuté a testované v závodnom prostredí cestných a terénnych motocyklov. Zaručuje mazací účinok aj pri extra dlhom používaní v náročných podmienkach.",
    desc: "Popis produktu:Vysoko výkonné mazivo navrhnuté a testované v závodnom prostredí cestných a terénnych motocyklov. Zaručuje mazací účinok aj pri extra dlhom používaní v náročných podmienkach. Prenikaním do reťazových ôk a mazaním spojovacích koliesok garantuje vysoký výkon. Chráni pred vodou a prachom. Charakteristika produktu: Vysokoviskózne mazivo pre motocyklové reťaze. Predchádza opotrebeniu. Aerosol by mal mať izbovú teplotu. Pred použitím potraste. Vyčistite reťaz a kolesá prevodu. Naneste rovnomernú vrstvu. Po ošetrení pomaly otáčajte reťazou.",
    ean: 8586016015747,
    package: 6,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 610613,
    brand: "DYNAMAX",
    image: "img10557",
    src: "10557.jpg",
    name: "DYNAMAX ENERGY BLUELINE 44",
    short_desc:
      "Jedná sa o kvalitné autobatérie pôvodom z Rakúska, výrobca Banner GmbH. Ah 44, prúd A 360, rozmery: 210x175x175 (Σ175).",
    desc: "Jedná sa o kvalitné autobatérie pôvodom z Rakúska, výrobca Banner GmbH. Ah 44, prúd A 360, rozmery: 210x175x175 (Σ175).",
    ean: 8586016017406,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 610614,
    brand: "DYNAMAX",
    image: "img10559",
    src: "10559.jpg",
    name: "DYNAMAX ENERGY BLUELINE 55",
    short_desc:
      "Jedná sa o kvalitné autobatérie pôvodom z Rakúska, výrobca Banner GmbH. Ah 55, prúd A 450, rozmery: 241x175x175 (Σ175).",
    desc: "Jedná sa o kvalitné autobatérie pôvodom z Rakúska, výrobca Banner GmbH. Ah 55, prúd A 450, rozmery: 241x175x175 (Σ175).",
    ean: 8586016017413,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 610615,
    brand: "DYNAMAX",
    image: "img10560",
    src: "10560.jpg",
    name: "DYNAMAX ENERGY BLUELINE 62",
    short_desc:
      "Jedná sa o kvalitné autobatérie pôvodom z Rakúska, výrobca Banner GmbH. Ah 62, prúd A 480, rozmery: 241x175x190 (Σ190).",
    desc: "Jedná sa o kvalitné autobatérie pôvodom z Rakúska, výrobca Banner GmbH. Ah 62, prúd A 480, rozmery: 241x175x190 (Σ190).",
    ean: 8586016017420,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 610616,
    brand: "DYNAMAX",
    image: "img10561",
    src: "10561.jpg",
    name: "DYNAMAX ENERGY BLUELINE 74",
    short_desc:
      "Jedná sa o kvalitné autobatérie pôvodom z Rakúska, výrobca Banner GmbH. Ah 72, prúd A 640, rozmery: 278x175x190 (Σ190).",
    desc: "Jedná sa o kvalitné autobatérie pôvodom z Rakúska, výrobca Banner GmbH. Ah 72, prúd A 640, rozmery: 278x175x190 (Σ190).",
    ean: 8586016017437,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 610617,
    brand: "DYNAMAX",
    image: "img10562",
    src: "10562.jpg",
    name: "DYNAMAX ENERGY BLUELINE 95",
    short_desc:
      "Jedná sa o kvalitné autobatérie pôvodom z Rakúska, výrobca Banner GmbH. Ah 95, prúd A 720, rozmery: 354x175x190 (Σ190).",
    desc: "Jedná sa o kvalitné autobatérie pôvodom z Rakúska, výrobca Banner GmbH. Ah 95, prúd A 720, rozmery: 354x175x190 (Σ190).",
    ean: 8586016017444,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 610618,
    brand: "DYNAMAX",
    image: "img10563",
    src: "10563.jpg",
    name: "DYNAMAX ENERGY BLUELINE 140HD",
    short_desc:
      "Jedná sa o kvalitné autobatérie pôvodom z Rakúska, výrobca Banner GmbH. Ah 140, prúd A 760, rozmery: 514x189x195 (Σ220).",
    desc: "Jedná sa o kvalitné autobatérie pôvodom z Rakúska, výrobca Banner GmbH. Ah 140, prúd A 760, rozmery: 514x189x195 (Σ220).",
    ean: 8586016017451,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 610619,
    brand: "DYNAMAX",
    image: "img10565",
    src: "10565.jpg",
    name: "DYNAMAX ENERGY BLUELINE 180HD",
    short_desc:
      "Jedná sa o kvalitné autobatérie pôvodom z Rakúska, výrobca Banner GmbH. Ah 180, prúd A 950, rozmery: 514x223x195 (Σ220).",
    desc: "Jedná sa o kvalitné autobatérie pôvodom z Rakúska, výrobca Banner GmbH. Ah 180, prúd A 950, rozmery: 514x223x195 (Σ220).",
    ean: 8586016017468,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 610823,
    brand: "DYNAMAX",
    image: "img10643",
    src: "10643.jpg",
    name: "DYNAMAX DPF TLAKOVÁ PIŠTOĽ",
    short_desc:
      "Striekacia pištoľ s tlakovou nádobou určená na čistenie filtrov pevných častíc s použitím čistiacej kvapaliny DYNAMAX AIR JET FLUID.",
    desc: "Striekacia pištoľ s tlakovou nádobou určená na čistenie filtrov pevných častíc s použitím čistiacej kvapaliny DYNAMAX AIR JET FLUID. Použitie: Uistite sa, že výfukový systém nemá žiadne úniky a pracuje správne. 1. Demontujte snímač teploty alebo tlaku. 2. Zrieďte kvapalinu s vodou v pomere 1:3 (pri silnejšom znečistení 1:2) 3. Naplňte striekaciu pištoľ kvapalinou a nastavte v nej tlak (2.5-4.0 bar). 4. Naštartujte motor a nechajte ho počas čistenia na voľnobehu. Striekajte produkt v 5 sekundových intervaloch cez demontovaný otvor. Odporúčame použiť min. 500 ml produktu v závislosti od znečistenia. V prípade potreby postup opakujte. 5. Namontujte snímače a vykonajte skúšobnú jazdu. Sadze, ktoré boli v priebehu čistenia rozpustené budú spálené počas pravidelnej regenerácie.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 611492,
    brand: "DYNAMAX",
    image: "img23665",
    src: "23665.jpg",
    name: "DXC9 - PRIEMYSELNÝ ČISTIČ RÚK 3,8 L",
    short_desc:
      "Vlastnosti a použitie – Mimoriadne silný čistiaci prostriedok na ruky na odstránenie priemyselnej špiny. Neobsahuje rozpúšťadlá. Pre mimoriadne efektívne čistenie ľahko emulguje so všetkými typmi špiny. Čistí a stará sa o ruky a zabraňuje podráždeniu pokožky. Vyvinuté s príjemnou čerstvou vôňou.",
    desc: "Vlastnosti a použitie – Mimoriadne silný čistiaci prostriedok na ruky na odstránenie priemyselnej špiny. Neobsahuje rozpúšťadlá. Pre mimoriadne efektívne čistenie ľahko emulguje so všetkými typmi špiny. Čistí a stará sa o ruky a zabraňuje podráždeniu pokožky. Vyvinuté s príjemnou čerstvou vôňou.",
    ean: 8586016018397,
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 611509,
    brand: "DYNAMAX",
    image: "img29111",
    src: "29111.jpg",
    name: "DXT6 PENETRAČNÝ OLEJ 400ML",
    short_desc:
      "Účinný nástroj na uvoľnenie zahrdzavených častí. Preniká hlboko do medzier medzi kovom a hrdzavými súčiastkami, ako sú skrutky a matice. Znižuje opotrebenie, trenie a poskytuje ochrannú vrstvu, aby sa zabránila ďalšej korózii/oxidácii.",
    desc: "Popis produktu:Účinný nástroj na uvoľnenie zahrdzavených častí. Preniká hlboko do medzier medzi kovom a hrdzavými súčiastkami, ako sú skrutky a matice. Znižuje opotrebenie, trenie a poskytuje ochrannú vrstvu, aby sa zabránila ďalšej korózii/oxidácii. Charakteristika produktu: Dobrá kvalita prenikania. Obsahuje grafit a MoS2. Odpudzovač vlhkosti. Predchádza hrdzi. Dá sa používať v rôznych polohách. Silný vstrekovací sprej. Pred použitím potraste. Aplikujte prenikajúci olej a nechajte ho zaúčinkovať",
    ean: 8586016018427,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 611510,
    brand: "DYNAMAX",
    image: "img29112",
    src: "29112.jpg",
    name: "DXT7 ŠTARTOVACÍ SPREJ 400ML",
    short_desc:
      "Pomôcka pri poruchách štartovanie s motormi s vnútorným spaľovaním. Bezpečný štart za studena všetkých motorov je možný vďaka špeciálnej kombinácii surovín použitých v spreji.",
    desc: "Pomôcka pri poruchách štartovanie s motormi s vnútorným spaľovaním. Bezpečný štart za studena všetkých motorov je možný vďaka špeciálnej kombinácii surovín použitých v spreji. Štartovací sprej je ideálny pri nízkych teplotách, vo vlhkom počasí alebo po dlhších prestojoch poľnohospodárskych strojov. Sprej chráni ako motor tak aj batériu. Charakteristika produktu: Rýchlo pôsobiaci. Na základe éteru. Pred použitím potraste. Vstrekujte Štart sprej niekoľko sekúnd do prívodu vzduchu na vzduchovom filtri.",
    ean: 8586016018434,
    package: 6,
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 611511,
    brand: "DYNAMAX",
    image: "img29113",
    src: "29113.jpg",
    name: "DXC10 ČISTIČ KARBURÁTORA 400ML",
    short_desc:
      "Na viditeľné časti karburátora, škrtiacu klapku, kanáliky a zachytávače nečistôt (sítka). Špeciálny aktívny čistiaci prostriedok na čistenie typického znečistenia a usadenín na škrtiacej klapke a v sacom priestore spaľovacieho benzínového motora. Zaručuje funkčnosť pohyblivých dielov.",
    desc: "Čistič karburátorov. Na viditeľné časti karburátora, škrtiacu klapku, kanáliky a zachytávače nečistôt (sítka). Špeciálny aktívny čistiaci prostriedok na čistenie typického znečistenia a usadenín na škrtiacej klapke a v sacom priestore spaľovacieho benzínového motora. Zaručuje funkčnosť pohyblivých dielov. Charakteristika produktu : Silné rozpúšťacie vlastnosti. Nezanecháva zvyšky. Nehrdzavie. Aerósol by mal mať izbovú teplotu. Teplota spracovania 5 – 30°C. Motor vychladne a umožní odmontovať vzduchový filter. Sprejujte na exteriér až pokiaľ nečistota nezmizne. Nasprejujte na viditeľné časti interiéru a nechajte pôsobiť. Naštartujte motor. Čistiaci prostriedok niekoľkokrát nastriekajte na prívod vzduchu a zvýšte rýchlosť. Vypnite motor a namontujte vzduchový filter.",
    ean: 8586016018441,
    package: 6,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 611512,
    brand: "DYNAMAX",
    image: "img29114",
    src: "29114.jpg",
    name: "DX MOTOFORCE ČISTIČ RETAZE 400ML",
    short_desc:
      "Vysoko účinný čistič , určený špeciálne na rýchle a bezpečné odstránenie tej najodolnejšej špiny. Jedinečné zloženie produktu si poradí s olejom, tukom a ďalšou špinou, ktorá sa lepí na reťazi. Čistič reťaze možno bez obáv použiť na všetky typy reťazí, vrátane tých, ktoré majú gumové krúžky.",
    desc: "Vysoko účinný čistič , určený špeciálne na rýchle a bezpečné odstránenie tej najodolnejšej špiny. Jedinečné zloženie produktu si poradí s olejom, tukom a ďalšou špinou, ktorá sa lepí na reťazi. Čistič reťaze možno bez obáv použiť na všetky typy reťazí, vrátane tých, ktoré majú gumové krúžky. Charakteristika produktu: Optimálny čistiaci účinok vďaka kombinácii gélovej štruktúry, emulgačných vlastností a pomalej rýchlosti vyparovania. Odstraňuje mazivo a olej. Silné rozpúšťacie vlastnosti. Aerósol by mal mať izbovú teplotu. Pred použitím potraste. Ošetrované súčasti poriadne nastriekajte. Nechajte pôsobiť niekoľko minút a pomaly otáčajte reťazou. Pomocou hadice ostriekajte vodou.",
    ean: 8586016018458,
    package: 6,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 611513,
    brand: "DYNAMAX",
    image: "img32932",
    src: "32932.jpg",
    name: "DXT8 ČISTIČ KLIMATIZÁCIE 400ML",
    short_desc:
      "Účinná pena na čistenie klimatizácie v motorových vozidlách. Neutralizuje zápach od stojacej vody v systéme. Obzvlášť jednoduché a rýchle použitie, auto môže byť po pár minútach opäť schopné prevádzky.",
    desc: "Účinná pena na čistenie klimatizácie v motorových vozidlách. Neutralizuje zápach od stojacej vody v systéme. Obzvlášť jednoduché a rýchle použitie, auto môže byť po pár minútach opäť schopné prevádzky. Spôsob použitia: Pred ošetrovaním elektroinštaláciu vypnite. Pred použitím potraste. Aplikujte na kondenzátor klimatizácie. Vsuňte adaptér do prívodu vzduchu na klimatizácii a plechovku úplne vyprázdnite. Poloha prívodu vzduchu sa líši podľa značky, poraďte sa s predajcom. Po nanesení motor ani elektroinštaláciu aspoň polhodinu nezapínajte. Pena za túto polhodinu klesne a opustí systém ako kvapalina cez výtok pre kondenzovanú vodu.",
    ean: 8586016018465,
    package: 6,
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 611514,
    brand: "DYNAMAX",
    image: "img32933",
    src: "32933.jpg",
    name: "DXC11 EGR CLEANER (ČISTIČ VENTILOV) 400 ML",
    short_desc:
      "Čistič ventilov EGR. Slúži na rozpustenie usadenín vo ventile EGR, systéme prívodu vzduchu, rozvádzacom a plniacom ventile. Slúži na obnovenie prívodu vzduchu do motora, zvýšenie výkonu a akcelerácie a zníženie dymenia výfukových plynov. Zvyšuje životnosť citlivých dielov motora.",
    desc: "Čistič ventilov EGR. Slúži na rozpustenie usadenín vo ventile EGR, systéme prívodu vzduchu, rozvádzacom a plniacom ventile. Slúži na obnovenie prívodu vzduchu do motora, zvýšenie výkonu a akcelerácie a zníženie dymenia výfukových plynov. Zvyšuje životnosť citlivých dielov motora.",
    ean: 8586016018472,
    package: 6,
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 611515,
    brand: "DYNAMAX",
    image: "img32934",
    src: "32934.jpg",
    name: "DXC12 DPF (ČISTIČ)CLEANER 500 ML",
    short_desc:
      "Čistič filtrov pevných častíc naftových motorov Prípravok slúži na uvoľnenie a odstránenie usadenín uhlíka a popola zo systémov filtrov pevných častíc naftových motorov.",
    desc: "Čistič filtrov pevných častíc naftových motorov Prípravok slúži na uvoľnenie a odstránenie usadenín uhlíka a popola zo systémov filtrov pevných častíc naftových motorov. Spôsob použitia: Z filtra demontujte snímač teploty alebo tlaku. Do otvoru za suňte špeciálnu hadičku. Nádobu vyprázdnite v nasledovných intervaloch: streknite 3 – 5 krát a nechajte 5 sekúnd vsakovať. Nainštalujte snímač teploty alebo tlaku. Naštartujte motor a nechajte ho, kým je vozidlo nehybné, asi 15 minút bežať, aby sa väčšina kvapaliny odparila. Vykonajte 30 minútovú skúšobnú jazdu. Vtedy môže dochádzať k vytváraniu pary.",
    ean: 8586016018489,
    package: 6,
    type: "doplnok",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 618497,
    brand: "DYNAMAX",
    image: "img68853",
    src: "68853.jpg",
    name: "DXI5 VLHČENÉ  UTIERKY NA INTERIÉR 24KS",
    short_desc:
      "Vysoko účinné univerzálne čistiace utierky, ktoré bezpečne odmasťujú a odstraňujú nečistoty z plastových a gumených povrchov, skla, kovu, imitácie kože, mechanických dielov, smaltovaného, či lakovaného povrchu a iných materiálov. Výborné na čistenie textilných častí interiéru, nezanechávajú fľaky. Príjemne parfumované.",
    desc: "Vysoko účinné univerzálne čistiace utierky, ktoré bezpečne odmasťujú a odstraňujú nečistoty z plastových a gumených povrchov, skla, kovu, imitácie kože, mechanických dielov, smaltovaného, či lakovaného povrchu a iných materiálov. Výborné na čistenie textilných častí interiéru, nezanechávajú fľaky. Príjemne parfumované. Nepoužívať na volant alebo riadiacu páku.",
    ean: 8586011472002,
    package: 10,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 618502,
    brand: "DYNAMAX",
    image: "img68970",
    src: "68970.jpg",
    name: "DXT9 VLHČENÉ UTIERKY NA RUKY 24KS",
    short_desc:
      "Dynamax - Vlhčené utierky určené na umytie,osvieženie, a ošetrenie rúk. Ľahko odstraňujú mastnotu, špinu a pot z rúk. Zanechávajú vláčnu a jemnú pokožku.",
    desc: "Dynamax - Vlhčené utierky určené na umytie,osvieženie, a ošetrenie rúk. Ľahko odstraňujú mastnotu, špinu a pot z rúk. Zanechávajú vláčnu a jemnú pokožku.",
    ean: 8586011472019,
    package: 10,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 618503,
    brand: "DYNAMAX",
    image: "img68854",
    src: "68854.jpg",
    name: "DXG4 VLHČENÉ UTIERKY NA SKLO 24 KS",
    short_desc:
      "Dynamax vlhčené utierky na čistenie skla. Sklo zostane dokonale brilantne čisté a bez šmúh.",
    desc: "Dynamax vlhčené utierky na čistenie skla. Sklo zostane dokonale brilantne čisté a bez šmúh.",
    ean: 8586011472026,
    package: 10,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 618504,
    brand: "DYNAMAX",
    image: "img68851",
    src: "68851.jpg",
    name: "DXI4 VLHČENÉ PLAKOVÉ UTIERKY NA PALUBNÚ DOSKU 24KS",
    short_desc:
      "Utierky sú vhodné na použitie nie len v interiéri, ale aj na vonkajšie čistenie plastových, gumových častí automobilov. Nevhodné na volant, riadiacu páku a pedále(šmýka sa).",
    desc: "Utierky sú vhodné na použitie nie len v interiéri, ale aj na vonkajšie čistenie plastových, gumových častí automobilov. Nevhodné na volant, riadiacu páku a pedále(šmýka sa). Ideálne na použitie v kombinácii so sprejom PLAK. Dlhotrvajúci povrch bez prachu, zabraňuje vyblednutiu farieb, príjemne vonia. Pôsobí antistaticky.",
    ean: 8586011472033,
    package: 10,
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502460,
    brand: "DYNAMAX",
    image: "img108090",
    src: "108090.jpg",
    name: "DYNAMAX OHHV 46 20L",
    short_desc:
      "Hydraulický olej OHHV 46 je hydrogenačne rafinovaný ropný olej zušľachtený prísadami proti oxidácii, korózii, na zníženie opotrebenia, proti peneniu a na zlepšenie viskozitných vlastností.",
    desc: 0,
    ean: 8586016018526,
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  /*
  {
    id: 503137,
    brand: "DYNAMAX",
    image: "img2000001",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/7/9/108479.jpg",
    name: "DYNAMAX ŠTARTOVACÍ BALÍČEK",
    short_desc: "Špeciálny štartovací balíček. Použiteľnosť a kvalita.",
    desc: "Špeciálny štartovací balíček 6 technických sprejov s dôrazom na kvalitu a použiteľnosť pre servis vozidiel. Obsahuje: DXT10 KERAMICKÝ SPREJ / CERAMIC SPRAYDXT11 TUK NA BRZDY / BRAKE GREASEDXT12 BIELY TUK / WHITE GREASEDXT13 SUCHÝ TEFLON / PTFE DRY GREASEDXT14 MEDENÝ SPREJ / COPPER SPRAYDXT15 ZMRAZOVAČ / FREEZER",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635522,
    brand: "DYNAMAX",
    image: "img2000002",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/7/6/108476.jpg",
    name: "DYNAMAX ENERGY BLUELINE 180HD",
    short_desc:
      "Autobatérie DYNAMAX ENERGY BLUELINE HD svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy podľa E 50342.",
    desc: "Autobatérie DYNAMAX ENERGY BLUELINE 180HD sú určené pre úžitkové vozidlá pracujúce pod vysokým zaťažením. <ul><li>Ľahká údržba</li> <li>Optimálny pomer ceny a výkonu</li> <li>Vysoko odolné a odolávajúce otrasom</li> <li>Spoľahlivé pri studenom štarte</li> <li>Šetrné k životnému prostrediu</li> </ul>Autobatérie sú vybavené vakovými separátormi pre ochranu proti spätnému zážihu a pre zaistenie vysokých úrovní štartovacieho prúdu. Vďaka robustnému dizajnu sú odolné proti vibráciám. Ich údržba je jednoduchá, vďaka externe viditeľným značkám hladiny elektrolytu a praktickým skrutkám. Využitie:Nákladné automobilyAutobusyPoľnohospodárska technikaStavebná technika  <table><tbody><tr><td>Kapacita batérie:</td> <td>180 Ah</td> </tr><tr><td>Prúd:</td> <td>950 A (EN)</td> </tr><tr><td>Napätie:</td> <td>12V</td> </tr><tr><td>Typ pólov:</td> <td>1 (štandard)</td> </tr><tr><td>Polarita:</td> <td>3 (oba póly na ľavej strane)</td> </tr><tr><td>Dĺžka:</td> <td>514 mm</td> </tr><tr><td>Šírka:</td> <td>223 mm</td> </tr><tr><td>Výška:</td> <td>220 mm</td> </tr><tr><td>Typ uchytenia:</td> <td>B00</td> </tr><tr><td>Záručná doba:</td> <td>12 mesiacov</td> </tr></tbody></table>",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635521,
    brand: "DYNAMAX",
    image: "img2000003",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/7/5/108475.jpg",
    name: "DYNAMAX ENERGY BLUELINE 140HD",
    short_desc:
      "Autobatérie DYNAMAX ENERGY BLUELINE HD svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy podľa E 50342.",
    desc: "Autobatérie DYNAMAX ENERGY BLUELINE 140HD sú určené pre úžitkové vozidlá pracujúce pod vysokým zaťažením. <ul><li>Ľahká údržba</li> <li>Optimálny pomer ceny a výkonu</li> <li>Vysoko odolné a odolávajúce otrasom</li> <li>Spoľahlivé pri studenom štarte</li> <li>Šetrné k životnému prostrediu</li> </ul> Autobatérie sú vybavené vakovými separátormi pre ochranu proti spätnému zážihu a pre zaistenie vysokých úrovní štartovacieho prúdu. Vďaka robustnému dizajnu sú odolné proti vibráciám. Ich údržba je jednoduchá, vďaka externe viditeľným značkám hladiny elektrolytu a praktickým skrutkám. Využitie:Nákladné automobilyAutobusyPoľnohospodárska technikaStavebná technika  <table><tbody><tr><td>Kapacita batérie:</td> <td>140 Ah</td> </tr><tr><td>Prúd:</td> <td>760 A (EN)</td> </tr><tr><td>Napätie:</td> <td>12V</td> </tr><tr><td>Typ pólov:</td> <td>1 (štandard)</td> </tr><tr><td>Polarita:</td> <td>3 (oba póly na ľavej strane)</td> </tr><tr><td>Dĺžka:</td> <td>514 mm</td> </tr><tr><td>Šírka:</td> <td>189 mm</td> </tr><tr><td>Výška:</td> <td>220 mm</td> </tr><tr><td>Typ uchytenia:</td> <td>B00</td> </tr><tr><td>Záručná doba:</td> <td>12 mesiacov</td> </tr></tbody></table>",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635520,
    brand: "DYNAMAX",
    image: "img2000004",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/7/4/108474.jpg",
    name: "DYNAMAX ENERGY BLUELINE 95AH",
    short_desc:
      "Autobatérie DYNAMAX ENERGY BLUELINE svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy podľa E 50342. Sú dostupné na trhu veľmi žiadaných typoch od 44 do 95 Ah. Záručná doba 30 mesiacov.",
    desc: "Autobatérie DYNAMAX ENERGY BLUELINE 95 sú vyvinuté vďaka modernej technológii na báze čistého vápnika, vďaka čomu sú úplne bez-údržbové. Vybavené štvorkomorovou ochranou proti úniku elektrolytu, aby ani pri extrémnych vibráciách nedošlo k vytečeniu batériovej kyseliny. O optimálnu prevádzkovú bezpečnosť sa stará centrálne odplynovanie a zabudovaná ochrana (privarená frita) proti spätnému zápalu a ochrana proti elektrostatickému výboju (ESD). Všetky spomenuté vlastnosti potvrdzujú kvalitu a zvýšenú bezpečnosť batérií v prevádzke. <ul><li>Batérie sú bez-údržbové</li> <li>Optimálny pomer ceny a výkonu</li> <li>Vysoko odolné a odolávajúce otrasom</li> <li>Pevné a odolné proti úniku elektrolytu</li> <li>Spoľahlivé pri studenom štarte</li> <li>Šetrné k životnému prostrediu</li> </ul>Využitie:Osobné automobily Dodávky Motorové člny  <table><tbody><tr><td>Kapacita batérie:</td> <td>95 Ah</td> </tr><tr><td>Prúd:</td> <td>720 A (EN)</td> </tr><tr><td>Napätie:</td> <td>12V</td> </tr><tr><td>Typ pólov:</td> <td>1 (štandard)</td> </tr><tr><td>Polarita:</td> <td>0 (+P)</td> </tr><tr><td>Dĺžka:</td> <td>354 mm</td> </tr><tr><td>Šírka:</td> <td>175 mm</td> </tr><tr><td>Výška:</td> <td>190 mm</td> </tr><tr><td>Typ uchytenia:</td> <td>B13</td> </tr><tr><td>Záručná doba:</td> <td>30 mesiacov</td> </tr></tbody></table>",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635519,
    brand: "DYNAMAX",
    image: "img2000005",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/7/3/108473.jpg",
    name: "DYNAMAX ENERGY BLUELINE 74AH",
    short_desc:
      "Autobatérie DYNAMAX ENERGY BLUELINE svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy podľa E 50342. Sú dostupné na trhu veľmi žiadaných typoch od 44 do 95 Ah. Záručná doba 30 mesiacov.",
    desc: "Autobatérie DYNAMAX ENERGY BLUELINE 74 sú vyvinuté vďaka modernej technológii na báze čistého vápnika, vďaka čomu sú úplne bez-údržbové. Vybavené štvorkomorovou ochranou proti úniku elektrolytu, aby ani pri extrémnych vibráciách nedošlo k vytečeniu batériovej kyseliny. O optimálnu prevádzkovú bezpečnosť sa stará centrálne odplynovanie a zabudovaná ochrana (privarená frita) proti spätnému zápalu a ochrana proti elektrostatickému výboju (ESD). Všetky spomenuté vlastnosti potvrdzujú kvalitu a zvýšenú bezpečnosť batérií v prevádzke. <ul><li>Batérie sú bez-údržbové</li> <li>Optimálny pomer ceny a výkonu</li> <li>Vysoko odolné a odolávajúce otrasom</li> <li>Pevné a odolné proti úniku elektrolytu</li> <li>Spoľahlivé pri studenom štarte</li> <li>Šetrné k životnému prostrediu</li> </ul>Využitie:Osobné automobily Dodávky Motorové člny  <table><tbody><tr><td>Kapacita batérie:</td> <td>74 Ah</td> </tr><tr><td>Prúd:</td> <td>640 A (EN)</td> </tr><tr><td>Napätie:</td> <td>12V</td> </tr><tr><td>Typ pólov:</td> <td>1 (štandard)</td> </tr><tr><td>Polarita:</td> <td>0 (+P)</td> </tr><tr><td>Dĺžka:</td> <td>278 mm</td> </tr><tr><td>Šírka:</td> <td>175 mm</td> </tr><tr><td>Výška:</td> <td>190 mm</td> </tr><tr><td>Typ uchytenia:</td> <td>B13</td> </tr><tr><td>Záručná doba:</td> <td>30 mesiacov</td> </tr></tbody></table>",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635518,
    brand: "DYNAMAX",
    image: "img2000006",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/7/2/108472.jpg",
    name: "DYNAMAX ENERGY BLUELINE 62AH",
    short_desc:
      "Autobatérie DYNAMAX ENERGY BLUELINE svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy podľa E 50342. Sú dostupné na trhu veľmi žiadaných typoch od 44 do 95 Ah. Záručná doba 30 mesiacov.",
    desc: "Autobatérie DYNAMAX ENERGY BLUELINE 62 sú vyvinuté vďaka modernej technológii na báze čistého vápnika, vďaka čomu sú úplne bez-údržbové. Vybavené štvorkomorovou ochranou proti úniku elektrolytu, aby ani pri extrémnych vibráciách nedošlo k vytečeniu batériovej kyseliny. O optimálnu prevádzkovú bezpečnosť sa stará centrálne odplynovanie a zabudovaná ochrana (privarená frita) proti spätnému zápalu a ochrana proti elektrostatickému výboju (ESD). Všetky spomenuté vlastnosti potvrdzujú kvalitu a zvýšenú bezpečnosť batérií v prevádzke. <ul><li>Batérie sú bez-údržbové</li> <li>Optimálny pomer ceny a výkonu</li> <li>Vysoko odolné a odolávajúce otrasom</li> <li>Pevné a odolné proti úniku elektrolytu</li> <li>Spoľahlivé pri studenom štarte</li> <li>Šetrné k životnému prostrediu</li> </ul>Využitie:Osobné automobily Dodávky Motorové člny  <table><tbody><tr><td>Kapacita batérie:</td> <td>62 Ah</td> </tr><tr><td>Prúd:</td> <td>480 A (EN)</td> </tr><tr><td>Napätie:</td> <td>12V</td> </tr><tr><td>Typ pólov:</td> <td>1 (štandard)</td> </tr><tr><td>Polarita:</td> <td>0 (+P)</td> </tr><tr><td>Dĺžka:</td> <td>241 mm</td> </tr><tr><td>Šírka:</td> <td>175 mm</td> </tr><tr><td>Výška:</td> <td>190 mm</td> </tr><tr><td>Typ uchytenia:</td> <td>B13</td> </tr><tr><td>Záručná doba:</td> <td>30 mesiacov</td> </tr></tbody></table>",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635516,
    brand: "DYNAMAX",
    image: "img2000007",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/7/1/108471.jpg",
    name: "DYNAMAX ENERGY BLUELINE 55AH",
    short_desc:
      "Autobatérie DYNAMAX ENERGY BLUELINE svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy podľa E 50342. Sú dostupné na trhu veľmi žiadaných typoch od 44 do 95 Ah. Záručná doba 30 mesiacov.",
    desc: "Autobatérie DYNAMAX ENERGY BLUELINE 55 sú vyvinuté vďaka modernej technológii na báze čistého vápnika, vďaka čomu sú úplne bez-údržbové. Vybavené štvorkomorovou ochranou proti úniku elektrolytu, aby ani pri extrémnych vibráciách nedošlo k vytečeniu batériovej kyseliny. O optimálnu prevádzkovú bezpečnosť sa stará centrálne odplynovanie a zabudovaná ochrana (privarená frita) proti spätnému zápalu a ochrana proti elektrostatickému výboju (ESD). Všetky spomenuté vlastnosti potvrdzujú kvalitu a zvýšenú bezpečnosť batérií v prevádzke. <ul><li>Batérie sú bez-údržbové</li> <li>Optimálny pomer ceny a výkonu</li> <li>Vysoko odolné a odolávajúce otrasom</li> <li>Pevné a odolné proti úniku elektrolytu</li> <li>Spoľahlivé pri studenom štarte</li> <li>Šetrné k životnému prostrediu</li> </ul>Využitie:Osobné automobily Dodávky Motorové člny  <table><tbody><tr><td>Kapacita batérie:</td> <td>55 Ah</td> </tr><tr><td>Prúd:</td> <td>450 A (EN)</td> </tr><tr><td>Napätie:</td> <td>12V</td> </tr><tr><td>Typ pólov:</td> <td>1 (štandard)</td> </tr><tr><td>Polarita:</td> <td>0 (+P)</td> </tr><tr><td>Dĺžka:</td> <td>241 mm</td> </tr><tr><td>Šírka:</td> <td>175 mm</td> </tr><tr><td>Výška:</td> <td>175 mm</td> </tr><tr><td>Typ uchytenia:</td> <td>B13</td> </tr><tr><td>Záručná doba:</td> <td>30 mesiacov</td> </tr></tbody></table>",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635515,
    brand: "DYNAMAX",
    image: "img2000008",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/7/0/108470.jpg",
    name: "DYNAMAX ENERGY BLUELINE 44AH",
    short_desc:
      "Autobatérie DYNAMAX ENERGY BLUELINE svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy podľa E 50342. Sú dostupné na trhu veľmi žiadaných typoch od 44 do 95 Ah. Záručná doba 30 mesiacov.",
    desc: "Autobatérie DYNAMAX ENERGY BLUELINE 44 sú vyvinuté vďaka modernej technológii na báze čistého vápnika, vďaka čomu sú úplne bez-údržbové. Vybavené štvorkomorovou ochranou proti úniku elektrolytu, aby ani pri extrémnych vibráciách nedošlo k vytečeniu batériovej kyseliny. O optimálnu prevádzkovú bezpečnosť sa stará centrálne odplynovanie a zabudovaná ochrana (privarená frita) proti spätnému zápalu a ochrana proti elektrostatickému výboju (ESD). Všetky spomenuté vlastnosti potvrdzujú kvalitu a zvýšenú bezpečnosť batérií v prevádzke.  <ul><li>Batérie sú bez-údržbové</li> <li>Optimálny pomer ceny a výkonu</li> <li>Vysoko odolné a odolávajúce otrasom</li> <li>Pevné a odolné proti úniku elektrolytu</li> <li>Spoľahlivé pri studenom štarte</li> <li>Šetrné k životnému prostrediu</li> </ul>Využitie:Osobné automobily Dodávky Motorové člny  <table><tbody><tr><td>Kapacita batérie:</td> <td>44 Ah</td> </tr><tr><td>Prúd:</td> <td>360 A (EN)</td> </tr><tr><td>Napätie:</td> <td>12V</td> </tr><tr><td>Typ pólov:</td> <td>1 (štandard)</td> </tr><tr><td>Polarita:</td> <td>0 (+P)</td> </tr><tr><td>Dĺžka:</td> <td>210 mm</td> </tr><tr><td>Šírka:</td> <td>175 mm</td> </tr><tr><td>Výška:</td> <td>175 mm</td> </tr><tr><td>Typ uchytenia:</td> <td>B13</td> </tr><tr><td>Záručná doba:</td> <td>30 mesiacov</td> </tr></tbody></table>",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635227,
    brand: "DYNAMAX",
    image: "img2000009",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/6/9/108469.jpg",
    name: "DYNAMAX ENERGY BLUELINE 100AH P ASIA",
    short_desc:
      "Autobatérie DYNAMAX BLUELINE ASIA svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy E 50342.",
    desc: "+ Batérie sú bez-údržbové  + Vysoko odolné a odolávajúce otrasom + Pevné a odolné proti úniku elektrolytu + Spoľahlivé s vynikajúcim výkonom + Šetrné k životnému prostrediu   <table><tbody><tr><td>Kapacita batérie:</td> <td></td> <td>100 Ah</td> </tr><tr><td>Prúd:</td> <td></td> <td>720 A (EN)</td> </tr><tr><td>Napätie:</td> <td></td> <td>12V</td> </tr><tr><td>Polarita:</td> <td></td> <td>0 (+P)</td> </tr><tr><td>Dĺžka:</td> <td></td> <td>303 mm</td> </tr><tr><td>Šírka:</td> <td></td> <td>175 mm</td> </tr><tr><td>Výška:</td> <td></td> <td>225 mm</td> </tr><tr><td>Typ uchytenia:</td> <td></td> <td>B01</td> </tr><tr><td>Záručná doba:</td> <td></td> <td>24 mesiacov</td> </tr></tbody></table>   Autobatérie DYNAMAX BLUELINE ASIA sú špeciálne vyvinuté autobatérie, ktoré disponujú špecifickými rozmermi a sú určené pre vozidlá ázijských značiek automobilov (Honda, Mazda, Mitsubishi, Nissan, Suzuki, Toyota a iné.).   Sú navrhnuté tak, aby udržovali správnu hladinu elektrolytu v hornej časti platní pomocou absorbovania objemu kyseliny až o 10 nm alebo aj viac ako konkurenčné autobatérie.   Patentovaný separátor kvapalných plynov zabraňuje stratám elektrolytu, zhromažďovaním a vracaním kvapaliny do zásobníka Nízko-odporové separátory obálok zlepšujú odolnosť proti vibráciám a zabraňujú vnútornému skratu medzi kladnými a zápornými platňami. Vďaka Polypropylénovému obalu je autobatéria mimoriadne pevná, odolná a odoláva nárazom a vibráciám spôsobenými nerovnosťami na cestách. Tepané olovo-vápenaté mriežky sú odolné voči korózii, prebíjaniu, tepelnému úniku a zabezpečujú , že riziko samo-vybíjania je menšie a napomáhajú minimálnemu splynovaniu a spotrebe vody. Vstavaný hydrometer známi ako „magické oko“, ľahko určí stav autobatérie.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635226,
    brand: "DYNAMAX",
    image: "img2000010",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/6/8/108468.jpg",
    name: "DYNAMAX ENERGY BLUELINE 70AH P ASIA",
    short_desc:
      "Autobatérie DYNAMAX BLUELINE ASIA svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy E 50342.",
    desc: "+ Batérie sú bez-údržbové  + Vysoko odolné a odolávajúce otrasom + Pevné a odolné proti úniku elektrolytu + Spoľahlivé s vynikajúcim výkonom + Šetrné k životnému prostrediu   <table><tbody><tr><td>Kapacita batérie:</td> <td></td> <td>70 Ah</td> </tr><tr><td>Prúd:</td> <td></td> <td>600 A (EN)</td> </tr><tr><td>Napätie:</td> <td></td> <td>12V</td> </tr><tr><td>Polarita:</td> <td></td> <td>0 (+P)</td> </tr><tr><td>Dĺžka:</td> <td></td> <td>260 mm</td> </tr><tr><td>Šírka:</td> <td></td> <td>173 mm</td> </tr><tr><td>Výška:</td> <td></td> <td>225 mm</td> </tr><tr><td>Typ uchytenia:</td> <td></td> <td>B01</td> </tr><tr><td>Záručná doba:</td> <td></td> <td>24 mesiacov</td> </tr></tbody></table>   Autobatérie DYNAMAX BLUELINE ASIA sú špeciálne vyvinuté autobatérie, ktoré disponujú špecifickými rozmermi a sú určené pre vozidlá ázijských značiek automobilov (Honda, Mazda, Mitsubishi, Nissan, Suzuki, Toyota a iné.).   Sú navrhnuté tak, aby udržovali správnu hladinu elektrolytu v hornej časti platní pomocou absorbovania objemu kyseliny až o 10 nm alebo aj viac ako konkurenčné autobatérie.   Patentovaný separátor kvapalných plynov zabraňuje stratám elektrolytu, zhromažďovaním a vracaním kvapaliny do zásobníka Nízko-odporové separátory obálok zlepšujú odolnosť proti vibráciám a zabraňujú vnútornému skratu medzi kladnými a zápornými platňami. Vďaka Polypropylénovému obalu je autobatéria mimoriadne pevná, odolná a odoláva nárazom a vibráciám spôsobenými nerovnosťami na cestách. Tepané olovo-vápenaté mriežky sú odolné voči korózii, prebíjaniu, tepelnému úniku a zabezpečujú , že riziko samo-vybíjania je menšie a napomáhajú minimálnemu splynovaniu a spotrebe vody. Vstavaný hydrometer známi ako „magické oko“, ľahko určí stav autobatérie.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635225,
    brand: "DYNAMAX",
    image: "img2000011",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/6/7/108467.jpg",
    name: "DYNAMAX ENERGY BLUELINE 60AH P  ASIA",
    short_desc:
      "Autobatérie DYNAMAX BLUELINE ASIA svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy E 50342.",
    desc: "+ Batérie sú bez-údržbové  + Vysoko odolné a odolávajúce otrasom + Pevné a odolné proti úniku elektrolytu + Spoľahlivé s vynikajúcim výkonom + Šetrné k životnému prostrediu   <table><tbody><tr><td>Kapacita batérie:</td> <td></td> <td>60 Ah</td> </tr><tr><td>Prúd:</td> <td></td> <td>540 A (EN)</td> </tr><tr><td>Napätie:</td> <td></td> <td>12V</td> </tr><tr><td>Polarita:</td> <td></td> <td>0 (+P)</td> </tr><tr><td>Dĺžka:</td> <td></td> <td>232 mm</td> </tr><tr><td>Šírka:</td> <td></td> <td>175 mm</td> </tr><tr><td>Výška:</td> <td></td> <td>225 mm</td> </tr><tr><td>Typ uchytenia:</td> <td></td> <td>B01</td> </tr><tr><td>Záručná doba:</td> <td></td> <td>24 mesiacov</td> </tr></tbody></table>   Autobatérie DYNAMAX BLUELINE ASIA sú špeciálne vyvinuté autobatérie, ktoré disponujú špecifickými rozmermi a sú určené pre vozidlá ázijských značiek automobilov (Honda, Mazda, Mitsubishi, Nissan, Suzuki, Toyota a iné.).   Sú navrhnuté tak, aby udržovali správnu hladinu elektrolytu v hornej časti platní pomocou absorbovania objemu kyseliny až o 10 nm alebo aj viac ako konkurenčné autobatérie.   Patentovaný separátor kvapalných plynov zabraňuje stratám elektrolytu, zhromažďovaním a vracaním kvapaliny do zásobníka Nízko-odporové separátory obálok zlepšujú odolnosť proti vibráciám a zabraňujú vnútornému skratu medzi kladnými a zápornými platňami. Vďaka Polypropylénovému obalu je autobatéria mimoriadne pevná, odolná a odoláva nárazom a vibráciám spôsobenými nerovnosťami na cestách. Tepané olovo-vápenaté mriežky sú odolné voči korózii, prebíjaniu, tepelnému úniku a zabezpečujú , že riziko samo-vybíjania je menšie a napomáhajú minimálnemu splynovaniu a spotrebe vody. Vstavaný hydrometer známi ako „magické oko“, ľahko určí stav autobatérie.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635224,
    brand: "DYNAMAX",
    image: "img2000012",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/6/6/108466.jpg",
    name: "DYNAMAX ENERGY BLUELINE 45AH P ASIA",
    short_desc:
      "Autobatérie DYNAMAX BLUELINE ASIA svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy E 50342.",
    desc: "+ Batérie sú bez-údržbové  + Vysoko odolné a odolávajúce otrasom + Pevné a odolné proti úniku elektrolytu + Spoľahlivé s vynikajúcim výkonom + Šetrné k životnému prostrediu   <table><tbody><tr><td>Kapacita batérie:</td> <td></td> <td>45 Ah</td> </tr><tr><td>Prúd:</td> <td></td> <td>330 A (EN)</td> </tr><tr><td>Napätie:</td> <td></td> <td>12V</td> </tr><tr><td>Typ pólov:</td> <td></td> <td>1 (štandard)</td> </tr><tr><td>Polarita:</td> <td></td> <td>0 (+P)</td> </tr><tr><td>Dĺžka:</td> <td></td> <td>238 mm</td> </tr><tr><td>Šírka:</td> <td></td> <td>129 mm</td> </tr><tr><td>Výška:</td> <td></td> <td>225 mm</td> </tr><tr><td>Typ uchytenia:</td> <td></td> <td>B00</td> </tr><tr><td>Záručná doba:</td> <td></td> <td>24 mesiacov</td> </tr></tbody></table>   Autobatérie DYNAMAX BLUELINE ASIA sú špeciálne vyvinuté autobatérie, ktoré disponujú špecifickými rozmermi a sú určené pre vozidlá ázijských značiek automobilov (Honda, Mazda, Mitsubishi, Nissan, Suzuki, Toyota a iné.).   Sú navrhnuté tak, aby udržovali správnu hladinu elektrolytu v hornej časti platní pomocou absorbovania objemu kyseliny až o 10 nm alebo aj viac ako konkurenčné autobatérie.   Patentovaný separátor kvapalných plynov zabraňuje stratám elektrolytu, zhromažďovaním a vracaním kvapaliny do zásobníka Nízko-odporové separátory obálok zlepšujú odolnosť proti vibráciám a zabraňujú vnútornému skratu medzi kladnými a zápornými platňami. Vďaka Polypropylénovému obalu je autobatéria mimoriadne pevná, odolná a odoláva nárazom a vibráciám spôsobenými nerovnosťami na cestách. Tepané olovo-vápenaté mriežky sú odolné voči korózii, prebíjaniu, tepelnému úniku a zabezpečujú , že riziko samo-vybíjania je menšie a napomáhajú minimálnemu splynovaniu a spotrebe vody. Vstavaný hydrometer známi ako „magické oko“, ľahko určí stav autobatérie.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635223,
    brand: "DYNAMAX",
    image: "img2000013",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/6/5/108465.jpg",
    name: "DYNAMAX ENERGY BLUELINE 35AH P ASIA",
    short_desc:
      "Autobatérie DYNAMAX BLUELINE ASIA svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy E 50342.",
    desc: "+ Batérie sú bez-údržbové  + Vysoko odolné a odolávajúce otrasom + Pevné a odolné proti úniku elektrolytu + Spoľahlivé s vynikajúcim výkonom + Šetrné k životnému prostrediu   <table><tbody><tr><td>Kapacita batérie:</td> <td></td> <td>35 Ah</td> </tr><tr><td>Prúd:</td> <td></td> <td>300 A (EN)</td> </tr><tr><td>Napätie:</td> <td></td> <td>12V</td> </tr><tr><td>Polarita:</td> <td></td> <td>0 (+P)</td> </tr><tr><td>Dĺžka:</td> <td></td> <td>187 mm</td> </tr><tr><td>Šírka:</td> <td></td> <td>127 mm</td> </tr><tr><td>Výška:</td> <td></td> <td>226 mm</td> </tr><tr><td>Typ uchytenia:</td> <td></td> <td>B00</td> </tr><tr><td>Záručná doba:</td> <td></td> <td>24 mesiacov</td> </tr></tbody></table>   Autobatérie DYNAMAX BLUELINE ASIA sú špeciálne vyvinuté autobatérie, ktoré disponujú špecifickými rozmermi a sú určené pre vozidlá ázijských značiek automobilov (Honda, Mazda, Mitsubishi, Nissan, Suzuki, Toyota a iné.).   Sú navrhnuté tak, aby udržovali správnu hladinu elektrolytu v hornej časti platní pomocou absorbovania objemu kyseliny až o 10 nm alebo aj viac ako konkurenčné autobatérie.   Patentovaný separátor kvapalných plynov zabraňuje stratám elektrolytu, zhromažďovaním a vracaním kvapaliny do zásobníka Nízko-odporové separátory obálok zlepšujú odolnosť proti vibráciám a zabraňujú vnútornému skratu medzi kladnými a zápornými platňami. Vďaka Polypropylénovému obalu je autobatéria mimoriadne pevná, odolná a odoláva nárazom a vibráciám spôsobenými nerovnosťami na cestách. Tepané olovo-vápenaté mriežky sú odolné voči korózii, prebíjaniu, tepelnému úniku a zabezpečujú , že riziko samo-vybíjania je menšie a napomáhajú minimálnemu splynovaniu a spotrebe vody. Vstavaný hydrometer známi ako „magické oko“, ľahko určí stav autobatérie.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635222,
    brand: "DYNAMAX",
    image: "img2000014",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/6/4/108464.jpg",
    name: "DYNAMAX ENERGY BLUELINE 100AH L ASIA",
    short_desc:
      "Autobatérie DYNAMAX BLUELINE ASIA svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy E 50342.",
    desc: "+ Batérie sú bez-údržbové  + Vysoko odolné a odolávajúce otrasom + Pevné a odolné proti úniku elektrolytu + Spoľahlivé s vynikajúcim výkonom + Šetrné k životnému prostrediu   <table><tbody><tr><td>Kapacita batérie:</td> <td></td> <td>100 Ah</td> </tr><tr><td>Prúd:</td> <td></td> <td>720 A (EN)</td> </tr><tr><td>Napätie:</td> <td></td> <td>12V</td> </tr><tr><td>Polarita:</td> <td></td> <td>1 (+L)</td> </tr><tr><td>Dĺžka:</td> <td></td> <td>303 mm</td> </tr><tr><td>Šírka:</td> <td></td> <td>175 mm</td> </tr><tr><td>Výška:</td> <td></td> <td>225 mm</td> </tr><tr><td>Typ uchytenia:</td> <td></td> <td>B01</td> </tr><tr><td>Záručná doba:</td> <td></td> <td>24 mesiacov</td> </tr></tbody></table>   Autobatérie DYNAMAX BLUELINE ASIA sú špeciálne vyvinuté autobatérie, ktoré disponujú špecifickými rozmermi a sú určené pre vozidlá ázijských značiek automobilov (Honda, Mazda, Mitsubishi, Nissan, Suzuki, Toyota a iné.).   Sú navrhnuté tak, aby udržovali správnu hladinu elektrolytu v hornej časti platní pomocou absorbovania objemu kyseliny až o 10 nm alebo aj viac ako konkurenčné autobatérie.   Patentovaný separátor kvapalných plynov zabraňuje stratám elektrolytu, zhromažďovaním a vracaním kvapaliny do zásobníka Nízko-odporové separátory obálok zlepšujú odolnosť proti vibráciám a zabraňujú vnútornému skratu medzi kladnými a zápornými platňami. Vďaka Polypropylénovému obalu je autobatéria mimoriadne pevná, odolná a odoláva nárazom a vibráciám spôsobenými nerovnosťami na cestách. Tepané olovo-vápenaté mriežky sú odolné voči korózii, prebíjaniu, tepelnému úniku a zabezpečujú , že riziko samo-vybíjania je menšie a napomáhajú minimálnemu splynovaniu a spotrebe vody. Vstavaný hydrometer známi ako „magické oko“, ľahko určí stav autobatérie.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635221,
    brand: "DYNAMAX",
    image: "img2000015",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/6/3/108463.jpg",
    name: "DYNAMAX ENERGY BLUELINE 70AH L ASIA",
    short_desc:
      "Autobatérie DYNAMAX BLUELINE ASIA svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy E 50342.",
    desc: "+ Batérie sú bez-údržbové  + Vysoko odolné a odolávajúce otrasom + Pevné a odolné proti úniku elektrolytu + Spoľahlivé s vynikajúcim výkonom + Šetrné k životnému prostrediu   <table><tbody><tr><td>Kapacita batérie:</td> <td></td> <td>70 Ah</td> </tr><tr><td>Prúd:</td> <td></td> <td>600 A (EN)</td> </tr><tr><td>Napätie:</td> <td></td> <td>12V</td> </tr><tr><td>Polarita:</td> <td></td> <td>1 (+L)</td> </tr><tr><td>Dĺžka:</td> <td></td> <td>260 mm</td> </tr><tr><td>Šírka:</td> <td></td> <td>173 mm</td> </tr><tr><td>Výška:</td> <td></td> <td>225 mm</td> </tr><tr><td>Typ uchytenia:</td> <td></td> <td>B01</td> </tr><tr><td>Záručná doba:</td> <td></td> <td>24 mesiacov</td> </tr></tbody></table>   Autobatérie DYNAMAX BLUELINE ASIA sú špeciálne vyvinuté autobatérie, ktoré disponujú špecifickými rozmermi a sú určené pre vozidlá ázijských značiek automobilov (Honda, Mazda, Mitsubishi, Nissan, Suzuki, Toyota a iné.).   Sú navrhnuté tak, aby udržovali správnu hladinu elektrolytu v hornej časti platní pomocou absorbovania objemu kyseliny až o 10 nm alebo aj viac ako konkurenčné autobatérie.   Patentovaný separátor kvapalných plynov zabraňuje stratám elektrolytu, zhromažďovaním a vracaním kvapaliny do zásobníka Nízko-odporové separátory obálok zlepšujú odolnosť proti vibráciám a zabraňujú vnútornému skratu medzi kladnými a zápornými platňami. Vďaka Polypropylénovému obalu je autobatéria mimoriadne pevná, odolná a odoláva nárazom a vibráciám spôsobenými nerovnosťami na cestách. Tepané olovo-vápenaté mriežky sú odolné voči korózii, prebíjaniu, tepelnému úniku a zabezpečujú , že riziko samo-vybíjania je menšie a napomáhajú minimálnemu splynovaniu a spotrebe vody. Vstavaný hydrometer známi ako „magické oko“, ľahko určí stav autobatérie.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635220,
    brand: "DYNAMAX",
    image: "img2000016",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/6/2/108462.jpg",
    name: "DYNAMAX ENERGY BLUELINE 60AH L ASIA",
    short_desc:
      "Autobatérie DYNAMAX BLUELINE ASIA svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy E 50342.",
    desc: "+ Batérie sú bez-údržbové  + Vysoko odolné a odolávajúce otrasom + Pevné a odolné proti úniku elektrolytu + Spoľahlivé s vynikajúcim výkonom + Šetrné k životnému prostrediu   <table><tbody><tr><td>Kapacita batérie:</td> <td></td> <td>60 Ah</td> </tr><tr><td>Prúd:</td> <td></td> <td>540 A (EN)</td> </tr><tr><td>Napätie:</td> <td></td> <td>12V</td> </tr><tr><td>Polarita:</td> <td></td> <td>1 (+L)</td> </tr><tr><td>Dĺžka:</td> <td></td> <td>232 mm</td> </tr><tr><td>Šírka:</td> <td></td> <td>175 mm</td> </tr><tr><td>Výška:</td> <td></td> <td>225 mm</td> </tr><tr><td>Typ uchytenia:</td> <td></td> <td>B01</td> </tr><tr><td>Záručná doba:</td> <td></td> <td>24 mesiacov</td> </tr></tbody></table>   Autobatérie DYNAMAX BLUELINE ASIA sú špeciálne vyvinuté autobatérie, ktoré disponujú špecifickými rozmermi a sú určené pre vozidlá ázijských značiek automobilov (Honda, Mazda, Mitsubishi, Nissan, Suzuki, Toyota a iné.).   Sú navrhnuté tak, aby udržovali správnu hladinu elektrolytu v hornej časti platní pomocou absorbovania objemu kyseliny až o 10 nm alebo aj viac ako konkurenčné autobatérie.   Patentovaný separátor kvapalných plynov zabraňuje stratám elektrolytu, zhromažďovaním a vracaním kvapaliny do zásobníka Nízko-odporové separátory obálok zlepšujú odolnosť proti vibráciám a zabraňujú vnútornému skratu medzi kladnými a zápornými platňami. Vďaka Polypropylénovému obalu je autobatéria mimoriadne pevná, odolná a odoláva nárazom a vibráciám spôsobenými nerovnosťami na cestách. Tepané olovo-vápenaté mriežky sú odolné voči korózii, prebíjaniu, tepelnému úniku a zabezpečujú , že riziko samo-vybíjania je menšie a napomáhajú minimálnemu splynovaniu a spotrebe vody. Vstavaný hydrometer známi ako „magické oko“, ľahko určí stav autobatérie.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635219,
    brand: "DYNAMAX",
    image: "img2000017",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/6/1/108461.jpg",
    name: "DYNAMAX ENERGY BLUELINE 45AH L ASIA",
    short_desc:
      "Autobatérie DYNAMAX BLUELINE ASIA svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy E 50342.",
    desc: "+ Batérie sú bez-údržbové  + Vysoko odolné a odolávajúce otrasom + Pevné a odolné proti úniku elektrolytu + Spoľahlivé s vynikajúcim výkonom + Šetrné k životnému prostrediu   <table><tbody><tr><td>Kapacita batérie:</td> <td></td> <td>45 Ah</td> </tr><tr><td>Prúd:</td> <td></td> <td>330 A (EN)</td> </tr><tr><td>Napätie:</td> <td></td> <td>12V</td> </tr><tr><td>Polarita:</td> <td></td> <td>1 (+L)</td> </tr><tr><td>Dĺžka:</td> <td></td> <td>238 mm</td> </tr><tr><td>Šírka:</td> <td></td> <td>129 mm</td> </tr><tr><td>Výška:</td> <td></td> <td>225 mm</td> </tr><tr><td>Typ uchytenia:</td> <td></td> <td>B00</td> </tr><tr><td>Záručná doba:</td> <td></td> <td>24 mesiacov</td> </tr></tbody></table>   Autobatérie DYNAMAX BLUELINE ASIA sú špeciálne vyvinuté autobatérie, ktoré disponujú špecifickými rozmermi a sú určené pre vozidlá ázijských značiek automobilov (Honda, Mazda, Mitsubishi, Nissan, Suzuki, Toyota a iné.).   Sú navrhnuté tak, aby udržovali správnu hladinu elektrolytu v hornej časti platní pomocou absorbovania objemu kyseliny až o 10 nm alebo aj viac ako konkurenčné autobatérie.   Patentovaný separátor kvapalných plynov zabraňuje stratám elektrolytu, zhromažďovaním a vracaním kvapaliny do zásobníka Nízko-odporové separátory obálok zlepšujú odolnosť proti vibráciám a zabraňujú vnútornému skratu medzi kladnými a zápornými platňami. Vďaka Polypropylénovému obalu je autobatéria mimoriadne pevná, odolná a odoláva nárazom a vibráciám spôsobenými nerovnosťami na cestách. Tepané olovo-vápenaté mriežky sú odolné voči korózii, prebíjaniu, tepelnému úniku a zabezpečujú , že riziko samo-vybíjania je menšie a napomáhajú minimálnemu splynovaniu a spotrebe vody. Vstavaný hydrometer známi ako „magické oko“, ľahko určí stav autobatérie.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635218,
    brand: "DYNAMAX",
    image: "img2000018",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/6/0/108460.jpg",
    name: "DYNAMAX ENERGY BLUELINE 35AH L ASIA",
    short_desc:
      "Autobatérie DYNAMAX BLUELINE ASIA svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy E 50342.",
    desc: "+ Batérie sú bez-údržbové  + Vysoko odolné a odolávajúce otrasom + Pevné a odolné proti úniku elektrolytu + Spoľahlivé s vynikajúcim výkonom + Šetrné k životnému prostrediu   <table><tbody><tr><td>Kapacita batérie:</td> <td></td> <td>35 Ah</td> </tr><tr><td>Prúd:</td> <td></td> <td>300 A (EN)</td> </tr><tr><td>Napätie:</td> <td></td> <td>12V</td> </tr><tr><td>Polarita:</td> <td></td> <td>1 (+L)</td> </tr><tr><td>Dĺžka:</td> <td></td> <td>187 mm</td> </tr><tr><td>Šírka:</td> <td></td> <td>127 mm</td> </tr><tr><td>Výška:</td> <td></td> <td>226 mm</td> </tr><tr><td>Typ uchytenia:</td> <td></td> <td>B00</td> </tr><tr><td>Záručná doba:</td> <td></td> <td>24 mesiacov</td> </tr></tbody></table>   Autobatérie DYNAMAX BLUELINE ASIA sú špeciálne vyvinuté autobatérie, ktoré disponujú špecifickými rozmermi a sú určené pre vozidlá ázijských značiek automobilov (Honda, Mazda, Mitsubishi, Nissan, Suzuki, Toyota a iné.). Sú navrhnuté tak, aby udržovali správnu hladinu elektrolytu v hornej časti platní pomocou absorbovania objemu kyseliny až o 10 nm alebo aj viac ako konkurenčné autobatérie. Patentovaný separátor kvapalných plynov zabraňuje stratám elektrolytu, zhromažďovaním a vracaním kvapaliny do zásobníka Nízko-odporové separátory obálok zlepšujú odolnosť proti vibráciám a zabraňujú vnútornému skratu medzi kladnými a zápornými platňami. Vďaka Polypropylénovému obalu je autobatéria mimoriadne pevná, odolná a odoláva nárazom a vibráciám spôsobenými nerovnosťami na cestách. Tepané olovo-vápenaté mriežky sú odolné voči korózii, prebíjaniu, tepelnému úniku a zabezpečujú , že riziko samo-vybíjania je menšie a napomáhajú minimálnemu splynovaniu a spotrebe vody. Vstavaný hydrometer známi ako „magické oko“, ľahko určí stav autobatérie.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635217,
    brand: "DYNAMAX",
    image: "img2000019",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/5/9/108459.jpg",
    name: "DYNAMAX ENERGY BLUELINE 95 AGM",
    short_desc:
      "Autobatérie DYNAMAX BLUELINE AGM svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy podľa E 50342.",
    desc: "Autobatérie DYNAMAX  BLUELINE AGM (Absorbent Glass Mat) sú špeciálne vyvinuté autobatérie pre autá s funkciou štart-stop, funkciou rekuperácie brzdnej energie a iným technológiám napomáhajúcim šetreniu paliva. Primárne sú určené pre mikro-hybridné, vysoko výkonné moderné autá ktoré vyžadujú vyššie prevádzkové parametre aké poskytujú klasické konvenčné batérie. Batéria napomáha opätovnému naštartovaniu pri častom vypínaní a zapínaní motora, a to vďaka odolnosti voči trojnásobne vyšším cyklom nabíjania a vybíjania. + Batérie sú bez-údržbové+ Vďaka Polypropylénovému obalu sú vysoko odolné a   odolávajúce otrasom+ Pevné a odolné proti úniku elektrolytu, kvapaliny a plynov- pri prevrátení nevytečie elektrolyt+ Elektrolyt je viazaný v absorbčnej sklenenej rohožy         (AGM)+ Nízke riziko samo-vybíjania+ Spoľahlivé s vynikajúcim výkonom+ Šetrné k životnému prostrediu <table><tbody><tr><td>Kapacita batérie:</td> <td>95 Ah AGM</td> </tr><tr><td>Prúd:</td> <td>850 A (EN)</td> </tr><tr><td>Napätie:</td> <td>12V</td> </tr><tr><td>Typ pólov:</td> <td>1 (štandard)</td> </tr><tr><td>Polarita:</td> <td>0 (+P)</td> </tr><tr><td>Dĺžka:</td> <td>353 mm</td> </tr><tr><td>Šírka:</td> <td>175 mm</td> </tr><tr><td>Výška:</td> <td>190 mm</td> </tr><tr><td>Typ uchytenia:</td> <td>B13</td> </tr><tr><td>Záručná doba:</td> <td>24 mesiacov</td> </tr></tbody></table>Využitie:•    Automobily•    Člny s elektromotorom•    Karavany•    Osvetlenia•    Domáce energetické systémy•    Inštalácie obnoviteľných zdrojov solárnej energie",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635216,
    brand: "DYNAMAX",
    image: "img2000020",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/8/4/108484.jpg",
    name: "DYNAMAX ENERGY BLUELINE 80 AGM",
    short_desc:
      "Autobatérie DYNAMAX BLUELINE AGM svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy podľa E 50342.",
    desc: "Autobatérie DYNAMAX  BLUELINE AGM (Absorbent Glass Mat) sú špeciálne vyvinuté autobatérie pre autá s funkciou štart-stop, funkciou rekuperácie brzdnej energie a iným technológiám napomáhajúcim šetreniu paliva. Primárne sú určené pre mikro-hybridné, vysoko výkonné moderné autá ktoré vyžadujú vyššie prevádzkové parametre aké poskytujú klasické konvenčné batérie. Batéria napomáha opätovnému naštartovaniu pri častom vypínaní a zapínaní motora, a to vďaka odolnosti voči trojnásobne vyšším cyklom nabíjania a vybíjania. + Batérie sú bez-údržbové+ Vďaka Polypropylénovému obalu sú vysoko odolné a   odolávajúce otrasom+ Pevné a odolné proti úniku elektrolytu, kvapaliny a plynov- pri prevrátení nevytečie elektrolyt+ Elektrolyt je viazaný v absorbčnej sklenenej rohožy         (AGM)+ Nízke riziko samo-vybíjania+ Spoľahlivé s vynikajúcim výkonom+ Šetrné k životnému prostrediu  <table><tbody><tr><td>Kapacita batérie:</td> <td>80 Ah AGM</td> </tr><tr><td>Prúd:</td> <td>800 A (EN)</td> </tr><tr><td>Napätie:</td> <td>12V</td> </tr><tr><td>Typ pólov:</td> <td>1 (štandard)</td> </tr><tr><td>Polarita:</td> <td>0 (+P)</td> </tr><tr><td>Dĺžka:</td> <td>315 mm</td> </tr><tr><td>Šírka:</td> <td>175 mm</td> </tr><tr><td>Výška:</td> <td>190 mm</td> </tr><tr><td>Typ uchytenia:</td> <td>B13</td> </tr><tr><td>Záručná doba:</td> <td>24 mesiacov</td> </tr></tbody></table> Využitie: •    Automobily•    Člny s elektromotorom•    Karavany•    Osvetlenia•    Domáce energetické systémy•    Inštalácie obnoviteľných zdrojov solárnej energie",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635215,
    brand: "DYNAMAX",
    image: "img2000021",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/8/5/108485.jpg",
    name: "DYNAMAX ENERGY BLUELINE 70 AGM",
    short_desc:
      "Autobatérie DYNAMAX BLUELINE AGM svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy podľa E 50342.",
    desc: "Autobatérie DYNAMAX  BLUELINE AGM (Absorbent Glass Mat) sú špeciálne vyvinuté autobatérie pre autá s funkciou štart-stop, funkciou rekuperácie brzdnej energie a iným technológiám napomáhajúcim šetreniu paliva. Primárne sú určené pre mikro-hybridné, vysoko výkonné moderné autá ktoré vyžadujú vyššie prevádzkové parametre aké poskytujú klasické konvenčné batérie. Batéria napomáha opätovnému naštartovaniu pri častom vypínaní a zapínaní motora, a to vďaka odolnosti voči trojnásobne vyšším cyklom nabíjania a vybíjania. + Batérie sú bez-údržbové+ Vďaka Polypropylénovému obalu sú vysoko odolné a   odolávajúce otrasom+ Pevné a odolné proti úniku elektrolytu, kvapaliny a plynov- pri prevrátení nevytečie elektrolyt+ Elektrolyt je viazaný v absorbčnej sklenenej rohožy         (AGM)+ Nízke riziko samo-vybíjania+ Spoľahlivé s vynikajúcim výkonom+ Šetrné k životnému prostrediu Využitie:•    Automobily•    Člny s elektromotorom•    Karavany•    Osvetlenia•    Domáce energetické systémy•    Inštalácie obnoviteľných zdrojov solárnej energie",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635214,
    brand: "DYNAMAX",
    image: "img2000022",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/5/8/108458.jpg",
    name: "DYNAMAX ENERGY BLUELINE 70 EFB",
    short_desc:
      "Autobatérie DYNAMAX BLUELINE EFB svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy podľa E 50342.",
    desc: "Autobatérie DYNAMAX BLUELINE EFB (Enhanced flooded battery) sú špeciálne vyvinuté autobatérie pre autá s funkciou štart-stop bez rekuperácie energie, ktoré vyžadujú vyššie prevádzkové parametre aké poskytujú klasické konvenčné batérie. Technológia EFB poskytuje napájanie všetkých elektrických komponentov pri vypnutom motore a napomáha opätovnému naštartovaniu vozidla pri častom vypínaní a zapínaní motora. Je to vďaka odolnosti voči dvojnásobne vyšším cyklom nabíjania a vybíjania. Autobatérie DYNAMAX BLUELINE EFB obsahujú väčšiu rezervu elektrolytu, veľkú plochu pre výmenu elektrolytov a elektródové vlajky sú chránené voči korózii a situáciám možného nebezpečenstva. + Batérie sú bez-údržbové+ Vysoko odolné a odolávajúce otrasom+ Pevné a odolné proti úniku elektrolytu+ Spoľahlivé s vynikajúcim výkonom+ Vhodné aj pre vozidlá v stavebnom priemysle+ Šetrné k životnému prostrediu <table><tbody><tr><td>Kapacita batérie:</td> <td>70 Ah AGM</td> </tr><tr><td>Prúd:</td> <td>760 A (EN)</td> </tr><tr><td>Napätie:</td> <td>12V</td> </tr><tr><td>Typ pólov:</td> <td>1 (štandard)</td> </tr><tr><td>Polarita:</td> <td>0 (+P)</td> </tr><tr><td>Dĺžka:</td> <td>276 mm</td> </tr><tr><td>Šírka:</td> <td>175 mm</td> </tr><tr><td>Výška:</td> <td>190 mm</td> </tr><tr><td>Typ uchytenia:</td> <td>B13</td> </tr><tr><td>Záručná doba:</td> <td>24 mesiacov</td> </tr></tbody></table>Pre negatívne (-) platne je charakteristické:a.    tvoria ich špeciálne PbCaSn zliatinové mriežky (olovo-vápnik-cín),b.    negatívna aktívna hmota obsahuje viac uhlíka,c.    expandér je navrhnutý tak, aby odolal častým cyklom funkcie Štart &amp; Stop,d.    vrstvy organických vlákien aktívne absorbujú expanziu aktívnej hmoty počas cyklov. Pre pozitívne (+) platne je charakteristické:a.    tvoria ich špeciálne PbCaSn zliatinové mriežky (olovo-vápnik-cín),b.    mriežky sú špeciálne navrhnuté, aby odolávali korózii a vysokým teplotám (SAEJ2801),c.    vrstvy organických vlákien aktívne absorbujú expanziu aktívnej hmoty počas cyklov.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 635213,
    brand: "DYNAMAX",
    image: "img2000023",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/4/5/7/108457.jpg",
    name: "DYNAMAX ENERGY BLUELINE 60 EFB",
    short_desc:
      "Autobatérie DYNAMAX BLUELINE EFB svojou vysokou kvalitou a optimálnymi parametrami zaručujú bezpečnosť používania a spoľahlivosť v prevádzke. Spĺňajú európske štandardy podľa E 50342.",
    desc: "Autobatérie DYNAMAX BLUELINE EFB (Enhanced flooded battery) sú špeciálne vyvinuté autobatérie pre autá s funkciou štart-stop bez rekuperácie energie, ktoré vyžadujú vyššie prevádzkové parametre aké poskytujú klasické konvenčné batérie. Technológia EFB poskytuje napájanie všetkých elektrických komponentov pri vypnutom motore a napomáha opätovnému naštartovaniu vozidla pri častom vypínaní a zapínaní motora. Je to vďaka odolnosti voči dvojnásobne vyšším cyklom nabíjania a vybíjania. Autobatérie DYNAMAX BLUELINE EFB obsahujú väčšiu rezervu elektrolytu, veľkú plochu pre výmenu elektrolytov a elektródové vlajky sú chránené voči korózii a situáciám možného nebezpečenstva. + Batérie sú bez-údržbové+ Vysoko odolné a odolávajúce otrasom+ Pevné a odolné proti úniku elektrolytu+ Spoľahlivé s vynikajúcim výkonom+ Vhodné aj pre vozidlá v stavebnom priemysle+ Šetrné k životnému prostrediu <table><tbody><tr><td>Kapacita batérie:</td> <td>60 Ah EFB</td> </tr><tr><td>Prúd:</td> <td>640 A (EN)</td> </tr><tr><td>Napätie:</td> <td>12V</td> </tr><tr><td>Typ pólov:</td> <td>1 (štandard)</td> </tr><tr><td>Polarita:</td> <td>0 (+P)</td> </tr><tr><td>Dĺžka:</td> <td>242 mm</td> </tr><tr><td>Šírka:</td> <td>175 mm</td> </tr><tr><td>Výška:</td> <td>190 mm</td> </tr><tr><td>Typ uchytenia:</td> <td>B13</td> </tr><tr><td>Záručná doba:</td> <td>24 mesiacov</td> </tr></tbody></table>Pre negatívne (-) platne je charakteristické:a. tvoria ich špeciálne PbCaSn zliatinové mriežky (olovo-vápnik-cín),b. negatívna aktívna hmota obsahuje viac uhlíka,c. expandér je navrhnutý tak, aby odolal častým cyklom funkcie Štart &amp; Stop,d. vrstvy organických vlákien aktívne absorbujú expanziu aktívnej hmoty počas cyklov. Pre pozitívne (+) platne je charakteristické:a. tvoria ich špeciálne PbCaSn zliatinové mriežky (olovo-vápnik-cín),b. mriežky sú špeciálne navrhnuté, aby odolávali korózii a vysokým teplotám (SAEJ2801),c. vrstvy organických vlákien aktívne absorbujú expanziu aktívnej hmoty počas cyklov.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 634918,
    brand: "DYNAMAX",
    image: "img2000024",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/3/9/6/108396.jpg",
    name: "DYNAMAX DXT11 TUK NA BRZDY 500ML",
    short_desc: "Nekovové mazadlo zabraňujúce zablokovaniu brzdového systému.",
    desc: "Vlastnosti výrobku: Vysoká tepelná stabilita. Odolný voči chemikáliám a poveternostným vplyvom. Zjednodušuje demontáž v budúcnosti. Aerósol by mal mať izbovú teplotu. Teplota spracovania 5 – 30°C. Pred použitím pretrepte. Nasprejujte brzdové diely, ktoré sa ošetria pred montážou. Vyhnite sa kontaktu s brzdovými kotúčmi a brzdovou plochou brzdových doštičiek.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "brzdovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 634917,
    brand: "DYNAMAX",
    image: "img2000025",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/3/9/5/108395.jpg",
    name: "DYNAMAX DXT15 STUDENÝ ŠOK - ZMRAZOVAČ 500ML",
    short_desc:
      "Účinný prostriedok na uvoľnenie skorodovaných alebo zadretých spojov.",
    desc: "Vlastnosti výrobku: Priama vstrekovacia tryska. Nakrátko zníži teplotu na –50°C. Aerosól by mal mat izbovú teplotu. Teplota spracovania 5 – 30°C. Spoj opakovane postriekajte krátkym stlačením trysky. Vďaka prudkému poklesu teploty môžete spoj uvoľniť.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 634916,
    brand: "DYNAMAX",
    image: "img2000026",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/3/9/4/108394.jpg",
    name: "DYNAMAX DXT12 BIELY TUK 500ML",
    short_desc:
      "Sprejové mazadlo na premazanie mechanických komponentov z kovu alebo plastu.",
    desc: "Vlastnosti výrobku: Zabraňuje opotrebovaniu a zlepeniu. Vynikajúca mechanická a tepelná stabilita. Vodoodpudivý. Pred použitím pretrepte. Optimálne premazanie získate po odparení rozpúšťadla.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 634915,
    brand: "DYNAMAX",
    image: "img2000027",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/3/9/3/108393.jpg",
    name: "DYNAMAX DXT13 PTFE SUCHÝ TEFLON 500ML",
    short_desc:
      "Mazivo na suché povrchy kovových a plastových mechanických častí, kde nesmú zostať žiadne zvyšky oleja alebo maziva.",
    desc: "Vlastnosti výrobku: Žiadne zvyšky oleja alebo maziva (suchý povlak). Nízky koeficient trenia. Vhodný ako prostriedok podporujúci odlepovanie foriem, kde nie je žiadúce použitie silikónu. Aerósol by mal mať izbovú teplotu. Teplota spracovania 5 – 30°C. Pred použitím pretrepte. Naneste tenkú vrstvu PTFE Dry. Po odparení rozpúšťadla ostane suchý ochranný povlak PTFE.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 634914,
    brand: "DYNAMAX",
    image: "img2000028",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/3/9/2/108392.jpg",
    name: "DYNAMAX DXT10 KERAMICKÝ SPRAY 500ML",
    short_desc:
      "Nekovové keramické mazivo ošetrujúce tie časti, ktoré sú vystavené veľkému zaťaženiu a/alebo veľmi vysokým teplotám.",
    desc: "Vlastnosti výrobku: Chráni pred elektrolytickou koróziou. Vysoká tepelná stabilita. Zabraňuje opotrebovaniu a zadretiu. Mimoriadne vhodný pre montáž brzdových systémov ABS a ASR a pre lambda snímače. Aersól by mal mať izbovú teplotu. Teplota spracovania 5 – 30°C. Pred použitím pretrepte. Naneste keramické mazivo. Špecifické vlastnosti sa dosiahnu po vyparení rozpúšťadla.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 634913,
    brand: "DYNAMAX",
    image: "img2000029",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/3/9/1/108391.jpg",
    name: "DYNAMAX DXT16 ODSTRAŇOVAČ ASFALTU 500ML",
    short_desc: "Odstraňovač smoly a živice.",
    desc: "Sprej na odstraňovanie smoly, bitúmenu, asfaltu a živice. Pred použitím potraste. Aplikujte a nechajte zapracovať. Odstráňte nečistotu handričkou. Pri silnom znečistení zopakujte postup ešte raz.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 634912,
    brand: "DYNAMAX",
    image: "img2000030",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/3/9/0/108390.jpg",
    name: "DYNAMAX DXI17 ODSTRAŇOVAČ NÁLEPIEK 500ML",
    short_desc:
      "Citrusový čistiaci prostriedok na odstraňovanie mastnoty, asfaltu, maziva, vosku, atramentu, živice, zvyškov nálepiek a lepidla z povrchov ošetrených a neošetrených kovov, dreva, kameňa a niektorých typov plastov.",
    desc: "Vlastnosti výrobku: Trvalé rozpúšťacie schopnosti sú dôsledkom nízkej rýchlosti odparovania. Antikorózny. Návod na použitie: Aerosól by mal mať izbovú teplotu. Teplota spracovania 5 – 30°C. Pred použitím potraste. Naneste rovnomerne na ošetrované časti a nechajte niekoľko minút pôsobiť. Čistou handričkou alebo tkaninou odstráňte nečistoty. Pred použitím vyskúšajte kompatibilitu povrchu.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 634911,
    brand: "DYNAMAX",
    image: "img2000031",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/3/8/9/108389.jpg",
    name: "DYNAMAX DXT14 MEDENÝ SPREJ 500ML",
    short_desc:
      "Sprej s vysokým obsahom medi na mazanie skrutkových spojov, ktoré sú vystavené veľmi vysokým teplotám.",
    desc: "Vlastnosti výrobku: Vysoká tepelná stabilita. Zabraňuje opotrebovaniu a zlepeniu. Odolný voči chemikáliám a poveternostným vplyvom. Chráni pred koróziou. Pred použitím pretrepte. Špecifická lubrikačná vlastnosť sa dosiahne po odparení rozpúšťadla (približne 1 minútu).",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 634910,
    brand: "DYNAMAX",
    image: "img2000032",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/3/8/7/108387.jpg",
    name: "DYNAMAX DXM6 SPREJ PROTI KUNÁM 500ML",
    short_desc:
      "Priehľadný sprej proti poškodeniam káblov a drôtov, ktoré spôsobujú kuny.",
    desc: "Vďaka jedinečnému lepkavému ochrannému povlaku sa kuny budú vyhýbať ošetrenému povrchu. Vlastnosti výrobku: Dlhodobá ochrana. Odolný voči vplyvom počasia, slabým kyselinám a alkáliám. Bez zápachu. Aerósol by mal mať izbovú teplotu. Teplota spracovania 5 – 30°C. Pred použitím pretrepte. Na chránený povrch naneste rovnomernú vrstvu.",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500075,
    brand: "DYNAMAX",
    image: "img2000033",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/3/8/5/108385.jpg",
    name: "DYNAMAX PREMIUM DIESEL PLUS 10W40 4L",
    short_desc:
      "Je polosyntetický motorový olej vhodný pre benzínové i dieselové motory.",
    desc: "Syntetická zložka oleja zlepšuje mazanie motora v záťažových podmienkach a zároveň zachováva výborné vlastnosti oleja. Je vhodný na celoročné používanie. Má vyhovujúce vlastnosti pri nízkych teplotách v zimnom období a tiež pri vysokých teplotách v letnom období.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 500074,
    brand: "DYNAMAX",
    image: "img2000034",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/3/8/4/108384.jpg",
    name: "DYNAMAX PREMIUM DIESEL PLUS 10W40 1L",
    short_desc:
      "Je polosyntetický motorový olej vhodný pre benzínové i dieselové motory.",
    desc: "Syntetická zložka oleja zlepšuje mazanie motora v záťažových podmienkach a zároveň zachováva výborné vlastnosti oleja. Je vhodný na celoročné používanie. Má vyhovujúce vlastnosti pri nízkych teplotách v zimnom období a tiež pri vysokých teplotách v letnom období.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "motorovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 503090,
    brand: "DYNAMAX",
    image: "img2000035",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/3/8/3/108383.jpg",
    name: "DYNAMAX DXC13 ČISTIČ BŔZD 25L",
    short_desc:
      "Čistič na brzdy s extra silnými rozpúšťacími vlastnosťami pre čistenie a odmasťovanie brzdových, spojkových, prevodových a palivových častí vozidla.",
    desc: "Vlastnosti výrobku: má antikorózny účinok, nezanecháva zvyšky a je nevodivý. Použitie: Pred použitím pretrepte. Zakryte lakované a plastové komponenty. Aplikujte na súčiastky pokiaľ nečistoty nezmiznú.",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "brzdovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502153,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX TRUCKMAN PLUS SHPD 15W40 5L",
    short_desc: "",
    desc: "",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502041,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX TRUCKMAN PLUS LM 10W40 5L",
    short_desc: "",
    desc: "",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 502412,
    brand: "DYNAMAX",
    image: "",
    src: "",
    name: "DYNAMAX COOL AL G11 60L BLUE KONCENTRAT",
    short_desc: "",
    desc: "",
    ean: "",
    package: "",
    type: "doplnok",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 503076,
    brand: "DYNAMAX",
    image: "img2000036",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/3/0/6/108306.jpg",
    name: "DYNAMAX HYPOL 75W-85 GL-5 1L",
    short_desc:
      "Univerzálny vysokovýkonný prevodový olej pre CVT prevodovky, manuálne prevodovky a diferenciály moderných osobných a ľahkých úžitkových vozidiel vyžadujúcich API GL-5.",
    desc: "Vyrobený na základe špeciálne vybraného syntetického základového oleja. Obsahuje balík aditív na zvýšenie odolnosti pri extrémnom tlaku, má excelentné tepelno-oxidačné vlastnosti, nízky bod tuhnutia, znižuje spotrebu paliva, výborne zabraňuje peneniu, opotrebeniu a korózii.  Viskozitná trieda: SAE 75W-85 Výkonnostný profil: API GL-5, MIL-L 2105E, API MT-1 Schválenia: SAE J2360, VW TL 521 45-X (G 052 145 A1), VW TL 521 90 (G 052 190 A2/ G 055 190 A2), MB 235.7, MB 235.74, MB 239.71, MB 239.72, ZF TE-ML 180",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 503075,
    brand: "DYNAMAX",
    image: "img2000037",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/3/0/5/108305.jpg",
    name: "DYNAMAX GEAR 75W-80 TRX GL-4 1L",
    short_desc:
      "Vysoko kvalitný olej do manuálnych prevodoviek osobných a ľahkých úžitkových vozidiel, ktoré používajú manuálnu prevodovku a manuálnu prevodovku s diferenciálom.",
    desc: "Nie je vhodný pre diferenciály a iné vyžadujúce API GL-5. Je na báze vysokokvalitného základového oleja vyrobeného syntetickou technológiou so špeciálnym balíkom aditív na zvýšenie termo-oxidačnej stability, zníženie spotreby paliva, ochranu pred koróziou, zlepšenie tekutosti pri nízkych teplotách, čo napomáha pri radení prevodových stupňov. Vhodný pre rôzne typy materiálov používaných na synchrónoch vrátane mosadze, uhlíka, bronzu a molybdénu.  <b>SCHVÁLENIA:</b> BMW MTF LT-2, BMW MTF LT-3, BMW MTF LT-4, Ford WSD-M2C200-C, GM 1940182, GM 1940764, GM 1940768, GM 1940004, GM 19259104, Ford WSS-M2C200-D2, MB 235.10, PSA B71 2330, MTF 94, Honda MTF, Honda MTF II/III, Nissan MT-XZ, Nissan MT-XZ TL, Volvo 97308, Volvo 97309, VW G 009 317, VW G 052 171, VW G 052 178, VW G 052 512, VW G 052 527, VW G 052 726, VW G 060 726, VW G 070 726, VW G50, Renault (NFJ/NFP/TRJ/TRT/TRZ)",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "prevodovy",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 503074,
    brand: "DYNAMAX",
    image: "img2000038",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/3/0/4/108304.jpg",
    name: "DYNAMAX PSF SYNTH 1L",
    short_desc:
      "Zelený syntetický hydraulický olej vyvinutý pre vysoko namáhané systémy posilňovača riadenia, centralizované hydraulické systémy a tlmiče, ktoré dokážu dosiahnuť trvalú teplotu oleja až do približne 140 °C.",
    desc: "Jedinečný balík aditív zaisťuje optimálnu teplotnú stabilitu, vysokú oxidačnú stabilitu, vynikajúce vlastnosti za studena, vysokú strihovú stabilitu. Osvedčená OEM technológia.  <b>ŠPECIFIKÁCIE:</b> BMW 83 29 0 429 576, Ford M2C204-A2, Ford 1 384 110, Hyundai/Kia PSF-4 03100-00130, Opel 1940 715, Opel 1940 766, Porsche 000 043 203 33, Toyota PSF NEW-W, Toyota 08886-01115, VW TL 521 46 (G002 000, G004 000 M2), CHF11S, CHF202, Citroen 9979 A1, Land Rover PAS Fluid 14315, RN2261, MB 343.0, MB 344.0, MB 345.0, SAAB 93160548, VOLVO 30741424, ZF TE-ML 02K",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  {
    id: 503102,
    brand: "DYNAMAX",
    image: "img2000039",
    src: "http://eshop.eurovat.sk/img/p/1/0/8/3/0/3/108303.jpg",
    name: "DYNAMAX SCREENWASH SERVICE PLUS -30 5L",
    short_desc:
      "Je vysoko účinná, celoročná mrazuvzdorná kvapalina do všetkých typov ostrekovačov motorových vozidiel.",
    desc: "DYNAMAX Screenwash SERVICE PLUS -30 °C je nemrznúca kvapalina do ostrekovačov automobilov. Spoľahlivo odstraňuje zo skla automobilu mastnotu a iné nečistoty. Chráni ostrekovací systém pred zamŕzaním a vytváraním vodného kameňa. Zlepšuje viditeľnosť počas nepriaznivého zimného počasia. DYNAMAX Screenwash SERVICE PLUS -30 °C sa používa neriedený alebo po nariedení podľa tabuľky.Doporučené pomery riedenia:Neriedený – použitie do -30°C;1 diel DYNAMAX Screenwash SERVICE PLUS -30 °C: 1 diel voda – použitie do -10°C1 diel DYNAMAX Screenwash SERVICE PLUS -30 °C: 2 diely voda – použitie do -6°C",
    ean: "",
    package: "",
    type: "olej",
    sub_category: "ostrekovaci",
    price: "12,78",
    "": "",
    __1: "",
    __2: "",
  },
  */
];

/*
const products = [
  {
    type: "olej",
    brand: "Shell",
    name: "Helix, Ultra ECT C3",
    price: 36.64,
    viscosity: "5W-30",
    volume: 4,
    image: olej1,
  },
  {
    type: "olej",
    brand: "Shell",
    name: "Helix, HX8 ECT",
    price: 39.2,
    viscosity: "5W-30",
    volume: 5,
    image: olej2,
  },
  {
    type: "olej",
    brand: "Febi Bilstein",
    name: "Brzdová kvapalina",
    price: 2.24,
    volume: 0.25,
    desc: ["DOT 4", "ISO 4925", "MB 331.0"],
    image: olej3,
  },
  {
    type: "olej",
    brand: "Shell",
    name: "Helix, Ultra ECT C3",
    price: 36.64,
    viscosity: "5W-30",
    volume: 4,
    image: olej1,
  },
  {
    type: "olej",
    brand: "Shell",
    name: "Helix, HX8 ECT",
    price: 39.2,
    viscosity: "5W-30",
    volume: 5,
    image: olej2,
  },
  {
    type: "filtre",
    brand: "MecaFilter",
    name: "Olejový filter",
    price: 9.67,
    design: "Pre zvýšené nároky",
    attributes: {
      "Vnútorný priemer": "96,0",
      "Priemer 3": "62,0",
      "Priemer 4": "71,0",
      Rozmer: 'D2=3/4"-16',
      Dĺžka: 114,
    },
    image: filter1,
  },
  {
    type: "filtre",
    brand: "Champion",
    name: "Olejový filter",
    price: 3.82,
    design: "Skrutkovací filter",
    desc: ["Vnútorný priemer: 71,5", "Vonkajší priemer: 93,0"],
    dimensions: '3/4"-16 UNF',
    height: 114,
    image: filter2,
  },
  {
    type: "filtre",
    brand: "MecaFilter",
    name: "Olejový filter",
    price: 9.67,
    design: "Pre zvýšené nároky",
    attributes: {
      "Vnútorný priemer": "96,0",
      "Priemer 3": "62,0",
      "Priemer 4": "71,0",
      Rozmer: 'D2=3/4"-16',
      Dĺžka: 114,
    },
    image: filter1,
  },
  {
    type: "filtre",
    brand: "Champion",
    name: "Olejový filter",
    price: 3.82,
    design: "Skrutkovací filter",
    desc: ["Vnútorný priemer: 71,5", "Vonkajší priemer: 93,0"],
    dimensions: '3/4"-16 UNF',
    height: 114,
    image: filter2,
  },
  {
    type: "filtre",
    brand: "MecaFilter",
    name: "Olejový filter",
    price: 9.67,
    design: "Pre zvýšené nároky",
    attributes: {
      "Vnútorný priemer": "96,0",
      "Priemer 3": "62,0",
      "Priemer 4": "71,0",
      Rozmer: 'D2=3/4"-16',
      Dĺžka: 114,
    },
    image: filter1,
  },
  {
    type: "cistenie",
    brand: "K2",
    name: "Polo Protectant 770ml",
    price: 2.17,
    image: sprej,
  },
  {
    type: "cistenie",
    brand: "K2",
    name: "Polo Protectant 770ml",
    price: 2.17,
    image: sprej,
  },
  {
    type: "cistenie",
    brand: "K2",
    name: "Polo Protectant 770ml",
    price: 2.17,
    image: sprej,
  },
  {
    type: "cistenie",
    brand: "K2",
    name: "Polo Protectant 770ml",
    price: 2.17,
    image: sprej,
  },
  {
    type: "cistenie",
    brand: "K2",
    name: "Polo Protectant 770ml",
    price: 2.17,
    image: sprej,
  },
  {
    type: "brzdy",
    brand: "Febi Bilstein",
    name: "Brzdový kotúč",
    price: 30.41,
    design: "Vnútorné chladenie",
    desc: [
      "Hrúbka kotúča: 22",
      "Počet pripevňovacích otvorov: 5",
      "Hrúbka: 76,0",
      "Vonkajší priemer: 296,0",
      "Miesto montáže: Predná náprava",
      "Minimálne hrúbka: 20,4",
      "Centrovací priemer: 79",
      "Hmotnosť: 7,52",
    ],
    image: brzdy1,
  },
  {
    type: "brzdy",
    brand: "Febi Bilstein",
    name: "Brzdový kotúč",
    price: 30.41,
    design: "Vnútorné chladenie",
    desc: [
      "Hrúbka kotúča: 22",
      "Počet pripevňovacích otvorov: 5",
      "Hrúbka: 76,0",
      "Vonkajší priemer: 296,0",
      "Miesto montáže: Predná náprava",
      "Minimálne hrúbka: 20,4",
      "Centrovací priemer: 79",
      "Hmotnosť: 7,52",
    ],
    image: brzdy1,
  },
  {
    type: "brzdy",
    brand: "Febi Bilstein",
    name: "Brzdový kotúč",
    price: 30.41,
    design: "Vnútorné chladenie",
    desc: [
      "Hrúbka kotúča: 22",
      "Počet pripevňovacích otvorov: 5",
      "Hrúbka: 76,0",
      "Vonkajší priemer: 296,0",
      "Miesto montáže: Predná náprava",
      "Minimálne hrúbka: 20,4",
      "Centrovací priemer: 79",
      "Hmotnosť: 7,52",
    ],
    image: brzdy1,
  },
  {
    type: "brzdy",
    brand: "Febi Bilstein",
    name: "Brzdový kotúč",
    price: 30.41,
    design: "Vnútorné chladenie",
    desc: [
      "Hrúbka kotúča: 22",
      "Počet pripevňovacích otvorov: 5",
      "Hrúbka: 76,0",
      "Vonkajší priemer: 296,0",
      "Miesto montáže: Predná náprava",
      "Minimálne hrúbka: 20,4",
      "Centrovací priemer: 79",
      "Hmotnosť: 7,52",
    ],
    image: brzdy1,
  },
  {
    type: "brzdy",
    brand: "Febi Bilstein",
    name: "Brzdový kotúč",
    price: 30.41,
    design: "Vnútorné chladenie",
    desc: [
      "Hrúbka kotúča: 22",
      "Počet pripevňovacích otvorov: 5",
      "Hrúbka: 76,0",
      "Vonkajší priemer: 296,0",
      "Miesto montáže: Predná náprava",
      "Minimálne hrúbka: 20,4",
      "Centrovací priemer: 79",
      "Hmotnosť: 7,52",
    ],
    image: brzdy1,
  },
];
*/

export default products;
